import type React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
import MdiIcon from '@mdi/react';
import * as mdiIcons from '@mdi/js/mdi';
import ListIcon from '@mui/icons-material/List';
import clsx from 'clsx';
import { LibraryAddCheckOutlined } from '@mui/icons-material';

type MdiIconProps = React.ComponentProps<typeof MdiIcon>;

export const StarterLogo = (props: SvgIconProps) => (
	<SvgIcon viewBox="16.4 11.4 1366.2 235.9" {...props}>
		<style type="text/css">{`
			.st0-DispatcherLogo{fill:url(#SVGID_1_);}
			.st1-DispatcherLogo{fill:url(#SVGID_00000002365623955516137640000004671488360052553121_);}

				.st2-DispatcherLogo{display:none;clip-path:url(#SVGID_00000132767043709528592540000016186195822080224153_);fill:url(#SVGID_00000040535164268144382740000007547128131427708053_);}
			.st3-DispatcherLogo{display:none;clip-path:url(#SVGID_00000003789004848413429430000014966690038044133016_);fill:#F0E3FC;}

				.st4-DispatcherLogo{clip-path:url(#SVGID_00000008136343564228465260000016084474228312539520_);fill:url(#SVGID_00000028286045580589563830000015358030318490520977_);}
			.st5-DispatcherLogo{clip-path:url(#SVGID_00000131330936573274988420000003129891811175820696_);fill:#F0E3FC;}

				.st6-DispatcherLogo{clip-path:url(#SVGID_00000133502692655169635070000005657403139187121803_);fill:url(#SVGID_00000009591067850299772600000016946873893934909825_);}
			.st7-DispatcherLogo{clip-path:url(#SVGID_00000077322191968845268610000005514041250154188965_);fill:#F0E3FC;}
			.st8-DispatcherLogo{fill:url(#SVGID_00000151527988501241088130000010193468904131991980_);}
			.st9-DispatcherLogo{fill:url(#SVGID_00000132786600369773780000000011019244614657462436_);}
			.st10-DispatcherLogo{fill:url(#SVGID_00000013180685853643278420000009148773385390388140_);}
			.st11-DispatcherLogo{fill:url(#SVGID_00000045589210664497915950000009611551907812600201_);}
			.st12-DispatcherLogo{fill:url(#SVGID_00000162322428717695902840000006218273471524827018_);}
			.st13-DispatcherLogo{fill:url(#SVGID_00000134942997441343795620000003077257760075822014_);}
			.st14-DispatcherLogo{enable-background:new    ;}
			.st15-DispatcherLogo{fill:#FFFFFF;}
			.st16-DispatcherLogo{fill:#38256E;}
			.st17-DispatcherLogo{display:none;fill:#FFFFFF;}
			.st18-DispatcherLogo{fill:none;stroke:#38256E;stroke-width:1.9275;}
	`}</style>
		<g id="Layer_1_00000013194088144880065740000017061373937390487967_">
			<linearGradient
				id="SVGID_1_"
				gradientUnits="userSpaceOnUse"
				x1="174.1293"
				y1="232.079"
				x2="170.3702"
				y2="16.721"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#652D90' }} />
				<stop offset={1} style={{ stopColor: '#262261' }} />
			</linearGradient>
			<path
				className="st0-DispatcherLogo"
				d="M264.2,219.6c0,2.3-2.5,4.2-5.5,4.2h-173c-3,0-5.5-1.9-5.5-4.2v-204c0-2.3,2.5-4.2,5.5-4.2h173.1   c3,0,5.5,1.9,5.5,4.2L264.2,219.6L264.2,219.6z"
			/>
			<linearGradient
				id="SVGID_00000041285228167392454390000004629383885181772174_"
				gradientUnits="userSpaceOnUse"
				x1="172.2"
				y1="24.1"
				x2="172.2"
				y2="224.7"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#652D90' }} />
				<stop offset="1.469358e-03" style={{ stopColor: '#6A3597' }} />
				<stop offset="3.767386e-03" style={{ stopColor: '#7A4BA8' }} />
				<stop offset="6.590164e-03" style={{ stopColor: '#926FC6' }} />
				<stop offset="8.379889e-03" style={{ stopColor: '#A48ADB' }} />
				<stop offset="8.379889e-03" style={{ stopColor: '#A48ADB' }} />
				<stop offset={1} style={{ stopColor: '#7D61BC' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000041285228167392454390000004629383885181772174_)',
				}}
				d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5   c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
			/>
			<g id="Layer_4" />
			<g>
				<g>
					<defs>
						<path
							id="SVGID_00000070796665058485671230000007856016415373090705_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000119800931402249822930000007097203158514766241_">
						<use
							xlinkHref="#SVGID_00000070796665058485671230000007856016415373090705_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000072271514542179063340000016179791507362764687_"
						cx="176.9"
						cy="43.05"
						r="75.8028"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							display: 'none',
							clipPath: 'url(#SVGID_00000119800931402249822930000007097203158514766241_)',
							fill: 'url(#SVGID_00000072271514542179063340000016179791507362764687_)',
						}}
						d="     M277.9,234.6c0.1-0.6,0.1-1.2,0.1-1.8c0-15.8-17.5-28.6-39.4-29.2c0.6-1.6,1-3.2,1-4.9c0-10-11.3-18.1-25.3-18.1     c-3.5,0-6.8,0.5-9.8,1.4c-3.3-10.7-16.7-18.7-32.6-18.7c-18.5,0-33.4,10.7-33.4,23.9c0,0,0,0,0,0.1c-0.7,0-1.3-0.1-2-0.1     c-13.6,0-24.9,7.1-27,16.4c-1.1-0.1-2.2-0.1-3.4-0.1c-16.8,0-30.3,9.7-30.3,21.7c0,3.4,1.1,6.5,3,9.4L277.9,234.6L277.9,234.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000001664502602007708480000002974140201123775411_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000036947482181468571760000018026151734725216131_">
						<use
							xlinkHref="#SVGID_00000001664502602007708480000002974140201123775411_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							display: 'none',
							clipPath: 'url(#SVGID_00000036947482181468571760000018026151734725216131_)',
							fill: '#F0E3FC',
						}}
						d="     M275.9,236.2c0.1-0.6,0.1-1.2,0.1-1.8c0-15.8-17.5-28.6-39.4-29.2c0.6-1.6,1-3.2,1-4.9c0-10-11.3-18.1-25.3-18.1     c-3.5,0-6.8,0.5-9.8,1.4c-3.3-10.7-16.7-18.7-32.6-18.7c-18.5,0-33.4,10.7-33.4,23.9c0,0,0,0,0,0.1c-0.7,0-1.3-0.1-2-0.1     c-13.6,0-24.9,7.1-27,16.4c-1.1-0.1-2.2-0.1-3.4-0.1c-16.8,0-30.3,9.7-30.3,21.7c0,3.4,1.1,6.5,3,9.4L275.9,236.2L275.9,236.2z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000063632112640895157060000001842241596263223486_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000068642338699180484160000015029524001177959854_">
						<use
							xlinkHref="#SVGID_00000063632112640895157060000001842241596263223486_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000177471877967020915320000001530498103170541476_"
						cx="212.75"
						cy="32.3"
						r="72.6722"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							clipPath: 'url(#SVGID_00000068642338699180484160000015029524001177959854_)',
							fill: 'url(#SVGID_00000177471877967020915320000001530498103170541476_)',
						}}
						d="     M308.9,226.3c0-11.9-9.6-21.5-21.5-21.5c-2.2,0-4.3,0.3-6.3,1c-3.6-11.6-14.4-20-27.1-20c-7.4,0-14,2.8-19.1,7.4     c-4.6-11.6-16-19.8-29.2-19.8c-13.5,0-25,8.5-29.5,20.4c-12.2,0.4-22.1,9.8-23.3,21.7c-1.4-0.3-2.9-0.5-4.4-0.5     c-8.2,0-15.1,5.3-17.6,12.6c-0.6-0.1-1.2-0.2-1.9-0.2c-6.9,0-12.4,5.6-12.4,12.4c0,2.3,0.6,4.4,1.7,6.2h178v-0.1     C303.7,242.5,308.9,235,308.9,226.3z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000100356313963960232590000015903028045410164866_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000074403877887726854320000017983392470320784318_">
						<use
							xlinkHref="#SVGID_00000100356313963960232590000015903028045410164866_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							clipPath: 'url(#SVGID_00000074403877887726854320000017983392470320784318_)',
							fill: '#F0E3FC',
						}}
						d="M307.4,227.6     c0-11.9-9.6-21.5-21.5-21.5c-2.2,0-4.3,0.3-6.3,1c-3.6-11.6-14.4-20-27.1-20c-7.4,0-14,2.8-19.1,7.4c-4.6-11.6-16-19.8-29.2-19.8     c-13.5,0-25,8.5-29.5,20.4c-12.2,0.4-22.1,9.8-23.3,21.7c-1.4-0.3-2.9-0.5-4.4-0.5c-8.2,0-15.1,5.3-17.6,12.6     c-0.6-0.1-1.2-0.2-1.9-0.2c-6.9,0-12.4,5.6-12.4,12.4c0,2.3,0.6,4.4,1.7,6.2h178v-0.1C302.2,243.8,307.4,236.3,307.4,227.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000026876442603572864850000008540552788318943889_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000098919323257675843810000009808057932471462308_">
						<use
							xlinkHref="#SVGID_00000026876442603572864850000008540552788318943889_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<radialGradient
						id="SVGID_00000054966472190796030240000009201105784534568353_"
						cx="145.3493"
						cy="42.6"
						r="72.6727"
						gradientTransform="matrix(1 0 0 -1 0 242)"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset={0} style={{ stopColor: '#652D90' }} />
						<stop offset="0.2315" style={{ stopColor: '#5D2C8A' }} />
						<stop offset="0.5934" style={{ stopColor: '#472879' }} />
						<stop offset={1} style={{ stopColor: '#262261' }} />
					</radialGradient>
					<path
						style={{
							clipPath: 'url(#SVGID_00000098919323257675843810000009808057932471462308_)',
							fill: 'url(#SVGID_00000054966472190796030240000009201105784534568353_)',
						}}
						d="     M61.8,235.6v0.1h178c1.1-1.8,1.7-3.9,1.7-6.2c0-6.9-5.6-12.4-12.4-12.4c-0.6,0-1.3,0.1-1.9,0.2c-2.5-7.3-9.4-12.6-17.6-12.6     c-1.5,0-3,0.2-4.4,0.5c-1.3-11.9-11.2-21.3-23.3-21.7c-4.5-11.9-16-20.4-29.5-20.4c-13.3,0-24.6,8.2-29.2,19.8     c-5-4.6-11.7-7.4-19.1-7.4c-12.8,0-23.5,8.4-27.1,20c-2-0.6-4.1-1-6.3-1c-11.9,0-21.5,9.6-21.5,21.5     C49.1,224.7,54.3,232.2,61.8,235.6z"
					/>
				</g>
				<g>
					<defs>
						<path
							id="SVGID_00000070116026933806641560000015214305612945087644_"
							d="M259.1,213.9c0,2.2-2.3,4-5.2,4H90.5      c-2.9,0-5.2-1.8-5.2-4V21.3c0-2.2,2.3-4,5.2-4h163.4c2.9,0,5.2,1.8,5.2,4V213.9z"
						/>
					</defs>
					<clipPath id="SVGID_00000064334759721226034530000001502323346090349242_">
						<use
							xlinkHref="#SVGID_00000070116026933806641560000015214305612945087644_"
							style={{ overflow: 'visible' }}
						/>
					</clipPath>
					<path
						style={{
							clipPath: 'url(#SVGID_00000064334759721226034530000001502323346090349242_)',
							fill: '#F0E3FC',
						}}
						d="M59.6,237.5v0.1h178     c1.1-1.8,1.7-3.9,1.7-6.2c0-6.9-5.6-12.4-12.4-12.4c-0.6,0-1.3,0.1-1.9,0.2c-2.5-7.3-9.4-12.6-17.6-12.6c-1.5,0-3,0.2-4.4,0.5     c-1.3-11.9-11.2-21.3-23.3-21.7c-4.5-11.9-16-20.4-29.5-20.4c-13.3,0-24.6,8.2-29.2,19.8c-5-4.6-11.7-7.4-19.1-7.4     c-12.8,0-23.5,8.4-27.1,20c-2-0.6-4.1-1-6.3-1c-11.9,0-21.5,9.6-21.5,21.5C47,226.6,52.2,234.1,59.6,237.5z"
					/>
				</g>
			</g>
			<linearGradient
				id="SVGID_00000158731775335847339040000016874825706913258424_"
				gradientUnits="userSpaceOnUse"
				x1="323.3"
				y1="163.95"
				x2="16.4"
				y2="163.95"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000158731775335847339040000016874825706913258424_)',
				}}
				d="M16.4,114.4c0,0,60.6-72.7,156.5-72.7   s150.4,72.7,150.4,72.7s-72.7-55.7-151.1-55.7C93.9,58.7,16.4,114.4,16.4,114.4z"
			/>
			<linearGradient
				id="SVGID_00000120544072886256165710000007104369613713975939_"
				gradientUnits="userSpaceOnUse"
				x1="311.6"
				y1="116.9"
				x2="28.1"
				y2="116.9"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000120544072886256165710000007104369613713975939_)',
				}}
				d="M28.1,158.8c0,0,56-67.4,144.6-67.4   s138.9,67.4,138.9,67.4s-67.1-53.1-139.6-53.1C99.7,105.7,28.1,158.8,28.1,158.8z"
			/>
			<linearGradient
				id="SVGID_00000000220903810881611400000003171512407082279845_"
				gradientUnits="userSpaceOnUse"
				x1="298.9"
				y1="79.4"
				x2="40.9"
				y2="79.4"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000000220903810881611400000003171512407082279845_)',
				}}
				d="M40.9,190.8c0,0,50.9-56.4,131.6-56.4   s126.4,56.4,126.4,56.4S235.9,146,170,146S40.9,190.8,40.9,190.8z"
			/>
			<linearGradient
				id="SVGID_00000076581861014547783360000005273743619199920544_"
				gradientUnits="userSpaceOnUse"
				x1="22.5"
				y1="168.5"
				x2="317.4"
				y2="168.5"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000076581861014547783360000005273743619199920544_)',
				}}
				d="M22.5,108.4c0,0,58.2-69.8,150.4-69.8   s144.5,69.8,144.5,69.8S247.5,55,172.2,55S22.5,108.4,22.5,108.4z"
			/>
			<linearGradient
				id="SVGID_00000118390640982573243060000006990520875794201006_"
				gradientUnits="userSpaceOnUse"
				x1="33.7"
				y1="123.25"
				x2="306.1"
				y2="123.25"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000118390640982573243060000006990520875794201006_)',
				}}
				d="M33.7,151.1c0,0,53.8-64.7,138.9-64.7   c85.2,0,133.5,64.7,133.5,64.7s-64.5-51-134.1-51C102.4,100.1,33.7,151.1,33.7,151.1z"
			/>
			<linearGradient
				id="SVGID_00000172427342366094383290000005473911128423917451_"
				gradientUnits="userSpaceOnUse"
				x1="45.9"
				y1="87.3"
				x2="293.8"
				y2="87.3"
				gradientTransform="matrix(1 0 0 -1 0 242)"
			>
				<stop offset={0} style={{ stopColor: '#FFFFFF' }} />
				<stop offset={1} style={{ stopColor: '#231F20' }} />
			</linearGradient>
			<path
				style={{
					fill: 'url(#SVGID_00000172427342366094383290000005473911128423917451_)',
				}}
				d="M45.9,181.8c0,0,48.9-54.2,126.4-54.2   s121.5,54.2,121.5,54.2s-60.5-43-123.8-43C106.7,138.9,45.9,181.8,45.9,181.8z"
			/>
			<g className="st14-DispatcherLogo">
				<path
					className="st15-DispatcherLogo"
					d="M330.6,14.7H368c27.8,0,39.8,20.2,39.8,45.1c0,24.9-12,45.1-39.8,45.1h-37.4V14.7z M346.4,92h15.5    c24.8,0,30.1-14.2,30.1-32.2s-5.3-32.2-30.1-32.2h-15.5V92z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M420.2,14.7h14.4v13.6h-14.4V14.7z M420.2,39.6h14.4v65.3h-14.4V39.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M461.1,83.9c0.8,8.3,7.1,11.4,14.8,11.4c5.4,0,14.9-1.1,14.5-8.6c-0.4-7.6-10.9-8.5-21.4-10.9    c-10.6-2.3-21-6.1-21-19.3c0-14.3,15.4-18.7,27.3-18.7c13.4,0,25.5,5.6,27.3,20.1h-15c-1.3-6.8-7-8.7-13.3-8.7    c-4.2,0-11.9,1-11.9,6.7c0,7.1,10.6,8.1,21.2,10.5c10.5,2.4,21.1,6.2,21.1,19.1c0,15.5-15.7,21.2-29.2,21.2    c-16.4,0-28.7-7.3-28.9-22.8H461.1z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M516.2,39.6h13.6v8.8h0.3c4-7.5,11.9-10.6,20.2-10.6c20.6,0,30.6,15.7,30.6,34.8c0,17.6-8.8,34.1-28.2,34.1    c-8.3,0-17.3-3-21.9-10.2h-0.3V129h-14.4V39.6z M548.5,49.2c-12.1,0-18.3,9.2-18.3,23.1c0,13.1,6.7,23,18.3,23    c13.1,0,18.1-11.6,18.1-23C566.5,60.4,560.3,49.2,548.5,49.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M647.8,90.4c0,3.5,0.8,4.9,3.4,4.9c0.9,0,2,0,3.5-0.3v10c-2.1,0.8-6.7,1.6-9.1,1.6c-5.8,0-10-2-11.1-8    c-5.7,5.6-14.9,8-22.6,8c-11.8,0-22.4-6.3-22.4-19.1c0-16.3,13-19,25.2-20.3c10.4-1.9,19.6-0.8,19.6-9.2c0-7.5-7.7-8.8-13.5-8.8    c-8.1,0-13.8,3.3-14.4,10.4h-14.4c1-16.8,15.3-21.7,29.7-21.7c12.8,0,26.2,5.2,26.2,19V90.4z M633.4,72.2    c-4.4,2.9-11.4,2.8-17.7,3.9c-6.2,1-11.8,3.3-11.8,10.9c0,6.4,8.2,8.3,13.3,8.3c6.3,0,16.2-3.3,16.2-12.4V72.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M656.8,39.6h10.9V20h14.4v19.6h13v10.7h-13v34.9c0,5.9,0.5,9,7,9c2,0,4,0,6.1-0.5v11.1    c-3.2,0.3-6.2,0.8-9.4,0.8c-15,0-17.8-5.8-18.1-16.7V50.3h-10.9V39.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M749.5,61.4c-1.1-8-7-12.3-14.9-12.3c-7.5,0-17.9,3.9-17.9,23.8c0,10.9,4.8,22.4,17.3,22.4    c8.3,0,14.2-5.6,15.5-14.9H764c-2.7,16.9-13.1,26.3-30,26.3c-20.5,0-31.7-14.5-31.7-33.7c0-19.7,10.7-35.1,32.2-35.1    c15.2,0,28.1,7.6,29.4,23.6H749.5z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M775.7,14.7h14.4v33.5h0.3c3.5-5.9,11-10.4,19.6-10.4c14.2,0,23.1,7.6,23.1,22.2v44.9h-14.4V63.8    c-0.3-10.2-4.3-14.7-12.8-14.7c-9.6,0-15.8,7.6-15.8,17.2v38.5h-14.4V14.7z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M859.5,76c0,10.2,5.6,19.3,17.6,19.3c8.3,0,13.4-3.7,15.9-10.9h13.6c-3.2,14.3-15.3,22.2-29.6,22.2    c-20.5,0-32-14.3-32-34.4c0-18.6,12.1-34.5,31.6-34.5c20.6,0,33.2,18.6,30.8,38.2H859.5z M893.1,66.5c-0.5-9.1-6.7-17.3-16.4-17.3    c-10,0-16.8,7.6-17.2,17.3H893.1z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M918.5,39.6H932v12.6h0.3c1.6-7,10.2-14.4,19.1-14.4c3.3,0,4.2,0.3,5.4,0.4v13.9c-2-0.3-4.2-0.6-6.2-0.6    c-9.9,0-17.7,8-17.7,22.4v31.1h-14.4V39.6z"
				/>
			</g>
			<g className="st14-DispatcherLogo">
				<path
					className="st15-DispatcherLogo"
					d="M578.3,155c-0.1-15-7.8-19.8-22-19.8c-10.2,0-21.2,4.9-21.2,17.2c0,9.1,7,12,14,14.2l8.8,2.8    c11.4,3.6,22.3,7.4,22.3,21.8c0,8.4-5.1,26.4-32.1,26.4c-18.6,0-32.2-9.2-31.3-30h7.9c-0.8,16.7,8.8,23,24,23    c10.8,0,23.6-5.5,23.6-18.4c0-12.1-11.4-14.3-20.6-17l-8.1-2.5c-9.7-2.9-16.4-8.9-16.4-19.9c0-17.2,14.7-24.5,29.4-24.5    c16.9,0,30.5,7,29.6,26.8H578.3z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M638.2,173.1c0.6-9.2-5.8-14.8-14.4-14.8c-17.6,0-26,17.5-26,33.6c0,11,5.4,19.2,16.8,19.2    c9.7,0,16.6-6.5,19.8-15.5h7.3c-4.4,14.2-13.5,21.8-28.1,21.8c-14.9,0-23.2-10.3-23.2-25.6c0-19.3,12-40,32.6-40    c13,0,22.9,6.7,22.5,21.1H638.2z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M656.5,172.3c2-14,12.5-20.3,25.4-20.3c8.1,0,20.8,2.9,20.8,13.8c0,6-2.6,15.4-3.7,20.9    c-2.7,13.9-4,17.2-4,20.9c0,2.2,2.1,2.5,3.8,2.5c1,0,1.9-0.1,2.9-0.2l-1,6c-1.6,0.4-4.1,0.6-6.1,0.6c-4.1,0-6.3-2.6-6.4-6.7    c0-1.1,0.1-2.3,0.2-3.4l-0.2-0.2c-4.2,7.2-12.5,11.4-20.8,11.4c-10.9,0-19.2-5-19.2-17.2c0-13.1,10.1-17.3,20.8-19.2    c7.7-1.2,14.4-0.6,19.1-1.8c4.8-1.2,7.2-4,7.2-12.1c0-7.3-7.1-8.9-12.7-8.9c-9.3,0-17.3,3.6-18.9,13.9H656.5z M692.8,182.6    l-0.2-0.2c-2.3,3-9.5,3.2-13.3,3.5c-9,0.7-23.7,1.2-23.7,14.2c0,7.9,6.4,11.2,13.4,11.2c11.8,0,19.2-7.3,21.5-18.1L692.8,182.6z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M721.3,153.8h6.8l-2.1,11.3h0.2c4.5-7.3,12.5-13.1,21.4-13.1c10.5,0,18.2,4.8,18.2,16.7    c0,1.9-0.3,4.4-0.9,7.3l-8.3,39.7h-7.3l8.4-40c0.5-1.9,0.8-4.2,0.8-6.2c0-8.2-6.1-11.2-12.6-11.2c-10.6,0-20.3,9.8-23.5,25.6    l-6.6,31.8h-7.3L721.3,153.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M781.6,130h64.9l-1.4,7h-28.5L800,215.7h-7.9l16.6-78.7h-28.5L781.6,130z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M837.8,153.8h6.6l-3,14.3h0.2c4.7-8.9,11.1-15.2,21.8-15.1c1.3,0,2.7,0,4,0.1l-1.6,7.6    c-1.4,0-2.8-0.1-4.2-0.1c-13.2,0.2-20.1,11.2-22.6,22.8l-6.8,32.4h-7.3L837.8,153.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M874.5,153.8h7.3l-12.9,61.9h-7.3L874.5,153.8z M879.5,130h7.3l-2.6,12.1h-7.3L879.5,130z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M896.7,153.8h6.6l-2.3,11.2h0.2c5.1-8.2,11.3-13,21.9-13c15.4,0,22.8,10.2,22.8,25.3    c0,19-12.7,40.2-32.8,40.2c-9.4,0-17.6-4.1-19.2-14.2h-0.2l-7.3,35.3H879L896.7,153.8z M896.3,193.3c0,10.8,6.1,17.9,16.8,17.9    c16.9,0,25.6-19.2,25.6-34.3c0-10.6-5.1-18.5-16.2-18.5C905.6,158.3,896.3,177.9,896.3,193.3z"
				/>
			</g>
		</g>
		<g id="Layer_6">
			<rect x={974} y="110.9" className="st16-DispatcherLogo" width="408.6" height="128.2" />
			<g>
				<path
					className="st17-DispatcherLogo"
					d="M870,129.3c22.1,0,36.7,15.2,36.7,36.7c0,35.3-22,51.3-44.5,51.3c-24,0-37.3-15.9-37.3-36.7    C824.9,145.3,848.1,129.3,870,129.3z M862.7,205.4c19.4,0,29.3-20.1,29.3-38.9c0-15.7-7.8-25.2-22.5-25.2    c-20,0-29.9,20.1-29.9,38.9C839.6,195.8,847.9,205.4,862.7,205.4z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1078.1,159.3c0-11.8-6.9-18-19-18c-20,0-29.9,20.1-29.9,38.9c0,15.7,8.4,25.2,23.1,25.2    c15.2,0,20.1-13.5,21.8-19.3h14.7c-4.8,21.2-19.4,31.3-37,31.3c-24,0-37.3-15.9-37.3-36.7c0-35.3,23.2-51.3,45.1-51.3    c19.9,0,33.8,10.7,33.2,30h-14.7V159.3z"
				/>
				<path className="st15-DispatcherLogo" d="M1111.9,131.3h13.4l-17.4,84.1h-13.4L1111.9,131.3z" />
				<path
					className="st15-DispatcherLogo"
					d="M1125.7,190.4c0-20,13.8-37.6,34.7-37.6c16.7,0,26.6,9.2,26.6,26.1c0,21.3-13.1,38-34.7,38    C1135.6,217,1125.7,207.4,1125.7,190.4z M1139.1,190.8c0,8.9,4.2,15.7,14,15.7c13.8,0,20.5-15,20.5-27.3c0-8.9-4.2-15.7-14-15.7    C1145.8,163.5,1139.1,178.6,1139.1,190.8z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1245.8,215.4h-12.6l1.9-8.8l-0.2-0.2c-4.8,6.7-12.6,10.7-21,10.7c-12.2,0-17.8-6.4-17.8-16.1    c0-2.2,0.1-5.4,0.6-7.5l8.1-38.9h13.4l-7.8,37.6c-0.5,2-0.9,4-0.9,5.7c0,2-0.6,8.7,9.3,8.7c10.4,0,17.4-9.9,19.3-19l6.8-33h13.4    L1245.8,215.4z"
				/>
				<path
					className="st15-DispatcherLogo"
					d="M1316.8,215.4H1304l1.9-8.2l-0.2-0.2c-5.3,7.9-11.9,10.1-19.1,10.1c-6.9,0-23.7-2.1-23.7-25    c0-19.7,12.1-39.2,33.1-39.2c8.1,0,15.2,2.6,18.4,10h0.2l6.7-31.6h13.4L1316.8,215.4z M1297.6,163.5c-15,0-21.3,15-21.3,28.6    c0,9.1,4.7,14.4,13.9,14.4c13.8,0,20.8-16.1,20.8-28.4C1311,170,1307.1,163.5,1297.6,163.5z"
				/>
			</g>
			<line className="st18-DispatcherLogo" x1="1287.8" y1="238.1" x2="570.2" y2="238.1" />
		</g>
	</SvgIcon>
);

export const EnterpriseLogo = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 976 241.8" {...props}>
		<linearGradient
			id="SVGID_1_"
			x1="174.129"
			x2="170.37"
			y1="232.079"
			y2="16.721"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#652D90" />
			<stop offset="1" stopColor="#262261" />
		</linearGradient>
		<path
			fill="url(#SVGID_1_)"
			d="M264.2 219.6c0 2.3-2.5 4.2-5.5 4.2h-173c-3 0-5.5-1.9-5.5-4.2v-204c0-2.3 2.5-4.2 5.5-4.2h173.1c3 0 5.5 1.9 5.5 4.2l-.1 204z"
		/>
		<radialGradient
			id="SVGID_00000044867621217590515610000007539254232463081375_"
			cx="157.102"
			cy="141.681"
			r="139.543"
			fx="86.534"
			fy="47.657"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#652D90" />
			<stop offset="0.232" stopColor="#5D2C8A" />
			<stop offset="0.593" stopColor="#472879" />
			<stop offset="1" stopColor="#262261" />
		</radialGradient>
		<path
			fill="url(#SVGID_00000044867621217590515610000007539254232463081375_)"
			d="M259.1 213.9c0 2.2-2.3 4-5.2 4H90.5c-2.9 0-5.2-1.8-5.2-4V21.3c0-2.2 2.3-4 5.2-4h163.4c2.9 0 5.2 1.8 5.2 4v192.6z"
		/>
		<linearGradient
			id="SVGID_00000180338547123919905580000006638438823608830385_"
			x1="323.3"
			x2="16.4"
			y1="163.95"
			y2="163.95"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000180338547123919905580000006638438823608830385_)"
			d="M16.4 114.4S77 41.7 172.9 41.7s150.4 72.7 150.4 72.7-72.7-55.7-151.1-55.7c-78.3 0-155.8 55.7-155.8 55.7z"
		/>
		<linearGradient
			id="SVGID_00000115496975107213465920000017461114203528088730_"
			x1="311.6"
			x2="28.1"
			y1="116.9"
			y2="116.9"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000115496975107213465920000017461114203528088730_)"
			d="M28.1 158.8s56-67.4 144.6-67.4 138.9 67.4 138.9 67.4-67.1-53.1-139.6-53.1c-72.3 0-143.9 53.1-143.9 53.1z"
		/>
		<linearGradient
			id="SVGID_00000042728904086291139350000006740508432388759720_"
			x1="298.9"
			x2="40.9"
			y1="79.4"
			y2="79.4"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000042728904086291139350000006740508432388759720_)"
			d="M40.9 190.8s50.9-56.4 131.6-56.4 126.4 56.4 126.4 56.4S235.9 146 170 146 40.9 190.8 40.9 190.8z"
		/>
		<linearGradient
			id="SVGID_00000107582082218647554340000007826131576691228848_"
			x1="22.5"
			x2="317.4"
			y1="168.5"
			y2="168.5"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000107582082218647554340000007826131576691228848_)"
			d="M22.5 108.4s58.2-69.8 150.4-69.8 144.5 69.8 144.5 69.8S247.5 55 172.2 55 22.5 108.4 22.5 108.4z"
		/>
		<linearGradient
			id="SVGID_00000070102584321948264040000003837661530533234621_"
			x1="33.7"
			x2="306.1"
			y1="123.25"
			y2="123.25"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000070102584321948264040000003837661530533234621_)"
			d="M33.7 151.1s53.8-64.7 138.9-64.7c85.2 0 133.5 64.7 133.5 64.7s-64.5-51-134.1-51-138.3 51-138.3 51z"
		/>
		<linearGradient
			id="SVGID_00000011730519720946581670000015713484023938053793_"
			x1="45.9"
			x2="293.8"
			y1="87.3"
			y2="87.3"
			gradientTransform="matrix(1 0 0 -1 0 242)"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset="0" stopColor="#FFF" />
			<stop offset="1" stopColor="#231F20" />
		</linearGradient>
		<path
			fill="url(#SVGID_00000011730519720946581670000015713484023938053793_)"
			d="M45.9 181.8s48.9-54.2 126.4-54.2 121.5 54.2 121.5 54.2-60.5-43-123.8-43c-63.3.1-124.1 43-124.1 43z"
		/>
		<g fill="currentColor">
			<path d="M330.6 14.7H368c27.8 0 39.8 20.2 39.8 45.1 0 24.9-12 45.1-39.8 45.1h-37.4V14.7zM346.4 92h15.5c24.8 0 30.1-14.2 30.1-32.2s-5.3-32.2-30.1-32.2h-15.5V92zM420.2 14.7h14.4v13.6h-14.4V14.7zm0 24.9h14.4v65.3h-14.4V39.6zM461.1 83.9c.8 8.3 7.1 11.4 14.8 11.4 5.4 0 14.9-1.1 14.5-8.6-.4-7.6-10.9-8.5-21.4-10.9-10.6-2.3-21-6.1-21-19.3 0-14.3 15.4-18.7 27.3-18.7 13.4 0 25.5 5.6 27.3 20.1h-15c-1.3-6.8-7-8.7-13.3-8.7-4.2 0-11.9 1-11.9 6.7 0 7.1 10.6 8.1 21.2 10.5 10.5 2.4 21.1 6.2 21.1 19.1 0 15.5-15.7 21.2-29.2 21.2-16.4 0-28.7-7.3-28.9-22.8h14.5zM516.2 39.6h13.6v8.8h.3c4-7.5 11.9-10.6 20.2-10.6 20.6 0 30.6 15.7 30.6 34.8 0 17.6-8.8 34.1-28.2 34.1-8.3 0-17.3-3-21.9-10.2h-.3V129h-14.4V39.6zm32.3 9.6c-12.1 0-18.3 9.2-18.3 23.1 0 13.1 6.7 23 18.3 23 13.1 0 18.1-11.6 18.1-23-.1-11.9-6.3-23.1-18.1-23.1zM647.8 90.4c0 3.5.8 4.9 3.4 4.9.9 0 2 0 3.5-.3v10c-2.1.8-6.7 1.6-9.1 1.6-5.8 0-10-2-11.1-8-5.7 5.6-14.9 8-22.6 8-11.8 0-22.4-6.3-22.4-19.1 0-16.3 13-19 25.2-20.3 10.4-1.9 19.6-.8 19.6-9.2 0-7.5-7.7-8.8-13.5-8.8-8.1 0-13.8 3.3-14.4 10.4H592c1-16.8 15.3-21.7 29.7-21.7 12.8 0 26.2 5.2 26.2 19v33.5zm-14.4-18.2c-4.4 2.9-11.4 2.8-17.7 3.9-6.2 1-11.8 3.3-11.8 10.9 0 6.4 8.2 8.3 13.3 8.3 6.3 0 16.2-3.3 16.2-12.4V72.2zM656.8 39.6h10.9V20h14.4v19.6h13v10.7h-13v34.9c0 5.9.5 9 7 9 2 0 4 0 6.1-.5v11.1c-3.2.3-6.2.8-9.4.8-15 0-17.8-5.8-18.1-16.7V50.3h-10.9V39.6zM749.5 61.4c-1.1-8-7-12.3-14.9-12.3-7.5 0-17.9 3.9-17.9 23.8 0 10.9 4.8 22.4 17.3 22.4 8.3 0 14.2-5.6 15.5-14.9H764c-2.7 16.9-13.1 26.3-30 26.3-20.5 0-31.7-14.5-31.7-33.7 0-19.7 10.7-35.1 32.2-35.1 15.2 0 28.1 7.6 29.4 23.6h-14.4zM775.7 14.7h14.4v33.5h.3c3.5-5.9 11-10.4 19.6-10.4 14.2 0 23.1 7.6 23.1 22.2v44.9h-14.4V63.8c-.3-10.2-4.3-14.7-12.8-14.7-9.6 0-15.8 7.6-15.8 17.2v38.5h-14.4V14.7zM859.5 76c0 10.2 5.6 19.3 17.6 19.3 8.3 0 13.4-3.7 15.9-10.9h13.6c-3.2 14.3-15.3 22.2-29.6 22.2-20.5 0-32-14.3-32-34.4 0-18.6 12.1-34.5 31.6-34.5 20.6 0 33.2 18.6 30.8 38.2h-47.9zm33.6-9.5c-.5-9.1-6.7-17.3-16.4-17.3-10 0-16.8 7.6-17.2 17.3h33.6zM918.5 39.6H932v12.6h.3c1.6-7 10.2-14.4 19.1-14.4 3.3 0 4.2.3 5.4.4v13.9c-2-.3-4.2-.6-6.2-.6-9.9 0-17.7 8-17.7 22.4V105h-14.4V39.6z" />
		</g>
		<g fill="currentColor">
			<path d="M666.8 155c-.1-15-7.8-19.8-22-19.8-10.2 0-21.2 4.9-21.2 17.2 0 9.1 7 12 14 14.2l8.8 2.8c11.4 3.6 22.3 7.4 22.3 21.8 0 8.4-5.1 26.4-32.1 26.4-18.6 0-32.2-9.2-31.3-30h7.9c-.8 16.7 8.8 23 24 23 10.8 0 23.6-5.5 23.6-18.4 0-12.1-11.4-14.3-20.6-17l-8.1-2.5c-9.7-2.9-16.4-8.9-16.4-19.9 0-17.2 14.7-24.5 29.4-24.5 16.9 0 30.5 7 29.6 26.8h-7.9zM682.4 153.8h10.8l3.8-18.7h7.3l-3.8 18.7h12l-1.2 6.4h-12.2l-8.3 39.7c-.6 2.9-.8 4-.8 5.9 0 2.2 1 4.3 3.8 4.3 2.9 0 5.7-.2 8.6-.7l-1.3 6.6c-2.4.2-5 .5-7.4.5-5.5 0-11.1-1.4-11.1-8.9 0-1.3.2-3.6.8-6.4l8.3-41H681l1.4-6.4zM723.5 153.8h6.6l-3 14.3h.2c4.7-8.9 11.1-15.2 21.8-15.1 1.3 0 2.7 0 4 .1l-1.6 7.6c-1.4 0-2.8-.1-4.2-.1-13.2.2-20.1 11.2-22.6 22.8l-6.8 32.4h-7.3l12.9-62zM755.8 172.3c2-14 12.5-20.3 25.4-20.3 8.1 0 20.8 2.9 20.8 13.8 0 6-2.6 15.4-3.7 20.9-2.7 13.9-4 17.2-4 20.9 0 2.2 2.1 2.5 3.8 2.5 1 0 1.9-.1 2.9-.2l-1 6c-1.6.4-4.1.6-6.1.6-4.1 0-6.3-2.6-6.4-6.7 0-1.1.1-2.3.2-3.4l-.2-.2c-4.2 7.2-12.5 11.4-20.8 11.4-10.9 0-19.2-5-19.2-17.2 0-13.1 10.1-17.3 20.8-19.2 7.7-1.2 14.4-.6 19.1-1.8 4.8-1.2 7.2-4 7.2-12.1 0-7.3-7.1-8.9-12.7-8.9-9.3 0-17.3 3.6-18.9 13.9h-7.2zm36.3 10.3l-.2-.2c-2.3 3-9.5 3.2-13.3 3.5-9 .7-23.7 1.2-23.7 14.2 0 7.9 6.4 11.2 13.4 11.2 11.8 0 19.2-7.3 21.5-18.1l2.3-10.6zM814 153.8h10.8l3.8-18.7h7.3l-3.8 18.7h12l-1.2 6.4h-12.2l-8.3 39.7c-.6 2.9-.8 4-.8 5.9 0 2.2 1 4.3 3.8 4.3 2.9 0 5.7-.2 8.6-.7l-1.3 6.6c-2.4.2-5 .5-7.4.5-5.5 0-11.1-1.4-11.1-8.9 0-1.3.2-3.6.8-6.4l8.3-41h-10.8l1.5-6.4zM890.2 215.7h-6.8l2.1-11.3h-.2c-4.5 7.3-12.5 13.1-21.4 13.1-10.5 0-18.2-4.8-18.2-16.7 0-1.9.3-4.4.9-7.3l8.3-39.7h7.3l-8.4 40c-.5 1.9-.8 4.2-.8 6.2 0 8.2 6.1 11.2 12.6 11.2 10.6 0 20.3-9.8 23.5-25.6l6.6-31.8h7.3l-12.8 61.9zM913.1 195.5c-.1 12 8.5 15.6 17 15.6 6.5 0 15.1-3.5 15.1-11.4 0-8-8.3-10.6-16.2-13.7-8-3.2-16.1-7-16.1-17.2 0-12 12.6-16.9 22.2-16.9 12.6 0 21.6 5.6 21.4 19.9h-7.3c.6-9.5-5.8-13.6-14.1-13.6-6.4 0-14.9 2-14.9 10.6 0 5.8 5.9 8.6 12.7 11.4 8.3 3.4 19.6 6.8 19.6 18.2 0 13.9-12.8 19-24.2 19-11.5 0-23.3-6.5-22.6-22h7.4z" />
		</g>
		<g>
			<defs>
				<path
					id="SVGID_00000077299778435145290620000009785151112440614297_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath>
				<use overflow="visible" xlinkHref="#SVGID_00000077299778435145290620000009785151112440614297_" />
			</clipPath>
			<radialGradient
				cx="176.9"
				cy="44.05"
				r="75.803"
				gradientTransform="matrix(1 0 0 -1 0 242)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#652D90" />
				<stop offset="0.232" stopColor="#5D2C8A" />
				<stop offset="0.593" stopColor="#472879" />
				<stop offset="1" stopColor="#262261" />
			</radialGradient>
			<defs>
				<path
					id="SVGID_00000169541521165433195990000017580546638327539077_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath>
				<use overflow="visible" xlinkHref="#SVGID_00000169541521165433195990000017580546638327539077_" />
			</clipPath>
			<defs>
				<path
					id="SVGID_00000137854696551782938230000003212650779968310930_"
					d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
				/>
			</defs>
			<clipPath id="SVGID_00000130638750412591470650000012460507851406900891_">
				<use overflow="visible" xlinkHref="#SVGID_00000137854696551782938230000003212650779968310930_" />
			</clipPath>
			<radialGradient
				id="SVGID_00000142890061831351477130000000448148074455887509_"
				cx="212.75"
				cy="33.3"
				r="72.672"
				gradientTransform="matrix(1 0 0 -1 0 242)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#652D90" />
				<stop offset="0.232" stopColor="#5D2C8A" />
				<stop offset="0.593" stopColor="#472879" />
				<stop offset="1" stopColor="#262261" />
			</radialGradient>
			<path
				fill="url(#SVGID_00000142890061831351477130000000448148074455887509_)"
				d="M308.9 225.3c0-11.9-9.6-21.5-21.5-21.5-2.2 0-4.3.3-6.3 1-3.6-11.6-14.4-20-27.1-20-7.4 0-14 2.8-19.1 7.4-4.6-11.6-16-19.8-29.2-19.8-13.5 0-25 8.5-29.5 20.4-12.2.4-22.1 9.8-23.3 21.7-1.4-.3-2.9-.5-4.4-.5-8.2 0-15.1 5.3-17.6 12.6-.6-.1-1.2-.2-1.9-.2-6.9 0-12.4 5.6-12.4 12.4 0 2.3.6 4.4 1.7 6.2h178v-.1c7.4-3.4 12.6-10.9 12.6-19.6z"
				clipPath="url(#SVGID_00000130638750412591470650000012460507851406900891_)"
			/>
			<g>
				<defs>
					<path
						id="SVGID_00000108289202153189116670000012143909518394247585_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000163030627674340773890000013090708013523077552_">
					<use overflow="visible" xlinkHref="#SVGID_00000108289202153189116670000012143909518394247585_" />
				</clipPath>
				<path
					fill="#F0E3FC"
					d="M307.5 226.6c0-11.9-9.6-21.5-21.5-21.5-2.2 0-4.3.3-6.3 1-3.6-11.6-14.4-20-27.1-20-7.4 0-14 2.8-19.1 7.4-4.6-11.6-16-19.8-29.2-19.8-13.5 0-25 8.5-29.5 20.4-12.2.4-22.1 9.8-23.3 21.7-1.4-.3-2.9-.5-4.4-.5-8.2 0-15.1 5.3-17.6 12.6-.6-.1-1.2-.2-1.9-.2-6.9 0-12.4 5.6-12.4 12.4 0 2.3.6 4.4 1.7 6.2h178v-.1c7.4-3.4 12.6-10.9 12.6-19.6z"
					clipPath="url(#SVGID_00000163030627674340773890000013090708013523077552_)"
				/>
			</g>
			<g>
				<defs>
					<path
						id="SVGID_00000002354032302746218140000013774416712513780634_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000015313719685158652840000017337947964771246527_">
					<use overflow="visible" xlinkHref="#SVGID_00000002354032302746218140000013774416712513780634_" />
				</clipPath>
				<radialGradient
					id="SVGID_00000150094893712890088820000016125505892426926484_"
					cx="145.35"
					cy="43.6"
					r="72.672"
					gradientTransform="matrix(1 0 0 -1 0 242)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stopColor="#652D90" />
					<stop offset="0.232" stopColor="#5D2C8A" />
					<stop offset="0.593" stopColor="#472879" />
					<stop offset="1" stopColor="#262261" />
				</radialGradient>
				<path
					fill="url(#SVGID_00000150094893712890088820000016125505892426926484_)"
					d="M61.8 234.6v.1h178c1.1-1.8 1.7-3.9 1.7-6.2 0-6.9-5.6-12.4-12.4-12.4-.6 0-1.3.1-1.9.2-2.5-7.3-9.4-12.6-17.6-12.6-1.5 0-3 .2-4.4.5-1.3-11.9-11.2-21.3-23.3-21.7-4.5-11.9-16-20.4-29.5-20.4-13.3 0-24.6 8.2-29.2 19.8-5-4.6-11.7-7.4-19.1-7.4-12.8 0-23.5 8.4-27.1 20-2-.6-4.1-1-6.3-1-11.9 0-21.5 9.6-21.5 21.5 0 8.7 5.2 16.2 12.6 19.6z"
					clipPath="url(#SVGID_00000015313719685158652840000017337947964771246527_)"
				/>
			</g>
			<g>
				<defs>
					<path
						id="SVGID_00000057113606027203086730000004364511563572098468_"
						d="M259.2 212.9c0 2.2-2.3 4-5.2 4H90.6c-2.9 0-5.2-1.8-5.2-4V20.2c0-2.2 2.3-4 5.2-4H254c2.9 0 5.2 1.8 5.2 4v192.7z"
					/>
				</defs>
				<clipPath id="SVGID_00000124858318944601487760000003660471649870897552_">
					<use overflow="visible" xlinkHref="#SVGID_00000057113606027203086730000004364511563572098468_" />
				</clipPath>
				<path
					fill="#F0E3FC"
					d="M59.7 236.5v.1h178c1.1-1.8 1.7-3.9 1.7-6.2 0-6.9-5.6-12.4-12.4-12.4-.6 0-1.3.1-1.9.2-2.5-7.3-9.4-12.6-17.6-12.6-1.5 0-3 .2-4.4.5-1.3-11.9-11.2-21.3-23.3-21.7-4.5-11.9-16-20.4-29.5-20.4-13.3 0-24.6 8.2-29.2 19.8-5-4.6-11.7-7.4-19.1-7.4-12.8 0-23.5 8.4-27.1 20-2-.6-4.1-1-6.3-1-11.9 0-21.5 9.6-21.5 21.5 0 8.7 5.2 16.2 12.6 19.6z"
					clipPath="url(#SVGID_00000124858318944601487760000003660471649870897552_)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PieChartIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Component_44_6" data-name="Component 44 – 6" transform="translate(2 3)">
			<g id="pie_chart_black_24dp" transform="translate(-2 -3)">
				<path id="Path_6182" data-name="Path 6182" d="M0,0H20V20H0Z" fill="none" />
				<path
					id="Path_6183"
					data-name="Path 6183"
					d="M10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm6.344,7.2H10.8V3.656A6.4,6.4,0,0,1,16.344,9.2ZM3.6,10A6.4,6.4,0,0,1,9.2,3.656V16.344A6.4,6.4,0,0,1,3.6,10Zm7.2,6.344V10.8h5.544A6.4,6.4,0,0,1,10.8,16.344Z"
					fill="#7d61bc"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const MFPIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 14.676 21.242">
		<path
			id="Union_98"
			data-name="Union 98"
			d="M15713.879,21928.242a.621.621,0,0,1-.562-.348h-4.865a.621.621,0,0,1-.562.348h-1.2a.621.621,0,0,1-.562-.348h-.011a1.123,1.123,0,0,1-1.123-1.121v-10.365l-2.675-1.137a.527.527,0,1,1,.413-.969l2.262.961v-1.236a.627.627,0,0,1,.628-.627h10.429a.625.625,0,0,1,.621.627v12.746a1.129,1.129,0,0,1-1.034,1.121.621.621,0,0,1-.556.348Zm-7.634-1.6h9.18v-12h-9.18Zm-.621-13.682a.627.627,0,0,1-.628-.621v-3.605a1.125,1.125,0,0,1,1.123-1.123h3.5a1.126,1.126,0,0,1,1.063.762l4.727-1.355a.524.524,0,1,1,.286,1.008l-3.718,1.066h3.569a1.127,1.127,0,0,1,1.122,1.123v2.125a.625.625,0,0,1-.621.621Zm.621-1.25h9.18v-1.369h-5.3a.626.626,0,0,1-.622-.627v-.854h-3.253Z"
			transform="translate(-15701.998 -21907)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const MFPIconFilled = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<rect width="26" height="26" fill="none" />
		<path
			d="M11.982,21.429a.63.63,0,0,1-.562-.347H6.507a.631.631,0,0,1-.563.347H4.729a.633.633,0,0,1-.563-.347H4.157a1.137,1.137,0,0,1-1.136-1.135V9.489L.323,8.344a.531.531,0,0,1,.416-.977l2.282.969V7.087a.631.631,0,0,1,.631-.631H14.174a.631.631,0,0,1,.631.631V19.948a1.137,1.137,0,0,1-1.043,1.131.63.63,0,0,1-.565.35ZM3.652,6.018a.631.631,0,0,1-.631-.631V1.752A1.137,1.137,0,0,1,4.157.617H7.69a1.137,1.137,0,0,1,1.075.77L13.531.021a.529.529,0,0,1,.292,1.016L10.076,2.111h3.594a1.137,1.137,0,0,1,1.136,1.136v2.14a.631.631,0,0,1-.631.631Z"
			transform="translate(3.665 2.286)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const TonerIconFull = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_168"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_167"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="currentColor"
						/>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<circle
							id="Ellipse_171"
							data-name="Ellipse 171"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(6.84 0)"
							fill="currentColor"
						/>
						<circle
							id="Ellipse_170"
							data-name="Ellipse 170"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="currentColor"
						/>
					</g>
				</g>
				<circle
					id="Ellipse_172"
					data-name="Ellipse 172"
					cx="3.044"
					cy="3.044"
					r="3.044"
					transform="translate(7.001)"
					fill="currentColor"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const TonerIconLow = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9997" data-name="Group 9997" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_168"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_167"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="#f9971c"
						/>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#fa971e"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#fa971e"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#fa971e"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774-2" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995-2" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993-2" data-name="Group 9993" transform="translate(0 6.395)">
						<circle
							id="Ellipse_169-2"
							data-name="Ellipse 169"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(14.003 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_168-2"
							data-name="Ellipse 168"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(7.001 0)"
							fill="#f9971c"
						/>
						<circle
							id="Ellipse_167-2"
							data-name="Ellipse 167"
							cx="3.044"
							cy="3.044"
							r="3.044"
							transform="translate(0 0)"
							fill="#f9971c"
						/>
					</g>
					<g id="Group_9994-2" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171-2"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#fa971c"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170-2"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#fa971c"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172-2"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#fa971c"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const TonerIconEmpty = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="bounding-box" width="24" height="24" fill="none" />
		<g id="Group_9998" data-name="Group 9998" transform="translate(0 0.004)">
			<g id="Group_9774" data-name="Group 9774" transform="translate(1.955 2.714)">
				<g id="Group_9995" data-name="Group 9995" transform="translate(0 6.089)">
					<g id="Group_9993" data-name="Group 9993" transform="translate(0 6.395)">
						<g
							id="Ellipse_169"
							data-name="Ellipse 169"
							transform="translate(14.003 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_168"
							data-name="Ellipse 168"
							transform="translate(7.001 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_167"
							data-name="Ellipse 167"
							transform="translate(0 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
					<g id="Group_9994" data-name="Group 9994" transform="translate(3.653 0)">
						<g
							id="Ellipse_171"
							data-name="Ellipse 171"
							transform="translate(6.84 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
						<g
							id="Ellipse_170"
							data-name="Ellipse 170"
							transform="translate(0 0)"
							fill="none"
							stroke="#cc1f02"
							strokeWidth="1"
						>
							<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
							<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
						</g>
					</g>
				</g>
				<g
					id="Ellipse_172"
					data-name="Ellipse 172"
					transform="translate(7.001)"
					fill="none"
					stroke="#cc1f02"
					strokeWidth="1"
				>
					<circle cx="3.044" cy="3.044" r="3.044" stroke="none" />
					<circle cx="3.044" cy="3.044" r="2.544" fill="none" />
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayFullIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#1a5395"
			/>
			<g transform="translate(4.044 0)">
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 206)" fill="#1a5395" />
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 202.5)" fill="#1a5395" />
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 199)" fill="#1a5395" />
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayLowIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#f9971c"
			/>
			<g transform="translate(4.044 0)">
				<path d="M240-198.144V-200h13.181v2.2Z" transform="translate(-240 206)" fill="#f9971c" />
			</g>
		</g>
	</SvgIcon>
);

export const PaperTrayEmptyIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(1.324 6.135)">
			<path
				d="M162.669-475.126a2.57,2.57,0,0,1-1.885-.784,2.57,2.57,0,0,1-.784-1.885V-486h2.669v8.206h16.014V-486h2.669v8.206a2.57,2.57,0,0,1-.784,1.885,2.57,2.57,0,0,1-1.885.784Z"
				transform="translate(-160 486.855)"
				fill="#cc1f02"
			/>
		</g>
	</SvgIcon>
);

export const PaperStackMonoIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="62" height="34" viewBox="0 0 62 34" {...props}>
		<g transform="translate(-652 -248.256)">
			<g transform="translate(652 264.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 262.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 260.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 258.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 256.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 254.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 252.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 250.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 248.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
				</g>
			</g>
			<g transform="translate(652 246.506)">
				<g transform="translate(0 1.75)">
					<g fill="#fff">
						<path
							d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
							stroke="none"
						/>
						<path
							d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
							stroke="none"
							fill="#c3c1c1"
						/>
					</g>
					<g transform="translate(11.352 3.137)">
						<g transform="translate(0)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(4.37 1.092)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(8.679 2.185)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(13.109 3.277)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
						<g transform="translate(17.595 4.538)">
							<path
								d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
								transform="translate(3.75 0.947)"
								fill="#282828"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PaperStackColorIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="62" height="34" viewBox="0 0 62 34" {...props}>
		<g id="Group_10533" data-name="Group 10533" transform="translate(0 16.25)">
			<g id="Group_10515" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460" data-name="Group 10460">
					<g id="Group_9985" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987" data-name="Group 9987">
								<g id="Polygon_6" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#8368bf"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10532" data-name="Group 10532" transform="translate(0 14.25)">
			<g id="Group_10515-2" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-2" data-name="Group 10460">
					<g id="Group_9985-2" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-2" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-2" data-name="Group 9987">
								<g id="Polygon_6-2" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10531" data-name="Group 10531" transform="translate(0 12.25)">
			<g id="Group_10515-3" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-3" data-name="Group 10460">
					<g id="Group_9985-3" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-3" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-3" data-name="Group 9987">
								<g id="Polygon_6-3" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10530" data-name="Group 10530" transform="translate(0 10.25)">
			<g id="Group_10515-4" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-4" data-name="Group 10460">
					<g id="Group_9985-4" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-4" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-4" data-name="Group 9987">
								<g id="Polygon_6-4" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10529" data-name="Group 10529" transform="translate(0 8.25)">
			<g id="Group_10515-5" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-5" data-name="Group 10460">
					<g id="Group_9985-5" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-5" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-5" data-name="Group 9987">
								<g id="Polygon_6-5" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#8368bf"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10528" data-name="Group 10528" transform="translate(0 6.25)">
			<g id="Group_10515-6" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-6" data-name="Group 10460">
					<g id="Group_9985-6" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-6" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-6" data-name="Group 9987">
								<g id="Polygon_6-6" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10527" data-name="Group 10527" transform="translate(0 4.25)">
			<g id="Group_10515-7" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-7" data-name="Group 10460">
					<g id="Group_9985-7" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-7" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-7" data-name="Group 9987">
								<g id="Polygon_6-7" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10526" data-name="Group 10526" transform="translate(0 2.25)">
			<g id="Group_10515-8" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-8" data-name="Group 10460">
					<g id="Group_9985-8" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-8" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-8" data-name="Group 9987">
								<g id="Polygon_6-8" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10525" data-name="Group 10525" transform="translate(0 0.25)">
			<g id="Group_10515-9" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-9" data-name="Group 10460">
					<g id="Group_9985-9" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-9" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-9" data-name="Group 9987">
								<g id="Polygon_6-9" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
		<g id="Group_10507" data-name="Group 10507" transform="translate(0 -1.75)">
			<g id="Group_10515-10" data-name="Group 10515" transform="translate(0 1.75)">
				<g id="Group_10460-10" data-name="Group 10460">
					<g id="Group_9985-10" data-name="Group 9985" transform="translate(0 0)">
						<g id="Group_9986-10" data-name="Group 9986" transform="translate(0 0)">
							<g id="Group_9987-10" data-name="Group 9987">
								<g id="Polygon_6-10" data-name="Polygon 6" fill="#fff">
									<path
										d="M 31 15.61271953582764 L 1.500712513923645 8 L 31 0.3872806429862976 L 60.49928665161133 8 L 31 15.61271953582764 Z"
										stroke="none"
									/>
									<path
										d="M 31 0.7745742797851562 L 3.001472473144531 8 L 31 15.22542572021484 L 58.99852752685547 8 L 31 0.7745742797851562 M 31 0 L 62 8 L 31 16 L 0 8 L 31 0 Z"
										stroke="none"
										fill="#7d61bc"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
				<g id="Group_10467" data-name="Group 10467" transform="translate(11.352 3.137)">
					<g id="Group_10462" data-name="Group 10462" transform="translate(0)">
						<path
							id="Line_593"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#de11eb"
						/>
					</g>
					<g id="Group_10463" data-name="Group 10463" transform="translate(4.37 1.092)">
						<path
							id="Line_593-2"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#10b2ec"
						/>
					</g>
					<g id="Group_10464" data-name="Group 10464" transform="translate(8.679 2.185)">
						<path
							id="Line_593-3"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#ecd611"
						/>
					</g>
					<g id="Group_10465" data-name="Group 10465" transform="translate(13.109 3.277)">
						<path
							id="Line_593-4"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#37f016"
						/>
					</g>
					<g id="Group_10466" data-name="Group 10466" transform="translate(17.595 4.538)">
						<path
							id="Line_593-5"
							data-name="Line 593"
							d="M-2.032,4.853-3.75,4.411l20.3-5.359,1.669.47Z"
							transform="translate(3.75 0.947)"
							fill="#ef7913"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const LongFeedPaperDirectionIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="38.365" height="47.001" viewBox="0 0 38.365 47.001" {...props}>
		<defs>
			<filter id="Rectangle_2305" x="0" y="0" width="38.365" height="47.001" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="portrait-lef-icon-paper-trays" transform="translate(4.5 3.5)">
			<g transform="matrix(1, 0, 0, 1, -4.5, -3.5)" filter="url(#Rectangle_2305)">
				<g
					id="Rectangle_2305-2"
					data-name="Rectangle 2305"
					transform="translate(4.5 3.5)"
					fill="#fff"
					stroke="#262626"
					strokeWidth="0.5"
				>
					<rect width="29.365" height="38.001" stroke="none" />
					<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
				</g>
			</g>
			<path
				id="Path_10460"
				data-name="Path 10460"
				d="M.883,0V-6.425H1.63V-.677H4.465V0ZM9.136,0H5.555V-6.425H9.136v.664H6.3v2.07H8.965v.659H6.3V-.668H9.136Zm2.171,0H10.56V-6.425h3.582v.664H11.307V-3.41H13.97v.664H11.307Z"
				transform="translate(8 23)"
				fill="#d7d7d7"
			/>
		</g>
	</SvgIcon>
);

export const ShortFeedPaperDirectionIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="47.001" height="38.365" viewBox="0 0 47.001 38.365" {...props}>
		<defs>
			<filter id="Rectangle_2305_sef" x="0" y="0" width="47.001" height="38.365" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="landscape-sef-icon-paper-trays" transform="translate(4.501 3.5)">
			<g id="Group_9890" data-name="Group 9890" transform="translate(-20320 -10199) rotate(90)">
				<g transform="matrix(0, -1, 1, 0, 10195.5, -20315.5)" filter="url(#Rectangle_2305_sef)">
					<g
						id="Rectangle_2305-2"
						data-name="Rectangle 2305"
						transform="translate(42.5 3.5) rotate(90)"
						fill="#fff"
						stroke="#262626"
						strokeWidth="0.5"
					>
						<rect width="29.365" height="38.001" stroke="none" />
						<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
					</g>
				</g>
				<path
					id="Path_10459"
					data-name="Path 10459"
					d="M4.509-1.709A1.576,1.576,0,0,1,3.894-.387a2.668,2.668,0,0,1-1.67.475A4.183,4.183,0,0,1,.466-.207V-.927a4.628,4.628,0,0,0,.861.264,4.532,4.532,0,0,0,.923.1A1.862,1.862,0,0,0,3.375-.85a.93.93,0,0,0,.378-.789,1.013,1.013,0,0,0-.134-.547,1.245,1.245,0,0,0-.448-.393,6.271,6.271,0,0,0-.956-.409,3.051,3.051,0,0,1-1.281-.76A1.678,1.678,0,0,1,.549-4.9a1.426,1.426,0,0,1,.558-1.182,2.319,2.319,0,0,1,1.477-.439,4.352,4.352,0,0,1,1.762.352l-.233.65a3.982,3.982,0,0,0-1.547-.334,1.5,1.5,0,0,0-.927.255.84.84,0,0,0-.334.708,1.084,1.084,0,0,0,.123.547,1.158,1.158,0,0,0,.415.391,5.16,5.16,0,0,0,.894.393,3.54,3.54,0,0,1,1.391.773A1.521,1.521,0,0,1,4.509-1.709ZM9.4,0H5.823V-6.425H9.4v.664H6.57v2.07H9.233v.659H6.57V-.668H9.4Zm2.171,0h-.747V-6.425H14.41v.664H11.575V-3.41h2.663v.664H11.575Z"
					transform="translate(10216.684 -20331.316) rotate(-90)"
					fill="#d7d7d7"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const DeviceGraySiloIcon = (props: SvgIconProps) => (
	<SvgIcon
		component="svg"
		viewBox="0 0 86.027 126.438"
		sx={{ width: 30, height: 'auto' }} // OR any size you want
		{...props}
	>
		<path
			id="Union_100"
			d="M6405.293-681.7v-.742h-2.332v.742h-1.3v-2.844h4.93v2.844Zm-48.469,0v-.742h-2.332v.742h-1.3v-2.844h4.929v2.844Zm-4.419-2.844a6,6,0,0,1-6-6v-57.373l-19.678-8.353,1.983-4.672,17.7,7.509v-21.751h66.349v84.639a6,6,0,0,1-6,6Z"
			transform="translate(-6326.727 808.139)"
			fill="#cecdcd"
		/>
		<path
			id="Union_65"
			d="M28.642,28.6H0V8.5a6,6,0,0,1,6-6H22.642a6,6,0,0,1,5.81,4.5L64.427,0,65.4,4.982,29.688,11.923H60.35a6,6,0,0,1,6,6V28.6H28.642Z"
			transform="translate(19.677 0)"
			fill="#cecdcd"
		/>
	</SvgIcon>
);

export const FitToWidthIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" {...props}>
		<g id="Group_8142" data-name="Group 8142" transform="translate(-1422 -99.635)">
			<g id="Group_8143" data-name="Group 8143" transform="translate(8374 18995.635)">
				<g id="Group_8146" data-name="Group 8146" transform="translate(-4.624 -10.693)">
					<path
						id="Union_52"
						data-name="Union 52"
						d="M9.312,3.45l.571-.572H2.544l.555.555-.924.924L0,2.183,2.184,0l.909.909-.571.57H9.86L9.306.924,10.229,0,12.4,2.174,10.22,4.358Z"
						transform="translate(-6944.557 -18876.057)"
						fill="white"
					/>
				</g>
				<rect
					id="Rectangle_3282"
					data-name="Rectangle 3282"
					width="2"
					height="22"
					transform="translate(-6936 -18896)"
					fill="white"
				/>
				<rect
					id="Rectangle_3283"
					data-name="Rectangle 3283"
					width="2"
					height="22"
					transform="translate(-6952 -18896)"
					fill="white"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const FitToHeightIcon = (props: SvgIconProps) => <FitToWidthIcon style={{ transform: 'rotate(90deg)' }} />;
export const FitToViewIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20.664" height="23.616" viewBox="0 0 20.664 23.616" {...props}>
		<g id="Group_7169" data-name="Group 7169" transform="translate(-649 -279)">
			<path
				id="document_scanner_24dp_FILL0_wght400_GRAD0_opsz24"
				d="M202.084-778.468h16.5v-19.447h-16.5Zm.868,2.084a2.843,2.843,0,0,1-2.085-.867,2.843,2.843,0,0,1-.867-2.085v-17.712a2.842,2.842,0,0,1,.867-2.085,2.843,2.843,0,0,1,2.085-.867h14.76a2.843,2.843,0,0,1,2.085.867,2.842,2.842,0,0,1,.867,2.085v17.712a2.843,2.843,0,0,1-.867,2.085,2.843,2.843,0,0,1-2.085.867Zm-.868-2.084v0Z"
				transform="translate(449 1079)"
				fill="#fff"
			/>
			<g id="Group_7169-2" data-name="Group 7169" transform="translate(653.085 282.631)">
				<g id="Group_2279" data-name="Group 2279" transform="translate(0 0)">
					<path
						id="zoom_out_map_FILL0_wght400_GRAD0_opsz48"
						d="M6,21.927V19.406H7.025v.762L9.552,17.64l.734.734L7.759,20.9h.762v1.025Zm9.775,0V20.9h.762l-2.51-2.51.734-.734,2.51,2.51v-.762H18.3v2.521ZM9.535,10.269l-2.51-2.51v.762H6V6H8.521V7.025H7.759l2.51,2.51Zm5.226,0-.734-.734,2.51-2.51h-.762V6H18.3V8.521H17.271V7.759Z"
						transform="translate(-6 -6)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506"
					data-name="Path 6506"
					d="M-15031.881-6591.177h.655l.683-.7v-.646h.983v2.311h-2.321Z"
					transform="translate(15034.605 6595.261)"
					fill="#fff"
				/>
				<g id="Group_2276" data-name="Group 2276" transform="translate(7.201 2.739)">
					<path
						id="Path_6506-2"
						data-name="Path 6506"
						d="M-15029.562-6591.177h-.654l-.684-.7v-.646h-.983v2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506-3"
					data-name="Path 6506"
					d="M-15031.881-6591.556h.655l.683.7v.647h.983v-2.311h-2.321Z"
					transform="translate(15034.605 6603.414)"
					fill="#fff"
				/>
				<g id="Group_2276-2" data-name="Group 2276" transform="translate(7.201 10.892)">
					<path
						id="Path_6506-4"
						data-name="Path 6506"
						d="M-15029.562-6591.556h-.654l-.684.7v.647h-.983v-2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const FitToPageIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20.664" height="23.616" viewBox="0 0 20.664 23.616" {...props}>
		<g id="Group_7169" data-name="Group 7169" transform="translate(-649 -279)">
			<path
				id="document_scanner_24dp_FILL0_wght400_GRAD0_opsz24"
				d="M202.084-778.468h16.5v-19.447h-16.5Zm.868,2.084a2.843,2.843,0,0,1-2.085-.867,2.843,2.843,0,0,1-.867-2.085v-17.712a2.842,2.842,0,0,1,.867-2.085,2.843,2.843,0,0,1,2.085-.867h14.76a2.843,2.843,0,0,1,2.085.867,2.842,2.842,0,0,1,.867,2.085v17.712a2.843,2.843,0,0,1-.867,2.085,2.843,2.843,0,0,1-2.085.867Zm-.868-2.084v0Z"
				transform="translate(449 1079)"
				fill="#fff"
			/>
			<g id="Group_7169-2" data-name="Group 7169" transform="translate(653.085 282.631)">
				<g id="Group_2279" data-name="Group 2279" transform="translate(0 0)">
					<path
						id="zoom_out_map_FILL0_wght400_GRAD0_opsz48"
						d="M6,21.927V19.406H7.025v.762L9.552,17.64l.734.734L7.759,20.9h.762v1.025Zm9.775,0V20.9h.762l-2.51-2.51.734-.734,2.51,2.51v-.762H18.3v2.521ZM9.535,10.269l-2.51-2.51v.762H6V6H8.521V7.025H7.759l2.51,2.51Zm5.226,0-.734-.734,2.51-2.51h-.762V6H18.3V8.521H17.271V7.759Z"
						transform="translate(-6 -6)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506"
					data-name="Path 6506"
					d="M-15031.881-6591.177h.655l.683-.7v-.646h.983v2.311h-2.321Z"
					transform="translate(15034.605 6595.261)"
					fill="#fff"
				/>
				<g id="Group_2276" data-name="Group 2276" transform="translate(7.201 2.739)">
					<path
						id="Path_6506-2"
						data-name="Path 6506"
						d="M-15029.562-6591.177h-.654l-.684-.7v-.646h-.983v2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
				<path
					id="Path_6506-3"
					data-name="Path 6506"
					d="M-15031.881-6591.556h.655l.683.7v.647h.983v-2.311h-2.321Z"
					transform="translate(15034.605 6603.414)"
					fill="#fff"
				/>
				<g id="Group_2276-2" data-name="Group 2276" transform="translate(7.201 10.892)">
					<path
						id="Path_6506-4"
						data-name="Path 6506"
						d="M-15029.562-6591.556h-.654l-.684.7v.647h-.983v-2.311h2.321Z"
						transform="translate(15031.883 6592.522)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const DownloadIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3034" data-name="Rectangle 3034" width="24" height="24" fill="none" />
		<path
			id="download_FILL0_wght400_GRAD0_opsz24"
			d="M168-788l-5-5,1.4-1.45,2.6,2.6V-800h2v8.15l2.6-2.6L173-793Zm-6,4a1.925,1.925,0,0,1-1.412-.587A1.927,1.927,0,0,1,160-786v-3h2v3h12v-3h2v3a1.928,1.928,0,0,1-.587,1.413A1.926,1.926,0,0,1,174-784Z"
			transform="translate(-156 804)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const RemoveShareIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_4228" data-name="Rectangle 4228" width="26" height="26" fill="none" />
		<path
			id="share_off_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M54.4-863.8a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,54.4-863.8Zm0-12.6a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,54.4-876.4Zm-13.5,5.625V-871a2.6,2.6,0,0,1,.788-1.913A2.6,2.6,0,0,1,43.6-873.7a2.674,2.674,0,0,1,1.013.191,2.669,2.669,0,0,1,.833.529l6.323-3.69a1.535,1.535,0,0,1-.056-.3q-.011-.146-.011-.326a2.6,2.6,0,0,1,.788-1.913A2.6,2.6,0,0,1,54.4-880a2.6,2.6,0,0,1,1.913.788A2.6,2.6,0,0,1,57.1-877.3a2.6,2.6,0,0,1-.788,1.913,2.6,2.6,0,0,1-1.913.788,2.673,2.673,0,0,1-1.013-.191,2.669,2.669,0,0,1-.833-.529l-6.3,3.668a8.428,8.428,0,0,0-.866-.18,5.84,5.84,0,0,0-.889-.068,6.255,6.255,0,0,0-1.924.293A6.146,6.146,0,0,0,40.9-870.774ZM54.4-862a2.6,2.6,0,0,1-1.913-.788A2.6,2.6,0,0,1,51.7-864.7q0-.135.068-.63l-.968-.585a7.808,7.808,0,0,0-.158-1.046,6.186,6.186,0,0,0-.315-1l2.228,1.283a2.67,2.67,0,0,1,.833-.529A2.673,2.673,0,0,1,54.4-867.4a2.6,2.6,0,0,1,1.913.788A2.6,2.6,0,0,1,57.1-864.7a2.6,2.6,0,0,1-.788,1.913A2.6,2.6,0,0,1,54.4-862Zm-9.9.9a4.337,4.337,0,0,1-3.184-1.316A4.337,4.337,0,0,1,40-865.6a4.338,4.338,0,0,1,1.316-3.184A4.337,4.337,0,0,1,44.5-870.1a4.337,4.337,0,0,1,3.184,1.316A4.338,4.338,0,0,1,49-865.6a4.337,4.337,0,0,1-1.316,3.184A4.337,4.337,0,0,1,44.5-861.1Zm0-3.87,1.575,1.6.653-.63-1.6-1.6,1.6-1.6-.63-.63-1.6,1.6-1.6-1.6-.63.63,1.6,1.6-1.6,1.6.63.63ZM54.4-864.7ZM54.4-877.3Z"
			transform="translate(-35.551 883.549)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const ReshareIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" {...props}>
		<path
			id="Union_108"
			data-name="Union 108"
			d="M-2331.983-13892.413l1.379-1.4h-3.649a1.683,1.683,0,0,1-1.236-.514,1.675,1.675,0,0,1-.513-1.232v-2.622h1.749v2.622h3.649l-1.4-1.376,1.246-1.246,3.5,3.5-3.5,3.5Zm8.481-2.022a2.8,2.8,0,0,1-.848-2.06,6.844,6.844,0,0,1,.073-.681l-6.819-3.98a2.836,2.836,0,0,1-.9.568,2.828,2.828,0,0,1-1.089.206,2.809,2.809,0,0,1-2.064-.848,2.814,2.814,0,0,1-.852-2.064,2.808,2.808,0,0,1,.852-2.06,2.814,2.814,0,0,1,2.064-.853,2.9,2.9,0,0,1,1.089.206,2.9,2.9,0,0,1,.9.573l6.819-3.98a1.7,1.7,0,0,1-.063-.328c-.007-.105-.01-.224-.01-.354a2.821,2.821,0,0,1,.848-2.063,2.81,2.81,0,0,1,2.063-.849,2.81,2.81,0,0,1,2.064.849,2.821,2.821,0,0,1,.848,2.063,2.811,2.811,0,0,1-.848,2.064,2.809,2.809,0,0,1-2.064.848,2.845,2.845,0,0,1-1.093-.206,2.893,2.893,0,0,1-.9-.568l-6.819,3.98a1.629,1.629,0,0,1,.06.328c.007.1.014.22.014.349s-.007.248-.014.354a1.642,1.642,0,0,1-.06.328l6.819,3.98a2.809,2.809,0,0,1,.9-.569,2.847,2.847,0,0,1,1.093-.21,2.814,2.814,0,0,1,2.064.853,2.807,2.807,0,0,1,.848,2.063,2.8,2.8,0,0,1-.848,2.06,2.8,2.8,0,0,1-2.064.853A2.8,2.8,0,0,1-2323.5-13894.436Zm1.372-2.751a.939.939,0,0,0-.28.691.946.946,0,0,0,.28.691.942.942,0,0,0,.691.279.942.942,0,0,0,.691-.279.946.946,0,0,0,.279-.691.938.938,0,0,0-.279-.691.927.927,0,0,0-.691-.279A.927.927,0,0,0-2322.129-13897.187Zm-11.652-6.8a.949.949,0,0,0-.276.691.935.935,0,0,0,.276.691.94.94,0,0,0,.695.279.938.938,0,0,0,.691-.279.938.938,0,0,0,.279-.691.952.952,0,0,0-.279-.691.954.954,0,0,0-.691-.279A.955.955,0,0,0-2333.781-13903.985Zm11.652-6.794a.95.95,0,0,0-.28.69.939.939,0,0,0,.28.691.927.927,0,0,0,.691.279.927.927,0,0,0,.691-.279.938.938,0,0,0,.279-.691.95.95,0,0,0-.279-.69.939.939,0,0,0-.691-.28A.939.939,0,0,0-2322.129-13910.779Z"
			transform="translate(2340.264 13915.096)"
			fill="#7d61bc"
		/>
		<rect id="Rectangle_4340" data-name="Rectangle 4340" width="26" height="26" fill="none" />
	</SvgIcon>
);

export const BadgeIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="Component_300_18"
		data-name="Component 300 – 18"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
	>
		<g id="license-publish-icon" opacity="0">
			<rect id="Rectangle_596" data-name="Rectangle 596" width="24" height="24" rx="4" fill="none" />
		</g>
		<g id="Group_9164" data-name="Group 9164" transform="translate(15094 5296)">
			<rect
				id="Rectangle_3709"
				data-name="Rectangle 3709"
				width="24"
				height="24"
				transform="translate(-15094 -5296)"
				fill="none"
			/>
			<path
				id="id_card_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M112.186-771.336h4.777v-1.579h-4.777Zm0-3.036h4.777v-1.579h-4.777Zm-9.15,6.113h7.692v-.376a1.84,1.84,0,0,0-1.042-1.654,5.6,5.6,0,0,0-2.8-.6,5.6,5.6,0,0,0-2.8.6,1.84,1.84,0,0,0-1.041,1.654Zm3.846-4.008a1.776,1.776,0,0,0,1.3-.538,1.776,1.776,0,0,0,.538-1.3,1.776,1.776,0,0,0-.538-1.3,1.776,1.776,0,0,0-1.3-.537,1.777,1.777,0,0,0-1.3.537,1.776,1.776,0,0,0-.537,1.3,1.776,1.776,0,0,0,.537,1.3A1.777,1.777,0,0,0,106.883-772.267Zm-4.98,8.057a1.837,1.837,0,0,1-1.35-.553,1.837,1.837,0,0,1-.553-1.35V-778.1a1.837,1.837,0,0,1,.553-1.35A1.837,1.837,0,0,1,101.9-780H118.1a1.837,1.837,0,0,1,1.35.553A1.837,1.837,0,0,1,120-778.1v11.984a1.837,1.837,0,0,1-.553,1.35,1.837,1.837,0,0,1-1.35.553Zm0-1.579H118.1a.309.309,0,0,0,.223-.1.309.309,0,0,0,.1-.223V-778.1a.309.309,0,0,0-.1-.223.309.309,0,0,0-.223-.1H101.9a.309.309,0,0,0-.223.1.309.309,0,0,0-.1.223v11.984a.309.309,0,0,0,.1.223A.309.309,0,0,0,101.9-765.789Zm-.324,0v0Z"
				transform="translate(-15192 -4511.895)"
				fill="inherit"
			/>
		</g>
	</SvgIcon>
);

export const AuthenticationIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="authentication-enable-icon-v4"
		xmlns="http://www.w3.org/2000/svg"
		width="25.328"
		height="24"
		viewBox="0 0 25.328 24"
	>
		<rect id="Rectangle_596" data-name="Rectangle 596" width="25" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<rect
			id="Rectangle_3750"
			data-name="Rectangle 3750"
			width="24"
			height="24"
			transform="translate(1.328)"
			fill="none"
		/>
		<g id="Group_9351" data-name="Group 9351" transform="translate(0 1)">
			<g id="Group_9350" data-name="Group 9350" transform="translate(-335.84 -641.301)">
				<g id="Group_6519" data-name="Group 6519" transform="translate(1.58 2.253)">
					<path
						id="Path_6954"
						data-name="Path 6954"
						d="M5.259,3.986h4.868a.523.523,0,0,1,.523.523V6.943a.523.523,0,0,1-.523.523H5.259a.523.523,0,0,1-.523-.523V4.509a.523.523,0,0,1,.523-.523M9.6,5.032H5.782V6.42H9.6Z"
						transform="translate(340.292 642.391)"
						fill="currentColor"
					/>
					<path
						id="Path_6956"
						data-name="Path 6956"
						d="M1.043,8.218l0-7.156H3.763l.462,2.029a.525.525,0,0,0,.51.408H11.3V9.53h1.045V2.976a.524.524,0,0,0-.524-.524H5.152l-.016-.071,6.245-1.336A.524.524,0,1,0,11.163.025L4.9,1.359,4.689.421a.523.523,0,0,0-.51-.408H.524A.525.525,0,0,0,0,.538S.02,8.983,0,8.812,1.027,8.2,1.043,8.218Z"
						transform="translate(340.201 642.314)"
						fill="currentColor"
					/>
				</g>
				<rect
					id="Rectangle_3009"
					data-name="Rectangle 3009"
					width="17.933"
					height="19.971"
					transform="translate(340.201 642.315)"
					fill="none"
				/>
			</g>
			<path
				id="key_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M63.723-695.183a1.055,1.055,0,0,1-.774-.32,1.054,1.054,0,0,1-.32-.774,1.055,1.055,0,0,1,.32-.774,1.054,1.054,0,0,1,.774-.319,1.054,1.054,0,0,1,.774.319,1.055,1.055,0,0,1,.32.774,1.055,1.055,0,0,1-.32.774A1.055,1.055,0,0,1,63.723-695.183Zm0,2.63a3.59,3.59,0,0,1-2.636-1.087A3.59,3.59,0,0,1,60-696.276a3.59,3.59,0,0,1,1.087-2.636A3.59,3.59,0,0,1,63.723-700a3.582,3.582,0,0,1,1.969.562,3.734,3.734,0,0,1,1.343,1.469H73.13l1.692,1.693-2.6,2.591-1.256-.944-1.289.957-1.322-.911H67.035a3.769,3.769,0,0,1-1.343,1.466A3.566,3.566,0,0,1,63.723-692.553Zm0-1.016a2.566,2.566,0,0,0,1.687-.588,2.7,2.7,0,0,0,.93-1.442h2.33l.975.674,1.323-.967,1.15.879,1.263-1.263-.677-.677H66.34a2.7,2.7,0,0,0-.93-1.443,2.566,2.566,0,0,0-1.687-.588,2.607,2.607,0,0,0-1.913.8,2.607,2.607,0,0,0-.8,1.912,2.608,2.608,0,0,0,.8,1.912A2.608,2.608,0,0,0,63.723-693.569Z"
				transform="translate(-54.391 712.027)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const ArrowStartIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<g id="Group_6604" data-name="Group 6604" transform="translate(-1449 -801)">
			<g id="arrow_right_black_24dp" transform="translate(1449 801)">
				<path id="Path_7895" data-name="Path 7895" d="M13.091,0H0V24H13.091Z" fill="none" />
				<path
					id="Path_7896"
					data-name="Path 7896"
					d="M19.091,25.182,10,16.091,19.091,7Z"
					transform="translate(-8.805 -3)"
					fill="currentColor"
				/>
			</g>
			<line
				id="Line_557"
				data-name="Line 557"
				y2="11"
				transform="translate(1449.5 808.5)"
				fill="none"
				stroke="currentColor"
				strokeWidth="1"
			/>
		</g>
	</SvgIcon>
);

export const ArrowEndIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<g id="arrow_right_black_24dp" transform="translate(0)">
			<path id="Path_7895" data-name="Path 7895" d="M0,0H13.091V24H0Z" fill="none" />
			<path
				id="Path_7896"
				data-name="Path 7896"
				d="M10,25.182l9.091-9.091L10,7Z"
				transform="translate(-7.196 -3)"
				fill="currentColor"
			/>
		</g>
		<line
			id="Line_557"
			data-name="Line 557"
			y2="11"
			transform="translate(12.591 7.5)"
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
		/>
	</SvgIcon>
);

export const ArrowPreviousIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<path d="M13.091,0H0V24H13.091Z" fill="none" />
		<path d="M19.091,25.182,10,16.091,19.091,7Z" transform="translate(-8.805 -3)" fill="currentColor" />
	</SvgIcon>
);

export const ArrowNextIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.091" height="24" viewBox="0 0 13.091 24" {...props}>
		<path id="Path_7895" data-name="Path 7895" d="M0,0H13.091V24H0Z" fill="none" />
		<path
			id="Path_7896"
			data-name="Path 7896"
			d="M10,25.182l9.091-9.091L10,7Z"
			transform="translate(-7.195 -3)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const BookmarkIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" {...props}>
		<g id="Component_44_6" data-name="Component 44 – 6" transform="translate(2 3)">
			<g id="pie_chart_black_24dp" transform="translate(-2 -3)">
				<path id="Path_6182" data-name="Path 6182" d="M0,0H20V20H0Z" fill="none" />
				<path
					id="Path_6183"
					data-name="Path 6183"
					d="M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-2v2h-2V7h-2V5h2V3h2v2h2v2z"
					fill="#663F80"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const OpenLinkIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		{/* <rect
			id="Rectangle_1712"
			data-name="Rectangle 1712"
			width="24"
			height="24"
			rx="4"
			fill="rgba(0,0,0,0.04)"
			opacity="0"
		/> */}
		<g id="launch_black_18dp" transform="translate(2 1)">
			<path id="Path_6748" data-name="Path 6748" d="M0,0H21V21H0Z" fill="none" />
			<path
				id="Path_6749"
				data-name="Path 6749"
				d="M16.333,16.333H4.667V4.667H10.5V3H4.667A1.666,1.666,0,0,0,3,4.667V16.333A1.666,1.666,0,0,0,4.667,18H16.333A1.672,1.672,0,0,0,18,16.333V10.5H16.333ZM12.167,3V4.667h2.992L6.967,12.858l1.175,1.175,8.192-8.192V8.833H18V3Z"
				fill="#7d61bc"
			/>
		</g>
	</SvgIcon>
);

export const LoadingIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" {...props}>
		<path
			id="Surface"
			d="M22,44A21.982,21.982,0,0,1,0,22H4a18,18,0,0,0,34.585,7.007A17.995,17.995,0,0,0,22,4V0a22.006,22.006,0,0,1,8.564,42.271A21.864,21.864,0,0,1,22,44Z"
			transform="translate(0)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const ChevronDownThin = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" {...props}>
		<path d="M17.418 6.109a.697.697 0 0 1 .979 0a.68.68 0 0 1 0 .969l-7.908 7.83a.697.697 0 0 1-.979 0l-7.908-7.83a.68.68 0 0 1 0-.969a.697.697 0 0 1 .979 0L10 13.25l7.418-7.141z" />
	</SvgIcon>
);

export const PurchaseCodeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" />
		<path
			d="M81.8-866.5v1.8H96.2v-1.8Zm0-9.9h1.98a1.258,1.258,0,0,1-.146-.427,3.184,3.184,0,0,1-.034-.473,2.6,2.6,0,0,1,.787-1.912A2.6,2.6,0,0,1,86.3-880a2.36,2.36,0,0,1,1.249.349,3.953,3.953,0,0,1,1,.866l.45.585.45-.585a3.264,3.264,0,0,1,.99-.878A2.48,2.48,0,0,1,91.7-880a2.6,2.6,0,0,1,1.912.788A2.6,2.6,0,0,1,94.4-877.3a3.185,3.185,0,0,1-.034.473,1.258,1.258,0,0,1-.146.427H96.2a1.734,1.734,0,0,1,1.271.529A1.733,1.733,0,0,1,98-874.6v9.9a1.733,1.733,0,0,1-.529,1.271,1.733,1.733,0,0,1-1.271.529H81.8a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,80-864.7v-9.9a1.733,1.733,0,0,1,.529-1.271A1.734,1.734,0,0,1,81.8-876.4Zm0,7.2H96.2v-5.4H91.61l1.89,2.565L92.06-871,89-875.14,85.94-871l-1.44-1.035,1.845-2.565H81.8Zm4.5-7.2a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,86.3-876.4Zm5.4,0a.871.871,0,0,0,.641-.259.871.871,0,0,0,.259-.641.871.871,0,0,0-.259-.641.871.871,0,0,0-.641-.259.871.871,0,0,0-.641.259.871.871,0,0,0-.259.641.871.871,0,0,0,.259.641A.871.871,0,0,0,91.7-876.4Z"
			transform="translate(-77 883.45)"
			fill="white"
		/>
	</SvgIcon>
);

export const LicenseGroupLineIcon = (props: SvgIconProps) => (
	<SvgIcon version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
		<g id="Layer_2" className="st0-LicenseGroupLineIcon">
			<rect
				x="3.8"
				y="2.7"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="12.1"
			/>
			<rect
				x="1.5"
				y="10.8"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="13"
				y="11"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="5.2"
				y="9.4"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7.2"
				height="3.4"
			/>
			<rect
				x="4.6"
				y="11"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="3.8"
			/>
			<rect
				x="9.5"
				y="10.8"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="2.9"
				height="3.8"
			/>
			<rect
				x="4.5"
				y="1.2"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7"
				height="3.2"
			/>
			<rect
				x="10.8"
				y="2.7"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="1.6"
				height="7.1"
			/>
			<rect
				x="7.1"
				y="4.2"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="2"
				height="5.4"
			/>
			<rect
				x="4.2"
				y="5.9"
				className="st1-LicenseGroupLineIcon"
				style={{ display: 'inline', fill: 'currentColor' }}
				width="7"
				height="2"
			/>
		</g>
		<g id="Layer_1">
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"
			/>
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"
			/>
			<rect
				x="5.4"
				y="7.9"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="5.4"
				y="4.3"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="7.9"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="4.3"
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				width="1.6"
				height="1.6"
			/>
			<path
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"
			/>
			<path
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"
			/>
			<line
				className="st3-LicenseGroupLineIcon"
				style={{
					fill: 'none',
					stroke: props.htmlColor,
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				x1="8"
				y1="15"
				x2="8"
				y2="12.6"
			/>
			<line
				className="st2-LicenseGroupLineIcon"
				style={{ fill: 'none', stroke: props.htmlColor, strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				x1="0.5"
				y1="15"
				x2="15.7"
				y2="15"
			/>
		</g>
	</SvgIcon>
);

export const WarningIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 13.818" {...props}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			id="Icon_material-warning"
			data-name="Icon material-warning"
			d="M1.5,16.818h16L9.5,3Zm8.727-2.182H8.773V13.182h1.455Zm0-2.909H8.773V8.818h1.455Z"
			transform="translate(-1.5 -3)"
			// fill="#fa0"
		/>
	</SvgIcon>
);

export const WarningIconOutlined = (props: SvgIconProps) => (
	<SvgIcon
		id="warning-outline-modal-icon-light-mode"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		{...props}
	>
		<rect id="Rectangle_1949" data-name="Rectangle 1949" width="24" height="24" fill="none" />
		<path
			id="warning_FILL0_wght400_GRAD0_opsz20"
			d="M48-844.183,59.89-864l11.89,19.817Zm3.5-1.982H68.285L59.89-860.147Zm8.389-1.321a.973.973,0,0,0,.708-.283.943.943,0,0,0,.289-.7.973.973,0,0,0-.283-.708.944.944,0,0,0-.7-.289.973.973,0,0,0-.708.283.943.943,0,0,0-.289.7.973.973,0,0,0,.283.708A.944.944,0,0,0,59.884-847.486Zm-.985-3.3h1.982v-5.284H58.9ZM59.89-853.156Z"
			transform="translate(-47.89 866.09)"
			fill="#fdb634"
		/>
	</SvgIcon>
);

export const PinFilled = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Layer_1">
			<path
				className="st0-PinFilled"
				d="M15.3,8.3c0,0.1-0.1,0.3-0.3,0.3h-1c-0.1,0-0.3-0.1-0.3-0.3V7h-2.9c-0.3,0-0.5,0.1-0.7,0.3L8.8,8.8   C8.6,9,8.3,9.1,8.1,9.1H7.2C7.1,9.1,7,8.9,7,8.8V1.2C7,1,7.1,0.9,7.2,0.9h0.8c0.3,0,0.5,0.1,0.7,0.3l1.4,1.4   C10.4,2.9,10.7,3,10.9,3h2.9V1.7c0-0.1,0.1-0.3,0.3-0.3h1c0.1,0,0.3,0.1,0.3,0.3V8.3z M2.2,5.7c0.1,0,0.2,0,0.2,0h3.5V4.2H2.5   c-0.1,0-0.2,0-0.2,0L0.3,4.7C0.2,4.8,0.1,4.9,0.1,5c0,0.1,0.1,0.2,0.2,0.2L2.2,5.7z"
			/>
		</g>
		<g id="Layer_1_copy" className="st1-PinFilled">
			<path
				className="st2-PinFilled"
				d="M15.3,8.3c0,0.1-0.1,0.3-0.3,0.3h-1c-0.1,0-0.3-0.1-0.3-0.3V7h-2.9c-0.3,0-0.5,0.1-0.7,0.3L8.8,8.8   C8.6,9,8.3,9.1,8.1,9.1H7.2C7.1,9.1,7,8.9,7,8.8V1.2C7,1,7.1,0.9,7.2,0.9h0.8c0.3,0,0.5,0.1,0.7,0.3l1.4,1.4   C10.4,2.9,10.7,3,10.9,3h2.9V1.7c0-0.1,0.1-0.3,0.3-0.3h1c0.1,0,0.3,0.1,0.3,0.3V8.3z M2.2,5.7c0.1,0,0.2,0,0.2,0h3.5V4.2H2.5   c-0.1,0-0.2,0-0.2,0L0.3,4.7C0.2,4.8,0.1,4.9,0.1,5c0,0.1,0.1,0.2,0.2,0.2L2.2,5.7z"
			/>
		</g>
	</SvgIcon>
);

// export const TenantsFilled = (props: SvgIconProps) => (
// 	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
// 		{/* <style type="text/css">
// 			.st0-TenantsFilled{fill:currentColor;}
// 			.st1-TenantsFilled{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
// 			.st2-TenantsFilled{fill:none;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}
// 		</style> */}
// 		<g id="Layer_2">
// 			<rect x="3.8" y="2.7" className="st0-TenantsFilled" width="1.6" height="12.1"/>
// 			<rect x="1.5" y="10.8" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="13" y="11" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="5.2" y="9.4" className="st0-TenantsFilled" width="7.2" height="3.4"/>
// 			<rect x="4.6" y="11" className="st0-TenantsFilled" width="1.6" height="3.8"/>
// 			<rect x="9.5" y="10.8" className="st0-TenantsFilled" width="2.9" height="3.8"/>
// 			<rect x="4.5" y="1.2" className="st0-TenantsFilled" width="7" height="3.2"/>
// 			<rect x="10.8" y="2.7" className="st0-TenantsFilled" width="1.6" height="7.1"/>
// 			<rect x="7.1" y="4.2" className="st0-TenantsFilled" width="2" height="5.4"/>
// 			<rect x="4.2" y="5.9" className="st0-TenantsFilled" width="7" height="2"/>
// 		</g>
// 		<g id="Layer_1">
// 			<path className="st1-TenantsFilled" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"/>
// 			<path className="st1-TenantsFilled" d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"/>
// 			<rect x="5.4" y="7.9" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="5.4" y="4.3" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="9.2" y="7.9" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<rect x="9.2" y="4.3" className="st2-TenantsFilled" width="1.6" height="1.6"/>
// 			<path className="st1-TenantsFilled" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"/>
// 			<path className="st2-TenantsFilled" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"/>
// 			<line className="st2-TenantsFilled" x1="8" y1="15" x2="8" y2="12.6"/>
// 			<line className="st1-TenantsFilled" x1="0.5" y1="15" x2="15.7" y2="15"/>
// 		</g>
// 	</SvgIcon>
// );

export const InviteAdminIcon = (props: SvgIconProps) => (
	<SvgIcon id="email" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<path id="Path_6175" data-name="Path 6175" d="M0,0H20V20H0Z" fill="none" />
		<path
			id="Path_6176"
			data-name="Path 6176"
			d="M18,5.5A1.557,1.557,0,0,0,16.4,4H3.6A1.557,1.557,0,0,0,2,5.5v9A1.557,1.557,0,0,0,3.6,16H16.4A1.557,1.557,0,0,0,18,14.5Zm-1.6,0L10,9.25,3.6,5.5Zm0,9H3.6V7L10,10.75,16.4,7Z"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const BlockSenderIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g transform="translate(3.85 4.45)">
			<g transform="translate(-2 -2.1)">
				<path
					d="M3.8,15v-.6a.67.67,0,0,1,.4-.7,10.019,10.019,0,0,1,5.1-1.4h.1a9.465,9.465,0,0,1,.5-1.8H9.3a11.07,11.07,0,0,0-6,1.7A2.772,2.772,0,0,0,2,14.5v2.4h8.5a4.981,4.981,0,0,1-1-1.9Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
				<path
					d="M9.3,9.5A3.691,3.691,0,0,0,13,5.8,3.63,3.63,0,0,0,9.3,2.1,3.777,3.777,0,0,0,5.6,5.9,3.608,3.608,0,0,0,9.3,9.5Zm0-5.4a1.8,1.8,0,1,1,0,3.6A1.88,1.88,0,0,1,7.4,5.9,1.817,1.817,0,0,1,9.3,4.1Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
			</g>

			<g transform="translate(-2 -2.1)">
				<path
					d="M14.2,9a4.1,4.1,0,1,0,4.1,4.1A4.118,4.118,0,0,0,14.2,9Zm-3.3,4.1a3.329,3.329,0,0,1,3.3-3.3,3.221,3.221,0,0,1,2,.7l-4.6,4.6A3.221,3.221,0,0,1,10.9,13.1Zm3.3,3.3a3.221,3.221,0,0,1-2-.7l4.6-4.6a3.456,3.456,0,0,1,.7,2A3.329,3.329,0,0,1,14.2,16.4Z"
					fill={props.fill === undefined ? '#7d61bc' : props.htmlColor}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const BlockSenderEnabledIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" rx="4" fill="#ee4035" />
		<g transform="translate(3.85 4.45)">
			<g transform="translate(-2 -2.1)">
				<path
					d="M3.8,15v-.6a.67.67,0,0,1,.4-.7,10.019,10.019,0,0,1,5.1-1.4h.1a9.465,9.465,0,0,1,.5-1.8H9.3a11.07,11.07,0,0,0-6,1.7A2.772,2.772,0,0,0,2,14.5v2.4h8.5a4.981,4.981,0,0,1-1-1.9Z"
					fill="#fff"
				/>
				<path
					d="M9.3,9.5A3.691,3.691,0,0,0,13,5.8,3.63,3.63,0,0,0,9.3,2.1,3.777,3.777,0,0,0,5.6,5.9,3.608,3.608,0,0,0,9.3,9.5Zm0-5.4a1.8,1.8,0,1,1,0,3.6A1.88,1.88,0,0,1,7.4,5.9,1.817,1.817,0,0,1,9.3,4.1Z"
					fill="#fff"
				/>
			</g>

			<g transform="translate(-2 -2.1)">
				<path
					d="M14.2,9a4.1,4.1,0,1,0,4.1,4.1A4.118,4.118,0,0,0,14.2,9Zm-3.3,4.1a3.329,3.329,0,0,1,3.3-3.3,3.221,3.221,0,0,1,2,.7l-4.6,4.6A3.221,3.221,0,0,1,10.9,13.1Zm3.3,3.3a3.221,3.221,0,0,1-2-.7l4.6-4.6a3.456,3.456,0,0,1,.7,2A3.329,3.329,0,0,1,14.2,16.4Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RefreshIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z" />
		</g>
	</SvgIcon>
);

export const RefreshInviteIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="email-resend"
		xmlns="http://www.w3.org/2000/svg"
		width="19.2"
		height="19.2"
		viewBox="0 0 19.2 19.2"
		{...props}
	>
		<g id="Layer_1_00000112633164956032736890000004167970257456723332_" transform="translate(-0.4 -0.4)">
			<g id="Group_742" data-name="Group 742">
				<rect
					id="Rectangle_660"
					data-name="Rectangle 660"
					width="19.2"
					height="19.2"
					transform="translate(0.4 0.4)"
					fill="none"
				/>
				<path
					id="Path_6179"
					data-name="Path 6179"
					d="M16.4,3.6H3.6A1.58,1.58,0,0,0,2,5.2v9.6a1.58,1.58,0,0,0,1.6,1.6H10V14.8H3.6v-8l6.4,4,6.4-4v4H18V5.2A1.58,1.58,0,0,0,16.4,3.6ZM10,9.2l-6.4-4H16.4Z"
					fill="currentColor"
				/>
			</g>
		</g>
		<g id="Layer_2_00000081623741961431659490000008462199773130730892_" transform="translate(-0.4 -0.4)">
			<path
				id="Path_6180"
				data-name="Path 6180"
				d="M17.7,13a4,4,0,0,0-2.6-1,3.6,3.6,0,1,0,0,7.2,3.547,3.547,0,0,0,3.5-2.7h-1A2.848,2.848,0,0,1,15,18.3a2.7,2.7,0,0,1,0-5.4,2.732,2.732,0,0,1,1.9.8l-1.4,1.4h3.2V11.9Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const CancelInviteIcon = (props: SvgIconProps) => (
	<SvgIcon id="email-cancel" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
		<g id="Layer_1_00000135651656977560700910000016907287840043262643_">
			<g id="Group_741" data-name="Group 741">
				<rect id="Rectangle_659" data-name="Rectangle 659" width="20" height="20" fill="none" />
				<path
					id="Path_6177"
					data-name="Path 6177"
					d="M16.7,3.3H3.3A1.666,1.666,0,0,0,1.7,5V15a1.752,1.752,0,0,0,1.7,1.7H10V15H3.3V6.7L10,10.9l6.7-4.2v4.2h1.7V5A1.828,1.828,0,0,0,16.7,3.3ZM10,9.2,3.3,5H16.6Z"
					fill="currentColor"
				/>
			</g>
		</g>
		<g id="Layer_2_00000052801258203231353290000008295030710211312045_">
			<path
				id="Path_6178"
				data-name="Path 6178"
				d="M18.3,12.8l-.6-.6L15,14.8l-2.6-2.6-.6.6,2.6,2.6L11.8,18l.6.6L15,16l2.6,2.6.6-.6-2.6-2.6Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const EditAdminIcon = (props: SvgIconProps) => (
	<SvgIcon
		id="contact_page_black_24dp"
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		{...props}
	>
		<rect id="Rectangle_662" data-name="Rectangle 662" width="20" height="20" fill="none" />
		<path
			id="Path_6184"
			data-name="Path 6184"
			d="M10.878,3.6,14.5,7.464V16.4h-9V3.6h5.378M11.5,2h-6A1.557,1.557,0,0,0,4,3.6V16.4A1.557,1.557,0,0,0,5.5,18h9A1.557,1.557,0,0,0,16,16.4V6.8L11.5,2ZM10,11.6a1.6,1.6,0,0,0,0-3.2,1.6,1.6,0,0,0,0,3.2Zm3,2.744a1.615,1.615,0,0,0-.915-1.48,4.917,4.917,0,0,0-4.17,0A1.615,1.615,0,0,0,7,14.344V14.8h6Z"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const DeviceIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<style type="text/css">{`
            .st0-DeviceIcon{fill:none;stroke:currentColor;stroke-width:1.9642;stroke-miterlimit:10;}
            .st1-DeviceIcon{fill:none;stroke:currentColor;stroke-width:1.9766;stroke-miterlimit:10;}
        `}</style>
		<line className="st0-DeviceIcon" x1="14" y1="8.7" x2="14" y2="22.8" />
		<path
			className="st1-DeviceIcon"
			d="M13.6,8.7h5.9c0.6,0,1-0.5,1-1V5.2c0-0.6-0.5-1-1-1h-5.9c-0.6,0-1,0.5-1,1v2.5C12.6,8.3,13.1,8.7,13.6,8.7z"
		/>
		<line className="st0-DeviceIcon" x1="4.1" y1="7.6" x2="12.4" y2="7.6" />
		<path
			className="st0-DeviceIcon"
			d="M19.5,22.9H4.8c-0.6,0-1-0.5-1-1V2.3c0-0.6,0.5-1,1-1h5.3v0.8l9.4-0.8c0.6,0,1,0.5,1,1V22
	C20.5,22.5,20.1,22.9,19.5,22.9z"
		/>
	</SvgIcon>
);

export const StopShareIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">{`
			.st0-StopShareIcon{fill:none;}
			.st1-StopShareIcon{fill:currentColor;}
		`}</style>
		<g>
			<path className="st0-StopShareIcon" d="M0,0h24v24H0V0z" />
		</g>
		<g>
			<path
				className="st1-StopShareIcon"
				d="M15.7,3H8.3L3,8.3v7.5L8.3,21h7.5l5.3-5.3V8.3L15.7,3z M19,14.9L14.9,19H9.1L5,14.9V9.1L9.1,5h5.8L19,9.1V14.9
				z M14.8,7.8L12,10.6L9.2,7.8L7.8,9.2l2.8,2.8l-2.8,2.8l1.4,1.4l2.8-2.8l2.8,2.8l1.4-1.4L13.4,12l2.8-2.8L14.8,7.8z"
			/>
		</g>
	</SvgIcon>
);

// export const FormIcon = (props: Omit<MdiIconProps, 'path'>) => (
// 	<MdiIcon
// 		path={mdiIcons.mdiFormatListBulletedSquare}
// 		{...props}
// 		className={clsx('mdi-svg-icon', props.className)}
// 	/>
// );
export const FormIcon = ListIcon;

export const NamingIcon = ListIcon;

export const NotificationsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M17,11H15V9H17V11M13,11H11V9H13V11M9,11H7V9H9V11Z" />
	</SvgIcon>
);

export const WorkflowIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiPlay} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const PolicyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			d="M23.4,14.4c-0.1,0-0.2,0-0.3-0.2c-1-1.9-2-3.9-3-5.8c0,0,0-0.1-0.1-0.1c0.4-0.1,0.8-0.2,1.2-0.4
	c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.8-0.8-1.3-0.5c-0.9,0.4-1.8,0.4-2.6-0.1c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.7-2.7-1-4.2-1
	c-0.3,0-0.5,0-0.8,0c0.7-0.3,1.2-1,1.2-1.8c0-1.1-0.9-1.9-1.9-1.9S10.1,2,10.1,3c0,0.8,0.5,1.5,1.2,1.8c-0.2,0-0.4,0-0.7,0
	C9,4.9,7.4,5.3,6,6.1c-0.8,0.4-1.6,0.4-2.4,0C3,5.8,2.5,6,2.2,6.6C2,7.1,2.2,7.6,2.8,7.9C3.1,8.1,3.5,8.2,4,8.3
	C3.9,8.4,3.9,8.4,3.8,8.5c-1,1.9-1.9,3.7-2.9,5.6c-0.1,0.2-0.2,0.3-0.5,0.3c-0.2,0-0.4,0.1-0.5,0.2v0.2c0.4,1.4,1.4,2.1,2.7,2.5
	c1.7,0.5,3.4,0.5,5-0.3c0.6-0.3,1.1-0.7,1.5-1.2c0.2-0.3,0.3-0.6,0.4-0.9c0-0.3-0.1-0.5-0.3-0.4c-0.4,0-0.5-0.1-0.6-0.4
	c-0.9-1.8-1.9-3.6-2.8-5.4C5.6,8.3,5.6,8.3,6,8.2c0.7-0.1,1.4-0.3,2-0.6c0.7-0.3,1.3-0.5,2.1-0.6c0.3,0,0.3,0,0.3,0.3
	c0,3.9,0,7.7,0,11.6c0,0.2,0,0.3-0.2,0.3c-0.7,0.1-1.3,0.7-1.4,1.4c0,0.2-0.1,0.2-0.2,0.2c-0.5,0-0.9,0-1.3,0c-1,0-1.6,0.6-1.6,1.6
	h12.8c0-0.9-0.7-1.6-1.6-1.6c-0.5,0-0.9,0-1.4,0c-0.1,0-0.2,0-0.2-0.2c-0.1-0.7-0.7-1.3-1.4-1.4c-0.1,0-0.2,0-0.2-0.2
	c0-3.9,0-7.8,0-11.8C13.6,7,13.7,7,13.8,7c0.6,0.1,1.2,0.2,1.8,0.5c0.8,0.3,1.7,0.6,2.6,0.7c0.2,0,0.1,0.2,0.1,0.2
	c-0.7,1.3-1.4,2.6-2,3.9c-0.3,0.6-0.6,1.2-0.9,1.8c-0.1,0.1-0.1,0.2-0.3,0.2c-0.1,0-0.1,0-0.2,0c-0.3,0-0.4,0.2-0.3,0.4
	c0.1,0.7,0.6,1.2,1.1,1.7c0.8,0.6,1.6,0.9,2.6,1c1.3,0.2,2.7,0.1,3.9-0.5c0.7-0.3,1.2-0.8,1.6-1.4c0.1-0.2,0.2-0.5,0.3-0.8v-0.2
	C23.9,14.4,23.7,14.4,23.4,14.4L23.4,14.4z M7.2,14.4H2.4c0.8-1.5,1.6-3,2.4-4.5C5.6,11.4,6.4,12.9,7.2,14.4z M16.8,14.4
	c0.8-1.5,1.6-3,2.4-4.5c0.8,1.5,1.6,3,2.4,4.5H16.8z"
		/>
	</SvgIcon>
);

export const AssignPolicyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M13.22 22.61c-.4.15-.8.29-1.22.39-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6c0 .9-.11 1.78-.3 2.65-.81-.41-1.73-.65-2.7-.65-3.31 0-6 2.69-6 6 0 1.36.46 2.61 1.22 3.61zM19 20v2.99s-1.99.01-2 0V20h-3v-2h3v-3h2v3h3v2h-3z" />
	</SvgIcon>
);

export const ViewIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
	</SvgIcon>
);

export const GenerateIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" {...props}>
		<g id="Generate_icon" data-name="Generate icon" transform="translate(-17)">
			<path
				id="_Color"
				data-name=" â†³Color"
				d="M11,16a7.943,7.943,0,0,1-4.26-1.24L8.2,13.3A5.886,5.886,0,0,0,11,14a6.007,6.007,0,0,0,6-6H14l4-4,4,4H19A8.01,8.01,0,0,1,11,16ZM4,12H4L0,8H3A7.986,7.986,0,0,1,15.26,1.24L13.8,2.7A5.886,5.886,0,0,0,11,2,6.007,6.007,0,0,0,5,8H8L4,12Z"
				transform="translate(17 0)"
				fill="#603fa5"
			/>
		</g>
	</SvgIcon>
);

export const FolderClosedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3375" data-name="Rectangle 3375" width="24" height="24" fill="none" />
		<path
			id="folder_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="folder_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M81.9-784.8a1.829,1.829,0,0,1-1.342-.558A1.829,1.829,0,0,1,80-786.7v-11.4a1.83,1.83,0,0,1,.558-1.342A1.83,1.83,0,0,1,81.9-800h5.7l1.9,1.9h7.6a1.83,1.83,0,0,1,1.342.558A1.83,1.83,0,0,1,99-796.2v9.5a1.829,1.829,0,0,1-.558,1.342,1.829,1.829,0,0,1-1.342.558Zm0-1.9H97.1v-9.5H88.716l-1.9-1.9H81.9Zm0,0v0Z"
			transform="translate(-77.5 804.469)"
			fill={props.htmlColor ?? '#7d61bc'}
		/>
	</SvgIcon>
);

export const FolderOpenIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			id="folder_open_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="folder_open_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M81.767-785.86a1.7,1.7,0,0,1-1.248-.519A1.7,1.7,0,0,1,80-787.628v-10.6a1.7,1.7,0,0,1,.519-1.248A1.7,1.7,0,0,1,81.767-800h5.3l1.767,1.767h7.07a1.7,1.7,0,0,1,1.248.519,1.7,1.7,0,0,1,.519,1.248H88.108l-1.767-1.767H81.767v10.6l2.121-7.07H99l-2.276,7.578a1.723,1.723,0,0,1-.652.917,1.754,1.754,0,0,1-1.049.342Zm1.856-1.767h11.4l1.591-5.3h-11.4Zm0,0,1.591-5.3Zm-1.856-8.837v0Z"
			transform="translate(-77.5 804.93)"
			fill={props.htmlColor ?? '#7d61bc'}
		/>
		<rect id="Rectangle_3374" data-name="Rectangle 3374" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const DocManagementIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_3793" data-name="Rectangle 3793" width="24" height="24" fill="none" />
		<path
			id="_Color"
			data-name=" â†³Color"
			d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
			transform="translate(23.02 18)"
			fill="currentColor"
		/>
		<path
			id="home_storage_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M145.369-790.659l-1.909-11.434h17.491l-1.909,11.434Zm1.3-1.559h11.07l1.325-8.316H145.345Zm3.456-4.418h4.158a.754.754,0,0,0,.555-.224.755.755,0,0,0,.224-.556.753.753,0,0,0-.224-.555.754.754,0,0,0-.555-.224h-4.158a.754.754,0,0,0-.555.224.755.755,0,0,0-.224.556.754.754,0,0,0,.224.556A.755.755,0,0,0,150.127-796.636Zm-4.158-6.7a.754.754,0,0,1-.555-.224.755.755,0,0,1-.224-.556.753.753,0,0,1,.224-.555.754.754,0,0,1,.555-.224h12.474a.753.753,0,0,1,.555.224.754.754,0,0,1,.224.555.753.753,0,0,1-.224.555.754.754,0,0,1-.555.224Zm2.079-2.8a.754.754,0,0,1-.555-.224.754.754,0,0,1-.224-.556.753.753,0,0,1,.224-.555.754.754,0,0,1,.555-.224h8.316a.754.754,0,0,1,.555.224.755.755,0,0,1,.224.556.753.753,0,0,1-.224.555.754.754,0,0,1-.555.224Zm-1.377,13.913h0Z"
			transform="translate(-140.123 812.092)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const ToastStatusPendingIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect width="24" height="24" fill="none" />
		<path
			d="M10,2.222A7.778,7.778,0,1,0,17.778,10,7.787,7.787,0,0,0,10,2.222M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"
			transform="translate(2 2)"
			fill="#727272"
		/>
	</SvgIcon>
);

export const ToastStatusDoneIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect width="24" height="24" fill="none" />
		<path
			d="M88.6-865.4l7.05-7.05-1.4-1.4L88.6-868.2l-2.85-2.85-1.4,1.4ZM90-860a9.738,9.738,0,0,1-3.9-.787,10.1,10.1,0,0,1-3.175-2.137,10.1,10.1,0,0,1-2.137-3.175A9.737,9.737,0,0,1,80-870a9.738,9.738,0,0,1,.788-3.9,10.1,10.1,0,0,1,2.137-3.175,10.1,10.1,0,0,1,3.175-2.138A9.738,9.738,0,0,1,90-880a9.738,9.738,0,0,1,3.9.787,10.1,10.1,0,0,1,3.175,2.138,10.1,10.1,0,0,1,2.137,3.175A9.738,9.738,0,0,1,100-870a9.737,9.737,0,0,1-.787,3.9,10.1,10.1,0,0,1-2.137,3.175,10.1,10.1,0,0,1-3.175,2.137A9.738,9.738,0,0,1,90-860Z"
			transform="translate(-78 882)"
			fill="#46a44a"
		/>
	</SvgIcon>
);

export const MyFilesIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="22"
		viewBox="0 0 22 22"
		overflow="visible"
	>
		<path
			id="Union_107"
			data-name="Union 107"
			d="M14019.9,1221.025a1.9,1.9,0,0,1-1.9-1.9v-11.4a1.9,1.9,0,0,1,1.9-1.9h.9v-2.582a1.247,1.247,0,0,1,1.25-1.244h11.5a1.245,1.245,0,0,1,1.251,1.244v4.481h.3a1.913,1.913,0,0,1,1.9,1.9v9.5a1.907,1.907,0,0,1-1.9,1.9Zm-.388-1.539h16.021l-.046-10.23h-8.817l-1.874-1.9h-5.3Zm0,0-.018-12.126Zm6.087-13.658,1.9,1.9h6.3v-4.481a.248.248,0,0,0-.25-.247h-11.5a.25.25,0,0,0-.25.247v2.582Zm1.9,1.173v-1h5.549v1Zm-5-2v-1h10.547v1Z"
			transform="translate(-14014 -1199.001)"
			fill="currentColor"
		/>
		<rect id="Rectangle_4227" data-name="Rectangle 4227" width="22" height="22" fill="none" />
	</SvgIcon>
);

export const ShareFileIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Boundary" width="24" height="24" fill="none" />
		<g id="Group_3177" data-name="Group 3177" transform="translate(1.787 6.172)">
			<path
				id="group_add_FILL1_wght400_GRAD0_opsz48"
				d="M4.3,20.6V18.838a2.163,2.163,0,0,1,1.276-1.989,14.853,14.853,0,0,1,2.412-.863,9.215,9.215,0,0,1,2.224-.263,9.1,9.1,0,0,1,2.215.263,14.994,14.994,0,0,1,2.4.863,2.191,2.191,0,0,1,.938.8,2.1,2.1,0,0,1,.357,1.192V20.6Zm5.912-6.024A2.7,2.7,0,0,1,7.4,11.763a2.7,2.7,0,0,1,2.815-2.815,2.7,2.7,0,0,1,2.815,2.815,2.7,2.7,0,0,1-2.815,2.815Zm2.984-.094a4.349,4.349,0,0,0,.723-1.239,4.288,4.288,0,0,0,.235-1.483,4.288,4.288,0,0,0-.235-1.483A4.349,4.349,0,0,0,13.2,9.042a3.04,3.04,0,0,1,2.505.432,2.6,2.6,0,0,1,1.079,2.29,2.6,2.6,0,0,1-1.079,2.29A3.04,3.04,0,0,1,13.2,14.484ZM17.25,20.6V18.838a3.444,3.444,0,0,0-.488-1.783,3.7,3.7,0,0,0-1.689-1.389,11.385,11.385,0,0,1,4.439,1.2A2.313,2.313,0,0,1,20.7,18.838V20.6Z"
				transform="translate(-0.277 -8.946)"
				fill="currentColor"
			/>
			<path
				id="group_add_FILL1_wght400_GRAD0_opsz48-2"
				data-name="group_add_FILL1_wght400_GRAD0_opsz48"
				d="M2.367,18.7V16.337H0v-1.42H2.367V12.55h1.42v2.367H6.154v1.42H3.787V18.7Z"
				transform="translate(0 -10.781)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const PropertiesIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_4222" data-name="Rectangle 4222" width="24" height="24" fill="none" />
		<path
			id="Union_104"
			data-name="Union 104"
			d="M11.011,19l-.2-1.192a3.764,3.764,0,0,1-.752-.3,2.991,2.991,0,0,1-.621-.458l-1.145.392-.771-1.258L8.44,15.4a3.339,3.339,0,0,1,0-1.685l-.921-.789.771-1.258,1.145.392a2.7,2.7,0,0,1,.621-.463,3.961,3.961,0,0,1,.752-.291l.2-1.192h1.5l.2,1.192a3.961,3.961,0,0,1,.752.291,2.7,2.7,0,0,1,.621.463l1.145-.392.771,1.258-.922.789a3.339,3.339,0,0,1,0,1.685l.922.788-.771,1.258-1.145-.392a2.991,2.991,0,0,1-.621.458,3.764,3.764,0,0,1-.752.3L12.515,19Zm-.717-5.907a2.075,2.075,0,1,0,2.938,2.931,2.075,2.075,0,1,0-2.938-2.931ZM1.812,19a1.751,1.751,0,0,1-1.286-.525A1.743,1.743,0,0,1,0,17.192V1.808A1.743,1.743,0,0,1,.526.525,1.752,1.752,0,0,1,1.812,0H9.774l5.263,5.25v4.807l-1.5-.6V6H9.022V1.5H1.812a.3.3,0,0,0-.212.1.293.293,0,0,0-.1.212V17.192a.293.293,0,0,0,.1.212.3.3,0,0,0,.212.1H6.524L7.416,19ZM1.5,17.5v0Z"
			transform="translate(3.996 2.5)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const RenameIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<g id="Icon_feather-edit-3" data-name="Icon feather-edit-3" transform="translate(0.062 0.718)">
			<path
				id="Path_5658"
				data-name="Path 5658"
				d="M31.97,30.625h-8.7a.625.625,0,0,1,0-1.25h8.7a.625.625,0,0,1,0,1.25Z"
				transform="translate(-13.002 -12.276)"
				fill="#7d61bc"
			/>
			<path
				id="Path_5659"
				data-name="Path 5659"
				d="M16.23,4.823a1.933,1.933,0,0,1,2.607,0,1.649,1.649,0,0,1,0,2.441L7.976,17.433,4.5,18.247l.869-3.254Z"
				fill="#7d61bc"
				stroke="#323232"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.25"
			/>
		</g>
		<rect id="Rectangle_3047" data-name="Rectangle 3047" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const FileTrashIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<path id="Path_6637" data-name="Path 6637" d="M0,0H24V24H0Z" fill="none" />
		<path
			id="Union_57"
			data-name="Union 57"
			d="M2.77,17.5A1.939,1.939,0,0,1,.923,15.489V3.421H12.006V15.489A1.938,1.938,0,0,1,10.158,17.5Zm7.9-1.358V4.766h-8.4V16.142H4.525V7.8H5.818v8.338H7.111V7.8H8.4v8.338ZM0,2.415V1.065H3.232L4.155,0H8.774L9.7,1.065h3.232v1.35Z"
			transform="translate(5.535 3.25)"
			fill="#ef4b41"
			stroke="rgba(0,0,0,0)"
			strokeWidth="1"
		/>
	</SvgIcon>
);

export const FavoriteIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_4220" data-name="Rectangle 4220" width="24" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<path
			id="favorite-dark-mode-icon"
			d="M87.227-864.359l3.324-2,3.323,2.031-.87-3.8,2.928-2.532-3.851-.343-1.53-3.587-1.53,3.561-3.851.343L88.1-868.13Zm-3.192,4.4,1.715-7.412L80-872.351l7.6-.659L90.551-880l2.954,6.99,7.6.659-5.75,4.985,1.714,7.412-6.515-3.93ZM90.551-869.185Z"
			transform="translate(-78.551 881.977)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const FavoriteActiveIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Rectangle_4220" data-name="Rectangle 4220" width="24" height="24" rx="4" fill="#F5CD06" />
		<path
			id="favorite-dark-mode-icon"
			d="M87.227-864.359l3.324-2,3.323,2.031-.87-3.8,2.928-2.532-3.851-.343-1.53-3.587-1.53,3.561-3.851.343L88.1-868.13Zm-3.192,4.4,1.715-7.412L80-872.351l7.6-.659L90.551-880l2.954,6.99,7.6.659-5.75,4.985,1.714,7.412-6.515-3.93ZM90.551-869.185Z"
			transform="translate(-78.551 881.977)"
			fill="#fff"
		/>
	</SvgIcon>
);

export const ChangeOwnerIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<rect id="Boundary" width="24" height="24" fill="none" />
		<g id="Group_7867" data-name="Group 7867" transform="translate(4.391 4.588)">
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.931,1.931,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.677,7.677,0,0,1,1.49-.45,8.085,8.085,0,0,1,1.55-.15,8.084,8.084,0,0,1,1.55.15,7.677,7.677,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-480 560)"
				fill="currentColor"
			/>
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24-2"
				data-name="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.932,1.932,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.672,7.672,0,0,1,1.49-.45,8.08,8.08,0,0,1,1.55-.15,8.079,8.079,0,0,1,1.55.15,7.671,7.671,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-472.187 566.823)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.446,0,2.828,1.618,1.211l.566.586-.627.627H4.319V0h.809V3.233H1.557l.627.627Z"
				transform="translate(6.223 9) rotate(90)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24-2"
				data-name="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.447,0,2.829,1.618,1.211l.566.587-.627.627H4.319V0h.809V3.234H1.557l.627.627Z"
				transform="translate(9.59 6.128) rotate(-90)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const MoveFileIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		overflow="visible"
	>
		<path
			id="drive_file_move_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M109.185-771.748l-1.578,1.578.94.94,3.187-3.187-3.187-3.187-.94.94,1.578,1.578h-3.97v1.338Zm-7.573,5.13a1.557,1.557,0,0,1-1.144-.468,1.556,1.556,0,0,1-.468-1.144v-10.156a1.557,1.557,0,0,1,.468-1.144,1.557,1.557,0,0,1,1.144-.468h4.9l1.784,1.784h7.042a1.557,1.557,0,0,1,1.144.468,1.557,1.557,0,0,1,.468,1.144v8.372a1.557,1.557,0,0,1-.468,1.144,1.557,1.557,0,0,1-1.144.468Zm0-1.338h13.724a.267.267,0,0,0,.2-.077.267.267,0,0,0,.077-.2V-776.6a.267.267,0,0,0-.077-.2.267.267,0,0,0-.2-.077h-7.59l-1.784-1.784h-4.351a.267.267,0,0,0-.2.077.267.267,0,0,0-.077.2v10.156a.267.267,0,0,0,.077.2A.267.267,0,0,0,101.613-767.957Zm-.275,0v0Z"
			transform="translate(-96 785.618)"
			fill="currentColor"
		/>
		<rect id="Rectangle_3977" data-name="Rectangle 3977" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const JpgFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#707070"
		/>
		<path
			d="M6.50049 14.5317L10.4009 11.1011L11.8735 12.5503L14.4263 9.96631L17.8325 14.4458L6.50049 14.5317Z"
			fill="#707070"
		/>
		<path
			d="M15 16H9C8.44772 16 8 16.4477 8 17V18.5C8 19.0523 8.44772 19.5 9 19.5H15C15.5523 19.5 16 19.0523 16 18.5V17C16 16.4477 15.5523 16 15 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M9.55225 18.4611L9.78025 18.4461C9.84592 18.4478 9.90958 18.4233 9.95725 18.3781C9.99883 18.3262 10.0192 18.2604 10.0142 18.1941V16.6941H10.4852V18.1941C10.4929 18.2783 10.482 18.3633 10.4532 18.4428C10.4244 18.5224 10.3785 18.5946 10.3186 18.6545C10.2588 18.7143 10.1865 18.7602 10.107 18.789C10.0274 18.8178 9.94251 18.8288 9.85825 18.8211L9.57925 18.8361L9.55225 18.4611ZM10.8752 16.6911H11.8472C12.0418 16.6791 12.2337 16.7413 12.3842 16.8651C12.4496 16.9273 12.5006 17.003 12.5338 17.0869C12.5669 17.1709 12.5814 17.261 12.5762 17.3511C12.5814 17.4412 12.5669 17.5313 12.5338 17.6152C12.5006 17.6991 12.4496 17.7749 12.3842 17.8371C12.2337 17.9609 12.0418 18.0231 11.8472 18.0111H11.3472V18.8061H10.8752V16.6911ZM11.7872 17.6571C12.0212 17.6571 12.1382 17.5571 12.1382 17.3571C12.1417 17.3145 12.1357 17.2718 12.1206 17.2318C12.1056 17.1919 12.0819 17.1558 12.0512 17.1261C11.9748 17.0707 11.8813 17.0442 11.7872 17.0511H11.3432V17.6601L11.7872 17.6571ZM14.6642 17.6391V18.6741C14.5497 18.7282 14.4287 18.7675 14.3042 18.7911C14.164 18.8193 14.0213 18.8334 13.8782 18.8331C13.6778 18.8388 13.4789 18.7952 13.2992 18.7061C13.1383 18.6221 13.0065 18.4913 12.9212 18.3311C12.8291 18.1516 12.7837 17.9518 12.7892 17.7501C12.7843 17.5509 12.8289 17.3537 12.9192 17.1761C13.0032 17.0157 13.1335 16.8843 13.2932 16.7991C13.469 16.7063 13.6655 16.6599 13.8642 16.6641C14.008 16.6629 14.151 16.6842 14.2882 16.7271C14.4075 16.7626 14.5184 16.8218 14.6142 16.9011L14.4642 17.2341C14.3769 17.1698 14.2805 17.1189 14.1782 17.0831C14.0814 17.0517 13.9801 17.0362 13.8782 17.0371C13.4702 17.0371 13.2662 17.2741 13.2662 17.7481C13.2511 17.9434 13.3076 18.1375 13.4252 18.2941C13.4873 18.3573 13.5624 18.4061 13.6453 18.4372C13.7282 18.4683 13.817 18.4809 13.9052 18.4741C14.0217 18.474 14.1377 18.4589 14.2502 18.4291V17.9631H13.8332V17.6391H14.6642Z"
			fill="#707070"
		/>
		<path
			d="M9.50049 10C10.0528 10 10.5005 9.55228 10.5005 9C10.5005 8.44772 10.0528 8 9.50049 8C8.9482 8 8.50049 8.44772 8.50049 9C8.50049 9.55228 8.9482 10 9.50049 10Z"
			fill="white"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			stroke="#707070"
		/>
	</SvgIcon>
);

export const PdfFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#EC2D25"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#EC2D25"
		/>
		<path
			d="M15 16H9C8.44772 16 8 16.4477 8 17V18.5C8 19.0523 8.44772 19.5 9 19.5H15C15.5523 19.5 16 19.0523 16 18.5V17C16 16.4477 15.5523 16 15 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M9.67519 17.686H9.82419C9.93484 17.6938 10.045 17.6646 10.1372 17.603C10.1715 17.5734 10.1985 17.5362 10.2158 17.4944C10.2332 17.4525 10.2405 17.4072 10.2372 17.362C10.2406 17.3189 10.2347 17.2756 10.2199 17.2351C10.205 17.1945 10.1816 17.1576 10.1512 17.127C10.0731 17.0702 9.97747 17.0429 9.88119 17.05H9.67519V17.686ZM10.7002 17.346C10.7065 17.4447 10.6903 17.5436 10.6529 17.6353C10.6155 17.7269 10.5578 17.8088 10.4842 17.875C10.3076 18.0075 10.0895 18.0724 9.86919 18.058H9.67519V18.82H9.22119V16.678H9.90519C10.1164 16.6633 10.3261 16.7227 10.4982 16.846C10.5678 16.9084 10.6222 16.9859 10.6572 17.0725C10.6922 17.1592 10.7069 17.2527 10.7002 17.346ZM12.9352 17.728C12.9452 17.8765 12.9236 18.0255 12.8719 18.1651C12.8202 18.3047 12.7395 18.4318 12.6352 18.538C12.3923 18.7405 12.0807 18.8415 11.7652 18.82H11.1582V16.678H11.8312C12.1284 16.6597 12.4209 16.7592 12.6452 16.955C12.745 17.0565 12.8223 17.1779 12.8723 17.3112C12.9222 17.4445 12.9437 17.5869 12.9352 17.729V17.728ZM12.4632 17.74C12.4632 17.28 12.2602 17.05 11.8542 17.05H11.6122V18.445H11.8072C12.2445 18.445 12.4632 18.21 12.4632 17.74ZM13.8802 18.82H13.4332V16.678H14.6612V17.05H13.8802V17.602H14.6072V17.973H13.8802V18.82Z"
			fill="#707070"
		/>
		<path
			d="M7.91498 14.8318C7.84958 14.7785 7.79735 14.7114 7.76264 14.6345C7.72793 14.5577 7.71247 14.4727 7.71577 14.3884C7.7266 14.1111 7.83959 13.9766 7.96577 13.8025C8.09194 13.6284 8.22928 13.5313 8.44428 13.3826C8.91548 13.0567 9.42965 12.7968 9.97162 12.6111C10.0376 12.5841 10.1038 12.5599 10.1708 12.5349C10.5668 11.8302 10.9213 11.1006 11.2294 10.3533C11.3874 9.97029 11.5189 9.60354 11.6279 9.25954C11.5339 9.0358 11.4548 8.8072 11.3876 8.57399C11.2466 8.10099 10.9633 6.95308 11.2763 6.44508C11.3144 6.38442 11.3636 6.33302 11.4228 6.29274C11.482 6.25246 11.5497 6.22382 11.6201 6.21071C11.6627 6.2038 11.7057 6.20007 11.749 6.19899C11.8773 6.19819 12.0027 6.22881 12.1162 6.28883C12.2296 6.34886 12.3278 6.43618 12.3994 6.54274C12.7804 7.08174 12.6994 8.15533 12.1494 9.72633C12.3011 9.96772 12.4681 10.1996 12.6494 10.4197C12.6864 10.4687 12.723 10.5115 12.749 10.5545C13.0061 10.8912 13.2827 11.2126 13.5771 11.5173C13.8841 11.4623 14.2041 11.4177 14.5341 11.3767C14.7207 11.3472 14.9097 11.3328 15.0986 11.3338C15.3728 11.3095 15.6476 11.3415 15.9091 11.4275C16.1706 11.5135 16.4118 11.6515 16.6181 11.8338C16.6765 11.8951 16.7204 11.9682 16.747 12.0486C16.7736 12.129 16.7827 12.2145 16.7724 12.2986C16.7234 12.6426 16.3724 12.8455 15.8154 12.8455C15.4233 12.8384 15.0365 12.7567 14.6747 12.6052C14.2337 12.4089 13.8342 12.1323 13.497 11.7869C12.81 11.9079 12.3371 12.0233 12.0361 12.1033C11.7661 12.1773 11.2357 12.3787 10.9247 12.5037C9.80975 14.5527 8.92483 14.9822 8.37983 14.9822C8.21224 14.9878 8.04716 14.935 7.91498 14.8318ZM8.78022 14.365C8.84173 14.365 9.3687 13.8025 9.3687 13.8025C9.8687 13.3025 10 12.9924 10.1708 12.7422C10.1708 12.7422 9.50465 12.9413 8.581 13.5857C8.194 13.8557 7.96591 14.1493 7.95991 14.3963C7.95958 14.4426 7.96911 14.4883 7.98725 14.531C8.05225 14.645 8.23217 14.793 8.78217 14.365H8.78022ZM14.5654 11.6228C14.3074 11.6538 14.0496 11.6972 13.8056 11.7322C14.0875 11.9989 14.4132 12.2148 14.7685 12.3709C15.0595 12.4898 15.3672 12.5628 15.6806 12.5877C15.7962 12.5772 15.9048 12.5267 15.9853 12.4431C16.0658 12.3596 16.1121 12.2484 16.1181 12.1326C16.1228 12.0268 16.0919 11.9238 16.0302 11.8377C15.9686 11.7515 15.8799 11.6877 15.7783 11.658C15.5552 11.6077 15.3273 11.5832 15.0986 11.5857C14.9209 11.5859 14.7433 11.5984 14.5673 11.6228H14.5654ZM11.6201 11.0584C11.4481 11.4514 11.2764 11.8259 11.1064 12.1599C11.4064 12.0449 11.7625 11.9151 11.9775 11.8591C12.2525 11.7871 12.6771 11.6752 13.2841 11.5662C13.0256 11.2931 12.7835 11.0059 12.5556 10.7068C12.5246 10.6638 12.4871 10.6209 12.4501 10.5779C12.3151 10.3999 12.175 10.2282 12.04 10.0252C11.923 10.3452 11.782 10.6994 11.622 11.0584H11.6201ZM11.663 6.45876C11.6267 6.46416 11.5933 6.47839 11.5634 6.49977C11.5335 6.52116 11.508 6.54914 11.4912 6.5818C11.3238 7.21939 11.3717 7.89436 11.6279 8.50172C11.6649 8.63272 11.706 8.75582 11.747 8.87282C11.983 8.19418 12.0924 7.47765 12.0693 6.75954C12.052 6.69258 12.0191 6.63193 11.9736 6.57985C11.9281 6.52776 11.8716 6.48686 11.8076 6.46071C11.7879 6.45887 11.7686 6.45887 11.749 6.46071C11.7211 6.4568 11.693 6.45489 11.665 6.4568L11.663 6.45876Z"
			fill="#EB3123"
		/>
	</SvgIcon>
);

export const MiscFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3862" data-name="Rectangle 3862" width="24" height="24" fill="none" />
		<g id="Group_9717" data-name="Group 9717" transform="translate(-306 -577)">
			<path
				id="Path_10092"
				data-name="Path 10092"
				d="M4.26,0H12a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.2Z"
				transform="translate(311.25 580.199)"
				fill="#fff"
			/>
			<path
				id="Path_10087_-_Outline"
				data-name="Path 10087 - Outline"
				d="M4.531.45.492,4.292.45,16.5A1.552,1.552,0,0,0,2,18.05H12.5a1.552,1.552,0,0,0,1.55-1.55V2A1.552,1.552,0,0,0,12.5.45M4.461,0H12.5a2,2,0,0,1,2,2V16.5a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.292Z"
				transform="translate(311 580)"
				fill="#707070"
			/>
			<path
				id="Path_10086_-_Outline"
				data-name="Path 10086 - Outline"
				d="M1.1,3.99H3.281a.793.793,0,0,0,.8-.783l.072-2.12M4.6.174,4.531,3.207A1.242,1.242,0,0,1,3.281,4.44H.1Z"
				transform="translate(310.949 579.9)"
				fill="#707070"
			/>
		</g>
		<g id="Group_10191" data-name="Group 10191" transform="translate(-553 -214.125)">
			<path
				id="Line_559"
				data-name="Line 559"
				d="M11,.375H0v-.75H11Z"
				transform="translate(559.75 223.5)"
				fill="#707070"
			/>
			<path
				id="Line_559-2"
				data-name="Line 559"
				d="M11,.375H0v-.75H11Z"
				transform="translate(559.75 225.5)"
				fill="#707070"
			/>
			<path
				id="Line_559-3"
				data-name="Line 559"
				d="M5.5.375H0v-.75H5.5Z"
				transform="translate(559.75 227.5)"
				fill="#707070"
			/>
		</g>
		<g id="Group_10192" data-name="Group 10192" transform="translate(-552.75 -214)">
			<g id="Group_9716" data-name="Group 9716" transform="translate(247 -364)">
				<rect
					id="Rectangle_3861"
					data-name="Rectangle 3861"
					width="8"
					height="3.5"
					rx="1"
					transform="translate(314 594)"
					fill="#d7d7d7"
				/>
			</g>
			<path
				id="Path_10098"
				data-name="Path 10098"
				d="M1.1,0H.642V-1.764H.06v-.378H1.677v.378H1.1ZM3.738,0H3.22l-.5-.81-.5.81H1.737l.71-1.1L1.783-2.142h.5l.461.771L3.2-2.142h.489L3.015-1.08Zm1.1,0H4.38V-1.764H3.8v-.378H5.416v.378H4.834Z"
				transform="translate(562.262 232.799)"
				fill="#707070"
				stroke="rgba(0,0,0,0)"
				strokeWidth="1"
			/>
		</g>
	</SvgIcon>
);

export const ZipFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<rect id="Rectangle_3862" data-name="Rectangle 3862" width="24" height="24" fill="none" />
		<g id="Group_12428" data-name="Group 12428" transform="translate(-555 -250)">
			<g id="Group_9717" data-name="Group 9717" transform="translate(249 -327)">
				<path
					id="Path_10092"
					data-name="Path 10092"
					d="M4.26,0H12a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.2Z"
					transform="translate(311.25 580.199)"
					fill="#fff"
				/>
				<path
					id="Path_10087_-_Outline"
					data-name="Path 10087 - Outline"
					d="M4.531.45.492,4.292.45,16.5A1.552,1.552,0,0,0,2,18.05H12.5a1.552,1.552,0,0,0,1.55-1.55V2A1.552,1.552,0,0,0,12.5.45M4.461,0H12.5a2,2,0,0,1,2,2V16.5a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V4.292Z"
					transform="translate(311 580)"
					fill="#707070"
				/>
				<path
					id="Path_10086_-_Outline"
					data-name="Path 10086 - Outline"
					d="M1.1,3.99H3.281a.793.793,0,0,0,.8-.783l.072-2.12M4.6.174,4.531,3.207A1.242,1.242,0,0,1,3.281,4.44H.1Z"
					transform="translate(310.949 579.9)"
					fill="#707070"
				/>
				<g id="Group_12425" data-name="Group 12425">
					<g id="Group_9716" data-name="Group 9716" transform="translate(0.168 -0.98)">
						<rect
							id="Rectangle_3861"
							data-name="Rectangle 3861"
							width="8"
							height="3.5"
							rx="1"
							transform="translate(314 594)"
							fill="#d7d7d7"
						/>
					</g>
					<path
						id="Path_10222"
						data-name="Path 10222"
						d="M1.769,0H.072V-.294L1.165-1.767H.1v-.375H1.739v.293L.647-.375H1.769Zm.363,0V-2.142h.484V0ZM3.674-1.134h.159a.556.556,0,0,0,.334-.083.282.282,0,0,0,.111-.241.287.287,0,0,0-.093-.236.455.455,0,0,0-.291-.076h-.22Zm1.092-.34a.636.636,0,0,1-.23.529,1.028,1.028,0,0,1-.654.183H3.674V0H3.19V-2.142h.728a1.014,1.014,0,0,1,.631.168A.594.594,0,0,1,4.766-1.474Z"
						transform="translate(315.83 595.84)"
						fill="#707070"
					/>
				</g>
			</g>
			<g id="Group_12427" data-name="Group 12427">
				<g id="Group_12426" data-name="Group 12426" transform="translate(565.322 253.4)">
					<g id="Union_111" data-name="Union 111" transform="translate(-24381.68 -22637.75)" fill="#fff">
						<path
							d="M 24383.748046875 22647.5390625 L 24383.462890625 22647.5390625 L 24383.462890625 22646.75390625 L 24383.462890625 22646.25390625 L 24382.962890625 22646.25390625 L 24382.177734375 22646.25390625 L 24382.177734375 22645.966796875 L 24383.75390625 22645.966796875 L 24383.75390625 22646.25390625 L 24383.748046875 22646.25390625 L 24383.748046875 22646.75390625 L 24383.748046875 22647.5390625 Z M 24385.0390625 22644.9609375 L 24383.46875 22644.9609375 L 24383.46875 22644.17578125 L 24383.46875 22643.67578125 L 24382.96875 22643.67578125 L 24382.177734375 22643.67578125 L 24382.177734375 22643.390625 L 24382.96875 22643.390625 L 24383.46875 22643.390625 L 24383.46875 22642.890625 L 24383.46875 22641.60546875 L 24383.46875 22641.10546875 L 24382.96875 22641.10546875 L 24382.177734375 22641.10546875 L 24382.177734375 22640.8203125 L 24382.96875 22640.8203125 L 24383.46875 22640.8203125 L 24383.46875 22640.3203125 L 24383.46875 22639.03515625 L 24383.46875 22638.25 L 24383.75390625 22638.25 L 24383.75390625 22639.03515625 L 24383.75390625 22639.53515625 L 24384.25390625 22639.53515625 L 24385.0390625 22639.53515625 L 24385.0390625 22639.8203125 L 24384.25390625 22639.8203125 L 24383.75390625 22639.8203125 L 24383.75390625 22640.3203125 L 24383.75390625 22641.60546875 L 24383.75390625 22642.10546875 L 24384.25390625 22642.10546875 L 24385.0390625 22642.10546875 L 24385.0390625 22642.390625 L 24384.25390625 22642.390625 L 24383.75390625 22642.390625 L 24383.75390625 22642.890625 L 24383.75390625 22644.17578125 L 24383.75390625 22644.67578125 L 24384.25390625 22644.67578125 L 24385.0390625 22644.67578125 L 24385.0390625 22644.9609375 Z"
							stroke="none"
						/>
						<path
							d="M 24384.248046875 22648.0390625 L 24382.962890625 22648.0390625 L 24382.962890625 22646.75390625 L 24384.248046875 22646.75390625 L 24384.248046875 22648.0390625 Z M 24384.25390625 22646.75390625 L 24381.677734375 22646.75390625 L 24381.677734375 22645.466796875 L 24384.25390625 22645.466796875 L 24384.25390625 22646.75390625 Z M 24385.5390625 22645.4609375 L 24382.96875 22645.4609375 L 24382.96875 22644.17578125 L 24385.5390625 22644.17578125 L 24385.5390625 22645.4609375 Z M 24384.25390625 22644.17578125 L 24381.677734375 22644.17578125 L 24381.677734375 22642.890625 L 24384.25390625 22642.890625 L 24384.25390625 22644.17578125 Z M 24385.5390625 22642.890625 L 24382.96875 22642.890625 L 24382.96875 22641.60546875 L 24385.5390625 22641.60546875 L 24385.5390625 22642.890625 Z M 24384.25390625 22641.60546875 L 24381.677734375 22641.60546875 L 24381.677734375 22640.3203125 L 24384.25390625 22640.3203125 L 24384.25390625 22641.60546875 Z M 24385.5390625 22640.3203125 L 24382.96875 22640.3203125 L 24382.96875 22637.75 L 24384.25390625 22637.75 L 24384.25390625 22639.03515625 L 24385.5390625 22639.03515625 L 24385.5390625 22640.3203125 Z"
							stroke="none"
							fill="#707070"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const BmpFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#707070"
		/>
		<path
			d="M6.50049 14.5317L10.4009 11.1011L11.8735 12.5503L14.4263 9.96631L17.8325 14.4458L6.50049 14.5317Z"
			fill="#707070"
		/>
		<path
			d="M15 16H9C8.44772 16 8 16.4477 8 17V18.5C8 19.0523 8.44772 19.5 9 19.5H15C15.5523 19.5 16 19.0523 16 18.5V17C16 16.4477 15.5523 16 15 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.4368 16.6499C14.7152 16.6499 14.9184 16.7095 15.0463 16.8286C15.1742 16.9468 15.2381 17.1099 15.2381 17.3179C15.2381 17.4116 15.2239 17.5015 15.1953 17.5874C15.1668 17.6724 15.1201 17.748 15.0551 17.8145C14.9912 17.8809 14.9056 17.9336 14.7983 17.9727C14.6911 18.0107 14.5588 18.0298 14.4013 18.0298H14.2051V18.7915H13.7476V16.6499H14.4368ZM14.4132 17.022H14.2051V17.6577H14.3556C14.4412 17.6577 14.5155 17.6465 14.5784 17.624C14.6414 17.6016 14.6901 17.5664 14.7246 17.5186C14.759 17.4707 14.7762 17.4092 14.7762 17.334C14.7762 17.2285 14.7467 17.1504 14.6877 17.0996C14.6286 17.0479 14.5371 17.022 14.4132 17.022Z"
			fill="#707070"
		/>
		<path
			d="M11.81 18.7915L11.2905 17.1113H11.2772C11.2792 17.1514 11.2822 17.2119 11.2861 17.293C11.291 17.373 11.2954 17.4585 11.2994 17.5493C11.3033 17.6401 11.3053 17.7222 11.3053 17.7954V18.7915H10.8965V16.6499H11.5193L12.0299 18.2876H12.0388L12.5804 16.6499H13.2032V18.7915H12.7767V17.7778C12.7767 17.7104 12.7777 17.6328 12.7796 17.5449C12.7826 17.457 12.786 17.3735 12.79 17.2944C12.7939 17.2144 12.7969 17.1543 12.7988 17.1143H12.7855L12.2292 18.7915H11.81Z"
			fill="#707070"
		/>
		<path
			d="M8.86572 16.6499H9.53722C9.82452 16.6499 10.042 16.6899 10.1895 16.77C10.3371 16.8501 10.4109 16.9907 10.4109 17.1919C10.4109 17.2729 10.3976 17.3462 10.3711 17.4116C10.3455 17.4771 10.3081 17.5308 10.2589 17.5728C10.2097 17.6147 10.1497 17.6421 10.0789 17.6548V17.6694C10.1507 17.6841 10.2156 17.7095 10.2737 17.7456C10.3317 17.7808 10.378 17.8325 10.4124 17.9009C10.4478 17.9683 10.4655 18.0581 10.4655 18.1704C10.4655 18.3003 10.4335 18.4116 10.3696 18.5044C10.3056 18.5972 10.2141 18.6685 10.0951 18.7183C9.97702 18.7671 9.83632 18.7915 9.673 18.7915H8.86572V16.6499ZM9.32323 17.498H9.58888C9.7217 17.498 9.81369 17.4775 9.86486 17.4365C9.91602 17.3945 9.9416 17.333 9.9416 17.252C9.9416 17.1699 9.9111 17.1113 9.8501 17.0762C9.79008 17.04 9.69464 17.022 9.56379 17.022H9.32323V17.498ZM9.32323 17.8584V18.4165H9.62134C9.75909 18.4165 9.85502 18.3901 9.90913 18.3374C9.96324 18.2847 9.9903 18.2139 9.9903 18.125C9.9903 18.0723 9.97849 18.0259 9.95488 17.9858C9.93127 17.9458 9.89142 17.9146 9.83534 17.8921C9.78024 17.8696 9.70399 17.8584 9.60659 17.8584H9.32323Z"
			fill="#707070"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			stroke="#707070"
		/>
	</SvgIcon>
);

export const ConfFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7D61BC"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7D61BC"
		/>
		<path
			d="M16 16.02H8C7.44772 16.02 7 16.4677 7 17.02V18.52C7 19.0723 7.44772 19.52 8 19.52H16C16.5523 19.52 17 19.0723 17 18.52V17.02C17 16.4677 16.5523 16.02 16 16.02Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.2832 18.8753H14.8364V16.7337H16.064V17.1058H15.2832V17.658H16.0098V18.0286H15.2832V18.8753Z"
			fill="#707070"
		/>
		<path
			d="M14.2959 18.8753H13.7188L12.7871 17.2552H12.7739C12.7778 17.3226 12.7812 17.3904 12.7842 17.4588C12.7871 17.5272 12.79 17.5955 12.793 17.6639C12.7959 17.7313 12.7988 17.7991 12.8018 17.8675V18.8753H12.396V16.7337H12.9688L13.8989 18.3377H13.9092C13.9072 18.2713 13.9048 18.2054 13.9019 18.14C13.8989 18.0745 13.896 18.0091 13.8931 17.9437C13.8911 17.8782 13.8892 17.8128 13.8872 17.7474V16.7337H14.2959V18.8753Z"
			fill="#707070"
		/>
		<path
			d="M11.9521 17.8016C11.9521 17.9666 11.9316 18.117 11.8906 18.2527C11.8496 18.3875 11.7871 18.5037 11.7031 18.6014C11.6201 18.699 11.5146 18.7742 11.3867 18.827C11.2588 18.8787 11.1074 18.9046 10.9326 18.9046C10.7578 18.9046 10.6064 18.8787 10.4785 18.827C10.3506 18.7742 10.2446 18.699 10.1606 18.6014C10.0776 18.5037 10.0156 18.387 9.97461 18.2513C9.93359 18.1155 9.91309 17.9647 9.91309 17.7986C9.91309 17.577 9.94922 17.3841 10.0215 17.22C10.0947 17.055 10.207 16.9271 10.3584 16.8362C10.5098 16.7454 10.7021 16.7 10.9355 16.7C11.168 16.7 11.3589 16.7454 11.5083 16.8362C11.6587 16.9271 11.77 17.055 11.8423 17.22C11.9155 17.3851 11.9521 17.5789 11.9521 17.8016ZM10.3892 17.8016C10.3892 17.951 10.4077 18.0799 10.4448 18.1883C10.4829 18.2957 10.542 18.3787 10.6221 18.4373C10.7021 18.4949 10.8057 18.5237 10.9326 18.5237C11.0615 18.5237 11.166 18.4949 11.2461 18.4373C11.3262 18.3787 11.3843 18.2957 11.4204 18.1883C11.4575 18.0799 11.4761 17.951 11.4761 17.8016C11.4761 17.577 11.4341 17.4002 11.3501 17.2713C11.2661 17.1424 11.1279 17.0779 10.9355 17.0779C10.8076 17.0779 10.7031 17.1072 10.6221 17.1658C10.542 17.2234 10.4829 17.3065 10.4448 17.4149C10.4077 17.5223 10.3892 17.6512 10.3892 17.8016Z"
			fill="#707070"
		/>
		<path
			d="M9.00488 17.0809C8.91797 17.0809 8.84082 17.098 8.77344 17.1321C8.70703 17.1653 8.65088 17.2137 8.60498 17.2772C8.56006 17.3406 8.52588 17.4173 8.50244 17.5071C8.479 17.597 8.46729 17.6981 8.46729 17.8104C8.46729 17.9617 8.48584 18.0911 8.52295 18.1985C8.56104 18.305 8.61963 18.3865 8.69873 18.4432C8.77783 18.4988 8.87988 18.5267 9.00488 18.5267C9.0918 18.5267 9.17871 18.5169 9.26562 18.4974C9.35352 18.4778 9.44873 18.45 9.55127 18.4139V18.7947C9.45654 18.8338 9.36328 18.8616 9.27148 18.8782C9.17969 18.8958 9.07666 18.9046 8.9624 18.9046C8.7417 18.9046 8.56006 18.8592 8.41748 18.7684C8.27588 18.6766 8.1709 18.5486 8.10254 18.3846C8.03418 18.2195 8 18.0272 8 17.8074C8 17.6453 8.02197 17.4969 8.06592 17.3621C8.10986 17.2274 8.17432 17.1107 8.25928 17.012C8.34424 16.9134 8.44922 16.8372 8.57422 16.7835C8.69922 16.7298 8.84277 16.7029 9.00488 16.7029C9.11133 16.7029 9.21777 16.7166 9.32422 16.744C9.43164 16.7703 9.53418 16.8069 9.63184 16.8538L9.48535 17.223C9.40527 17.1849 9.32471 17.1517 9.24365 17.1234C9.1626 17.095 9.08301 17.0809 9.00488 17.0809Z"
			fill="#707070"
		/>
		<path
			d="M11.6945 14L11.5197 12.8973C11.3987 12.8516 11.2816 12.7959 11.1697 12.7309C11.056 12.6669 10.9477 12.5938 10.8459 12.5123L9.81218 12.9849L9 11.5498L9.94508 10.8606C9.93266 10.8014 9.92541 10.7413 9.92342 10.6809C9.92047 10.6153 9.91899 10.5555 9.91899 10.5017C9.91899 10.4479 9.92047 10.388 9.92342 10.322C9.92543 10.2618 9.93268 10.2018 9.94508 10.1428L9 9.45362L9.81366 8.01855L10.8473 8.49117C10.9492 8.40964 11.0575 8.33656 11.1712 8.2726C11.282 8.20785 11.3993 8.15503 11.5212 8.11506L11.6945 7H13.3041L13.4788 8.10275C13.6005 8.14857 13.7189 8.20267 13.8332 8.2647C13.9489 8.32488 14.0563 8.39985 14.1527 8.48771L15.1863 8.01513L16 9.45017L15.0549 10.1236C15.0669 10.1857 15.0742 10.2485 15.0766 10.3117C15.0795 10.3773 15.081 10.44 15.081 10.4998C15.081 10.5595 15.0795 10.6207 15.0766 10.6834C15.074 10.7451 15.0668 10.8064 15.0549 10.867L16 11.5494L15.1863 12.9844L14.1527 12.5118C14.0513 12.5932 13.9446 12.6677 13.8332 12.7348C13.7225 12.8037 13.6034 12.8582 13.4788 12.8968L13.3041 13.9995L11.6945 14ZM12.4993 11.637C12.649 11.6395 12.7976 11.6113 12.936 11.5541C13.0745 11.497 13.1997 11.4121 13.3041 11.3047C13.4115 11.2003 13.4963 11.075 13.5535 10.9366C13.6106 10.7982 13.6388 10.6495 13.6363 10.4998C13.6388 10.35 13.6107 10.2013 13.5535 10.0629C13.4964 9.92446 13.4115 9.7992 13.3041 9.69485C13.1997 9.58744 13.0745 9.50254 12.936 9.44539C12.7976 9.38824 12.649 9.36005 12.4993 9.36255C12.3495 9.36005 12.2009 9.38824 12.0625 9.44539C11.9241 9.50254 11.7988 9.58744 11.6945 9.69485C11.5871 9.7992 11.5022 9.92446 11.445 10.0629C11.3879 10.2013 11.3597 10.35 11.3622 10.4998C11.3597 10.6495 11.3879 10.7982 11.445 10.9366C11.5022 11.075 11.5871 11.2003 11.6945 11.3047C11.7988 11.4122 11.9241 11.4973 12.0626 11.5545C12.2011 11.6117 12.3499 11.64 12.4998 11.6375L12.4993 11.637ZM12.4993 11.1117C12.4187 11.113 12.3386 11.0977 12.2641 11.0669C12.1897 11.0361 12.1223 10.9903 12.0661 10.9325C12.0083 10.8763 11.9625 10.8089 11.9317 10.7344C11.9009 10.6599 11.8857 10.5799 11.8869 10.4992C11.8857 10.4186 11.9009 10.3386 11.9317 10.2641C11.9625 10.1896 12.0083 10.1222 12.0661 10.0661C12.1223 10.0082 12.1897 9.96244 12.2641 9.93162C12.3386 9.9008 12.4187 9.88557 12.4993 9.88685C12.5799 9.88557 12.6599 9.9008 12.7344 9.93162C12.8089 9.96244 12.8763 10.0082 12.9324 10.0661C12.9903 10.1222 13.036 10.1896 13.0668 10.2641C13.0976 10.3386 13.1129 10.4186 13.1116 10.4992C13.1129 10.5799 13.0976 10.6599 13.0668 10.7344C13.036 10.8089 12.9903 10.8763 12.9324 10.9325C12.8764 10.9904 12.8091 11.0363 12.7347 11.0673C12.6603 11.0983 12.5803 11.1137 12.4998 11.1127L12.4993 11.1117ZM12.1148 13.4752H12.8847L13.0072 12.495C13.199 12.4487 13.3832 12.3751 13.5541 12.2765C13.7253 12.178 13.8827 12.0573 14.0222 11.9176L14.9496 12.3203L15.2996 11.6901L14.477 11.0861C14.5003 10.9876 14.5194 10.8892 14.5341 10.7907C14.5488 10.6929 14.5561 10.5942 14.5558 10.4953C14.5559 10.3966 14.55 10.298 14.5381 10.1999C14.526 10.1 14.5056 10.0012 14.477 9.90458L15.2996 9.3005L14.9496 8.67037L14.0222 9.07307C13.8909 8.92378 13.7375 8.79544 13.5674 8.69252C13.3959 8.58963 13.2054 8.52265 13.0072 8.49562L12.8847 7.51544H12.1148L11.9923 8.49562C11.7969 8.5354 11.6093 8.60638 11.4365 8.70583C11.2656 8.80421 11.1107 8.92821 10.9773 9.07355L10.0499 8.67085L9.69995 9.30101L10.5225 9.90506C10.4992 10.0035 10.4801 10.102 10.4654 10.2004C10.4507 10.2982 10.4434 10.397 10.4437 10.4958C10.4435 10.5947 10.4507 10.6934 10.4654 10.7912C10.4798 10.8874 10.4988 10.9858 10.5225 11.0866L9.69995 11.6901L10.0499 12.3203L10.9773 11.9176C11.1168 12.0573 11.2742 12.178 11.4454 12.2765C11.6163 12.3751 11.8005 12.4487 11.9923 12.495L12.1148 13.4752Z"
			fill="#7D61BC"
		/>
	</SvgIcon>
);

export const CrdownloadFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#2B74A5"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#2B74A5"
		/>
		<path
			d="M12.2576 12.7L9.94878 10.4083L10.5953 9.74376L11.7959 10.9354V7.20001H12.7194V10.9354L13.92 9.74376L14.5665 10.4083L12.2576 12.7ZM9.48701 14.5333C9.23304 14.5333 9.01563 14.4436 8.83477 14.2641C8.65391 14.0846 8.56348 13.8688 8.56348 13.6167V12.2417H9.48701V13.6167H15.0282V12.2417H15.9518V13.6167C15.9518 13.8688 15.8614 14.0846 15.6805 14.2641C15.4996 14.4436 15.2822 14.5333 15.0282 14.5333H9.48701Z"
			fill="#2B74A5"
		/>
		<rect x="5.69238" y="16" width="13.0975" height="3.5" rx="0.5" fill="#D7D7D7" />
		<path
			d="M18.2642 17.7227C18.2642 17.8835 18.2386 18.0179 18.1874 18.126C18.1367 18.2334 18.0632 18.3145 17.9667 18.3691C17.8703 18.4232 17.7541 18.4502 17.6183 18.4502H17.2837V17.0225H17.6547C17.7787 17.0225 17.8862 17.0492 17.9772 17.1025C18.0683 17.1553 18.1389 17.2337 18.189 17.3379C18.2391 17.4414 18.2642 17.5697 18.2642 17.7227ZM18.0039 17.7305C18.0039 17.625 17.991 17.5384 17.9651 17.4707C17.9398 17.4023 17.9021 17.3519 17.8519 17.3193C17.8024 17.2868 17.7409 17.2705 17.6676 17.2705H17.5343V18.2002H17.6418C17.7641 18.2002 17.8549 18.1608 17.9142 18.082C17.974 18.0033 18.0039 17.8861 18.0039 17.7305Z"
			fill="#707070"
		/>
		<path
			d="M16.8644 18.4502L16.7787 18.1104H16.3478L16.2622 18.4502H15.9922L16.4093 17.0166H16.7156L17.1343 18.4502H16.8644ZM16.7189 17.8564L16.6332 17.5244C16.6278 17.5023 16.6205 17.474 16.6114 17.4395C16.6027 17.4043 16.5938 17.3688 16.5847 17.333C16.5761 17.2965 16.5691 17.265 16.5637 17.2383C16.5583 17.265 16.5507 17.2982 16.541 17.3379C16.5319 17.377 16.523 17.4141 16.5144 17.4492C16.5057 17.4844 16.4995 17.5094 16.4958 17.5244L16.4109 17.8564H16.7189Z"
			fill="#707070"
		/>
		<path
			d="M15.8957 17.7344C15.8957 17.8444 15.8844 17.9447 15.8617 18.0352C15.8391 18.125 15.8046 18.2025 15.7583 18.2676C15.7125 18.3327 15.6543 18.3828 15.5837 18.418C15.5131 18.4525 15.4296 18.4697 15.3331 18.4697C15.2366 18.4697 15.1531 18.4525 15.0825 18.418C15.0119 18.3828 14.9535 18.3327 14.9071 18.2676C14.8613 18.2025 14.8271 18.1247 14.8045 18.0342C14.7818 17.9437 14.7705 17.8431 14.7705 17.7324C14.7705 17.5846 14.7904 17.4561 14.8303 17.3467C14.8707 17.2367 14.9327 17.1514 15.0162 17.0908C15.0998 17.0303 15.2059 17 15.3347 17C15.463 17 15.5683 17.0303 15.6508 17.0908C15.7338 17.1514 15.7952 17.2367 15.8351 17.3467C15.8755 17.4567 15.8957 17.5859 15.8957 17.7344ZM15.0332 17.7344C15.0332 17.834 15.0435 17.9199 15.0639 17.9922C15.0849 18.0638 15.1175 18.1191 15.1617 18.1582C15.2059 18.1966 15.263 18.2158 15.3331 18.2158C15.4042 18.2158 15.4619 18.1966 15.5061 18.1582C15.5503 18.1191 15.5823 18.0638 15.6023 17.9922C15.6227 17.9199 15.633 17.834 15.633 17.7344C15.633 17.5846 15.6098 17.4668 15.5635 17.3809C15.5171 17.2949 15.4409 17.252 15.3347 17.252C15.2641 17.252 15.2065 17.2715 15.1617 17.3105C15.1175 17.349 15.0849 17.4043 15.0639 17.4766C15.0435 17.5482 15.0332 17.6341 15.0332 17.7344Z"
			fill="#707070"
		/>
		<path d="M13.8872 18.4502V17.0225H14.1378V18.2002H14.6171V18.4502H13.8872Z" fill="#707070" />
		<path
			d="M13.5889 18.4502H13.2704L12.7563 17.3701H12.7491C12.7512 17.415 12.7531 17.4603 12.7547 17.5059C12.7563 17.5514 12.758 17.597 12.7596 17.6426C12.7612 17.6875 12.7628 17.7327 12.7644 17.7783V18.4502H12.5405V17.0225H12.8566L13.3699 18.0918H13.3755C13.3744 18.0475 13.3731 18.0036 13.3715 17.96C13.3699 17.9163 13.3683 17.8727 13.3666 17.8291C13.3656 17.7855 13.3645 17.7419 13.3634 17.6982V17.0225H13.5889V18.4502Z"
			fill="#707070"
		/>
		<path
			d="M12.3915 17.0225L12.0908 18.4502H11.8055L11.6454 17.7002C11.6422 17.6859 11.6379 17.6641 11.6325 17.6348C11.6271 17.6055 11.6214 17.5736 11.6155 17.5391C11.6096 17.5039 11.6042 17.471 11.5993 17.4404C11.595 17.4092 11.5921 17.3844 11.5904 17.3662C11.5888 17.3844 11.5856 17.4089 11.5807 17.4395C11.5764 17.4701 11.5713 17.5026 11.5654 17.5371C11.56 17.5716 11.5546 17.6038 11.5492 17.6338C11.5438 17.6637 11.5395 17.6865 11.5363 17.7021L11.377 18.4502H11.0925L10.791 17.0225H11.0376L11.1887 17.8018C11.193 17.8252 11.1979 17.8532 11.2033 17.8857C11.2092 17.9183 11.2148 17.9525 11.2202 17.9883C11.2262 18.0234 11.2313 18.0576 11.2356 18.0908C11.2404 18.1234 11.2439 18.1517 11.2461 18.1758C11.2488 18.151 11.2523 18.1224 11.2566 18.0898C11.2609 18.0566 11.2655 18.0231 11.2704 17.9893C11.2757 17.9548 11.2811 17.9229 11.2865 17.8936C11.2919 17.8643 11.2968 17.8405 11.3011 17.8223L11.4732 17.0225H11.7101L11.8823 17.8223C11.886 17.8398 11.8903 17.8636 11.8952 17.8936C11.9006 17.9229 11.906 17.9548 11.9114 17.9893C11.9167 18.0238 11.9216 18.0576 11.9259 18.0908C11.9308 18.1234 11.9343 18.1517 11.9364 18.1758C11.9402 18.1432 11.9453 18.1038 11.9518 18.0576C11.9588 18.0107 11.966 17.9642 11.9736 17.918C11.9817 17.8717 11.9887 17.833 11.9946 17.8018L12.145 17.0225H12.3915Z"
			fill="#707070"
		/>
		<path
			d="M10.695 17.7344C10.695 17.8444 10.6837 17.9447 10.6611 18.0352C10.6384 18.125 10.6039 18.2025 10.5576 18.2676C10.5118 18.3327 10.4536 18.3828 10.383 18.418C10.3124 18.4525 10.2289 18.4697 10.1324 18.4697C10.036 18.4697 9.95243 18.4525 9.88184 18.418C9.81124 18.3828 9.75277 18.3327 9.70643 18.2676C9.66063 18.2025 9.62641 18.1247 9.60377 18.0342C9.58114 17.9437 9.56982 17.8431 9.56982 17.7324C9.56982 17.5846 9.58976 17.4561 9.62964 17.3467C9.67006 17.2367 9.73203 17.1514 9.81555 17.0908C9.89908 17.0303 10.0052 17 10.134 17C10.2623 17 10.3676 17.0303 10.4501 17.0908C10.5331 17.1514 10.5945 17.2367 10.6344 17.3467C10.6748 17.4567 10.695 17.5859 10.695 17.7344ZM9.83253 17.7344C9.83253 17.834 9.84277 17.9199 9.86325 17.9922C9.88426 18.0638 9.91686 18.1191 9.96105 18.1582C10.0052 18.1966 10.0624 18.2158 10.1324 18.2158C10.2035 18.2158 10.2612 18.1966 10.3054 18.1582C10.3496 18.1191 10.3817 18.0638 10.4016 17.9922C10.4221 17.9199 10.4323 17.834 10.4323 17.7344C10.4323 17.5846 10.4091 17.4668 10.3628 17.3809C10.3164 17.2949 10.2402 17.252 10.134 17.252C10.0634 17.252 10.0058 17.2715 9.96105 17.3105C9.91686 17.349 9.88426 17.4043 9.86325 17.4766C9.84277 17.5482 9.83253 17.6341 9.83253 17.7344Z"
			fill="#707070"
		/>
		<path
			d="M9.37747 17.7227C9.37747 17.8835 9.35187 18.0179 9.30068 18.126C9.25002 18.2334 9.17647 18.3145 9.08001 18.3691C8.98355 18.4232 8.86742 18.4502 8.73162 18.4502H8.39697V17.0225H8.76799C8.89194 17.0225 8.99944 17.0492 9.09051 17.1025C9.18159 17.1553 9.25218 17.2337 9.30229 17.3379C9.35241 17.4414 9.37747 17.5697 9.37747 17.7227ZM9.11719 17.7305C9.11719 17.625 9.10426 17.5384 9.07839 17.4707C9.05306 17.4023 9.01534 17.3519 8.96522 17.3193C8.91565 17.2868 8.85421 17.2705 8.78093 17.2705H8.64755V18.2002H8.75506C8.87739 18.2002 8.96819 18.1608 9.02746 18.082C9.08728 18.0033 9.11719 17.8861 9.11719 17.7305Z"
			fill="#707070"
		/>
		<path
			d="M7.64854 17.0225C7.75578 17.0225 7.84416 17.0381 7.91367 17.0693C7.98373 17.1006 8.03573 17.1478 8.06968 17.2109C8.10363 17.2741 8.12061 17.3538 8.12061 17.4502C8.12061 17.5153 8.11037 17.5723 8.08989 17.6211C8.06941 17.6699 8.04247 17.7113 8.00906 17.7451C7.97565 17.779 7.93954 17.8066 7.90074 17.8281L8.24832 18.4502H7.97026L7.68815 17.9023H7.55478V18.4502H7.3042V17.0225H7.64854ZM7.63076 17.2705H7.55478V17.6562H7.63561C7.7186 17.6562 7.77788 17.6396 7.81344 17.6064C7.84955 17.5726 7.8676 17.5231 7.8676 17.458C7.8676 17.3903 7.8482 17.3421 7.8094 17.3135C7.77114 17.2848 7.71159 17.2705 7.63076 17.2705Z"
			fill="#707070"
		/>
		<path
			d="M6.75031 17.2539C6.70235 17.2539 6.65978 17.2653 6.6226 17.2881C6.58595 17.3102 6.55497 17.3424 6.52964 17.3848C6.50485 17.4271 6.48599 17.4782 6.47306 17.5381C6.46012 17.598 6.45366 17.6654 6.45366 17.7402C6.45366 17.8411 6.46389 17.9274 6.48437 17.999C6.50539 18.07 6.53772 18.1243 6.58137 18.1621C6.62502 18.1992 6.68133 18.2178 6.75031 18.2178C6.79827 18.2178 6.84623 18.2113 6.89419 18.1982C6.94269 18.1852 6.99523 18.1667 7.05182 18.1426V18.3965C6.99954 18.4225 6.94808 18.4411 6.89743 18.4521C6.84677 18.4639 6.78992 18.4697 6.72687 18.4697C6.60508 18.4697 6.50485 18.4395 6.42617 18.3789C6.34804 18.3177 6.29011 18.2324 6.25238 18.123C6.21466 18.013 6.1958 17.8848 6.1958 17.7383C6.1958 17.6302 6.20793 17.5312 6.23218 17.4414C6.25643 17.3516 6.29199 17.2738 6.33887 17.208C6.38576 17.1423 6.44369 17.0915 6.51266 17.0557C6.58164 17.0199 6.66086 17.002 6.75031 17.002C6.80905 17.002 6.86779 17.0111 6.92653 17.0293C6.9858 17.0469 7.04238 17.0713 7.09627 17.1025L7.01544 17.3486C6.97125 17.3232 6.92679 17.3011 6.88207 17.2822C6.83734 17.2633 6.79342 17.2539 6.75031 17.2539Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const CsvFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#17824A"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#17824A"
		/>
		<path d="M8.85 13.75H6.75V13H8.85V13.75Z" fill="#17824A" />
		<path d="M11.85 13.75H9.75V13H11.85V13.75Z" fill="#17824A" />
		<path d="M14.85 13.75H12.75V13H14.85V13.75Z" fill="#17824A" />
		<path d="M17.85 13.75H15.75V13H17.85V13.75Z" fill="#17824A" />
		<path d="M8.85 12H6.75V11.25H8.85V12Z" fill="#17824A" />
		<path d="M11.85 12H9.75V11.25H11.85V12Z" fill="#17824A" />
		<path d="M14.85 12H12.75V11.25H14.85V12Z" fill="#17824A" />
		<path d="M17.85 12H15.75V11.25H17.85V12Z" fill="#17824A" />
		<path d="M8.85 10.25H6.75V9.5H8.85V10.25Z" fill="#17824A" />
		<path d="M11.85 10.25H9.75V9.5H11.85V10.25Z" fill="#17824A" />
		<path d="M14.85 10.25H12.75V9.5H14.85V10.25Z" fill="#17824A" />
		<path d="M17.85 10.25H15.75V9.5H17.85V10.25Z" fill="#17824A" />
		<path
			d="M15.25 16H9.25C8.69772 16 8.25 16.4477 8.25 17V18.5C8.25 19.0523 8.69772 19.5 9.25 19.5H15.25C15.8023 19.5 16.25 19.0523 16.25 18.5V17C16.25 16.4477 15.8023 16 15.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.9409 16.7307L14.2129 18.8723H13.7178L12.9912 16.7307H13.4497L13.8525 18.0051C13.8594 18.0266 13.8706 18.0671 13.8862 18.1267C13.9019 18.1853 13.9175 18.2478 13.9331 18.3142C13.9497 18.3796 13.9609 18.4338 13.9668 18.4768C13.9727 18.4338 13.9829 18.3796 13.9976 18.3142C14.0132 18.2488 14.0283 18.1868 14.043 18.1282C14.0586 18.0686 14.0698 18.0276 14.0767 18.0051L14.4824 16.7307H14.9409Z"
			fill="#707070"
		/>
		<path
			d="M12.8726 18.2776C12.8726 18.4045 12.8418 18.5149 12.7803 18.6086C12.7188 18.7024 12.6289 18.7747 12.5107 18.8254C12.3936 18.8762 12.251 18.9016 12.083 18.9016C12.0088 18.9016 11.936 18.8967 11.8647 18.887C11.7944 18.8772 11.7266 18.863 11.6611 18.8445C11.5967 18.825 11.5352 18.801 11.4766 18.7727V18.3508C11.5781 18.3958 11.6836 18.4363 11.793 18.4724C11.9023 18.5085 12.0107 18.5266 12.1182 18.5266C12.1924 18.5266 12.252 18.5168 12.2969 18.4973C12.3428 18.4778 12.376 18.4509 12.3965 18.4167C12.417 18.3826 12.4272 18.3435 12.4272 18.2996C12.4272 18.2458 12.4092 18.2 12.373 18.1619C12.3369 18.1238 12.2871 18.0881 12.2236 18.0549C12.1611 18.0217 12.0903 17.9861 12.0112 17.948C11.9614 17.9246 11.9072 17.8962 11.8486 17.863C11.79 17.8289 11.7344 17.7874 11.6816 17.7385C11.6289 17.6897 11.5854 17.6306 11.5513 17.5613C11.5181 17.491 11.5015 17.407 11.5015 17.3093C11.5015 17.1814 11.5308 17.072 11.5894 16.9812C11.6479 16.8904 11.7314 16.821 11.8398 16.7732C11.9492 16.7244 12.0781 16.7 12.2266 16.7C12.3379 16.7 12.4438 16.7131 12.5444 16.7395C12.646 16.7649 12.752 16.802 12.8623 16.8508L12.7158 17.2039C12.6172 17.1638 12.5288 17.1331 12.4507 17.1116C12.3726 17.0891 12.293 17.0779 12.2119 17.0779C12.1553 17.0779 12.1069 17.0872 12.0669 17.1057C12.0269 17.1233 11.9966 17.1487 11.9761 17.1819C11.9556 17.2141 11.9453 17.2517 11.9453 17.2947C11.9453 17.3455 11.96 17.3884 11.9893 17.4236C12.0195 17.4578 12.0645 17.491 12.124 17.5232C12.1846 17.5554 12.2598 17.593 12.3496 17.636C12.459 17.6877 12.5522 17.7419 12.6294 17.7986C12.7075 17.8542 12.7676 17.9202 12.8096 17.9963C12.8516 18.0715 12.8726 18.1653 12.8726 18.2776Z"
			fill="#707070"
		/>
		<path
			d="M10.605 17.0779C10.5181 17.0779 10.4409 17.095 10.3735 17.1292C10.3071 17.1624 10.251 17.2107 10.2051 17.2742C10.1602 17.3376 10.126 17.4143 10.1025 17.5042C10.0791 17.594 10.0674 17.6951 10.0674 17.8074C10.0674 17.9587 10.0859 18.0881 10.123 18.1956C10.1611 18.302 10.2197 18.3835 10.2988 18.4402C10.3779 18.4958 10.48 18.5237 10.605 18.5237C10.6919 18.5237 10.7788 18.5139 10.8657 18.4944C10.9536 18.4749 11.0488 18.447 11.1514 18.4109V18.7917C11.0566 18.8308 10.9634 18.8586 10.8716 18.8752C10.7798 18.8928 10.6768 18.9016 10.5625 18.9016C10.3418 18.9016 10.1602 18.8562 10.0176 18.7654C9.87598 18.6736 9.771 18.5457 9.70264 18.3816C9.63428 18.2166 9.6001 18.0242 9.6001 17.8044C9.6001 17.6423 9.62207 17.4939 9.66602 17.3591C9.70996 17.2244 9.77441 17.1077 9.85938 17.009C9.94434 16.9104 10.0493 16.8342 10.1743 16.7805C10.2993 16.7268 10.4429 16.7 10.605 16.7C10.7114 16.7 10.8179 16.7136 10.9243 16.741C11.0317 16.7673 11.1343 16.804 11.2319 16.8508L11.0854 17.22C11.0054 17.1819 10.9248 17.1487 10.8438 17.1204C10.7627 17.092 10.6831 17.0779 10.605 17.0779Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const DocFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#106EAD"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#106EAD"
		/>
		<path
			d="M15.75 16H8.75C8.19772 16 7.75 16.4477 7.75 17V18.5C7.75 19.0523 8.19772 19.5 8.75 19.5H15.75C16.3023 19.5 16.75 19.0523 16.75 18.5V17C16.75 16.4477 16.3023 16 15.75 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.7769 17.1855C14.6899 17.1855 14.6128 17.2026 14.5454 17.2368C14.479 17.27 14.4229 17.3184 14.377 17.3818C14.332 17.4453 14.2979 17.522 14.2744 17.6118C14.251 17.7017 14.2393 17.8027 14.2393 17.915C14.2393 18.0664 14.2578 18.1958 14.2949 18.3032C14.333 18.4097 14.3916 18.4912 14.4707 18.5479C14.5498 18.6035 14.6519 18.6313 14.7769 18.6313C14.8638 18.6313 14.9507 18.6216 15.0376 18.6021C15.1255 18.5825 15.2207 18.5547 15.3232 18.5186V18.8994C15.2285 18.9385 15.1353 18.9663 15.0435 18.9829C14.9517 19.0005 14.8486 19.0093 14.7344 19.0093C14.5137 19.0093 14.332 18.9639 14.1895 18.873C14.0479 18.7812 13.9429 18.6533 13.8745 18.4893C13.8062 18.3242 13.772 18.1318 13.772 17.9121C13.772 17.75 13.7939 17.6016 13.8379 17.4668C13.8818 17.332 13.9463 17.2153 14.0312 17.1167C14.1162 17.0181 14.2212 16.9419 14.3462 16.8882C14.4712 16.8345 14.6147 16.8076 14.7769 16.8076C14.8833 16.8076 14.9897 16.8213 15.0962 16.8486C15.2036 16.875 15.3062 16.9116 15.4038 16.9585L15.2573 17.3276C15.1772 17.2896 15.0967 17.2563 15.0156 17.228C14.9346 17.1997 14.855 17.1855 14.7769 17.1855Z"
			fill="#707070"
		/>
		<path
			d="M13.4233 17.9062C13.4233 18.0713 13.4028 18.2217 13.3618 18.3574C13.3208 18.4922 13.2583 18.6084 13.1743 18.7061C13.0913 18.8037 12.9858 18.8789 12.8579 18.9316C12.73 18.9834 12.5786 19.0093 12.4038 19.0093C12.229 19.0093 12.0776 18.9834 11.9497 18.9316C11.8218 18.8789 11.7158 18.8037 11.6318 18.7061C11.5488 18.6084 11.4868 18.4917 11.4458 18.356C11.4048 18.2202 11.3843 18.0693 11.3843 17.9033C11.3843 17.6816 11.4204 17.4888 11.4927 17.3247C11.5659 17.1597 11.6782 17.0317 11.8296 16.9409C11.981 16.8501 12.1733 16.8047 12.4067 16.8047C12.6392 16.8047 12.8301 16.8501 12.9795 16.9409C13.1299 17.0317 13.2412 17.1597 13.3135 17.3247C13.3867 17.4897 13.4233 17.6836 13.4233 17.9062ZM11.8604 17.9062C11.8604 18.0557 11.8789 18.1846 11.916 18.293C11.9541 18.4004 12.0132 18.4834 12.0933 18.542C12.1733 18.5996 12.2769 18.6284 12.4038 18.6284C12.5327 18.6284 12.6372 18.5996 12.7173 18.542C12.7974 18.4834 12.8555 18.4004 12.8916 18.293C12.9287 18.1846 12.9473 18.0557 12.9473 17.9062C12.9473 17.6816 12.9053 17.5049 12.8213 17.376C12.7373 17.2471 12.5991 17.1826 12.4067 17.1826C12.2788 17.1826 12.1743 17.2119 12.0933 17.2705C12.0132 17.3281 11.9541 17.4111 11.916 17.5195C11.8789 17.627 11.8604 17.7559 11.8604 17.9062Z"
			fill="#707070"
		/>
		<path
			d="M11.0356 17.8887C11.0356 18.1299 10.9893 18.3315 10.8965 18.4937C10.8047 18.6548 10.6714 18.7764 10.4966 18.8584C10.3218 18.9395 10.1113 18.98 9.86523 18.98H9.25879V16.8384H9.93115C10.1558 16.8384 10.3506 16.8784 10.5156 16.9585C10.6807 17.0376 10.8086 17.1553 10.8994 17.3115C10.9902 17.4668 11.0356 17.6592 11.0356 17.8887ZM10.564 17.9004C10.564 17.7422 10.5405 17.6123 10.4937 17.5107C10.4478 17.4082 10.3794 17.3325 10.2886 17.2837C10.1987 17.2349 10.0874 17.2104 9.95459 17.2104H9.71289V18.605H9.90771C10.1294 18.605 10.2939 18.5459 10.4014 18.4277C10.5098 18.3096 10.564 18.1338 10.564 17.9004Z"
			fill="#707070"
		/>
		<path d="M17.75 10.25H10.75V9.5H17.75V10.25Z" fill="#106EAD" />
		<path d="M17.75 12.25H6.75V11.5H17.75V12.25Z" fill="#106EAD" />
		<path d="M12.25 14.25H6.75V13.5H12.25V14.25Z" fill="#106EAD" />
		<rect x="6.75" y="8.25" width="3" height="2" fill="#106EAD" />
	</SvgIcon>
);

export const DocxFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#106EAD"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#106EAD"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M16.5029 18.9253H15.9844L15.4863 18.1152L14.9883 18.9253H14.502L15.2124 17.8208L14.5474 16.7837H15.0483L15.5098 17.5542L15.9624 16.7837H16.4517L15.7793 17.8457L16.5029 18.9253Z"
			fill="#707070"
		/>
		<path
			d="M13.7681 17.1309C13.6812 17.1309 13.604 17.1479 13.5366 17.1821C13.4702 17.2153 13.4141 17.2637 13.3682 17.3271C13.3232 17.3906 13.2891 17.4673 13.2656 17.5571C13.2422 17.647 13.2305 17.748 13.2305 17.8604C13.2305 18.0117 13.249 18.1411 13.2861 18.2485C13.3242 18.355 13.3828 18.4365 13.4619 18.4932C13.541 18.5488 13.6431 18.5767 13.7681 18.5767C13.855 18.5767 13.9419 18.5669 14.0288 18.5474C14.1167 18.5278 14.2119 18.5 14.3145 18.4639V18.8447C14.2197 18.8838 14.1265 18.9116 14.0347 18.9282C13.9429 18.9458 13.8398 18.9546 13.7256 18.9546C13.5049 18.9546 13.3232 18.9092 13.1807 18.8184C13.0391 18.7266 12.9341 18.5986 12.8657 18.4346C12.7974 18.2695 12.7632 18.0771 12.7632 17.8574C12.7632 17.6953 12.7852 17.5469 12.8291 17.4121C12.873 17.2773 12.9375 17.1606 13.0225 17.062C13.1074 16.9634 13.2124 16.8872 13.3374 16.8335C13.4624 16.7798 13.606 16.7529 13.7681 16.7529C13.8745 16.7529 13.981 16.7666 14.0874 16.7939C14.1948 16.8203 14.2974 16.8569 14.395 16.9038L14.2485 17.2729C14.1685 17.2349 14.0879 17.2017 14.0068 17.1733C13.9258 17.145 13.8462 17.1309 13.7681 17.1309Z"
			fill="#707070"
		/>
		<path
			d="M12.4146 17.8516C12.4146 18.0166 12.394 18.167 12.353 18.3027C12.312 18.4375 12.2495 18.5537 12.1655 18.6514C12.0825 18.749 11.9771 18.8242 11.8491 18.877C11.7212 18.9287 11.5698 18.9546 11.395 18.9546C11.2202 18.9546 11.0688 18.9287 10.9409 18.877C10.813 18.8242 10.707 18.749 10.623 18.6514C10.54 18.5537 10.478 18.437 10.437 18.3013C10.396 18.1655 10.3755 18.0146 10.3755 17.8486C10.3755 17.627 10.4116 17.4341 10.4839 17.27C10.5571 17.105 10.6694 16.9771 10.8208 16.8862C10.9722 16.7954 11.1646 16.75 11.3979 16.75C11.6304 16.75 11.8213 16.7954 11.9707 16.8862C12.1211 16.9771 12.2324 17.105 12.3047 17.27C12.3779 17.4351 12.4146 17.6289 12.4146 17.8516ZM10.8516 17.8516C10.8516 18.001 10.8701 18.1299 10.9072 18.2383C10.9453 18.3457 11.0044 18.4287 11.0845 18.4873C11.1646 18.5449 11.2681 18.5737 11.395 18.5737C11.5239 18.5737 11.6284 18.5449 11.7085 18.4873C11.7886 18.4287 11.8467 18.3457 11.8828 18.2383C11.9199 18.1299 11.9385 18.001 11.9385 17.8516C11.9385 17.627 11.8965 17.4502 11.8125 17.3213C11.7285 17.1924 11.5903 17.1279 11.3979 17.1279C11.27 17.1279 11.1655 17.1572 11.0845 17.2158C11.0044 17.2734 10.9453 17.3564 10.9072 17.4648C10.8701 17.5723 10.8516 17.7012 10.8516 17.8516Z"
			fill="#707070"
		/>
		<path
			d="M10.0269 17.834C10.0269 18.0752 9.98047 18.2769 9.8877 18.439C9.7959 18.6001 9.6626 18.7217 9.48779 18.8037C9.31299 18.8848 9.10254 18.9253 8.85645 18.9253H8.25V16.7837H8.92236C9.14697 16.7837 9.3418 16.8237 9.50684 16.9038C9.67188 16.9829 9.7998 17.1006 9.89062 17.2568C9.98145 17.4121 10.0269 17.6045 10.0269 17.834ZM9.55518 17.8457C9.55518 17.6875 9.53174 17.5576 9.48486 17.4561C9.43896 17.3535 9.37061 17.2778 9.27979 17.229C9.18994 17.1802 9.07861 17.1558 8.9458 17.1558H8.7041V18.5503H8.89893C9.12061 18.5503 9.28516 18.4912 9.39258 18.373C9.50098 18.2549 9.55518 18.0791 9.55518 17.8457Z"
			fill="#707070"
		/>
		<path d="M17.75 10.25H10.75V9.5H17.75V10.25Z" fill="#106EAD" />
		<path d="M17.75 12.25H6.75V11.5H17.75V12.25Z" fill="#106EAD" />
		<path d="M12.25 14.25H6.75V13.5H12.25V14.25Z" fill="#106EAD" />
		<rect x="6.75" y="8.25" width="3" height="2" fill="#106EAD" />
	</SvgIcon>
);

export const EmlFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#51AED6"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#51AED6"
		/>
		<path
			d="M16.2998 16.02H8.2998C7.74752 16.02 7.2998 16.4677 7.2998 17.02V18.52C7.2998 19.0723 7.74752 19.52 8.2998 19.52H16.2998C16.8521 19.52 17.2998 19.0723 17.2998 18.52V17.02C17.2998 16.4677 16.8521 16.02 16.2998 16.02Z"
			fill="#D7D7D7"
		/>
		<path d="M13.9116 18.9616V16.82H14.3657V18.5866H15.2344V18.9616H13.9116Z" fill="#707070" />
		<path
			d="M11.9883 18.9616L11.4727 17.2814H11.4595C11.4614 17.3215 11.4644 17.382 11.4683 17.4631C11.4731 17.5432 11.4775 17.6286 11.4814 17.7194C11.4854 17.8102 11.4873 17.8923 11.4873 17.9655V18.9616H11.0815V16.82H11.6997L12.2065 18.4577H12.2153L12.7529 16.82H13.3711V18.9616H12.9478V17.9479C12.9478 17.8806 12.9487 17.8029 12.9507 17.715C12.9536 17.6271 12.957 17.5436 12.9609 17.4645C12.9648 17.3845 12.9678 17.3244 12.9697 17.2844H12.9565L12.4043 18.9616H11.9883Z"
			fill="#707070"
		/>
		<path
			d="M10.6333 18.9616H9.3999V16.82H10.6333V17.1921H9.854V17.6623H10.5791V18.0344H9.854V18.5866H10.6333V18.9616Z"
			fill="#707070"
		/>
		<path
			d="M9.5249 14.6C9.45616 14.6001 9.38811 14.5852 9.32492 14.5562C9.26174 14.5272 9.20474 14.4847 9.15743 14.4313C9.10777 14.3808 9.06821 14.32 9.04115 14.2526C9.01408 14.1852 9.00009 14.1126 9 14.0392V9.16253C8.99986 9.08886 9.01374 9.01593 9.04081 8.94821C9.06788 8.88049 9.10756 8.81941 9.15743 8.7687C9.20474 8.71526 9.26174 8.67273 9.32492 8.64372C9.38811 8.61471 9.45616 8.59982 9.5249 8.59998H15.4751C15.5438 8.59982 15.6119 8.61471 15.6751 8.64372C15.7383 8.67273 15.7953 8.71526 15.8426 8.7687C15.8924 8.81941 15.9321 8.88049 15.9592 8.94821C15.9863 9.01593 16.0001 9.08886 16 9.16253V14.0392C15.9962 14.187 15.9396 14.3275 15.8419 14.4318C15.7443 14.5361 15.613 14.5963 15.4751 14.6H9.5249ZM12.5 11.7696L9.5249 9.67862V14.0392H15.4751V9.67862L12.5 11.7696ZM12.5 11.207L15.4402 9.16253H9.56867L12.5 11.207Z"
			fill="#51AED6"
		/>
	</SvgIcon>
);

export const ExeFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#174560"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#174560"
		/>
		<path
			d="M16.2998 16.02H8.2998C7.74752 16.02 7.2998 16.4677 7.2998 17.02V18.52C7.2998 19.0723 7.74752 19.52 8.2998 19.52H16.2998C16.8521 19.52 17.2998 19.0723 17.2998 18.52V17.02C17.2998 16.4677 16.8521 16.02 16.2998 16.02Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.916 18.8916H13.6826V16.75H14.916V17.1221H14.1367V17.5923H14.8618V17.9644H14.1367V18.5166H14.916V18.8916Z"
			fill="#707070"
		/>
		<path
			d="M13.4131 18.8916H12.8945L12.3965 18.0815L11.8984 18.8916H11.4121L12.1226 17.7871L11.4575 16.75H11.9585L12.4199 17.5205L12.8726 16.75H13.3618L12.6895 17.812L13.4131 18.8916Z"
			fill="#707070"
		/>
		<path
			d="M11.2334 18.8916H10V16.75H11.2334V17.1221H10.4541V17.5923H11.1792V17.9644H10.4541V18.5166H11.2334V18.8916Z"
			fill="#707070"
		/>
		<path
			d="M14.5312 11.8594L14.5215 12.3906C14.5748 12.4222 14.6263 12.4576 14.6748 12.4961C14.7241 12.5339 14.7687 12.5787 14.8066 12.6279L15.3311 12.4912L15.5938 13.2324L15.0947 13.4697C15.0952 13.4998 15.0939 13.5307 15.0898 13.5605C15.0858 13.5913 15.0811 13.6206 15.0762 13.6484C15.0713 13.6764 15.0651 13.7053 15.0586 13.7344C15.0523 13.7631 15.0438 13.7919 15.0332 13.8193L15.4209 14.2178L14.9199 14.8242L14.4736 14.5166C14.4193 14.5464 14.3625 14.5724 14.3047 14.5947C14.2471 14.6178 14.1866 14.6338 14.125 14.6416L13.9521 15.1445L13.1963 15.0117L13.2051 14.4795C13.1522 14.4481 13.1017 14.4127 13.0547 14.373C13.0066 14.3336 12.962 14.2899 12.9209 14.2432L12.3965 14.3799L12.1338 13.6387L12.6348 13.3936C12.6338 13.3649 12.6356 13.336 12.6396 13.3076C12.6437 13.2766 12.6479 13.2479 12.6523 13.2227C12.6568 13.1974 12.6621 13.1693 12.6689 13.1387C12.6749 13.1106 12.6837 13.0833 12.6943 13.0566L12.3076 12.6543L12.8076 12.0479L13.2539 12.3555C13.3085 12.3256 13.3661 12.3009 13.4248 12.2803C13.482 12.2591 13.5412 12.244 13.6016 12.2354L13.7754 11.7256L14.5312 11.8594ZM13.791 12.4521C13.6962 12.4547 13.6019 12.4725 13.5127 12.5049C13.4244 12.5369 13.3412 12.5825 13.2666 12.6396L12.8652 12.374L12.6484 12.6406L12.9844 12.9922C12.9653 13.0365 12.9487 13.082 12.9336 13.127C12.9187 13.1715 12.9065 13.2174 12.8984 13.2637C12.8902 13.31 12.886 13.3573 12.8848 13.4043C12.8836 13.4504 12.884 13.4979 12.8867 13.5469L12.4512 13.7627L12.5635 14.0869L13.0322 13.9746C13.0862 14.0518 13.1495 14.1222 13.2217 14.1826C13.2938 14.243 13.3747 14.2924 13.4609 14.3301L13.4375 14.8008L13.7988 14.8643L13.9375 14.4141C14.0313 14.4081 14.1236 14.3885 14.2119 14.3564C14.3004 14.3244 14.3848 14.2806 14.4619 14.2266L14.8633 14.4932L15.0801 14.2256L14.7441 13.874C14.7632 13.8298 14.7799 13.7851 14.7949 13.7402C14.8099 13.6956 14.822 13.6499 14.8301 13.6035C14.8383 13.5572 14.8432 13.5099 14.8457 13.4629C14.8483 13.4151 14.8472 13.3669 14.8418 13.3193L15.2773 13.1035L15.165 12.7793L14.6963 12.8916C14.647 12.8107 14.586 12.7371 14.5146 12.6748C14.4427 12.6124 14.3583 12.5652 14.2676 12.5361L14.292 12.0664L13.9297 12.0029L13.791 12.4521ZM13.958 12.9014C14.0284 12.9126 14.0961 12.9383 14.1562 12.9766C14.2164 13.0148 14.2685 13.065 14.3086 13.124C14.3503 13.1818 14.3792 13.2478 14.3945 13.3174C14.4099 13.3871 14.411 13.4592 14.3975 13.5293C14.3862 13.5998 14.3605 13.6673 14.3223 13.7275C14.284 13.7878 14.2338 13.8398 14.1748 13.8799C14.117 13.9216 14.0511 13.9514 13.9814 13.9668C13.9118 13.9821 13.8396 13.9833 13.7695 13.9697C13.6991 13.9585 13.6315 13.9328 13.5713 13.8945C13.5111 13.8562 13.459 13.8061 13.4189 13.7471C13.3772 13.6892 13.3484 13.6224 13.333 13.5527C13.3177 13.4831 13.3165 13.4108 13.3301 13.3408C13.3413 13.2705 13.3671 13.2027 13.4053 13.1426C13.4435 13.0825 13.4938 13.0312 13.5527 12.9912C13.6106 12.9494 13.6764 12.9197 13.7461 12.9043C13.8157 12.889 13.888 12.8878 13.958 12.9014ZM13.8008 13.1494C13.7633 13.1577 13.7274 13.1738 13.6963 13.1963C13.6647 13.2177 13.6378 13.2452 13.6172 13.2773C13.5966 13.3098 13.5822 13.3468 13.5762 13.3848C13.569 13.4223 13.5699 13.4608 13.5781 13.498C13.5864 13.5356 13.6025 13.5714 13.625 13.6025C13.6466 13.6343 13.6737 13.662 13.7061 13.6826C13.7223 13.693 13.7399 13.7012 13.7578 13.708L13.8135 13.7227C13.8512 13.7298 13.8903 13.7301 13.9277 13.7217C13.9651 13.7133 14.0002 13.6963 14.0312 13.6738C14.0628 13.6524 14.0898 13.625 14.1104 13.5928C14.131 13.5603 14.1453 13.5233 14.1514 13.4854C14.1585 13.4478 14.1576 13.4094 14.1494 13.3721C14.1411 13.3345 14.1251 13.2987 14.1025 13.2676C14.0811 13.236 14.0537 13.209 14.0215 13.1885C13.9891 13.1678 13.952 13.1535 13.9141 13.1475C13.8766 13.1403 13.8381 13.1412 13.8008 13.1494ZM12.2256 8.29395C12.3132 8.32695 12.3991 8.36646 12.4814 8.41113C12.5645 8.45439 12.6417 8.5082 12.7109 8.57129L13.4561 8.23145L14.042 9.26465L13.3613 9.75C13.37 9.79461 13.3752 9.84033 13.377 9.88574C13.3791 9.93276 13.3799 9.9777 13.3799 10.0205C13.3799 10.0635 13.3791 10.1082 13.377 10.1533C13.3751 10.1976 13.3698 10.2417 13.3613 10.2852L14.042 10.7764L13.4561 11.8105L12.7109 11.4697C12.638 11.5283 12.5616 11.5826 12.4814 11.6309C12.4017 11.6805 12.3153 11.7193 12.2256 11.7471L12.0996 12.541L10.9404 12.542L10.8145 11.7471C10.7274 11.7142 10.6429 11.6747 10.5625 11.6279C10.4806 11.5819 10.4024 11.5294 10.3291 11.4707L9.58496 11.8105L9 10.7773L9.68066 10.2803C9.67177 10.2378 9.66648 10.1947 9.66504 10.1514C9.66292 10.1042 9.66212 10.0611 9.66211 10.0225C9.66211 9.98369 9.66291 9.94009 9.66504 9.89258C9.66649 9.84924 9.67175 9.80611 9.68066 9.76367L9 9.26758L9.58594 8.2334L10.3301 8.57422C10.4033 8.5156 10.4817 8.46299 10.5635 8.41699C10.6431 8.37041 10.7277 8.33151 10.8154 8.30273L10.9404 7.5H12.0996L12.2256 8.29395ZM11.1553 8.57715C11.0146 8.6058 10.8793 8.65689 10.7549 8.72852C10.6317 8.79937 10.5199 8.88848 10.4238 8.99316L9.75586 8.70312L9.50391 9.15723L10.0967 9.59277C10.08 9.66342 10.0663 9.73404 10.0557 9.80469C10.0451 9.875 10.0399 9.94647 10.04 10.0176C10.0399 10.0887 10.0451 10.1601 10.0557 10.2305C10.0661 10.2997 10.0797 10.3708 10.0967 10.4434L9.50391 10.8779L9.75586 11.332L10.4238 11.042C10.5243 11.1426 10.6384 11.2299 10.7617 11.3008C10.8847 11.3717 11.0173 11.4246 11.1553 11.458L11.2432 12.1641H11.7979L11.8867 11.458C12.0247 11.4246 12.1573 11.3717 12.2803 11.3008C12.4035 11.2299 12.5167 11.1426 12.6172 11.042L13.2852 11.332L13.5371 10.8779L12.9453 10.4434C12.9621 10.3725 12.9757 10.3013 12.9863 10.2305C12.9969 10.1601 13.0021 10.0888 13.002 10.0176C13.002 9.94647 12.9978 9.87528 12.9893 9.80469C12.9806 9.73269 12.9659 9.66135 12.9453 9.5918L13.5371 9.15723L13.2852 8.70312L12.6172 8.99316C12.5226 8.88568 12.4125 8.79286 12.29 8.71875C12.1667 8.64472 12.0293 8.59666 11.8867 8.57715L11.7979 7.87109H11.2432L11.1553 8.57715ZM11.5205 9.20117C11.6283 9.19939 11.7353 9.22057 11.835 9.26172C11.9346 9.30288 12.0245 9.36408 12.0996 9.44141C12.1769 9.51653 12.2381 9.60641 12.2793 9.70605C12.3204 9.8057 12.3407 9.91272 12.3389 10.0205C12.3407 10.1283 12.3204 10.2353 12.2793 10.335C12.2381 10.4347 12.177 10.5254 12.0996 10.6006C12.0245 10.6778 11.9345 10.7392 11.835 10.7803C11.7601 10.8112 11.681 10.8301 11.6006 10.8369L11.5205 10.8398C11.4127 10.8416 11.3057 10.8214 11.2061 10.7803C11.1063 10.739 11.0156 10.6781 10.9404 10.6006C10.8631 10.5254 10.8019 10.4346 10.7607 10.335C10.7197 10.2354 10.6994 10.1282 10.7012 10.0205C10.6994 9.91276 10.7196 9.80567 10.7607 9.70605C10.8018 9.6065 10.8632 9.5165 10.9404 9.44141C11.0156 9.36405 11.1064 9.30288 11.2061 9.26172C11.3057 9.22058 11.4127 9.19937 11.5205 9.20117ZM11.5205 9.5791C11.4625 9.57818 11.4042 9.58913 11.3506 9.61133C11.2971 9.63352 11.2484 9.66642 11.208 9.70801C11.1664 9.74839 11.1335 9.79704 11.1113 9.85059C11.0891 9.90425 11.0782 9.96244 11.0791 10.0205C11.0782 10.0784 11.0892 10.1359 11.1113 10.1895C11.1335 10.243 11.1665 10.2917 11.208 10.332C11.2484 10.3736 11.297 10.4075 11.3506 10.4297C11.3773 10.4407 11.4054 10.4487 11.4336 10.4541L11.5205 10.4619C11.5786 10.4627 11.6368 10.452 11.6904 10.4297C11.7439 10.4074 11.7918 10.3737 11.832 10.332C11.8737 10.2916 11.9065 10.2431 11.9287 10.1895C11.9509 10.1359 11.9618 10.0785 11.9609 10.0205C11.9619 9.96244 11.9509 9.90425 11.9287 9.85059C11.9065 9.79713 11.8736 9.74833 11.832 9.70801C11.7917 9.6665 11.743 9.63347 11.6895 9.61133C11.6359 9.58923 11.5784 9.5782 11.5205 9.5791Z"
			fill="#174560"
		/>
	</SvgIcon>
);

export const GifFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#707070"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M15.2402 16H9.24023C8.68795 16 8.24023 16.4477 8.24023 17V18.5C8.24023 19.0523 8.68795 19.5 9.24023 19.5H15.2402C15.7925 19.5 16.2402 19.0523 16.2402 18.5V17C16.2402 16.4477 15.7925 16 15.2402 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M13.709 18.9224H13.2622V16.7808H14.4897V17.1528H13.709V17.7051H14.4355V18.0757H13.709V18.9224Z"
			fill="#707070"
		/>
		<path d="M12.269 18.9224V16.7808H12.7231V18.9224H12.269Z" fill="#707070" />
		<path
			d="M10.9082 17.7197H11.7578V18.8301C11.6455 18.8672 11.5288 18.897 11.4077 18.9194C11.2866 18.9409 11.1494 18.9517 10.9961 18.9517C10.7832 18.9517 10.6025 18.9097 10.4541 18.8257C10.3057 18.7417 10.1929 18.6177 10.1157 18.4536C10.0386 18.2896 10 18.0879 10 17.8486C10 17.624 10.043 17.4297 10.1289 17.2656C10.2158 17.1016 10.3423 16.9746 10.5083 16.8848C10.6753 16.7949 10.8789 16.75 11.1191 16.75C11.2324 16.75 11.3442 16.7622 11.4546 16.7866C11.5649 16.811 11.665 16.8428 11.7549 16.8818L11.604 17.2451C11.5386 17.2119 11.4639 17.1841 11.3799 17.1616C11.2959 17.1392 11.208 17.1279 11.1162 17.1279C10.9844 17.1279 10.8696 17.1582 10.772 17.2188C10.6753 17.2793 10.6001 17.3643 10.5464 17.4736C10.4937 17.582 10.4673 17.71 10.4673 17.8574C10.4673 17.9971 10.4863 18.1211 10.5244 18.2295C10.5625 18.3369 10.6226 18.4214 10.7046 18.4829C10.7866 18.5435 10.8936 18.5737 11.0254 18.5737C11.0898 18.5737 11.144 18.5708 11.188 18.5649C11.2329 18.5581 11.2749 18.5513 11.314 18.5444V18.0977H10.9082V17.7197Z"
			fill="#707070"
		/>
		<path
			d="M6.50049 14.5317L10.4009 11.1011L11.8735 12.5503L14.4263 9.96631L17.8325 14.4458L6.50049 14.5317Z"
			fill="#707070"
		/>
		<path
			d="M9.50049 10C10.0528 10 10.5005 9.55228 10.5005 9C10.5005 8.44772 10.0528 8 9.50049 8C8.9482 8 8.50049 8.44772 8.50049 9C8.50049 9.55228 8.9482 10 9.50049 10Z"
			fill="white"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			stroke="#707070"
		/>
	</SvgIcon>
);

export const HtmFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7CC2E8"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7CC2E8"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.0811 18.9416L13.5654 17.2614H13.5522C13.5542 17.3015 13.5571 17.362 13.561 17.4431C13.5659 17.5231 13.5703 17.6086 13.5742 17.6994C13.5781 17.7902 13.5801 17.8723 13.5801 17.9455V18.9416H13.1743V16.8H13.7925L14.2993 18.4377H14.3081L14.8457 16.8H15.4639V18.9416H15.0405V17.9279C15.0405 17.8605 15.0415 17.7829 15.0435 17.695C15.0464 17.6071 15.0498 17.5236 15.0537 17.4445C15.0576 17.3644 15.0605 17.3044 15.0625 17.2643H15.0493L14.4971 18.9416H14.0811Z"
			fill="#707070"
		/>
		<path d="M12.2632 18.9416H11.8091V17.1779H11.2275V16.8H12.8447V17.1779H12.2632V18.9416Z" fill="#707070" />
		<path
			d="M10.895 18.9416H10.4424V18.0173H9.59424V18.9416H9.14014V16.8H9.59424V17.6393H10.4424V16.8H10.895V18.9416Z"
			fill="#707070"
		/>
		<path d="M17.75 10.2H6.75V9.45001H17.75V10.2Z" fill="#7CC2E8" />
		<path d="M17.75 12.25H6.75V11.5H17.75V12.25Z" fill="#7CC2E8" />
		<path d="M12.25 14.25H6.75V13.5H12.25V14.25Z" fill="#7CC2E8" />
	</SvgIcon>
);

export const HtmlFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7CC2E8"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7CC2E8"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path d="M15.1641 18.8916V16.75H15.6182V18.5166H16.4868V18.8916H15.1641Z" fill="#707070" />
		<path
			d="M13.2407 18.8916L12.7251 17.2114H12.7119C12.7139 17.2515 12.7168 17.312 12.7207 17.3931C12.7256 17.4731 12.73 17.5586 12.7339 17.6494C12.7378 17.7402 12.7397 17.8223 12.7397 17.8955V18.8916H12.334V16.75H12.9521L13.459 18.3877H13.4678L14.0054 16.75H14.6235V18.8916H14.2002V17.8779C14.2002 17.8105 14.2012 17.7329 14.2031 17.645C14.2061 17.5571 14.2095 17.4736 14.2134 17.3945C14.2173 17.3145 14.2202 17.2544 14.2222 17.2144H14.209L13.6567 18.8916H13.2407Z"
			fill="#707070"
		/>
		<path d="M11.4229 18.8916H10.9688V17.1279H10.3872V16.75H12.0044V17.1279H11.4229V18.8916Z" fill="#707070" />
		<path
			d="M10.0547 18.8916H9.60205V17.9673H8.75391V18.8916H8.2998V16.75H8.75391V17.5894H9.60205V16.75H10.0547V18.8916Z"
			fill="#707070"
		/>
		<path d="M17.75 10.2H6.75V9.44995H17.75V10.2Z" fill="#7CC2E8" />
		<path d="M17.75 12.25H6.75V11.5H17.75V12.25Z" fill="#7CC2E8" />
		<path d="M12.25 14.25H6.75V13.5H12.25V14.25Z" fill="#7CC2E8" />
		<path
			d="M13.6848 7.95482L12.48 6.75L13.6848 5.54518L14.0221 5.88253L13.1607 6.75L14.0221 7.61747L13.6848 7.95482ZM14.7571 8.75L14.2993 8.60542L15.5041 4.75L15.9619 4.89458L14.7571 8.75ZM16.5764 7.95482L16.239 7.61747L17.1005 6.75L16.239 5.88253L16.5764 5.54518L17.7812 6.75L16.5764 7.95482Z"
			fill="#7CC2E8"
		/>
	</SvgIcon>
);

export const IcsFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#756BAF"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#756BAF"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.5205 18.2776C14.5205 18.4045 14.4897 18.5149 14.4282 18.6086C14.3667 18.7024 14.2769 18.7747 14.1587 18.8254C14.0415 18.8762 13.8989 18.9016 13.731 18.9016C13.6567 18.9016 13.584 18.8967 13.5127 18.887C13.4424 18.8772 13.3745 18.863 13.3091 18.8445C13.2446 18.825 13.1831 18.801 13.1245 18.7727V18.3508C13.2261 18.3958 13.3315 18.4363 13.4409 18.4724C13.5503 18.5085 13.6587 18.5266 13.7661 18.5266C13.8403 18.5266 13.8999 18.5168 13.9448 18.4973C13.9907 18.4778 14.0239 18.4509 14.0444 18.4167C14.0649 18.3826 14.0752 18.3435 14.0752 18.2996C14.0752 18.2458 14.0571 18.2 14.021 18.1619C13.9849 18.1238 13.9351 18.0881 13.8716 18.0549C13.8091 18.0217 13.7383 17.9861 13.6592 17.948C13.6094 17.9246 13.5552 17.8962 13.4966 17.863C13.438 17.8289 13.3823 17.7874 13.3296 17.7385C13.2769 17.6897 13.2334 17.6306 13.1992 17.5613C13.166 17.491 13.1494 17.407 13.1494 17.3093C13.1494 17.1814 13.1787 17.072 13.2373 16.9812C13.2959 16.8904 13.3794 16.821 13.4878 16.7732C13.5972 16.7244 13.7261 16.7 13.8745 16.7C13.9858 16.7 14.0918 16.7131 14.1924 16.7395C14.2939 16.7649 14.3999 16.802 14.5103 16.8508L14.3638 17.2039C14.2651 17.1638 14.1768 17.1331 14.0986 17.1116C14.0205 17.0891 13.9409 17.0779 13.8599 17.0779C13.8032 17.0779 13.7549 17.0872 13.7148 17.1057C13.6748 17.1233 13.6445 17.1487 13.624 17.1819C13.6035 17.2141 13.5933 17.2517 13.5933 17.2947C13.5933 17.3455 13.6079 17.3884 13.6372 17.4236C13.6675 17.4578 13.7124 17.491 13.772 17.5232C13.8325 17.5554 13.9077 17.593 13.9976 17.636C14.1069 17.6877 14.2002 17.7419 14.2773 17.7986C14.3555 17.8542 14.4155 17.9202 14.4575 17.9963C14.4995 18.0715 14.5205 18.1653 14.5205 18.2776Z"
			fill="#707070"
		/>
		<path
			d="M12.2529 17.0779C12.166 17.0779 12.0889 17.095 12.0215 17.1292C11.9551 17.1624 11.8989 17.2107 11.853 17.2742C11.8081 17.3376 11.7739 17.4143 11.7505 17.5042C11.7271 17.594 11.7153 17.6951 11.7153 17.8074C11.7153 17.9587 11.7339 18.0881 11.771 18.1956C11.8091 18.302 11.8677 18.3835 11.9468 18.4402C12.0259 18.4958 12.1279 18.5237 12.2529 18.5237C12.3398 18.5237 12.4268 18.5139 12.5137 18.4944C12.6016 18.4749 12.6968 18.447 12.7993 18.4109V18.7917C12.7046 18.8308 12.6113 18.8586 12.5195 18.8752C12.4277 18.8928 12.3247 18.9016 12.2104 18.9016C11.9897 18.9016 11.8081 18.8562 11.6655 18.7654C11.5239 18.6736 11.4189 18.5457 11.3506 18.3816C11.2822 18.2166 11.248 18.0242 11.248 17.8044C11.248 17.6423 11.27 17.4939 11.314 17.3591C11.3579 17.2244 11.4224 17.1077 11.5073 17.009C11.5923 16.9104 11.6973 16.8342 11.8223 16.7805C11.9473 16.7268 12.0908 16.7 12.2529 16.7C12.3594 16.7 12.4658 16.7136 12.5723 16.741C12.6797 16.7673 12.7822 16.804 12.8799 16.8508L12.7334 17.22C12.6533 17.1819 12.5728 17.1487 12.4917 17.1204C12.4106 17.092 12.3311 17.0779 12.2529 17.0779Z"
			fill="#707070"
		/>
		<path d="M10.3501 18.8723V16.7307H10.8042V18.8723H10.3501Z" fill="#707070" />
		<path
			d="M14.7835 8.05558H14.4502V7.38892H13.7835V8.05558H11.1169V7.38892H10.4502V8.05558H10.1169C10.0295 8.05563 9.94297 8.07292 9.8623 8.10648C9.78162 8.14004 9.70836 8.1892 9.64673 8.25114C9.5851 8.31308 9.53631 8.38659 9.50315 8.46743C9.47 8.54828 9.45313 8.63487 9.45353 8.72225L9.4502 13.3889C9.4502 13.5657 9.52043 13.7353 9.64546 13.8603C9.77048 13.9853 9.94005 14.0556 10.1169 14.0556H14.7835C14.9602 14.0551 15.1294 13.9846 15.2544 13.8597C15.3793 13.7348 15.4497 13.5656 15.4502 13.3889V8.72225C15.4497 8.5456 15.3793 8.37634 15.2544 8.25143C15.1294 8.12652 14.9602 8.05611 14.7835 8.05558ZM14.7835 13.3889H10.1169V10.0556H14.7835V13.3889ZM14.7835 9.38892H10.1169V8.72225H14.7835V9.38892ZM11.4502 11.3889H10.7835V10.7222H11.4502V11.3889ZM12.7835 11.3889H12.1169V10.7222H12.7835V11.3889ZM14.1169 11.3889H13.4502V10.7222H14.1169V11.3889ZM11.4502 12.7222H10.7835V12.0556H11.4502V12.7222ZM12.7835 12.7222H12.1169V12.0556H12.7835V12.7222ZM14.1169 12.7222H13.4502V12.0556H14.1169V12.7222Z"
			fill="#756BAF"
		/>
	</SvgIcon>
);

export const IniFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#8A93E2"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#8A93E2"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path d="M13.8135 18.8916V16.75H14.2676V18.8916H13.8135Z" fill="#707070" />
		<path
			d="M13.2729 18.8916H12.6958L11.7642 17.2715H11.751C11.7549 17.3389 11.7583 17.4067 11.7612 17.4751C11.7642 17.5435 11.7671 17.6118 11.77 17.6802C11.7729 17.7476 11.7759 17.8154 11.7788 17.8838V18.8916H11.373V16.75H11.9458L12.876 18.354H12.8862C12.8843 18.2876 12.8818 18.2217 12.8789 18.1562C12.876 18.0908 12.873 18.0254 12.8701 17.96C12.8682 17.8945 12.8662 17.8291 12.8643 17.7637V16.75H13.2729V18.8916Z"
			fill="#707070"
		/>
		<path d="M10.3799 18.8916V16.75H10.834V18.8916H10.3799Z" fill="#707070" />
		<path
			d="M12.2428 14V12.1144H12.7572V12.8H15.5V13.3144H12.7572V14H12.2428ZM9.5 13.3144V12.8H11.3856V13.3144H9.5ZM10.8715 11.9428V11.2572H9.5V10.7428H10.8715V10.0572H11.3859V11.9428H10.8715ZM12.2431 11.2572V10.7428H15.5V11.2572H12.2431ZM13.6146 9.88564V8H14.129V8.68564H15.5V9.2H14.1285V9.88564H13.6146ZM9.5 9.2V8.68564H12.7572V9.2H9.5Z"
			fill="#8A93E2"
		/>
	</SvgIcon>
);

export const JpegFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#707070"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M15.2402 16H9.24023C8.68795 16 8.24023 16.4477 8.24023 17V18.5C8.24023 19.0523 8.68795 19.5 9.24023 19.5H15.2402C15.7925 19.5 16.2402 19.0523 16.2402 18.5V17C16.2402 16.4477 15.7925 16 15.2402 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M8.99561 18.4972L9.22361 18.4822C9.28928 18.4839 9.35294 18.4594 9.40061 18.4142C9.44219 18.3623 9.46256 18.2966 9.45761 18.2302V16.7302H9.92861V18.2302C9.93629 18.3145 9.92534 18.3994 9.89655 18.479C9.86776 18.5585 9.82182 18.6308 9.76199 18.6906C9.70216 18.7504 9.62991 18.7964 9.55035 18.8252C9.47079 18.854 9.38587 18.8649 9.30161 18.8572L9.02261 18.8722L8.99561 18.4972ZM10.3186 16.7272H11.2906C11.4852 16.7152 11.677 16.7774 11.8276 16.9012C11.8929 16.9634 11.944 17.0392 11.9771 17.1231C12.0103 17.207 12.0248 17.2971 12.0196 17.3872C12.0248 17.4773 12.0103 17.5674 11.9771 17.6514C11.944 17.7353 11.8929 17.811 11.8276 17.8732C11.677 17.997 11.4852 18.0592 11.2906 18.0472H10.7906V18.8422H10.3186V16.7272ZM11.2306 17.6932C11.4646 17.6932 11.5816 17.5932 11.5816 17.3932C11.5851 17.3507 11.5791 17.3079 11.564 17.268C11.549 17.228 11.5253 17.1919 11.4946 17.1622C11.4182 17.1069 11.3247 17.0803 11.2306 17.0872H10.7866V17.6962L11.2306 17.6932ZM15.6035 17.6752V18.7102C15.4889 18.7643 15.3679 18.8037 15.2435 18.8272C15.1032 18.8554 14.9605 18.8695 14.8175 18.8692C14.617 18.8749 14.4181 18.8313 14.2385 18.7422C14.0775 18.6582 13.9457 18.5275 13.8605 18.3672C13.7683 18.1877 13.7229 17.9879 13.7285 17.7862C13.7235 17.5871 13.7681 17.3898 13.8585 17.2122C13.9424 17.0518 14.0727 16.9204 14.2325 16.8352C14.4082 16.7424 14.6047 16.696 14.8035 16.7002C14.9472 16.6991 15.0903 16.7203 15.2275 16.7632C15.3467 16.7987 15.4576 16.8579 15.5535 16.9372L15.4035 17.2702C15.3161 17.206 15.2198 17.1551 15.1175 17.1192C15.0206 17.0879 14.9193 17.0723 14.8175 17.0732C14.4095 17.0732 14.2055 17.3102 14.2055 17.7842C14.1903 17.9795 14.2468 18.1736 14.3645 18.3302C14.4265 18.3934 14.5016 18.4423 14.5845 18.4734C14.6674 18.5045 14.7562 18.517 14.8445 18.5102C14.9609 18.5102 15.0769 18.495 15.1895 18.4652V17.9992H14.7725V17.6752H15.6035Z"
			fill="#707070"
		/>
		<path
			d="M13.4599 18.8564H12.2173V16.7148H13.4599V17.0869H12.6748V17.5571H13.4053V17.9292H12.6748V18.4814H13.4599V18.8564Z"
			fill="#707070"
		/>
		<path
			d="M6.50049 14.5317L10.4009 11.1011L11.8735 12.5503L14.4263 9.96631L17.8325 14.4458L6.50049 14.5317Z"
			fill="#707070"
		/>
		<path
			d="M9.50049 10C10.0528 10 10.5005 9.55228 10.5005 9C10.5005 8.44772 10.0528 8 9.50049 8C8.9482 8 8.50049 8.44772 8.50049 9C8.50049 9.55228 8.9482 10 9.50049 10Z"
			fill="white"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			stroke="#707070"
		/>
	</SvgIcon>
);

export const JsFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7CC2E8"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7CC2E8"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M13.7495 18.2277C13.7495 18.3546 13.7188 18.465 13.6572 18.5587C13.5957 18.6525 13.5059 18.7247 13.3877 18.7755C13.2705 18.8263 13.1279 18.8517 12.96 18.8517C12.8857 18.8517 12.813 18.8468 12.7417 18.837C12.6714 18.8273 12.6035 18.8131 12.5381 18.7946C12.4736 18.775 12.4121 18.7511 12.3535 18.7228V18.3009C12.4551 18.3458 12.5605 18.3864 12.6699 18.4225C12.7793 18.4586 12.8877 18.4767 12.9951 18.4767C13.0693 18.4767 13.1289 18.4669 13.1738 18.4474C13.2197 18.4279 13.2529 18.401 13.2734 18.3668C13.2939 18.3326 13.3042 18.2936 13.3042 18.2496C13.3042 18.1959 13.2861 18.15 13.25 18.1119C13.2139 18.0739 13.1641 18.0382 13.1006 18.005C13.0381 17.9718 12.9673 17.9362 12.8882 17.8981C12.8384 17.8746 12.7842 17.8463 12.7256 17.8131C12.667 17.7789 12.6113 17.7374 12.5586 17.6886C12.5059 17.6398 12.4624 17.5807 12.4282 17.5114C12.395 17.441 12.3784 17.3571 12.3784 17.2594C12.3784 17.1315 12.4077 17.0221 12.4663 16.9313C12.5249 16.8405 12.6084 16.7711 12.7168 16.7233C12.8262 16.6744 12.9551 16.65 13.1035 16.65C13.2148 16.65 13.3208 16.6632 13.4214 16.6896C13.5229 16.715 13.6289 16.7521 13.7393 16.8009L13.5928 17.1539C13.4941 17.1139 13.4058 17.0831 13.3276 17.0616C13.2495 17.0392 13.1699 17.028 13.0889 17.028C13.0322 17.028 12.9839 17.0372 12.9438 17.0558C12.9038 17.0734 12.8735 17.0988 12.853 17.132C12.8325 17.1642 12.8223 17.2018 12.8223 17.2448C12.8223 17.2955 12.8369 17.3385 12.8662 17.3737C12.8965 17.4078 12.9414 17.441 13.001 17.4733C13.0615 17.5055 13.1367 17.5431 13.2266 17.5861C13.3359 17.6378 13.4292 17.692 13.5063 17.7487C13.5845 17.8043 13.6445 17.8702 13.6865 17.9464C13.7285 18.0216 13.7495 18.1154 13.7495 18.2277Z"
			fill="#707070"
		/>
		<path
			d="M11.2681 18.8516C11.2095 18.8516 11.1582 18.8482 11.1143 18.8413C11.0693 18.8355 11.0312 18.8281 11 18.8194V18.4414C11.0312 18.4483 11.0649 18.4546 11.1011 18.4605C11.1362 18.4673 11.1738 18.4707 11.2139 18.4707C11.2666 18.4707 11.314 18.4605 11.356 18.44C11.3979 18.4204 11.4312 18.3828 11.4556 18.3272C11.48 18.2715 11.4922 18.1914 11.4922 18.0869V16.6501H11.9463V18.084C11.9463 18.2676 11.9175 18.4155 11.8599 18.5278C11.8032 18.6411 11.7236 18.7232 11.6211 18.7739C11.5195 18.8257 11.4019 18.8516 11.2681 18.8516Z"
			fill="#707070"
		/>
		<path
			d="M10.5635 9.75684L9.27148 11.0576L10.5635 12.3584L10.0576 12.8652L8.25 11.0576L10.0576 9.25L10.5635 9.75684ZM16.2021 11.0576L14.3945 12.8652L13.8887 12.3584L15.1807 11.0576L13.8887 9.75684L14.3945 9.25L16.2021 11.0576ZM10.75 10.5576C11.0261 10.5576 11.25 10.7815 11.25 11.0576C11.25 11.3338 11.0261 11.5576 10.75 11.5576C10.4739 11.5576 10.25 11.3338 10.25 11.0576C10.25 10.7815 10.4739 10.5576 10.75 10.5576ZM12.25 10.5576C12.5261 10.5576 12.75 10.7815 12.75 11.0576C12.75 11.3338 12.5261 11.5576 12.25 11.5576C11.9739 11.5576 11.75 11.3338 11.75 11.0576C11.75 10.7815 11.9739 10.5576 12.25 10.5576ZM13.75 10.5576C14.0261 10.5576 14.25 10.7815 14.25 11.0576C14.25 11.3338 14.0261 11.5576 13.75 11.5576C13.4739 11.5576 13.25 11.3338 13.25 11.0576C13.25 10.7815 13.4739 10.5576 13.75 10.5576Z"
			fill="#7CC2E8"
		/>
	</SvgIcon>
);

export const LogFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.51978H17.25C17.7804 3.51978 18.2891 3.73049 18.6642 4.10556C19.0393 4.48063 19.25 4.98934 19.25 5.51978V19.5198C19.25 20.0502 19.0393 20.5589 18.6642 20.934C18.2891 21.3091 17.7804 21.5198 17.25 21.5198H7.25C6.71957 21.5198 6.21086 21.3091 5.83579 20.934C5.46071 20.5589 5.25 20.0502 5.25 19.5198V7.71978L9.51 3.51978Z"
			fill="white"
		/>
		<path
			d="M9.531 3.7708L5.492 7.6128L5.45 19.8208C5.45053 20.2317 5.614 20.6257 5.90457 20.9162C6.19514 21.2068 6.58908 21.3703 7 21.3708H17.5C17.9109 21.3703 18.3049 21.2068 18.5954 20.9162C18.886 20.6257 19.0495 20.2317 19.05 19.8208V5.3208C19.0495 4.90988 18.886 4.51594 18.5954 4.22537C18.3049 3.9348 17.9109 3.77133 17.5 3.7708M9.461 3.3208H17.5C18.0304 3.3208 18.5391 3.53151 18.9142 3.90659C19.2893 4.28166 19.5 4.79037 19.5 5.3208V19.8208C19.5 20.3512 19.2893 20.8599 18.9142 21.235C18.5391 21.6101 18.0304 21.8208 17.5 21.8208H7C6.46957 21.8208 5.96086 21.6101 5.58579 21.235C5.21071 20.8599 5 20.3512 5 19.8208V7.6128L9.461 3.3208Z"
			fill="#5F3FA5"
		/>
		<path
			d="M6.04883 7.21078H8.22983C8.43963 7.21264 8.64163 7.13129 8.79157 6.98453C8.94152 6.83777 9.02719 6.63757 9.02983 6.42778L9.10183 4.30778M9.54883 3.39478L9.47983 6.42778C9.47745 6.757 9.34445 7.07181 9.11005 7.30302C8.87566 7.53423 8.55906 7.6629 8.22983 7.66078H5.04883L9.54883 3.39478Z"
			fill="#5F3FA5"
		/>
		<path
			d="M16.25 16.3208H8.25C7.69772 16.3208 7.25 16.7685 7.25 17.3208V18.8208C7.25 19.3731 7.69772 19.8208 8.25 19.8208H16.25C16.8023 19.8208 17.25 19.3731 17.25 18.8208V17.3208C17.25 16.7685 16.8023 16.3208 16.25 16.3208Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.397 18.0435H15.2466V19.1538C15.1343 19.1909 15.0176 19.2207 14.8965 19.2432C14.7754 19.2646 14.6382 19.2754 14.4849 19.2754C14.272 19.2754 14.0913 19.2334 13.9429 19.1494C13.7944 19.0654 13.6816 18.9414 13.6045 18.7773C13.5273 18.6133 13.4888 18.4116 13.4888 18.1724C13.4888 17.9478 13.5317 17.7534 13.6177 17.5894C13.7046 17.4253 13.8311 17.2983 13.9971 17.2085C14.1641 17.1187 14.3677 17.0737 14.6079 17.0737C14.7212 17.0737 14.833 17.0859 14.9434 17.1104C15.0537 17.1348 15.1538 17.1665 15.2437 17.2056L15.0928 17.5688C15.0273 17.5356 14.9526 17.5078 14.8687 17.4854C14.7847 17.4629 14.6968 17.4517 14.605 17.4517C14.4731 17.4517 14.3584 17.4819 14.2607 17.5425C14.1641 17.603 14.0889 17.688 14.0352 17.7974C13.9824 17.9058 13.9561 18.0337 13.9561 18.1812C13.9561 18.3208 13.9751 18.4448 14.0132 18.5532C14.0513 18.6606 14.1113 18.7451 14.1934 18.8066C14.2754 18.8672 14.3823 18.8975 14.5142 18.8975C14.5786 18.8975 14.6328 18.8945 14.6768 18.8887C14.7217 18.8818 14.7637 18.875 14.8027 18.8682V18.4214H14.397V18.0435Z"
			fill="#707070"
		/>
		<path
			d="M13.1401 18.1724C13.1401 18.3374 13.1196 18.4878 13.0786 18.6235C13.0376 18.7583 12.9751 18.8745 12.8911 18.9722C12.8081 19.0698 12.7026 19.145 12.5747 19.1978C12.4468 19.2495 12.2954 19.2754 12.1206 19.2754C11.9458 19.2754 11.7944 19.2495 11.6665 19.1978C11.5386 19.145 11.4326 19.0698 11.3486 18.9722C11.2656 18.8745 11.2036 18.7578 11.1626 18.6221C11.1216 18.4863 11.1011 18.3354 11.1011 18.1694C11.1011 17.9478 11.1372 17.7549 11.2095 17.5908C11.2827 17.4258 11.395 17.2979 11.5464 17.207C11.6978 17.1162 11.8901 17.0708 12.1235 17.0708C12.356 17.0708 12.5469 17.1162 12.6963 17.207C12.8467 17.2979 12.958 17.4258 13.0303 17.5908C13.1035 17.7559 13.1401 17.9497 13.1401 18.1724ZM11.5771 18.1724C11.5771 18.3218 11.5957 18.4507 11.6328 18.5591C11.6709 18.6665 11.73 18.7495 11.8101 18.8081C11.8901 18.8657 11.9937 18.8945 12.1206 18.8945C12.2495 18.8945 12.354 18.8657 12.4341 18.8081C12.5142 18.7495 12.5723 18.6665 12.6084 18.5591C12.6455 18.4507 12.6641 18.3218 12.6641 18.1724C12.6641 17.9478 12.6221 17.771 12.5381 17.6421C12.4541 17.5132 12.3159 17.4487 12.1235 17.4487C11.9956 17.4487 11.8911 17.478 11.8101 17.5366C11.73 17.5942 11.6709 17.6772 11.6328 17.7856C11.5957 17.8931 11.5771 18.022 11.5771 18.1724Z"
			fill="#707070"
		/>
		<path d="M9.5 19.2461V17.1045H9.9541V18.8711H10.8228V19.2461H9.5Z" fill="#707070" />
		<path
			d="M9.75 13.8633H6.75V13.1133H9.75V13.8633ZM10.375 13.1133C10.5821 13.1133 10.75 13.2812 10.75 13.4883C10.75 13.6954 10.5821 13.8633 10.375 13.8633C10.1679 13.8633 10 13.6954 10 13.4883C10 13.2812 10.1679 13.1133 10.375 13.1133ZM17.75 13.8633H11V13.1133H17.75V13.8633Z"
			fill="#5F3FA5"
		/>
		<path
			d="M9.75 12.21H6.75V11.46H9.75V12.21ZM10.375 11.46C10.5821 11.46 10.75 11.6279 10.75 11.835C10.75 12.0421 10.5821 12.21 10.375 12.21C10.1679 12.21 10 12.0421 10 11.835C10 11.6279 10.1679 11.46 10.375 11.46ZM17.75 12.21H11V11.46H17.75V12.21Z"
			fill="#5F3FA5"
		/>
		<path
			d="M9.75 10.5566H6.75V9.80664H9.75V10.5566ZM10.375 9.80664C10.5821 9.80664 10.75 9.97453 10.75 10.1816C10.75 10.3887 10.5821 10.5566 10.375 10.5566C10.1679 10.5566 10 10.3887 10 10.1816C10 9.97453 10.1679 9.80664 10.375 9.80664ZM17.75 10.5566H11V9.80664H17.75V10.5566Z"
			fill="#5F3FA5"
		/>
	</SvgIcon>
);

export const MboxFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#51AED6"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#51AED6"
		/>
		<path
			d="M16.5498 16.02H8.0498C7.49752 16.02 7.0498 16.4677 7.0498 17.02V18.52C7.0498 19.0723 7.49752 19.52 8.0498 19.52H16.5498C17.1021 19.52 17.5498 19.0723 17.5498 18.52V17.02C17.5498 16.4677 17.1021 16.02 16.5498 16.02Z"
			fill="#D7D7D7"
		/>
		<path
			d="M16.9648 18.9253H16.4463L15.9482 18.1152L15.4502 18.9253H14.9639L15.6743 17.8208L15.0093 16.7837H15.5103L15.9717 17.5542L16.4243 16.7837H16.9136L16.2412 17.8457L16.9648 18.9253Z"
			fill="#707070"
		/>
		<path
			d="M14.7896 17.8516C14.7896 18.0166 14.769 18.167 14.728 18.3027C14.687 18.4375 14.6245 18.5537 14.5405 18.6514C14.4575 18.749 14.3521 18.8242 14.2241 18.877C14.0962 18.9287 13.9448 18.9546 13.77 18.9546C13.5952 18.9546 13.4438 18.9287 13.3159 18.877C13.188 18.8242 13.082 18.749 12.998 18.6514C12.915 18.5537 12.853 18.437 12.812 18.3013C12.771 18.1655 12.7505 18.0146 12.7505 17.8486C12.7505 17.627 12.7866 17.4341 12.8589 17.27C12.9321 17.105 13.0444 16.9771 13.1958 16.8862C13.3472 16.7954 13.5396 16.75 13.7729 16.75C14.0054 16.75 14.1963 16.7954 14.3457 16.8862C14.4961 16.9771 14.6074 17.105 14.6797 17.27C14.7529 17.4351 14.7896 17.6289 14.7896 17.8516ZM13.2266 17.8516C13.2266 18.001 13.2451 18.1299 13.2822 18.2383C13.3203 18.3457 13.3794 18.4287 13.4595 18.4873C13.5396 18.5449 13.6431 18.5737 13.77 18.5737C13.8989 18.5737 14.0034 18.5449 14.0835 18.4873C14.1636 18.4287 14.2217 18.3457 14.2578 18.2383C14.2949 18.1299 14.3135 18.001 14.3135 17.8516C14.3135 17.627 14.2715 17.4502 14.1875 17.3213C14.1035 17.1924 13.9653 17.1279 13.7729 17.1279C13.645 17.1279 13.5405 17.1572 13.4595 17.2158C13.3794 17.2734 13.3203 17.3564 13.2822 17.4648C13.2451 17.5723 13.2266 17.7012 13.2266 17.8516Z"
			fill="#707070"
		/>
		<path
			d="M10.8301 16.7837H11.4966C11.7817 16.7837 11.9976 16.8237 12.144 16.9038C12.2905 16.9839 12.3638 17.1245 12.3638 17.3257C12.3638 17.4067 12.3506 17.48 12.3242 17.5454C12.2988 17.6108 12.2617 17.6646 12.2129 17.7065C12.1641 17.7485 12.1045 17.7759 12.0342 17.7886V17.8032C12.1055 17.8179 12.1699 17.8433 12.2275 17.8794C12.2852 17.9146 12.3311 17.9663 12.3652 18.0347C12.4004 18.1021 12.418 18.1919 12.418 18.3042C12.418 18.4341 12.3862 18.5454 12.3228 18.6382C12.2593 18.731 12.1685 18.8022 12.0503 18.8521C11.9331 18.9009 11.7935 18.9253 11.6313 18.9253H10.8301V16.7837ZM11.2842 17.6318H11.5479C11.6797 17.6318 11.771 17.6113 11.8218 17.5703C11.8726 17.5283 11.8979 17.4668 11.8979 17.3857C11.8979 17.3037 11.8677 17.2451 11.8071 17.21C11.7476 17.1738 11.6528 17.1558 11.5229 17.1558H11.2842V17.6318ZM11.2842 17.9922V18.5503H11.5801C11.7168 18.5503 11.812 18.5239 11.8657 18.4712C11.9194 18.4185 11.9463 18.3477 11.9463 18.2588C11.9463 18.2061 11.9346 18.1597 11.9111 18.1196C11.8877 18.0796 11.8481 18.0483 11.7925 18.0259C11.7378 18.0034 11.6621 17.9922 11.5654 17.9922H11.2842Z"
			fill="#707070"
		/>
		<path
			d="M8.90674 18.9253L8.39111 17.2451H8.37793C8.37988 17.2852 8.38281 17.3457 8.38672 17.4268C8.3916 17.5068 8.396 17.5923 8.3999 17.6831C8.40381 17.7739 8.40576 17.856 8.40576 17.9292V18.9253H8V16.7837H8.61816L9.125 18.4214H9.13379L9.67139 16.7837H10.2896V18.9253H9.86621V17.9116C9.86621 17.8442 9.86719 17.7666 9.86914 17.6787C9.87207 17.5908 9.87549 17.5073 9.87939 17.4282C9.8833 17.3481 9.88623 17.2881 9.88818 17.248H9.875L9.32275 18.9253H8.90674Z"
			fill="#707070"
		/>
		<path
			d="M15.2256 8.5C15.2941 8.49992 15.3618 8.51505 15.4248 8.54395C15.488 8.57296 15.5455 8.6155 15.5928 8.66895C15.6425 8.71961 15.682 8.78101 15.709 8.84863C15.736 8.91626 15.7501 8.98895 15.75 9.0625V12.25C16.0261 12.25 16.25 12.4739 16.25 12.75V14.25C16.25 14.5261 16.0261 14.75 15.75 14.75H8.75C8.47386 14.75 8.25 14.5261 8.25 14.25V12.75C8.25 12.4739 8.47386 12.25 8.75 12.25V9.0625C8.74986 8.98895 8.76402 8.91626 8.79102 8.84863C8.81805 8.78101 8.85746 8.71961 8.90723 8.66895C8.95454 8.6155 9.01201 8.57296 9.0752 8.54395C9.13819 8.51505 9.20589 8.49992 9.27441 8.5H15.2256ZM12.25 11.6699L9.27441 9.5791V12.25H11.25C11.25 12.8023 11.6977 13.25 12.25 13.25C12.8023 13.25 13.25 12.8023 13.25 12.25H15.2256V9.5791L12.25 11.6699ZM12.25 11.1074L15.1904 9.0625H9.31836L12.25 11.1074Z"
			fill="#51AED6"
		/>
	</SvgIcon>
);

export const MhtmlFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7CC2E8"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7CC2E8"
		/>
		<path
			d="M17.5 16H7C6.44772 16 6 16.4477 6 17V18.5C6 19.0523 6.44772 19.5 7 19.5H17.5C18.0523 19.5 18.5 19.0523 18.5 18.5V17C18.5 16.4477 18.0523 16 17.5 16Z"
			fill="#D7D7D7"
		/>
		<path d="M16.3945 19V16.8584H16.8486V18.625H17.7173V19H16.3945Z" fill="#707070" />
		<path
			d="M14.4712 19L13.9556 17.3198H13.9424C13.9443 17.3599 13.9473 17.4204 13.9512 17.5015C13.9561 17.5815 13.9604 17.667 13.9644 17.7578C13.9683 17.8486 13.9702 17.9307 13.9702 18.0039V19H13.5645V16.8584H14.1826L14.6895 18.4961H14.6982L15.2358 16.8584H15.854V19H15.4307V17.9863C15.4307 17.9189 15.4316 17.8413 15.4336 17.7534C15.4365 17.6655 15.4399 17.582 15.4438 17.5029C15.4478 17.4229 15.4507 17.3628 15.4526 17.3228H15.4395L14.8872 19H14.4712Z"
			fill="#707070"
		/>
		<path d="M12.6533 19H12.1992V17.2363H11.6177V16.8584H13.2349V17.2363H12.6533V19Z" fill="#707070" />
		<path
			d="M11.2852 19H10.8325V18.0757H9.98438V19H9.53027V16.8584H9.98438V17.6978H10.8325V16.8584H11.2852V19Z"
			fill="#707070"
		/>
		<path
			d="M7.60693 19L7.09131 17.3198H7.07812C7.08008 17.3599 7.08301 17.4204 7.08691 17.5015C7.0918 17.5815 7.09619 17.667 7.1001 17.7578C7.104 17.8486 7.10596 17.9307 7.10596 18.0039V19H6.7002V16.8584H7.31836L7.8252 18.4961H7.83398L8.37158 16.8584H8.98975V19H8.56641V17.9863C8.56641 17.9189 8.56738 17.8413 8.56934 17.7534C8.57227 17.6655 8.57568 17.582 8.57959 17.5029C8.5835 17.4229 8.58643 17.3628 8.58838 17.3228H8.5752L8.02295 19H7.60693Z"
			fill="#707070"
		/>
		<path
			d="M9.2121 14.0215C9.00258 14.0215 8.82321 13.9478 8.674 13.8004C8.5248 13.653 8.4502 13.4758 8.4502 13.2688V8.75269C8.4502 8.5457 8.5248 8.3685 8.674 8.2211C8.82321 8.0737 9.00258 8 9.2121 8H11.4978L12.2597 8.75269H15.3073C15.5169 8.75269 15.6962 8.82639 15.8454 8.97379C15.9946 9.12119 16.0692 9.29839 16.0692 9.50538V11.3871H13.4026C12.7677 11.3871 12.228 11.6066 11.7835 12.0457C11.3391 12.4848 11.1169 13.0179 11.1169 13.6452V14.0215H9.2121ZM13.2502 15L11.8788 13.6452L13.2502 12.2903L13.7835 12.8266L12.955 13.6452L13.7835 14.4637L13.2502 15ZM15.0788 15L14.5454 14.4637L15.374 13.6452L14.5454 12.8266L15.0788 12.2903L16.4502 13.6452L15.0788 15Z"
			fill="#7CC2E8"
		/>
	</SvgIcon>
);

export const MovFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#4CAF50"
		/>
		<path
			d="M9.45 14.5C9.2575 14.5 9.09271 14.4347 8.95563 14.3042C8.81854 14.1736 8.75 14.0167 8.75 13.8333V9.16667C8.75 8.98333 8.81854 8.82639 8.95563 8.69583C9.09271 8.56528 9.2575 8.5 9.45 8.5H15.05C15.2425 8.5 15.4073 8.56528 15.5444 8.69583C15.6815 8.82639 15.75 8.98333 15.75 9.16667V13.8333C15.75 14.0167 15.6815 14.1736 15.5444 14.3042C15.4073 14.4347 15.2425 14.5 15.05 14.5H9.45ZM9.45 13.8333H10.15V13.1667H9.45V13.8333ZM14.35 13.8333H15.05V13.1667H14.35V13.8333ZM9.45 12.5H10.15V11.8333H9.45V12.5ZM14.35 12.5H15.05V11.8333H14.35V12.5ZM9.45 11.1667H10.15V10.5H9.45V11.1667ZM14.35 11.1667H15.05V10.5H14.35V11.1667ZM9.45 9.83333H10.15V9.16667H9.45V9.83333ZM14.35 9.83333H15.05V9.16667H14.35V9.83333ZM10.85 13.8333H13.65V9.16667H10.85V13.8333Z"
			fill="#4CAF50"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#4CAF50"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.7979 16.7837L15.0698 18.9253H14.5747L13.8481 16.7837H14.3066L14.7095 18.0581C14.7163 18.0796 14.7275 18.1201 14.7432 18.1797C14.7588 18.2383 14.7744 18.3008 14.79 18.3672C14.8066 18.4326 14.8179 18.4868 14.8237 18.5298C14.8296 18.4868 14.8398 18.4326 14.8545 18.3672C14.8701 18.3018 14.8853 18.2397 14.8999 18.1812C14.9155 18.1216 14.9268 18.0806 14.9336 18.0581L15.3394 16.7837H15.7979Z"
			fill="#707070"
		/>
		<path
			d="M13.6738 17.8516C13.6738 18.0166 13.6533 18.167 13.6123 18.3027C13.5713 18.4375 13.5088 18.5537 13.4248 18.6514C13.3418 18.749 13.2363 18.8242 13.1084 18.877C12.9805 18.9287 12.8291 18.9546 12.6543 18.9546C12.4795 18.9546 12.3281 18.9287 12.2002 18.877C12.0723 18.8242 11.9663 18.749 11.8823 18.6514C11.7993 18.5537 11.7373 18.437 11.6963 18.3013C11.6553 18.1655 11.6348 18.0146 11.6348 17.8486C11.6348 17.627 11.6709 17.4341 11.7432 17.27C11.8164 17.105 11.9287 16.9771 12.0801 16.8862C12.2314 16.7954 12.4238 16.75 12.6572 16.75C12.8896 16.75 13.0806 16.7954 13.23 16.8862C13.3804 16.9771 13.4917 17.105 13.564 17.27C13.6372 17.4351 13.6738 17.6289 13.6738 17.8516ZM12.1108 17.8516C12.1108 18.001 12.1294 18.1299 12.1665 18.2383C12.2046 18.3457 12.2637 18.4287 12.3438 18.4873C12.4238 18.5449 12.5273 18.5737 12.6543 18.5737C12.7832 18.5737 12.8877 18.5449 12.9678 18.4873C13.0479 18.4287 13.106 18.3457 13.1421 18.2383C13.1792 18.1299 13.1978 18.001 13.1978 17.8516C13.1978 17.627 13.1558 17.4502 13.0718 17.3213C12.9878 17.1924 12.8496 17.1279 12.6572 17.1279C12.5293 17.1279 12.4248 17.1572 12.3438 17.2158C12.2637 17.2734 12.2046 17.3564 12.1665 17.4648C12.1294 17.5723 12.1108 17.7012 12.1108 17.8516Z"
			fill="#707070"
		/>
		<path
			d="M9.80664 18.9253L9.29102 17.2451H9.27783C9.27979 17.2852 9.28271 17.3457 9.28662 17.4268C9.2915 17.5068 9.2959 17.5923 9.2998 17.6831C9.30371 17.7739 9.30566 17.856 9.30566 17.9292V18.9253H8.8999V16.7837H9.51807L10.0249 18.4214H10.0337L10.5713 16.7837H11.1895V18.9253H10.7661V17.9116C10.7661 17.8442 10.7671 17.7666 10.769 17.6787C10.772 17.5908 10.7754 17.5073 10.7793 17.4282C10.7832 17.3481 10.7861 17.2881 10.7881 17.248H10.7749L10.2227 18.9253H9.80664Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const Mp4FileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#4CAF50"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#4CAF50"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.3696 18.4478H15.1118V18.8916H14.6694V18.4478H13.7554V18.1328L14.6943 16.75H15.1118V18.0962H15.3696V18.4478ZM14.6694 18.0962V17.7329C14.6694 17.6987 14.6699 17.6582 14.6709 17.6113C14.6729 17.5645 14.6748 17.5176 14.6768 17.4707C14.6787 17.4238 14.6807 17.3823 14.6826 17.3462C14.6855 17.3091 14.6875 17.2832 14.6885 17.2686H14.6768C14.6582 17.3086 14.6387 17.3477 14.6182 17.3857C14.5977 17.4229 14.5737 17.4619 14.5464 17.5029L14.1538 18.0962H14.6694Z"
			fill="#707070"
		/>
		<path
			d="M12.7739 16.75C13.0503 16.75 13.252 16.8096 13.3789 16.9287C13.5059 17.0469 13.5693 17.21 13.5693 17.418C13.5693 17.5117 13.5552 17.6016 13.5269 17.6875C13.4985 17.7725 13.4521 17.8481 13.3877 17.9146C13.3242 17.981 13.2393 18.0337 13.1328 18.0728C13.0264 18.1108 12.895 18.1299 12.7388 18.1299H12.5439V18.8916H12.0898V16.75H12.7739ZM12.7505 17.1221H12.5439V17.7578H12.6934C12.7783 17.7578 12.8521 17.7466 12.9146 17.7241C12.9771 17.7017 13.0254 17.6665 13.0596 17.6187C13.0938 17.5708 13.1108 17.5093 13.1108 17.4341C13.1108 17.3286 13.0815 17.2505 13.0229 17.1997C12.9644 17.1479 12.8735 17.1221 12.7505 17.1221Z"
			fill="#707070"
		/>
		<path
			d="M10.1665 18.8916L9.65088 17.2114H9.6377C9.63965 17.2515 9.64258 17.312 9.64648 17.3931C9.65137 17.4731 9.65576 17.5586 9.65967 17.6494C9.66357 17.7402 9.66553 17.8223 9.66553 17.8955V18.8916H9.25977V16.75H9.87793L10.3848 18.3877H10.3936L10.9312 16.75H11.5493V18.8916H11.126V17.8779C11.126 17.8105 11.127 17.7329 11.1289 17.645C11.1318 17.5571 11.1353 17.4736 11.1392 17.3945C11.1431 17.3145 11.146 17.2544 11.1479 17.2144H11.1348L10.5825 18.8916H10.1665Z"
			fill="#707070"
		/>
		<path
			d="M11.5 12.6L13.6 11.25L11.5 9.9V12.6ZM12.25 14.25C11.835 14.25 11.445 14.1712 11.08 14.0138C10.715 13.8562 10.3975 13.6425 10.1275 13.3725C9.8575 13.1025 9.64375 12.785 9.48625 12.42C9.32875 12.055 9.25 11.665 9.25 11.25C9.25 10.835 9.32875 10.445 9.48625 10.08C9.64375 9.715 9.8575 9.3975 10.1275 9.1275C10.3975 8.8575 10.715 8.64375 11.08 8.48625C11.445 8.32875 11.835 8.25 12.25 8.25C12.665 8.25 13.055 8.32875 13.42 8.48625C13.785 8.64375 14.1025 8.8575 14.3725 9.1275C14.6425 9.3975 14.8562 9.715 15.0138 10.08C15.1712 10.445 15.25 10.835 15.25 11.25C15.25 11.665 15.1712 12.055 15.0138 12.42C14.8562 12.785 14.6425 13.1025 14.3725 13.3725C14.1025 13.6425 13.785 13.8562 13.42 14.0138C13.055 14.1712 12.665 14.25 12.25 14.25ZM12.25 13.65C12.92 13.65 13.4875 13.4175 13.9525 12.9525C14.4175 12.4875 14.65 11.92 14.65 11.25C14.65 10.58 14.4175 10.0125 13.9525 9.5475C13.4875 9.0825 12.92 8.85 12.25 8.85C11.58 8.85 11.0125 9.0825 10.5475 9.5475C10.0825 10.0125 9.85 10.58 9.85 11.25C9.85 11.92 10.0825 12.4875 10.5475 12.9525C11.0125 13.4175 11.58 13.65 12.25 13.65Z"
			fill="#4CAF50"
		/>
	</SvgIcon>
);

export const MsiFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#0D8DCD"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#0D8DCD"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path d="M14.5146 18.8339V16.6923H14.9688V18.8339H14.5146Z" fill="#707070" />
		<path
			d="M14.1265 18.2391C14.1265 18.3661 14.0957 18.4764 14.0342 18.5702C13.9727 18.6639 13.8828 18.7362 13.7646 18.787C13.6475 18.8378 13.5049 18.8632 13.3369 18.8632C13.2627 18.8632 13.1899 18.8583 13.1187 18.8485C13.0483 18.8387 12.9805 18.8246 12.915 18.806C12.8506 18.7865 12.7891 18.7626 12.7305 18.7343V18.3124C12.832 18.3573 12.9375 18.3978 13.0469 18.434C13.1562 18.4701 13.2646 18.4882 13.3721 18.4882C13.4463 18.4882 13.5059 18.4784 13.5508 18.4589C13.5967 18.4393 13.6299 18.4125 13.6504 18.3783C13.6709 18.3441 13.6812 18.3051 13.6812 18.2611C13.6812 18.2074 13.6631 18.1615 13.627 18.1234C13.5908 18.0853 13.541 18.0497 13.4775 18.0165C13.415 17.9833 13.3442 17.9476 13.2651 17.9095C13.2153 17.8861 13.1611 17.8578 13.1025 17.8246C13.0439 17.7904 12.9883 17.7489 12.9355 17.7001C12.8828 17.6512 12.8394 17.5922 12.8052 17.5228C12.772 17.4525 12.7554 17.3685 12.7554 17.2709C12.7554 17.1429 12.7847 17.0336 12.8433 16.9427C12.9019 16.8519 12.9854 16.7826 13.0938 16.7347C13.2031 16.6859 13.332 16.6615 13.4805 16.6615C13.5918 16.6615 13.6978 16.6747 13.7983 16.701C13.8999 16.7264 14.0059 16.7635 14.1162 16.8124L13.9697 17.1654C13.8711 17.1254 13.7827 17.0946 13.7046 17.0731C13.6265 17.0507 13.5469 17.0394 13.4658 17.0394C13.4092 17.0394 13.3608 17.0487 13.3208 17.0673C13.2808 17.0848 13.2505 17.1102 13.23 17.1434C13.2095 17.1757 13.1992 17.2133 13.1992 17.2562C13.1992 17.307 13.2139 17.35 13.2432 17.3851C13.2734 17.4193 13.3184 17.4525 13.3779 17.4847C13.4385 17.517 13.5137 17.5546 13.6035 17.5975C13.7129 17.6493 13.8062 17.7035 13.8833 17.7601C13.9614 17.8158 14.0215 17.8817 14.0635 17.9579C14.1055 18.0331 14.1265 18.1268 14.1265 18.2391Z"
			fill="#707070"
		/>
		<path
			d="M10.939 18.8339L10.4233 17.1537H10.4102C10.4121 17.1937 10.415 17.2543 10.4189 17.3353C10.4238 17.4154 10.4282 17.5009 10.4321 17.5917C10.436 17.6825 10.438 17.7645 10.438 17.8378V18.8339H10.0322V16.6923H10.6504L11.1572 18.33H11.166L11.7036 16.6923H12.3218V18.8339H11.8984V17.8202C11.8984 17.7528 11.8994 17.6752 11.9014 17.5873C11.9043 17.4994 11.9077 17.4159 11.9116 17.3368C11.9155 17.2567 11.9185 17.1967 11.9204 17.1566H11.9072L11.355 18.8339H10.939Z"
			fill="#707070"
		/>
		<path
			d="M12.3501 14.5341C13.2438 14.5341 14.009 14.2158 14.6454 13.5794C15.2819 12.9429 15.6001 12.1778 15.6001 11.2841C15.6001 10.3903 15.2819 9.6252 14.6454 8.98875C14.009 8.35229 13.2438 8.03406 12.3501 8.03406C11.4563 8.03406 10.6912 8.35229 10.0548 8.98875C9.41833 9.6252 9.1001 10.3903 9.1001 11.2841C9.1001 12.1778 9.41833 12.9429 10.0548 13.5794C10.6912 14.2158 11.4563 14.5341 12.3501 14.5341ZM12.3501 12.0966C12.1199 12.0966 11.9269 12.0187 11.7712 11.863C11.6155 11.7072 11.5376 11.5143 11.5376 11.2841C11.5376 11.0538 11.6155 10.8609 11.7712 10.7052C11.9269 10.5494 12.1199 10.4716 12.3501 10.4716C12.5803 10.4716 12.7733 10.5494 12.929 10.7052C13.0847 10.8609 13.1626 11.0538 13.1626 11.2841C13.1626 11.5143 13.0847 11.7072 12.929 11.863C12.7733 12.0187 12.5803 12.0966 12.3501 12.0966Z"
			fill="#0D8DCD"
		/>
	</SvgIcon>
);

export const PngFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#707070"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M15.2402 16H9.24023C8.68795 16 8.24023 16.4477 8.24023 17V18.5C8.24023 19.0523 8.68795 19.5 9.24023 19.5H15.2402C15.7925 19.5 16.2402 19.0523 16.2402 18.5V17C16.2402 16.4477 15.7925 16 15.2402 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.457 17.6697H15.3066V18.7801C15.1943 18.8172 15.0776 18.847 14.9565 18.8694C14.8354 18.8909 14.6982 18.9017 14.5449 18.9017C14.332 18.9017 14.1514 18.8597 14.0029 18.7757C13.8545 18.6917 13.7417 18.5677 13.6646 18.4036C13.5874 18.2396 13.5488 18.0379 13.5488 17.7986C13.5488 17.574 13.5918 17.3797 13.6777 17.2156C13.7646 17.0516 13.8911 16.9246 14.0571 16.8348C14.2241 16.7449 14.4277 16.7 14.668 16.7C14.7812 16.7 14.8931 16.7122 15.0034 16.7366C15.1138 16.761 15.2139 16.7928 15.3037 16.8318L15.1528 17.1951C15.0874 17.1619 15.0127 17.1341 14.9287 17.1116C14.8447 17.0892 14.7568 17.0779 14.665 17.0779C14.5332 17.0779 14.4185 17.1082 14.3208 17.1688C14.2241 17.2293 14.1489 17.3143 14.0952 17.4236C14.0425 17.532 14.0161 17.66 14.0161 17.8074C14.0161 17.9471 14.0352 18.0711 14.0732 18.1795C14.1113 18.2869 14.1714 18.3714 14.2534 18.4329C14.3354 18.4935 14.4424 18.5237 14.5742 18.5237C14.6387 18.5237 14.6929 18.5208 14.7368 18.515C14.7817 18.5081 14.8237 18.5013 14.8628 18.4944V18.0477H14.457V17.6697Z"
			fill="#707070"
		/>
		<path
			d="M13.1035 18.8724H12.5264L11.5947 17.2523H11.5815C11.5854 17.3196 11.5889 17.3875 11.5918 17.4559C11.5947 17.5242 11.5977 17.5926 11.6006 17.6609C11.6035 17.7283 11.6064 17.7962 11.6094 17.8646V18.8724H11.2036V16.7308H11.7764L12.7065 18.3348H12.7168C12.7148 18.2684 12.7124 18.2025 12.7095 18.137C12.7065 18.0716 12.7036 18.0062 12.7007 17.9407C12.6987 17.8753 12.6968 17.8099 12.6948 17.7444V16.7308H13.1035V18.8724Z"
			fill="#707070"
		/>
		<path
			d="M10.0039 16.7308C10.2803 16.7308 10.4819 16.7903 10.6089 16.9095C10.7358 17.0276 10.7993 17.1907 10.7993 17.3987C10.7993 17.4925 10.7852 17.5823 10.7568 17.6683C10.7285 17.7532 10.6821 17.8289 10.6177 17.8953C10.5542 17.9617 10.4692 18.0145 10.3628 18.0535C10.2563 18.0916 10.125 18.1107 9.96875 18.1107H9.77393V18.8724H9.31982V16.7308H10.0039ZM9.98047 17.1028H9.77393V17.7386H9.92334C10.0083 17.7386 10.082 17.7274 10.1445 17.7049C10.207 17.6824 10.2554 17.6473 10.2896 17.5994C10.3237 17.5516 10.3408 17.4901 10.3408 17.4149C10.3408 17.3094 10.3115 17.2313 10.2529 17.1805C10.1943 17.1287 10.1035 17.1028 9.98047 17.1028Z"
			fill="#707070"
		/>
		<path
			d="M6.50049 14.5317L10.4009 11.1011L11.8735 12.5503L14.4263 9.96631L17.8325 14.4458L6.50049 14.5317Z"
			fill="#707070"
		/>
		<path
			d="M9.50049 10C10.0528 10 10.5005 9.55228 10.5005 9C10.5005 8.44772 10.0528 8 9.50049 8C8.9482 8 8.50049 8.44772 8.50049 9C8.50049 9.55228 8.9482 10 9.50049 10Z"
			fill="white"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			stroke="#707070"
		/>
	</SvgIcon>
);

export const PptxFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#B43923"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#B43923"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.9961 18.8916H15.4775L14.9795 18.0815L14.4814 18.8916H13.9951L14.7056 17.7871L14.0405 16.75H14.5415L15.0029 17.5205L15.4556 16.75H15.9448L15.2725 17.812L15.9961 18.8916Z"
			fill="#707070"
		/>
		<path d="M13.3535 18.8916H12.8994V17.1279H12.3179V16.75H13.9351V17.1279H13.3535V18.8916Z" fill="#707070" />
		<path
			d="M11.3276 16.75C11.604 16.75 11.8057 16.8096 11.9326 16.9287C12.0596 17.0469 12.123 17.21 12.123 17.418C12.123 17.5117 12.1089 17.6016 12.0806 17.6875C12.0522 17.7725 12.0059 17.8481 11.9414 17.9146C11.8779 17.981 11.793 18.0337 11.6865 18.0728C11.5801 18.1108 11.4487 18.1299 11.2925 18.1299H11.0977V18.8916H10.6436V16.75H11.3276ZM11.3042 17.1221H11.0977V17.7578H11.2471C11.332 17.7578 11.4058 17.7466 11.4683 17.7241C11.5308 17.7017 11.5791 17.6665 11.6133 17.6187C11.6475 17.5708 11.6646 17.5093 11.6646 17.4341C11.6646 17.3286 11.6353 17.2505 11.5767 17.1997C11.5181 17.1479 11.4272 17.1221 11.3042 17.1221Z"
			fill="#707070"
		/>
		<path
			d="M9.44385 16.75C9.72021 16.75 9.92188 16.8096 10.0488 16.9287C10.1758 17.0469 10.2393 17.21 10.2393 17.418C10.2393 17.5117 10.2251 17.6016 10.1968 17.6875C10.1685 17.7725 10.1221 17.8481 10.0576 17.9146C9.99414 17.981 9.90918 18.0337 9.80273 18.0728C9.69629 18.1108 9.56494 18.1299 9.40869 18.1299H9.21387V18.8916H8.75977V16.75H9.44385ZM9.42041 17.1221H9.21387V17.7578H9.36328C9.44824 17.7578 9.52197 17.7466 9.58447 17.7241C9.64697 17.7017 9.69531 17.6665 9.72949 17.6187C9.76367 17.5708 9.78076 17.5093 9.78076 17.4341C9.78076 17.3286 9.75146 17.2505 9.69287 17.1997C9.63428 17.1479 9.54346 17.1221 9.42041 17.1221Z"
			fill="#707070"
		/>
		<path
			d="M12 11.5H15C15 13.1569 13.6569 14.5 12 14.5C10.3431 14.5 9 13.1569 9 11.5C9 9.84315 10.3431 8.5 12 8.5V11.5ZM12.5 8C14.1569 8 15.5 9.34315 15.5 11H12.5V8Z"
			fill="#B43923"
		/>
	</SvgIcon>
);

export const PsFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#059FE0"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#059FE0"
		/>
		<path
			d="M15.2402 16H9.24023C8.68795 16 8.24023 16.4477 8.24023 17V18.5C8.24023 19.0523 8.68795 19.5 9.24023 19.5H15.2402C15.7925 19.5 16.2402 19.0523 16.2402 18.5V17C16.2402 16.4477 15.7925 16 15.2402 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M13.8994 18.2277C13.8994 18.3546 13.8687 18.465 13.8071 18.5587C13.7456 18.6525 13.6558 18.7247 13.5376 18.7755C13.4204 18.8263 13.2778 18.8517 13.1099 18.8517C13.0356 18.8517 12.9629 18.8468 12.8916 18.837C12.8213 18.8273 12.7534 18.8131 12.688 18.7946C12.6235 18.775 12.562 18.7511 12.5034 18.7228V18.3009C12.605 18.3458 12.7104 18.3864 12.8198 18.4225C12.9292 18.4586 13.0376 18.4767 13.145 18.4767C13.2192 18.4767 13.2788 18.4669 13.3237 18.4474C13.3696 18.4279 13.4028 18.401 13.4233 18.3668C13.4438 18.3326 13.4541 18.2936 13.4541 18.2496C13.4541 18.1959 13.436 18.15 13.3999 18.1119C13.3638 18.0739 13.314 18.0382 13.2505 18.005C13.188 17.9718 13.1172 17.9362 13.0381 17.8981C12.9883 17.8746 12.9341 17.8463 12.8755 17.8131C12.8169 17.7789 12.7612 17.7374 12.7085 17.6886C12.6558 17.6398 12.6123 17.5807 12.5781 17.5114C12.5449 17.441 12.5283 17.3571 12.5283 17.2594C12.5283 17.1315 12.5576 17.0221 12.6162 16.9313C12.6748 16.8405 12.7583 16.7711 12.8667 16.7233C12.9761 16.6744 13.105 16.65 13.2534 16.65C13.3647 16.65 13.4707 16.6632 13.5713 16.6896C13.6729 16.715 13.7788 16.7521 13.8892 16.8009L13.7427 17.1539C13.644 17.1139 13.5557 17.0831 13.4775 17.0616C13.3994 17.0392 13.3198 17.028 13.2388 17.028C13.1821 17.028 13.1338 17.0372 13.0938 17.0558C13.0537 17.0734 13.0234 17.0988 13.0029 17.132C12.9824 17.1642 12.9722 17.2018 12.9722 17.2448C12.9722 17.2955 12.9868 17.3385 13.0161 17.3737C13.0464 17.4078 13.0913 17.441 13.1509 17.4733C13.2114 17.5055 13.2866 17.5431 13.3765 17.5861C13.4858 17.6378 13.5791 17.692 13.6562 17.7487C13.7344 17.8043 13.7944 17.8702 13.8364 17.9464C13.8784 18.0216 13.8994 18.1154 13.8994 18.2277Z"
			fill="#707070"
		/>
		<path
			d="M11.4355 16.6808C11.7119 16.6808 11.9136 16.7404 12.0405 16.8595C12.1675 16.9777 12.231 17.1407 12.231 17.3488C12.231 17.4425 12.2168 17.5323 12.1885 17.6183C12.1602 17.7032 12.1138 17.7789 12.0493 17.8453C11.9858 17.9117 11.9009 17.9645 11.7944 18.0035C11.688 18.0416 11.5566 18.0607 11.4004 18.0607H11.2056V18.8224H10.7515V16.6808H11.4355ZM11.4121 17.0529H11.2056V17.6886H11.355C11.4399 17.6886 11.5137 17.6774 11.5762 17.6549C11.6387 17.6324 11.687 17.5973 11.7212 17.5494C11.7554 17.5016 11.7725 17.4401 11.7725 17.3649C11.7725 17.2594 11.7432 17.1813 11.6846 17.1305C11.626 17.0787 11.5352 17.0529 11.4121 17.0529Z"
			fill="#707070"
		/>
		<path
			d="M16.8286 13.9526L7.83643 14.021L10.3813 11.7827L11.5229 12.9067L11.8784 13.2563L12.229 12.9019L14.3765 10.7271L16.8286 13.9526Z"
			fill="#059FE0"
			stroke="#059FE0"
		/>
		<path
			d="M9.50049 8.5C9.77663 8.5 10.0005 8.72386 10.0005 9C10.0005 9.27614 9.77663 9.5 9.50049 9.5C9.22435 9.5 9.00049 9.27614 9.00049 9C9.00049 8.72386 9.22435 8.5 9.50049 8.5Z"
			fill="#10BADC"
			stroke="#001E36"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			fill="#10BADC"
			stroke="#059FE0"
		/>
	</SvgIcon>
);

export const ShFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#323232"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#323232"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.2021 18.8063H13.7495V17.882H12.9014V18.8063H12.4473V16.6647H12.9014V17.504H13.7495V16.6647H14.2021V18.8063Z"
			fill="#707070"
		/>
		<path
			d="M12.0591 18.2115C12.0591 18.3385 12.0283 18.4489 11.9668 18.5426C11.9053 18.6364 11.8154 18.7086 11.6973 18.7594C11.5801 18.8102 11.4375 18.8356 11.2695 18.8356C11.1953 18.8356 11.1226 18.8307 11.0513 18.8209C10.981 18.8112 10.9131 18.797 10.8477 18.7784C10.7832 18.7589 10.7217 18.735 10.6631 18.7067V18.2848C10.7646 18.3297 10.8701 18.3702 10.9795 18.4064C11.0889 18.4425 11.1973 18.4606 11.3047 18.4606C11.3789 18.4606 11.4385 18.4508 11.4834 18.4313C11.5293 18.4117 11.5625 18.3849 11.583 18.3507C11.6035 18.3165 11.6138 18.2775 11.6138 18.2335C11.6138 18.1798 11.5957 18.1339 11.5596 18.0958C11.5234 18.0577 11.4736 18.0221 11.4102 17.9889C11.3477 17.9557 11.2769 17.92 11.1978 17.882C11.1479 17.8585 11.0938 17.8302 11.0352 17.797C10.9766 17.7628 10.9209 17.7213 10.8682 17.6725C10.8154 17.6237 10.772 17.5646 10.7378 17.4952C10.7046 17.4249 10.688 17.3409 10.688 17.2433C10.688 17.1154 10.7173 17.006 10.7759 16.9152C10.8345 16.8243 10.918 16.755 11.0264 16.7072C11.1357 16.6583 11.2646 16.6339 11.4131 16.6339C11.5244 16.6339 11.6304 16.6471 11.731 16.6735C11.8325 16.6989 11.9385 16.736 12.0488 16.7848L11.9023 17.1378C11.8037 17.0978 11.7153 17.067 11.6372 17.0455C11.5591 17.0231 11.4795 17.0118 11.3984 17.0118C11.3418 17.0118 11.2935 17.0211 11.2534 17.0397C11.2134 17.0573 11.1831 17.0826 11.1626 17.1158C11.1421 17.1481 11.1318 17.1857 11.1318 17.2286C11.1318 17.2794 11.1465 17.3224 11.1758 17.3575C11.2061 17.3917 11.251 17.4249 11.3105 17.4572C11.3711 17.4894 11.4463 17.527 11.5361 17.5699C11.6455 17.6217 11.7388 17.6759 11.8159 17.7325C11.894 17.7882 11.9541 17.8541 11.9961 17.9303C12.0381 18.0055 12.0591 18.0992 12.0591 18.2115Z"
			fill="#707070"
		/>
		<path
			d="M16 13.934H12V12.934H16V13.934ZM12.2031 11.3383L9.6123 13.9271L8.88672 13.2025L10.7393 11.3383L8.88672 9.474L9.6123 8.74939L12.2031 11.3383Z"
			fill="#404040"
		/>
	</SvgIcon>
);

export const SvgFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#323232"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#323232"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.0474 17.7313H14.897V18.8417C14.7847 18.8788 14.668 18.9086 14.5469 18.931C14.4258 18.9525 14.2886 18.9633 14.1353 18.9633C13.9224 18.9633 13.7417 18.9213 13.5933 18.8373C13.4448 18.7533 13.332 18.6293 13.2549 18.4652C13.1777 18.3011 13.1392 18.0995 13.1392 17.8602C13.1392 17.6356 13.1821 17.4413 13.2681 17.2772C13.355 17.1132 13.4814 16.9862 13.6475 16.8964C13.8145 16.8065 14.0181 16.7616 14.2583 16.7616C14.3716 16.7616 14.4834 16.7738 14.5938 16.7982C14.7041 16.8226 14.8042 16.8544 14.894 16.8934L14.7432 17.2567C14.6777 17.2235 14.603 17.1957 14.519 17.1732C14.4351 17.1508 14.3472 17.1395 14.2554 17.1395C14.1235 17.1395 14.0088 17.1698 13.9111 17.2303C13.8145 17.2909 13.7393 17.3759 13.6855 17.4852C13.6328 17.5936 13.6064 17.7216 13.6064 17.869C13.6064 18.0087 13.6255 18.1327 13.6636 18.2411C13.7017 18.3485 13.7617 18.433 13.8438 18.4945C13.9258 18.5551 14.0327 18.5853 14.1646 18.5853C14.229 18.5853 14.2832 18.5824 14.3271 18.5765C14.3721 18.5697 14.4141 18.5629 14.4531 18.556V18.1093H14.0474V17.7313Z"
			fill="#707070"
		/>
		<path
			d="M12.9634 16.7924L12.2354 18.934H11.7402L11.0137 16.7924H11.4722L11.875 18.0668C11.8818 18.0883 11.8931 18.1288 11.9087 18.1884C11.9243 18.2469 11.9399 18.3094 11.9556 18.3759C11.9722 18.4413 11.9834 18.4955 11.9893 18.5385C11.9951 18.4955 12.0054 18.4413 12.02 18.3759C12.0356 18.3104 12.0508 18.2484 12.0654 18.1898C12.0811 18.1302 12.0923 18.0892 12.0991 18.0668L12.5049 16.7924H12.9634Z"
			fill="#707070"
		/>
		<path
			d="M10.895 18.3392C10.895 18.4662 10.8643 18.5765 10.8027 18.6703C10.7412 18.764 10.6514 18.8363 10.5332 18.8871C10.416 18.9379 10.2734 18.9633 10.1055 18.9633C10.0312 18.9633 9.9585 18.9584 9.88721 18.9486C9.81689 18.9388 9.74902 18.9247 9.68359 18.9061C9.61914 18.8866 9.55762 18.8627 9.49902 18.8344V18.4125C9.60059 18.4574 9.70605 18.4979 9.81543 18.5341C9.9248 18.5702 10.0332 18.5883 10.1406 18.5883C10.2148 18.5883 10.2744 18.5785 10.3193 18.559C10.3652 18.5394 10.3984 18.5126 10.4189 18.4784C10.4395 18.4442 10.4497 18.4052 10.4497 18.3612C10.4497 18.3075 10.4316 18.2616 10.3955 18.2235C10.3594 18.1854 10.3096 18.1498 10.2461 18.1166C10.1836 18.0834 10.1128 18.0477 10.0337 18.0096C9.98389 17.9862 9.92969 17.9579 9.87109 17.9247C9.8125 17.8905 9.75684 17.849 9.7041 17.8002C9.65137 17.7513 9.60791 17.6923 9.57373 17.6229C9.54053 17.5526 9.52393 17.4686 9.52393 17.371C9.52393 17.243 9.55322 17.1337 9.61182 17.0428C9.67041 16.952 9.75391 16.8827 9.8623 16.8348C9.97168 16.786 10.1006 16.7616 10.249 16.7616C10.3604 16.7616 10.4663 16.7748 10.5669 16.8011C10.6685 16.8265 10.7744 16.8636 10.8848 16.9125L10.7383 17.2655C10.6396 17.2255 10.5513 17.1947 10.4731 17.1732C10.395 17.1508 10.3154 17.1395 10.2344 17.1395C10.1777 17.1395 10.1294 17.1488 10.0894 17.1674C10.0493 17.1849 10.019 17.2103 9.99854 17.2435C9.97803 17.2758 9.96777 17.3134 9.96777 17.3563C9.96777 17.4071 9.98242 17.4501 10.0117 17.4852C10.042 17.5194 10.0869 17.5526 10.1465 17.5848C10.207 17.6171 10.2822 17.6547 10.3721 17.6976C10.4814 17.7494 10.5747 17.8036 10.6519 17.8602C10.73 17.9159 10.79 17.9818 10.832 18.058C10.874 18.1332 10.895 18.2269 10.895 18.3392Z"
			fill="#707070"
		/>
		<g filter="url(#filter0_d_2525_2088)">
			<path
				d="M12.4004 8.43396C12.8461 8.43403 13.2184 8.74553 13.3135 9.16248C13.4038 9.18328 13.4931 9.20708 13.5811 9.23376H17.2441C17.3303 9.23389 17.4003 9.3039 17.4004 9.39001C17.4003 9.47617 17.3303 9.54614 17.2441 9.54626H14.3311C15.3421 10.0934 16.0928 11.0574 16.3574 12.2074C16.7755 12.3018 17.0879 12.675 17.0879 13.1215C17.0878 13.6389 16.6679 14.0588 16.1504 14.059C15.6328 14.0589 15.213 13.639 15.2129 13.1215C15.2129 12.7536 15.425 12.4351 15.7334 12.2816C15.426 11.0577 14.4633 10.0945 13.2393 9.78748C13.0858 10.0961 12.7683 10.3089 12.4004 10.309C12.0323 10.3089 11.7139 10.0964 11.5605 9.78748C10.3368 10.0948 9.37366 11.0579 9.06641 12.2816C9.37536 12.435 9.58789 12.7532 9.58789 13.1215C9.58776 13.639 9.16796 14.0589 8.65039 14.059C8.13285 14.0589 7.71303 13.639 7.71289 13.1215C7.71289 12.6753 8.02486 12.3021 8.44238 12.2074C8.7069 11.0573 9.45858 10.0935 10.4697 9.54626H7.55664C7.47039 9.54626 7.40046 9.47625 7.40039 9.39001C7.40051 9.30382 7.47042 9.23376 7.55664 9.23376H11.2197C11.3077 9.20709 11.3969 9.18328 11.4873 9.16248C11.5824 8.74549 11.9547 8.43401 12.4004 8.43396ZM8.375 12.5619C8.16833 12.6639 8.02539 12.8755 8.02539 13.1215C8.02553 13.4664 8.30541 13.7464 8.65039 13.7465C8.9954 13.7464 9.27526 13.4664 9.27539 13.1215C9.27539 12.9065 9.16725 12.7164 9.00195 12.6039C8.97647 12.7727 8.96289 12.9456 8.96289 13.1215H8.33789C8.33789 12.9317 8.34982 12.7447 8.375 12.5619ZM16.4248 12.5619C16.45 12.7448 16.4629 12.9317 16.4629 13.1215H15.8379C15.8379 12.9455 15.8234 12.7727 15.7979 12.6039C15.633 12.7164 15.5254 12.9069 15.5254 13.1215C15.5255 13.4664 15.8054 13.7464 16.1504 13.7465C16.4953 13.7463 16.7753 13.4664 16.7754 13.1215C16.7754 12.8751 16.632 12.6637 16.4248 12.5619ZM12.4004 9.68396C12.2245 9.68396 12.0516 9.69656 11.8828 9.72205C11.9952 9.88768 12.1852 9.99642 12.4004 9.99646C12.6153 9.99641 12.8045 9.88737 12.917 9.72205C12.7485 9.69665 12.576 9.68397 12.4004 9.68396ZM12.4004 8.74646C12.1536 8.7465 11.9414 8.89025 11.8398 9.09802C12.0231 9.0726 12.2102 9.05896 12.4004 9.05896C12.5903 9.05897 12.777 9.07269 12.96 9.09802C12.8583 8.89051 12.647 8.74651 12.4004 8.74646Z"
				fill="#323232"
			/>
		</g>
		<path
			d="M8.64355 12.4967C8.98856 12.4967 9.26855 12.7767 9.26855 13.1217C9.26829 13.4665 8.9884 13.7457 8.64355 13.7457C8.29868 13.7457 8.01882 13.4665 8.01855 13.1217C8.01855 12.7767 8.29852 12.4967 8.64355 12.4967ZM16.1504 12.4967C16.4954 12.4967 16.7754 12.7767 16.7754 13.1217C16.7751 13.4665 16.4953 13.7457 16.1504 13.7457C15.8056 13.7457 15.5257 13.4665 15.5254 13.1217C15.5254 12.7767 15.8054 12.4968 16.1504 12.4967ZM12.3965 8.74768C12.7415 8.74768 13.0215 9.02765 13.0215 9.37268C13.0212 9.71751 12.7414 9.9967 12.3965 9.9967C12.0518 9.99651 11.7727 9.7174 11.7725 9.37268C11.7725 9.02776 12.0516 8.74787 12.3965 8.74768Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_d_2525_2088"
				x="3.40039"
				y="8.43396"
				width="18"
				height="13.625"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="2" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2525_2088" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2525_2088" result="shape" />
			</filter>
		</defs>
	</SvgIcon>
);

export const SwfFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#ED4B3F"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#ED4B3F"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.5693 18.9338H14.1226V16.7922H15.3501V17.1643H14.5693V17.7166H15.2959V18.0872H14.5693V18.9338Z"
			fill="#707070"
		/>
		<path
			d="M13.853 16.7922L13.3081 18.9338H12.791L12.501 17.8088C12.4951 17.7874 12.4873 17.7546 12.4775 17.7107C12.4678 17.6667 12.4575 17.6189 12.4468 17.5671C12.436 17.5144 12.4263 17.4651 12.4175 17.4192C12.4097 17.3723 12.4043 17.3352 12.4014 17.3079C12.3984 17.3352 12.3926 17.3718 12.3838 17.4177C12.376 17.4636 12.3667 17.5125 12.356 17.5642C12.3462 17.616 12.3364 17.6643 12.3267 17.7092C12.3169 17.7542 12.3091 17.7883 12.3032 17.8118L12.0146 18.9338H11.499L10.9526 16.7922H11.3994L11.6733 17.9612C11.6812 17.9963 11.6899 18.0383 11.6997 18.0872C11.7104 18.136 11.7207 18.1873 11.7305 18.241C11.7412 18.2937 11.7505 18.345 11.7583 18.3948C11.7671 18.4436 11.7734 18.4861 11.7773 18.5222C11.7822 18.4851 11.7886 18.4421 11.7964 18.3933C11.8042 18.3435 11.8125 18.2932 11.8213 18.2424C11.8311 18.1907 11.8408 18.1428 11.8506 18.0989C11.8604 18.0549 11.8691 18.0193 11.877 17.9919L12.189 16.7922H12.6182L12.9302 17.9919C12.937 18.0183 12.9448 18.054 12.9536 18.0989C12.9634 18.1428 12.9731 18.1907 12.9829 18.2424C12.9927 18.2942 13.0015 18.345 13.0093 18.3948C13.0181 18.4436 13.0244 18.4861 13.0283 18.5222C13.0352 18.4734 13.0444 18.4143 13.0562 18.345C13.0688 18.2747 13.082 18.2048 13.0957 18.1355C13.1104 18.0662 13.123 18.0081 13.1338 17.9612L13.4062 16.7922H13.853Z"
			fill="#707070"
		/>
		<path
			d="M10.834 18.3391C10.834 18.4661 10.8032 18.5764 10.7417 18.6702C10.6802 18.7639 10.5903 18.8362 10.4722 18.887C10.355 18.9377 10.2124 18.9631 10.0444 18.9631C9.97021 18.9631 9.89746 18.9583 9.82617 18.9485C9.75586 18.9387 9.68799 18.9246 9.62256 18.906C9.55811 18.8865 9.49658 18.8625 9.43799 18.8342V18.4124C9.53955 18.4573 9.64502 18.4978 9.75439 18.5339C9.86377 18.5701 9.97217 18.5881 10.0796 18.5881C10.1538 18.5881 10.2134 18.5784 10.2583 18.5588C10.3042 18.5393 10.3374 18.5125 10.3579 18.4783C10.3784 18.4441 10.3887 18.405 10.3887 18.3611C10.3887 18.3074 10.3706 18.2615 10.3345 18.2234C10.2983 18.1853 10.2485 18.1497 10.1851 18.1165C10.1226 18.0833 10.0518 18.0476 9.97266 18.0095C9.92285 17.9861 9.86865 17.9578 9.81006 17.9246C9.75146 17.8904 9.6958 17.8489 9.64307 17.8C9.59033 17.7512 9.54688 17.6921 9.5127 17.6228C9.47949 17.5525 9.46289 17.4685 9.46289 17.3708C9.46289 17.2429 9.49219 17.1335 9.55078 17.0427C9.60938 16.9519 9.69287 16.8826 9.80127 16.8347C9.91064 16.7859 10.0396 16.7615 10.188 16.7615C10.2993 16.7615 10.4053 16.7747 10.5059 16.801C10.6074 16.8264 10.7134 16.8635 10.8237 16.9124L10.6772 17.2654C10.5786 17.2253 10.4902 17.1946 10.4121 17.1731C10.334 17.1506 10.2544 17.1394 10.1733 17.1394C10.1167 17.1394 10.0684 17.1487 10.0283 17.1672C9.98828 17.1848 9.95801 17.2102 9.9375 17.2434C9.91699 17.2756 9.90674 17.3132 9.90674 17.3562C9.90674 17.407 9.92139 17.45 9.95068 17.4851C9.98096 17.5193 10.0259 17.5525 10.0854 17.5847C10.146 17.6169 10.2212 17.6545 10.311 17.6975C10.4204 17.7493 10.5137 17.8035 10.5908 17.8601C10.6689 17.9158 10.729 17.9817 10.771 18.0579C10.813 18.1331 10.834 18.2268 10.834 18.3391Z"
			fill="#707070"
		/>
		<path
			d="M12.0005 7.73413C13.9335 7.73413 15.5005 9.30113 15.5005 11.2341C15.5005 12.5076 14.8201 13.6218 13.8032 14.2341H14.0015V14.7341H12.0015H12.0005C10.0675 14.7341 8.50049 13.1671 8.50049 11.2341C8.50049 9.30113 10.0675 7.73413 12.0005 7.73413ZM15.3022 14.7341H14.3022V14.2341H15.3022V14.7341ZM16.603 14.7341H15.603V14.2341H16.603V14.7341ZM13.0259 11.989C12.6606 11.989 12.3647 12.2858 12.3647 12.6511C12.365 13.0162 12.6607 13.3123 13.0259 13.3123C13.3909 13.3121 13.6868 13.0161 13.687 12.6511C13.687 12.2859 13.3911 11.9891 13.0259 11.989ZM10.981 11.9783C10.6157 11.9783 10.3199 12.2742 10.3198 12.6394C10.3198 13.0047 10.6157 13.3005 10.981 13.3005C11.3462 13.3005 11.6421 13.0047 11.6421 12.6394C11.642 12.2742 11.3462 11.9783 10.981 11.9783ZM12.0278 11.0408C11.9062 11.0409 11.8072 11.1399 11.8071 11.2615C11.8071 11.3832 11.9062 11.4821 12.0278 11.4822C12.1496 11.4822 12.2485 11.3832 12.2485 11.2615C12.2484 11.1398 12.1495 11.0408 12.0278 11.0408ZM10.3198 10.0486C9.95453 10.0486 9.65771 10.3454 9.65771 10.7107C9.65784 11.0759 9.95461 11.3718 10.3198 11.3718C10.6849 11.3717 10.9808 11.0758 10.981 10.7107C10.981 10.3455 10.685 10.0488 10.3198 10.0486ZM13.6821 10.0486C13.3168 10.0486 13.021 10.3454 13.021 10.7107C13.0211 11.0759 13.3169 11.3718 13.6821 11.3718C14.0472 11.3717 14.3431 11.0758 14.3433 10.7107C14.3433 10.3455 14.0473 10.0487 13.6821 10.0486ZM12.0278 8.83667C11.6627 8.83679 11.3668 9.13265 11.3667 9.4978C11.3667 9.86302 11.6626 10.1588 12.0278 10.1589C12.3931 10.1589 12.6899 9.86309 12.6899 9.4978C12.6899 9.13257 12.3931 8.83667 12.0278 8.83667Z"
			fill="#ED4B3F"
		/>
	</SvgIcon>
);

export const TiffFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M6.04932 6.88997H8.23032C8.44012 6.89184 8.64212 6.81049 8.79206 6.66373C8.94201 6.51697 9.02768 6.31677 9.03032 6.10697L9.10232 3.98697M9.54932 3.07397L9.48032 6.10697C9.47794 6.4362 9.34494 6.75101 9.11054 6.98222C8.87615 7.21343 8.55955 7.3421 8.23032 7.33997H5.04932L9.54932 3.07397Z"
			fill="#014881"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#014881"
		/>
		<path
			d="M15.2402 16H9.24023C8.68795 16 8.24023 16.4477 8.24023 17V18.5C8.24023 19.0523 8.68795 19.5 9.24023 19.5H15.2402C15.7925 19.5 16.2402 19.0523 16.2402 18.5V17C16.2402 16.4477 15.7925 16 15.2402 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M14.3315 18.8916H13.8848V16.75H15.1123V17.1221H14.3315V17.6743H15.0581V18.0449H14.3315V18.8916Z"
			fill="#707070"
		/>
		<path
			d="M12.6851 18.8916H12.2383V16.75H13.4658V17.1221H12.6851V17.6743H13.4116V18.0449H12.6851V18.8916Z"
			fill="#707070"
		/>
		<path d="M11.2451 18.8916V16.75H11.6992V18.8916H11.2451Z" fill="#707070" />
		<path d="M10.334 18.8916H9.87988V17.1279H9.29834V16.75H10.9155V17.1279H10.334V18.8916Z" fill="#707070" />
		<path
			d="M16.8286 13.9526L7.83643 14.021L10.3813 11.7827L11.5229 12.9067L11.8784 13.2563L12.229 12.9019L14.3765 10.7271L16.8286 13.9526Z"
			fill="#014881"
			stroke="#014881"
		/>
		<path
			d="M9.50049 8.5C9.77663 8.5 10.0005 8.72386 10.0005 9C10.0005 9.27614 9.77663 9.5 9.50049 9.5C9.22435 9.5 9.00049 9.27614 9.00049 9C9.00049 8.72386 9.22435 8.5 9.50049 8.5Z"
			fill="#014881"
			stroke="#014881"
		/>
		<path
			d="M9.50049 9.5C9.77663 9.5 10.0005 9.27614 10.0005 9C10.0005 8.72386 9.77663 8.5 9.50049 8.5C9.22435 8.5 9.00049 8.72386 9.00049 9C9.00049 9.27614 9.22435 9.5 9.50049 9.5Z"
			fill="#014881"
			stroke="#014881"
		/>
	</SvgIcon>
);

export const TxtFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#707070"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#707070"
		/>
		<path d="M17.75 9.75H6.75V9H17.75V9.75Z" fill="#707070" />
		<path d="M17.75 11.75H6.75V11H17.75V11.75Z" fill="#707070" />
		<path d="M12.25 13.75H6.75V13H12.25V13.75Z" fill="#707070" />
		<path
			d="M15.25 16H9.25C8.69772 16 8.25 16.4477 8.25 17V18.5C8.25 19.0523 8.69772 19.5 9.25 19.5H15.25C15.8023 19.5 16.25 19.0523 16.25 18.5V17C16.25 16.4477 15.8023 16 15.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M10.6123 18.799H10.1543V17.035H9.57227V16.657H11.1893V17.035H10.6123V18.799ZM13.2503 18.799H12.7323L12.2323 17.989L11.7323 18.799H11.2493L11.9593 17.699L11.2953 16.657H11.7953L12.2563 17.428L12.7123 16.657H13.2013L12.5273 17.719L13.2503 18.799ZM14.3503 18.799H13.8923V17.035H13.3123V16.657H14.9283V17.035H14.3463L14.3503 18.799Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const WfxcFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#5F3FA5"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#5F3FA5"
		/>
		<path
			d="M16.5499 16H7.94971C7.39742 16 6.94971 16.4477 6.94971 17V18.5C6.94971 19.0523 7.39742 19.5 7.94971 19.5H16.5499C17.1022 19.5 17.5499 19.0523 17.5499 18.5V17C17.5499 16.4477 17.1022 16 16.5499 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.8965 17.2056C15.8096 17.2056 15.7324 17.2227 15.665 17.2568C15.5986 17.29 15.5425 17.3384 15.4966 17.4019C15.4517 17.4653 15.4175 17.542 15.394 17.6318C15.3706 17.7217 15.3589 17.8228 15.3589 17.9351C15.3589 18.0864 15.3774 18.2158 15.4146 18.3232C15.4526 18.4297 15.5112 18.5112 15.5903 18.5679C15.6694 18.6235 15.7715 18.6514 15.8965 18.6514C15.9834 18.6514 16.0703 18.6416 16.1572 18.6221C16.2451 18.6025 16.3403 18.5747 16.4429 18.5386V18.9194C16.3481 18.9585 16.2549 18.9863 16.1631 19.0029C16.0713 19.0205 15.9683 19.0293 15.854 19.0293C15.6333 19.0293 15.4517 18.9839 15.3091 18.8931C15.1675 18.8013 15.0625 18.6733 14.9941 18.5093C14.9258 18.3442 14.8916 18.1519 14.8916 17.9321C14.8916 17.77 14.9136 17.6216 14.9575 17.4868C15.0015 17.3521 15.0659 17.2354 15.1509 17.1367C15.2358 17.0381 15.3408 16.9619 15.4658 16.9082C15.5908 16.8545 15.7344 16.8276 15.8965 16.8276C16.0029 16.8276 16.1094 16.8413 16.2158 16.8687C16.3232 16.895 16.4258 16.9316 16.5234 16.9785L16.377 17.3477C16.2969 17.3096 16.2163 17.2764 16.1353 17.248C16.0542 17.2197 15.9746 17.2056 15.8965 17.2056Z"
			fill="#707070"
		/>
		<path
			d="M14.7173 19H14.1987L13.7007 18.1899L13.2026 19H12.7163L13.4268 17.8955L12.7617 16.8584H13.2627L13.7241 17.6289L14.1768 16.8584H14.666L13.9937 17.9204L14.7173 19Z"
			fill="#707070"
		/>
		<path
			d="M11.7861 19H11.3394V16.8584H12.5669V17.2305H11.7861V17.7827H12.5127V18.1533H11.7861V19Z"
			fill="#707070"
		/>
		<path
			d="M11.0698 16.8584L10.5249 19H10.0078L9.71777 17.875C9.71191 17.8535 9.7041 17.8208 9.69434 17.7769C9.68457 17.7329 9.67432 17.6851 9.66357 17.6333C9.65283 17.5806 9.64307 17.5312 9.63428 17.4854C9.62646 17.4385 9.62109 17.4014 9.61816 17.374C9.61523 17.4014 9.60938 17.438 9.60059 17.4839C9.59277 17.5298 9.5835 17.5786 9.57275 17.6304C9.56299 17.6821 9.55322 17.7305 9.54346 17.7754C9.53369 17.8203 9.52588 17.8545 9.52002 17.8779L9.23145 19H8.71582L8.16943 16.8584H8.61621L8.89014 18.0273C8.89795 18.0625 8.90674 18.1045 8.9165 18.1533C8.92725 18.2021 8.9375 18.2534 8.94727 18.3071C8.95801 18.3599 8.96729 18.4111 8.9751 18.4609C8.98389 18.5098 8.99023 18.5522 8.99414 18.5884C8.99902 18.5513 9.00537 18.5083 9.01318 18.4595C9.021 18.4097 9.0293 18.3594 9.03809 18.3086C9.04785 18.2568 9.05762 18.209 9.06738 18.165C9.07715 18.1211 9.08594 18.0854 9.09375 18.0581L9.40576 16.8584H9.83496L10.147 18.0581C10.1538 18.0845 10.1616 18.1201 10.1704 18.165C10.1802 18.209 10.1899 18.2568 10.1997 18.3086C10.2095 18.3604 10.2183 18.4111 10.2261 18.4609C10.2349 18.5098 10.2412 18.5522 10.2451 18.5884C10.252 18.5396 10.2612 18.4805 10.2729 18.4111C10.2856 18.3408 10.2988 18.271 10.3125 18.2017C10.3271 18.1323 10.3398 18.0742 10.3506 18.0273L10.623 16.8584H11.0698Z"
			fill="#707070"
		/>
		<path
			d="M12.25 7.4342C13.1545 7.4342 13.9226 7.71572 14.5537 8.27795C15.1845 8.84013 15.5 9.52405 15.5 10.3297V10.5524H15.6543C16.1809 10.589 16.6199 10.778 16.9717 11.1188C17.3236 11.4597 17.5 11.8652 17.5 12.3346C17.4999 12.8312 17.3057 13.2519 16.918 13.5973C16.5301 13.9428 16.0577 14.1158 15.5 14.1158H9.5C8.809 14.1158 8.21928 13.902 7.73145 13.4742C7.24388 13.0467 7.00012 12.5251 7 11.9098C7 11.3649 7.19622 10.88 7.58789 10.4557C7.97954 10.0314 8.47932 9.78041 9.08691 9.70276C9.24716 9.03691 9.6225 8.49214 10.2139 8.06897C10.8052 7.64579 11.484 7.4342 12.25 7.4342ZM12.5908 9.05725V9.60999H11.5176V10.9918H10.8555V10.4381H9.09961V11.9713H10.8555V11.4205H11.5176V12.7994H12.5908V13.3522H14.3496V11.8199H12.5908V12.3698H11.9316V10.0397H12.5908V10.5924H14.3496V9.05725H12.5908Z"
			fill="#5F3FA5"
		/>
	</SvgIcon>
);

export const WfxpFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#5F3FA5"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#5F3FA5"
		/>
		<path
			d="M16.5499 16H7.94971C7.39742 16 6.94971 16.4477 6.94971 17V18.5C6.94971 19.0523 7.39742 19.5 7.94971 19.5H16.5499C17.1022 19.5 17.5499 19.0523 17.5499 18.5V17C17.5499 16.4477 17.1022 16 16.5499 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M15.7856 16.7584C16.062 16.7584 16.2637 16.818 16.3906 16.9371C16.5176 17.0553 16.5811 17.2184 16.5811 17.4264C16.5811 17.5201 16.5669 17.61 16.5386 17.6959C16.5103 17.7809 16.4639 17.8566 16.3994 17.923C16.3359 17.9894 16.251 18.0421 16.1445 18.0812C16.0381 18.1193 15.9067 18.1383 15.7505 18.1383H15.5557V18.9H15.1016V16.7584H15.7856ZM15.7622 17.1305H15.5557V17.7662H15.7051C15.79 17.7662 15.8638 17.755 15.9263 17.7325C15.9888 17.7101 16.0371 17.6749 16.0713 17.6271C16.1055 17.5792 16.1226 17.5177 16.1226 17.4425C16.1226 17.337 16.0933 17.2589 16.0347 17.2081C15.9761 17.1564 15.8853 17.1305 15.7622 17.1305Z"
			fill="#707070"
		/>
		<path
			d="M14.832 18.9H14.3135L13.8154 18.09L13.3174 18.9H12.8311L13.5415 17.7955L12.8765 16.7584H13.3774L13.8389 17.5289L14.2915 16.7584H14.7808L14.1084 17.8204L14.832 18.9Z"
			fill="#707070"
		/>
		<path
			d="M11.9009 18.9H11.4541V16.7584H12.6816V17.1305H11.9009V17.6827H12.6274V18.0533H11.9009V18.9Z"
			fill="#707070"
		/>
		<path
			d="M11.1846 16.7584L10.6396 18.9H10.1226L9.83252 17.775C9.82666 17.7535 9.81885 17.7208 9.80908 17.6769C9.79932 17.6329 9.78906 17.5851 9.77832 17.5333C9.76758 17.4806 9.75781 17.4313 9.74902 17.3854C9.74121 17.3385 9.73584 17.3014 9.73291 17.274C9.72998 17.3014 9.72412 17.338 9.71533 17.3839C9.70752 17.4298 9.69824 17.4786 9.6875 17.5304C9.67773 17.5822 9.66797 17.6305 9.6582 17.6754C9.64844 17.7203 9.64062 17.7545 9.63477 17.778L9.34619 18.9H8.83057L8.28418 16.7584H8.73096L9.00488 17.9274C9.0127 17.9625 9.02148 18.0045 9.03125 18.0533C9.04199 18.1022 9.05225 18.1534 9.06201 18.2072C9.07275 18.2599 9.08203 18.3112 9.08984 18.361C9.09863 18.4098 9.10498 18.4523 9.10889 18.4884C9.11377 18.4513 9.12012 18.4083 9.12793 18.3595C9.13574 18.3097 9.14404 18.2594 9.15283 18.2086C9.1626 18.1569 9.17236 18.109 9.18213 18.0651C9.19189 18.0211 9.20068 17.9855 9.2085 17.9581L9.52051 16.7584H9.94971L10.2617 17.9581C10.2686 17.9845 10.2764 18.0201 10.2852 18.0651C10.2949 18.109 10.3047 18.1569 10.3145 18.2086C10.3242 18.2604 10.333 18.3112 10.3408 18.361C10.3496 18.4098 10.356 18.4523 10.3599 18.4884C10.3667 18.4396 10.376 18.3805 10.3877 18.3112C10.4004 18.2408 10.4136 18.171 10.4272 18.1017C10.4419 18.0323 10.4546 17.9742 10.4653 17.9274L10.7378 16.7584H11.1846Z"
			fill="#707070"
		/>
		<path
			d="M13.5845 14.8341V13.9327H11.7443V11.6861H10.6102V12.5829H7.59961V10.0852H10.6102V10.9865H11.7443V8.73537H13.5845V7.83411H16.5996V10.3363H13.5845V9.43493H12.4549V13.2332H13.5845V12.3363H16.5996V14.8341H13.5845ZM14.2949 14.1345H15.8891V13.0359H14.2949V14.1345ZM8.31014 11.8834H9.8997V10.7847H8.31014V11.8834ZM14.2949 9.63675H15.8891V8.53366H14.2949V9.63675Z"
			fill="#5F3FA5"
		/>
	</SvgIcon>
);

export const WinmdFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#106EAD"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#106EAD"
		/>
		<path
			d="M17.5499 16H6.94971C6.39742 16 5.94971 16.4477 5.94971 17V18.5C5.94971 19.0523 6.39742 19.5 6.94971 19.5H17.5499C18.1022 19.5 18.5499 19.0523 18.5499 18.5V17C18.5499 16.4477 18.1022 16 17.5499 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M17.9185 17.9087C17.9185 18.1499 17.8721 18.3516 17.7793 18.5137C17.6875 18.6748 17.5542 18.7964 17.3794 18.8784C17.2046 18.9595 16.9941 19 16.748 19H16.1416V16.8584H16.814C17.0386 16.8584 17.2334 16.8984 17.3984 16.9785C17.5635 17.0576 17.6914 17.1753 17.7822 17.3315C17.873 17.4868 17.9185 17.6792 17.9185 17.9087ZM17.4468 17.9204C17.4468 17.7622 17.4233 17.6323 17.3765 17.5308C17.3306 17.4282 17.2622 17.3525 17.1714 17.3037C17.0815 17.2549 16.9702 17.2305 16.8374 17.2305H16.5957V18.625H16.7905C17.0122 18.625 17.1768 18.5659 17.2842 18.4478C17.3926 18.3296 17.4468 18.1538 17.4468 17.9204Z"
			fill="#707070"
		/>
		<path
			d="M14.2183 19L13.7026 17.3198H13.6895C13.6914 17.3599 13.6943 17.4204 13.6982 17.5015C13.7031 17.5815 13.7075 17.667 13.7114 17.7578C13.7153 17.8486 13.7173 17.9307 13.7173 18.0039V19H13.3115V16.8584H13.9297L14.4365 18.4961H14.4453L14.9829 16.8584H15.6011V19H15.1777V17.9863C15.1777 17.9189 15.1787 17.8413 15.1807 17.7534C15.1836 17.6655 15.187 17.582 15.1909 17.5029C15.1948 17.4229 15.1978 17.3628 15.1997 17.3228H15.1865L14.6343 19H14.2183Z"
			fill="#707070"
		/>
		<path
			d="M12.771 19H12.1938L11.2622 17.3799H11.249C11.2529 17.4473 11.2563 17.5151 11.2593 17.5835C11.2622 17.6519 11.2651 17.7202 11.2681 17.7886C11.271 17.856 11.2739 17.9238 11.2769 17.9922V19H10.8711V16.8584H11.4438L12.374 18.4624H12.3843C12.3823 18.396 12.3799 18.3301 12.377 18.2646C12.374 18.1992 12.3711 18.1338 12.3682 18.0684C12.3662 18.0029 12.3643 17.9375 12.3623 17.8721V16.8584H12.771V19Z"
			fill="#707070"
		/>
		<path d="M9.87793 19V16.8584H10.332V19H9.87793Z" fill="#707070" />
		<path
			d="M9.6084 16.8584L9.06348 19H8.54639L8.25635 17.875C8.25049 17.8535 8.24268 17.8208 8.23291 17.7769C8.22314 17.7329 8.21289 17.6851 8.20215 17.6333C8.19141 17.5806 8.18164 17.5312 8.17285 17.4854C8.16504 17.4385 8.15967 17.4014 8.15674 17.374C8.15381 17.4014 8.14795 17.438 8.13916 17.4839C8.13135 17.5298 8.12207 17.5786 8.11133 17.6304C8.10156 17.6821 8.0918 17.7305 8.08203 17.7754C8.07227 17.8203 8.06445 17.8545 8.05859 17.8779L7.77002 19H7.25439L6.70801 16.8584H7.15479L7.42871 18.0273C7.43652 18.0625 7.44531 18.1045 7.45508 18.1533C7.46582 18.2021 7.47607 18.2534 7.48584 18.3071C7.49658 18.3599 7.50586 18.4111 7.51367 18.4609C7.52246 18.5098 7.52881 18.5522 7.53271 18.5884C7.5376 18.5513 7.54395 18.5083 7.55176 18.4595C7.55957 18.4097 7.56787 18.3594 7.57666 18.3086C7.58643 18.2568 7.59619 18.209 7.60596 18.165C7.61572 18.1211 7.62451 18.0854 7.63232 18.0581L7.94434 16.8584H8.37354L8.68555 18.0581C8.69238 18.0845 8.7002 18.1201 8.70898 18.165C8.71875 18.209 8.72852 18.2568 8.73828 18.3086C8.74805 18.3604 8.75684 18.4111 8.76465 18.4609C8.77344 18.5098 8.77979 18.5522 8.78369 18.5884C8.79053 18.5396 8.7998 18.4805 8.81152 18.4111C8.82422 18.3408 8.8374 18.271 8.85107 18.2017C8.86572 18.1323 8.87842 18.0742 8.88916 18.0273L9.16162 16.8584H9.6084Z"
			fill="#707070"
		/>
		<path
			d="M13.2 14.0002V13.3752H14.25C14.3492 13.3752 14.4323 13.3453 14.4994 13.2854C14.5665 13.2255 14.6 13.1513 14.6 13.0627V12.4377C14.6 12.2398 14.6642 12.0601 14.7925 11.8987C14.9208 11.7372 15.09 11.6226 15.3 11.5549V11.4456C15.09 11.3778 14.9208 11.2633 14.7925 11.1018C14.6642 10.9403 14.6 10.7607 14.6 10.5627V9.93774C14.6 9.8492 14.5665 9.77498 14.4994 9.71509C14.4323 9.65519 14.3492 9.62524 14.25 9.62524H13.2V9.00024H14.25C14.5417 9.00024 14.7896 9.09139 14.9938 9.27368C15.1979 9.45597 15.3 9.67733 15.3 9.93774V10.5627C15.3 10.6513 15.3335 10.7255 15.4006 10.7854C15.4677 10.8453 15.5508 10.8752 15.65 10.8752H16V12.1252H15.65C15.5508 12.1252 15.4677 12.1552 15.4006 12.2151C15.3335 12.275 15.3 12.3492 15.3 12.4377V13.0627C15.3 13.3232 15.1979 13.5445 14.9938 13.7268C14.7896 13.9091 14.5417 14.0002 14.25 14.0002H13.2ZM10.75 14.0002C10.4583 14.0002 10.2104 13.9091 10.0063 13.7268C9.80208 13.5445 9.7 13.3232 9.7 13.0627V12.4377C9.7 12.3492 9.66646 12.275 9.59938 12.2151C9.53229 12.1552 9.44917 12.1252 9.35 12.1252H9V10.8752H9.35C9.44917 10.8752 9.53229 10.8453 9.59938 10.7854C9.66646 10.7255 9.7 10.6513 9.7 10.5627V9.93774C9.7 9.67733 9.80208 9.45597 10.0063 9.27368C10.2104 9.09139 10.4583 9.00024 10.75 9.00024H11.8V9.62524H10.75C10.6508 9.62524 10.5677 9.65519 10.5006 9.71509C10.4335 9.77498 10.4 9.8492 10.4 9.93774V10.5627C10.4 10.7607 10.3358 10.9403 10.2075 11.1018C10.0792 11.2633 9.91 11.3778 9.7 11.4456V11.5549C9.91 11.6226 10.0792 11.7372 10.2075 11.8987C10.3358 12.0601 10.4 12.2398 10.4 12.4377V13.0627C10.4 13.1513 10.4335 13.2255 10.5006 13.2854C10.5677 13.3453 10.6508 13.3752 10.75 13.3752H11.8V14.0002H10.75Z"
			fill="#106EAD"
		/>
	</SvgIcon>
);

export const XlsFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#17824A"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#17824A"
		/>
		<path d="M8.85 13.75H6.75V13H8.85V13.75Z" fill="#17824A" />
		<path d="M11.85 13.75H9.75V13H11.85V13.75Z" fill="#17824A" />
		<path d="M14.85 13.75H12.75V13H14.85V13.75Z" fill="#17824A" />
		<path d="M17.85 13.75H15.75V13H17.85V13.75Z" fill="#17824A" />
		<path d="M8.85 12H6.75V11.25H8.85V12Z" fill="#17824A" />
		<path d="M11.85 12H9.75V11.25H11.85V12Z" fill="#17824A" />
		<path d="M14.85 12H12.75V11.25H14.85V12Z" fill="#17824A" />
		<path d="M17.85 12H15.75V11.25H17.85V12Z" fill="#17824A" />
		<path d="M8.85 10.25H6.75V9.5H8.85V10.25Z" fill="#17824A" />
		<path d="M11.85 10.25H9.75V9.5H11.85V10.25Z" fill="#17824A" />
		<path d="M14.85 10.25H12.75V9.5H14.85V10.25Z" fill="#17824A" />
		<path d="M17.85 10.25H15.75V9.5H17.85V10.25Z" fill="#17824A" />
		<path
			d="M15.25 16H9.25C8.69772 16 8.25 16.4477 8.25 17V18.5C8.25 19.0523 8.69772 19.5 9.25 19.5H15.25C15.8023 19.5 16.25 19.0523 16.25 18.5V17C16.25 16.4477 15.8023 16 15.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M11.5331 18.773H11.0161L10.6291 18.079L10.2191 18.773H9.72412L10.3761 17.735L9.75212 16.735H10.2651L10.6291 17.398L11.0021 16.736H11.4941L10.8701 17.719L11.5331 18.773ZM11.6281 16.735H12.0541V18.407H13.0631V18.773H11.6271L11.6281 16.735ZM13.9411 18.479C14.0241 18.4816 14.1068 18.4705 14.1861 18.446C14.2381 18.4327 14.2841 18.402 14.3164 18.3592C14.3488 18.3163 14.3656 18.2637 14.3641 18.21C14.3652 18.1783 14.3575 18.1469 14.342 18.1193C14.3265 18.0916 14.3037 18.0687 14.2761 18.053C14.1892 18.0054 14.0954 17.9717 13.9981 17.953L13.7821 17.909C13.6276 17.8827 13.4787 17.8299 13.3421 17.753C13.2731 17.7031 13.2179 17.6365 13.1818 17.5593C13.1458 17.4821 13.13 17.397 13.1361 17.312C13.1343 17.2262 13.1512 17.141 13.1858 17.0624C13.2203 16.9838 13.2716 16.9137 13.3361 16.857C13.5015 16.7254 13.7103 16.6608 13.9211 16.676C14.1184 16.6704 14.3118 16.7306 14.4711 16.847C14.5476 16.9056 14.6091 16.9814 14.6507 17.0683C14.6922 17.1552 14.7126 17.2507 14.7101 17.347H14.2991C14.2992 17.293 14.2843 17.2399 14.2561 17.1939C14.2278 17.1478 14.1873 17.1105 14.1391 17.086C14.062 17.0497 13.9773 17.0322 13.8921 17.035C13.7998 17.0302 13.7082 17.0532 13.6291 17.101C13.5977 17.1204 13.572 17.1477 13.5544 17.1802C13.5369 17.2126 13.5282 17.2491 13.5291 17.286C13.5282 17.32 13.5371 17.3534 13.5549 17.3824C13.5726 17.4113 13.5984 17.4345 13.6291 17.449C13.7139 17.4873 13.8028 17.5155 13.8941 17.533L14.2451 17.617C14.3702 17.6414 14.4888 17.6918 14.5931 17.765C14.6538 17.8146 14.7019 17.8777 14.7337 17.9492C14.7655 18.0208 14.78 18.0988 14.7761 18.177C14.7777 18.2655 14.7593 18.3532 14.7223 18.4335C14.6852 18.5139 14.6305 18.5848 14.5621 18.641C14.3908 18.7727 14.1778 18.8384 13.9621 18.826C13.7388 18.8386 13.5179 18.7744 13.3361 18.644C13.261 18.5849 13.2012 18.5086 13.1615 18.4217C13.1219 18.3347 13.1035 18.2395 13.1081 18.144H13.5141C13.5201 18.2193 13.5464 18.2915 13.5901 18.353C13.6357 18.3986 13.6909 18.4335 13.7515 18.4552C13.8122 18.477 13.8769 18.4851 13.9411 18.479Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const XlsxFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#17824A"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#17824A"
		/>
		<path d="M8.85 13.75H6.75V13H8.85V13.75Z" fill="#17824A" />
		<path d="M11.85 13.75H9.75V13H11.85V13.75Z" fill="#17824A" />
		<path d="M14.85 13.75H12.75V13H14.85V13.75Z" fill="#17824A" />
		<path d="M17.85 13.75H15.75V13H17.85V13.75Z" fill="#17824A" />
		<path d="M8.85 12H6.75V11.25H8.85V12Z" fill="#17824A" />
		<path d="M11.85 12H9.75V11.25H11.85V12Z" fill="#17824A" />
		<path d="M14.85 12H12.75V11.25H14.85V12Z" fill="#17824A" />
		<path d="M17.85 12H15.75V11.25H17.85V12Z" fill="#17824A" />
		<path d="M8.85 10.25H6.75V9.5H8.85V10.25Z" fill="#17824A" />
		<path d="M11.85 10.25H9.75V9.5H11.85V10.25Z" fill="#17824A" />
		<path d="M14.85 10.25H12.75V9.5H14.85V10.25Z" fill="#17824A" />
		<path d="M17.85 10.25H15.75V9.5H17.85V10.25Z" fill="#17824A" />
		<path
			d="M15.25 16H9.25C8.69772 16 8.25 16.4477 8.25 17V18.5C8.25 19.0523 8.69772 19.5 9.25 19.5H15.25C15.8023 19.5 16.25 19.0523 16.25 18.5V17C16.25 16.4477 15.8023 16 15.25 16Z"
			fill="#D7D7D7"
		/>
		<path
			d="M10.7196 18.773H10.2026L9.81564 18.079L9.40564 18.773H8.91064L9.56264 17.735L8.93864 16.735H9.45164L9.81564 17.398L10.1886 16.736H10.6806L10.0566 17.719L10.7196 18.773ZM10.8146 16.735H11.2406V18.407H12.2496V18.773H10.8136L10.8146 16.735ZM13.1276 18.479C13.2106 18.4816 13.2934 18.4705 13.3726 18.446C13.4247 18.4327 13.4706 18.402 13.5029 18.3592C13.5353 18.3163 13.5521 18.2637 13.5506 18.21C13.5517 18.1783 13.544 18.1469 13.5285 18.1193C13.513 18.0916 13.4902 18.0687 13.4626 18.053C13.3757 18.0054 13.282 17.9717 13.1846 17.953L12.9686 17.909C12.8141 17.8827 12.6652 17.8299 12.5286 17.753C12.4596 17.7031 12.4044 17.6365 12.3684 17.5593C12.3323 17.4821 12.3166 17.397 12.3226 17.312C12.3208 17.2262 12.3378 17.141 12.3723 17.0624C12.4068 16.9838 12.4582 16.9137 12.5226 16.857C12.688 16.7254 12.8968 16.6608 13.1076 16.676C13.3049 16.6704 13.4984 16.7306 13.6576 16.847C13.7341 16.9056 13.7957 16.9814 13.8372 17.0683C13.8787 17.1552 13.8991 17.2507 13.8966 17.347H13.4856C13.4857 17.293 13.4708 17.2399 13.4426 17.1939C13.4143 17.1478 13.3739 17.1105 13.3256 17.086C13.2485 17.0497 13.1639 17.0322 13.0786 17.035C12.9864 17.0302 12.8947 17.0532 12.8156 17.101C12.7843 17.1204 12.7585 17.1477 12.741 17.1802C12.7234 17.2126 12.7147 17.2491 12.7156 17.286C12.7147 17.32 12.7237 17.3534 12.7414 17.3824C12.7592 17.4113 12.785 17.4345 12.8156 17.449C12.9004 17.4873 12.9893 17.5155 13.0806 17.533L13.4316 17.617C13.5567 17.6414 13.6753 17.6918 13.7796 17.765C13.8403 17.8146 13.8884 17.8777 13.9202 17.9492C13.952 18.0208 13.9665 18.0988 13.9626 18.177C13.9643 18.2655 13.9458 18.3532 13.9088 18.4335C13.8717 18.5139 13.817 18.5848 13.7486 18.641C13.5773 18.7727 13.3644 18.8384 13.1486 18.826C12.9253 18.8386 12.7044 18.7744 12.5226 18.644C12.4476 18.5849 12.3877 18.5086 12.348 18.4217C12.3084 18.3347 12.2901 18.2395 12.2946 18.144H12.7006C12.7066 18.2193 12.7329 18.2915 12.7766 18.353C12.8223 18.3986 12.8774 18.4335 12.9381 18.4552C12.9987 18.477 13.0635 18.4851 13.1276 18.479Z"
			fill="#707070"
		/>
		<path
			d="M15.1777 18.7731H15.6947L15.0317 17.7191L15.6557 16.7361H15.1637L14.7907 17.3981L14.4267 16.7351H13.9137L14.5377 17.7351L13.8857 18.7731H14.3807L14.7907 18.0791L15.1777 18.7731Z"
			fill="#707070"
		/>
	</SvgIcon>
);

export const XmlFileIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path
			d="M9.51 3.19897H17.25C17.7804 3.19897 18.2891 3.40969 18.6642 3.78476C19.0393 4.15983 19.25 4.66854 19.25 5.19897V19.199C19.25 19.7294 19.0393 20.2381 18.6642 20.6132C18.2891 20.9883 17.7804 21.199 17.25 21.199H7.25C6.71957 21.199 6.21086 20.9883 5.83579 20.6132C5.46071 20.2381 5.25 19.7294 5.25 19.199V7.39897L9.51 3.19897Z"
			fill="white"
		/>
		<path
			d="M9.531 3.45L5.492 7.292L5.45 19.5C5.45053 19.9109 5.614 20.3049 5.90457 20.5954C6.19514 20.886 6.58908 21.0495 7 21.05H17.5C17.9109 21.0495 18.3049 20.886 18.5954 20.5954C18.886 20.3049 19.0495 19.9109 19.05 19.5V5C19.0495 4.58908 18.886 4.19514 18.5954 3.90457C18.3049 3.614 17.9109 3.45053 17.5 3.45M9.461 3H17.5C18.0304 3 18.5391 3.21071 18.9142 3.58579C19.2893 3.96086 19.5 4.46957 19.5 5V19.5C19.5 20.0304 19.2893 20.5391 18.9142 20.9142C18.5391 21.2893 18.0304 21.5 17.5 21.5H7C6.46957 21.5 5.96086 21.2893 5.58579 20.9142C5.21071 20.5391 5 20.0304 5 19.5V7.292L9.461 3Z"
			fill="#7CC2E8"
		/>
		<path
			d="M6.04883 6.88997H8.22983C8.43963 6.89184 8.64163 6.81049 8.79157 6.66373C8.94152 6.51697 9.02719 6.31677 9.02983 6.10697L9.10183 3.98697M9.54883 3.07397L9.47983 6.10697C9.47745 6.4362 9.34445 6.75101 9.11005 6.98222C8.87566 7.21343 8.55906 7.3421 8.22983 7.33997H5.04883L9.54883 3.07397Z"
			fill="#7CC2E8"
		/>
		<path
			d="M16.25 16H8.25C7.69772 16 7.25 16.4477 7.25 17V18.5C7.25 19.0523 7.69772 19.5 8.25 19.5H16.25C16.8023 19.5 17.25 19.0523 17.25 18.5V17C17.25 16.4477 16.8023 16 16.25 16Z"
			fill="#D7D7D7"
		/>
		<path d="M14.3506 18.8916V16.75H14.8047V18.5166H15.6733V18.8916H14.3506Z" fill="#707070" />
		<path
			d="M12.4272 18.8916L11.9116 17.2114H11.8984C11.9004 17.2515 11.9033 17.312 11.9072 17.3931C11.9121 17.4731 11.9165 17.5586 11.9204 17.6494C11.9243 17.7402 11.9263 17.8223 11.9263 17.8955V18.8916H11.5205V16.75H12.1387L12.6455 18.3877H12.6543L13.1919 16.75H13.8101V18.8916H13.3867V17.8779C13.3867 17.8105 13.3877 17.7329 13.3896 17.645C13.3926 17.5571 13.396 17.4736 13.3999 17.3945C13.4038 17.3145 13.4067 17.2544 13.4087 17.2144H13.3955L12.8433 18.8916H12.4272Z"
			fill="#707070"
		/>
		<path
			d="M11.251 18.8916H10.7324L10.2344 18.0815L9.73633 18.8916H9.25L9.96045 17.7871L9.29541 16.75H9.79639L10.2578 17.5205L10.7104 16.75H11.1997L10.5273 17.812L11.251 18.8916Z"
			fill="#707070"
		/>
		<path
			d="M10.3072 12.8072L8.5 11L10.3072 9.19277L10.8133 9.6988L9.52108 11L10.8133 12.3012L10.3072 12.8072ZM11.9157 14L11.2289 13.7831L13.0361 8L13.7229 8.21687L11.9157 14ZM14.6446 12.8072L14.1386 12.3012L15.4307 11L14.1386 9.6988L14.6446 9.19277L16.4518 11L14.6446 12.8072Z"
			fill="#7CC2E8"
		/>
	</SvgIcon>
);

export const BreadcrumbChevronIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="#1f1f1f"
		viewBox="0 -960 960 960"
	>
		<path d="M540-480 356-664l20-20 204 204-204 204-20-20 184-184Z" />
	</SvgIcon>
);

export const DownloadReportAndAttachmentsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="download-report-and-files-icon">
			<rect id="Rectangle_3961" data-name="Rectangle 3961" width="24" height="24" fill="none" />
		</g>
		<g id="Group_10120" data-name="Group 10120" transform="translate(-670.62 -168.545)">
			<path
				id="box_add_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
				d="M150.369-816.2h0Zm-9.073,0h0Zm.337-1.3h11.414l-.942-1.122a.336.336,0,0,0-.1-.066.265.265,0,0,0-.112-.025h-9.114a.266.266,0,0,0-.112.025.336.336,0,0,0-.1.066Zm3.983,5.575h3.456V-816.2h-3.456Zm3.707,6.6h-7.761a1.5,1.5,0,0,1-1.1-.459,1.5,1.5,0,0,1-.459-1.1v-10.1a1.581,1.581,0,0,1,.089-.527,1.49,1.49,0,0,1,.267-.466l1.213-1.467a1.407,1.407,0,0,1,.532-.421,1.6,1.6,0,0,1,.676-.147h9.12a1.615,1.615,0,0,1,.679.147,1.419,1.419,0,0,1,.537.421l1.221,1.484a1.529,1.529,0,0,1,.267.471c.059.17.081.115.081,4.042h-1.3l.008-2.761h-3.024v5.628H144.32V-816.2H141.3v9.322a.259.259,0,0,0,.075.191.259.259,0,0,0,.191.075h7.024a3.746,3.746,0,0,0,.313.691A4.413,4.413,0,0,0,149.323-805.311Z"
				transform="translate(533.971 991.73)"
				fill={props.htmlColor ?? '#7d61bc'}
			/>
			<g id="Group_10119" data-name="Group 10119" transform="translate(684.756 180.528)">
				<path
					id="file_save_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
					d="M181.2-854.84,184.367-858l-.907-.907-1.607,1.607v-3.935h-1.3v3.935l-1.607-1.607-.907.907Zm-3.257,2.7v-1.3h6.513v1.3Z"
					transform="translate(-177.946 861.24)"
					fill={props.htmlColor ?? '#7d61bc'}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const GetReportOnlyIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3961" data-name="Rectangle 3961" width="24" height="24" fill="none" />
		<g id="Group_10116" data-name="Group 10116" transform="translate(-1.328 -0.402)">
			<g id="Group_10117" data-name="Group 10117" transform="translate(6.047 3.457)">
				<g id="Group_10121" data-name="Group 10121" transform="translate(0 0)">
					<path
						id="Union_54"
						data-name="Union 54"
						d="M0,7.538V4.5H4.889V7.538ZM0,3.759V3H7.211v.76Zm0-1.5V1.5H7.211v.76ZM0,.76V0H3.339V.76Z"
						transform="translate(1.973 4.604)"
						fill={props.htmlColor ?? '#7d61bc'}
					/>
					<path
						id="file_save_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
						d="M181.441-854.694l3.032-3.032-.869-.869-1.539,1.539v-3.77h-1.248v3.77l-1.539-1.539-.869.869Zm-3.12,2.584v-1.248h6.241v1.248Zm-6.817-3.328a1.446,1.446,0,0,1-1.059-.445,1.447,1.447,0,0,1-.445-1.059V-868.5a1.446,1.446,0,0,1,.445-1.059A1.446,1.446,0,0,1,171.5-870h5.777l4.785,4.785v2.565h-1.248v-1.941h-4.16v-4.16H171.5a.244.244,0,0,0-.176.08.245.245,0,0,0-.08.176v11.553a.244.244,0,0,0,.08.176.244.244,0,0,0,.176.08H176.5v1.248Zm-.256-1.248v0Z"
						transform="translate(-170 870)"
						fill={props.htmlColor ?? '#7d61bc'}
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const CloneIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
		/>
	</SvgIcon>
);

export const CloseIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M 0 0 h 24 v 24 H 0 z" fill="none" />
		<path d="M 21 6 a 1 1 1 0 0 -3 -3 L 18 3 L 12 9 L 6 3 a 1 1 1 0 0 -3 3 L 3 6 L 9 12 L 3 18 a 1 1 1 0 0 3 3 L 6 21 L 12 15 L 18 21 a 1 1 1 0 0 3 -3 L 21 18 L 15 12 z" />
	</SvgIcon>
);

export const FileCopyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
		/>
	</SvgIcon>
);

export const NotSecureIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5M11,7H13V13H11M11,15H13V17H11"
		/>
	</SvgIcon>
);

export const OfflineStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M19.43,19L21.5,21.11L20.12,22.5L18.03,20.41L15.91,22.53L14.5,21.11L16.61,19L14.5,16.86L15.88,15.47L18,17.59L20.12,15.47L21.55,16.9L19.43,19M21,11C21,11.9 20.9,12.78 20.71,13.65C20.13,13.35 19.5,13.15 18.81,13.05C18.93,12.45 19,11.83 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21L12.31,20.91C12.5,21.53 12.83,22.11 13.22,22.62L12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11Z"
		/>
	</SvgIcon>
);

export const PendingStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M18 12A6.41 6.41 0 0 1 20.87 12.67A11.63 11.63 0 0 0 21 11V5L12 1L3 5V11C3 16.55 6.84 21.74 12 23C12.35 22.91 12.7 22.8 13 22.68A6.42 6.42 0 0 1 11.5 18.5A6.5 6.5 0 0 1 18 12M18 14.5V13L15.75 15.25L18 17.5V16A2.5 2.5 0 0 1 20.24 19.62L21.33 20.71A4 4 0 0 0 18 14.5M18 21A2.5 2.5 0 0 1 15.76 17.38L14.67 16.29A4 4 0 0 0 18 22.5V24L20.25 21.75L18 19.5Z"
		/>
	</SvgIcon>
);

export const NoPolicyStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M1,4.27L3,6.27V11C3,16.55 6.84,21.74 12,23C13.87,22.54 15.57,21.56 16.97,20.24L19.23,22.5L20.5,21.22L2.28,3L1,4.27M12,21C8.25,20 5,15.54 5,11.22V8.27L15.59,18.86C14.53,19.89 13.3,20.65 12,21M21,5V11C21,13.28 20.35,15.5 19.23,17.4L17.77,15.95C18.54,14.5 19,12.84 19,11.22V6.3L12,3.18L7.16,5.34L5.65,3.82L12,1L21,5Z"
		/>
	</SvgIcon>
);

export const NotAssessedStatusIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z"
		/>
	</SvgIcon>
);

export const HandleBarIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 31 611" {...props}>
		<defs>
			<filter id="Rectangle_1538" x="0" y="0" width="31" height="611" filterUnits="userSpaceOnUse">
				<feOffset dy="6" />
				<feGaussianBlur stdDeviation="4.5" result="blur" />
				<feFlood floodColor="#7d61bc" floodOpacity="0.341" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="Group_2852" data-name="Group 2852" transform="translate(-981.5 -133.499)">
			<g transform="matrix(1, 0, 0, 1, 981.5, 133.5)" filter="url(#Rectangle_1538)">
				<rect
					id="Rectangle_1538-2"
					data-name="Rectangle 1538"
					width="4"
					height="584"
					rx="2"
					transform="translate(13.5 7.5)"
					fill="#7d61bc"
				/>
			</g>
			<g id="Group_2839" data-name="Group 2839" transform="translate(1370 -96) rotate(90)">
				<rect
					id="Rectangle_1273"
					data-name="Rectangle 1273"
					width="20"
					height="8"
					rx="3"
					transform="translate(519 369)"
					fill="#7d61bc"
				/>
				<g id="Group_1799" data-name="Group 1799" transform="translate(0 -0.5)">
					<rect
						id="Rectangle_1274"
						data-name="Rectangle 1274"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 371)"
						fill="#fff"
					/>
					<rect
						id="Rectangle_1275"
						data-name="Rectangle 1275"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 373)"
						fill="#fff"
					/>
					<rect
						id="Rectangle_1276"
						data-name="Rectangle 1276"
						width="14"
						height="1"
						rx="0.5"
						transform="translate(522 375)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const HideWorkflowActivityIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24.706 21.92" {...props}>
		<path
			id="Union_3"
			data-name="Union 3"
			d="M-1117.47-2942.056a9.188,9.188,0,0,0-1.132.343,10.667,10.667,0,0,0-2.88,1.633h0a10.686,10.686,0,0,0-2.881-1.633,9.108,9.108,0,0,0-3.213-.583,8.752,8.752,0,0,0-2.286.305,10.088,10.088,0,0,0-2.147.86,1.18,1.18,0,0,1-.546.145,1.089,1.089,0,0,1-.576-.173,1.076,1.076,0,0,1-.54-.97v-13.351a1.2,1.2,0,0,1,.152-.582.964.964,0,0,1,.457-.416q.4-.194.806-.363l-1.744-1.744,1.414-1.414,20.507,20.507-1.414,1.414Zm-2.9-1.293q.565-.269,1.135-.476l-1.135-1.135Zm9.507,2.259-3.365-3.364c.279.028.547.065.8.109a12.438,12.438,0,0,1,1.925.5v-10.971a9.714,9.714,0,0,0-1.9-.582,10.281,10.281,0,0,0-1.981-.193,10.212,10.212,0,0,0-2.577.332,9.561,9.561,0,0,0-2.41,1v3.667l-7.212-7.212h.01a12.029,12.029,0,0,1,3.144.416,12,12,0,0,1,2.95,1.246,12.027,12.027,0,0,1,2.95-1.246,12.035,12.035,0,0,1,3.145-.416,11.537,11.537,0,0,1,2.812.345,13.893,13.893,0,0,1,2.673.984.964.964,0,0,1,.457.416,1.2,1.2,0,0,1,.152.582v13.351a1.076,1.076,0,0,1-.54.97,1.089,1.089,0,0,1-.575.173A1.119,1.119,0,0,1-1110.868-2941.09Zm-1.75-4.585a7.874,7.874,0,0,0-1.343-.374,7.9,7.9,0,0,0-1.427-.124c-.186,0-.371.006-.547.017l-1.481-1.481.019,0a10.138,10.138,0,0,1,2.009-.193,9.054,9.054,0,0,1,1.413.11c.457.074.914.167,1.357.278v1.773Zm-5.785-2.95-.862-.862v-.619a9.76,9.76,0,0,1,1.869-.581,10.059,10.059,0,0,1,2.009-.194,9.054,9.054,0,0,1,1.413.11c.458.074.914.167,1.357.278v1.773a7.866,7.866,0,0,0-1.344-.374,7.794,7.794,0,0,0-1.427-.125,7.656,7.656,0,0,0-2.022.264,8.886,8.886,0,0,0-.993.332Zm-.862-2.647v-1.883a9.83,9.83,0,0,1,1.869-.58,10.08,10.08,0,0,1,2.009-.195,8.97,8.97,0,0,1,1.413.112c.462.074.918.167,1.357.276v1.773a7.838,7.838,0,0,0-1.344-.373,7.909,7.909,0,0,0-1.427-.126,7.706,7.706,0,0,0-2.022.265,8.86,8.86,0,0,0-1.854.733h0Z"
			transform="translate(1134 2960)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const ShowWorkflowActivityIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24.378 17.729" {...props}>
		<path
			id="menu_book_FILL1_wght400_GRAD0_opsz24"
			d="M54.405,262.538v-1.884a9.738,9.738,0,0,1,1.87-.582,10.085,10.085,0,0,1,2.008-.194,8.927,8.927,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,7.686,7.686,0,0,0-2.022.263A8.929,8.929,0,0,0,54.405,262.538Zm0,6.094v-1.884a9.729,9.729,0,0,1,1.87-.582,10.083,10.083,0,0,1,2.008-.194,8.931,8.931,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,8.089,8.089,0,0,0-2.022.249A7.665,7.665,0,0,0,54.405,268.632Zm0-3.047V263.7a9.733,9.733,0,0,1,1.87-.582,10.08,10.08,0,0,1,2.008-.194,8.927,8.927,0,0,1,1.413.111q.693.111,1.357.277v1.773a7.678,7.678,0,0,0-2.77-.5,7.686,7.686,0,0,0-2.022.263A8.932,8.932,0,0,0,54.405,265.585ZM53.3,270.46a12.18,12.18,0,0,1,2.452-.873,11,11,0,0,1,2.535-.291,11.378,11.378,0,0,1,1.953.166,12.58,12.58,0,0,1,1.925.5v-10.97a9.6,9.6,0,0,0-1.9-.582,10.176,10.176,0,0,0-4.557.138,9.491,9.491,0,0,0-2.41,1Zm-1.108,3.269a10.636,10.636,0,0,0-2.881-1.634,9.079,9.079,0,0,0-3.213-.582,8.68,8.68,0,0,0-2.285.3,10.025,10.025,0,0,0-2.147.859,1.125,1.125,0,0,1-1.662-1V258.327a1.191,1.191,0,0,1,.152-.582.956.956,0,0,1,.457-.416,13.7,13.7,0,0,1,2.673-.983A11.44,11.44,0,0,1,46.094,256a11.911,11.911,0,0,1,6.094,1.662A11.911,11.911,0,0,1,58.283,256a11.44,11.44,0,0,1,2.812.346,13.7,13.7,0,0,1,2.673.983.956.956,0,0,1,.457.416,1.19,1.19,0,0,1,.152.582v13.352a1.125,1.125,0,0,1-1.662,1,10.025,10.025,0,0,0-2.147-.859,8.68,8.68,0,0,0-2.285-.3,9.079,9.079,0,0,0-3.213.582A10.636,10.636,0,0,0,52.189,273.729Z"
			transform="translate(-40 -256)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const HideWorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 23.446 23.466" {...props}>
		<path
			id="Union_5"
			data-name="Union 5"
			d="M-1120.587-2937.536a5.633,5.633,0,0,1-2.077-2.567,5.64,5.64,0,0,1,2.077-2.566,5.778,5.778,0,0,1,1.713-.791l-3.777-3.777a1.52,1.52,0,0,1-1,.382,1.526,1.526,0,0,1-1.426-.993h-1.62a1.519,1.519,0,0,0-1.518,1.517,1.521,1.521,0,0,0,1.518,1.519h3.037v-1.519l2.025,2.026-2.023,2.021,0,0v-1.517h-3.037a2.534,2.534,0,0,1-2.53-2.532,2.533,2.533,0,0,1,2.53-2.531h1.615a1.508,1.508,0,0,1,.306-.5l-1.913-1.914a1.517,1.517,0,0,1-1.019.394,1.535,1.535,0,0,1-.257-.021,1.515,1.515,0,0,1-1.261-1.5,1.514,1.514,0,0,1,.392-1.02l-1.678-1.678h-.148v14h7.2v2h-7.2a2,2,0,0,1-2-2v-14a2,2,0,0,1,.662-1.485l-2-2,1.414-1.415,22.032,22.032-1.415,1.414-1.457-1.458a5.8,5.8,0,0,1-3.887,1.477A5.8,5.8,0,0,1-1120.587-2937.536Zm-.6-2.567a4.416,4.416,0,0,0,3.871,2.231,4.482,4.482,0,0,0,2.94-1.087l-1.746-1.746a1.327,1.327,0,0,1,.144.6,1.339,1.339,0,0,1-1.337,1.338,1.339,1.339,0,0,1-1.337-1.338,1.338,1.338,0,0,1,1.337-1.335,1.332,1.332,0,0,1,.6.144l-1.019-1.019A4.4,4.4,0,0,0-1121.184-2940.1Zm6.518-4.748-2-2v-8.253h-8.252l-2-2h10.252a2,2,0,0,1,2,2v10.253Zm-3.969-3.969-.724-.725a1.508,1.508,0,0,0,.25-.835,1.52,1.52,0,0,0-1.519-1.518h-1.084l-1.013-1.012h2.1a2.534,2.534,0,0,1,2.532,2.531,2.507,2.507,0,0,1-.537,1.56h0Z"
			transform="translate(1134 2960)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const ShowWorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 20.703 20.567" {...props}>
		<g id="Group_2833" data-name="Group 2833" transform="translate(-1751 -3933)">
			<g id="Group_2831" data-name="Group 2831" transform="translate(1753.432 3935.179)">
				<path
					id="Path_6638"
					data-name="Path 6638"
					d="M9.6,2.012H3.951a1.519,1.519,0,1,0,0,1.012H9.6a1.519,1.519,0,1,1,0,3.037H8a1.519,1.519,0,0,0-2.855,0H3.531a2.531,2.531,0,1,0,0,5.062H6.568v1.519l2.025-2.025L6.568,8.592v1.519H3.531a1.519,1.519,0,1,1,0-3.037h1.62a1.519,1.519,0,0,0,2.85,0H9.6a2.531,2.531,0,1,0,0-5.062Z"
					transform="translate(0 0)"
					fill="currentColor"
				/>
			</g>
			<path
				id="Subtraction_1"
				data-name="Subtraction 1"
				d="M9.2,18H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H16a2,2,0,0,1,2,2V12.75H16V2H2V16H9.2v2Z"
				transform="translate(1751 3933)"
				fill="currentColor"
			/>
			<g id="Group_2832" data-name="Group 2832" transform="translate(-43.707 14.854)">
				<path
					id="Path_6637"
					data-name="Path 6637"
					d="M11.351,10.338a4.394,4.394,0,0,1,3.871,2.23,4.475,4.475,0,0,1-7.742,0,4.394,4.394,0,0,1,3.871-2.23m0-1.338A5.748,5.748,0,0,0,6,12.568a5.8,5.8,0,0,0,10.7,0A5.748,5.748,0,0,0,11.351,9Zm0,4.905a1.338,1.338,0,1,1,1.338-1.338A1.336,1.336,0,0,1,11.351,13.905Z"
					transform="translate(1798.707 3922.578)"
					fill="currentColor"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const DraftIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<style type="text/css">
			{`
	.draft-icon-st0{fill:currentColor;}
	.draft-icon-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1_00000005265729232914183250000018352830802228111789_">
			<g>
				<path
					className="draft-icon-st0"
					d="M11,7.6l1.8-1.9c0.7,0.2,1.4,0,2-0.6s0.8-1.5,0.6-2.3L14,4.1c0,0-0.6,0.3-1.2-0.3s-0.3-1.2-0.3-1.2l1.3-1.3
			C13,1,12.1,1.2,11.5,1.9c-0.5,0.5-0.8,1.3-0.6,2L9.2,5.7L11,7.6z"
				/>
				<path
					className="draft-icon-st0"
					d="M3.8,10.9C3.7,11,3.7,11,3.6,11.1c-0.7-0.2-1.4,0.1-2,0.6c-0.5,0.7-0.8,1.5-0.5,2.3l1.4-1.3
			c0,0,0.6-0.3,1.2,0.3S4,14.2,4,14.2l-1.3,1.3c0.7,0.3,1.5,0,2.1-0.6s0.8-1.4,0.6-2c0.1,0,0.1-0.1,0.2-0.2l1.5-1.5L5.3,9.4
			L3.8,10.9z"
				/>
				<path
					className="draft-icon-st0"
					d="M11.2,9.4L9.6,7.8L7.9,6.1l0,0L6.5,4.6l1.4-1.4C8,3.1,8,2.7,7.8,2.5L6.1,0.7c-0.2-0.2-0.6-0.2-0.8,0L0.8,5.2
			C0.6,5.4,0.6,5.8,0.8,6l1.8,1.8C2.8,8,3.2,8,3.4,7.8l1.2-1.2L6,8l0,0l3.1,3.1L11.2,9.4z"
				/>
			</g>
		</g>
		<g id="Layer_2_00000054949564155520815650000012624840614540392345_">
			<path
				className="draft-icon-st1"
				d="M20.8,17.7c0-0.1,0-0.1,0-0.1c0-2.8-1.8-5.3-4.2-6.3V17h-1.1v-6.8c0,0-0.5-0.5-1.7-0.5s-1.7,0.5-1.7,0.5V17H11
		v-5.8c-2.3,0.9-4,3.2-4,6c0,0.1,0,0.4,0,0.5c-0.4,0.4-0.6,0.7-0.6,1.1c0,1.4,3.3,2.6,7.5,2.6s7.5-1.2,7.5-2.6
		C21.4,18.4,21.2,18.1,20.8,17.7z"
			/>
		</g>
	</SvgIcon>
);

export const FilterIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M0,0h24 M24,24H0" fill="none" />
			<path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
			<path d="M0,0h24v24H0V0z" fill="none" />
		</g>
	</SvgIcon>
);

export const LogsIcon = (props: SvgIconProps) => (
	<SvgIcon
		{...props}
		// version="1.1"
		// xmlns="http://www.w3.org/2000/svg"
		// x="0px"
		// y="0px"
		viewBox="0 0 16 16"
		// className="icon"
		// htmlColor="hotpink"
		// style={{
		// 	fill: 'rebeccapurple',
		// 	stroke: 'rebeccapurple'
		// }}
		// style={{
		// 	enableBackground: 'new 0 0 16 16'
		// }}
	>
		<g id="Layer_2">
			<polygon
				// fill="currentColor"
				// className={`fill-${props.color}`}
				// style={{
				// 	fill: '#a48adb'
				// 	// stroke: 'rebeccapurple'
				// }}
				points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9"
			/>
		</g>
		<g id="Layer_1" className="">
			<polyline
				// className={`stroke-${props.color}`}
				// stroke="currentColor"
				style={{
					// fill: 'rebeccapurple',
					stroke: 'black',
				}}
				points={`
                        13.4,3.3
                        15.1,3.3
                        15.1,13.5
                        0.7,13.5
                        0.7,3.3
                        2.4,3.3
                    `}
			/>
			<g>
				<path
					// className={`stroke-${props.color}`}
					// stroke="currentColor"
					style={{
						// fill: 'rebeccapurple',
						stroke: 'black',
					}}
					d={`
                            M 7.9,3.3
                            c 0,0,1.3-0.8,2.6-1.1
                            c 1.4-0.3,2.7-0.2,2.7-0.2
                            v 10.2
                            v 0
                            c 0,0-1.4-0.1-2.7,0.2
                            c -1.3,0.3-2.6,1.1-2.6,1.1
                            V 3.3
                            z
                        `}
				/>
				<path
					// className={`stroke-${props.color}`}
					// stroke="currentColor"
					style={{
						// fill: 'rebeccapurple',
						stroke: 'black',
					}}
					d={`
                            M 7.9,13.5
                            V 3.3
                            c 0,0-1.3-0.8-2.6-1.1
                            C 3.9,1.8,2.6,1.9,2.6,1.9
                            v 10.2
                            v 0
                            c 0,0,1.4-0.1,2.7,0.2
                            C 6.6,12.7,7.9,13.5,7.9,13.5
                            L 7.9,13.5
                            z
                        `}
				/>
			</g>
		</g>
	</SvgIcon>
);

export const UserIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					// className="st0"
					d="M3.2,21.1c-0.8,0-1.2-0.6-1.2-1.2c0-0.2,0-0.8,0.3-1.7c0.3-1.2,4.1-2.3,5.6-2.8l0.4-0.1l0,0
			C9,15,9.2,13.4,9.2,13l0-0.3L9,12.6c-0.2-0.1-0.4-0.4-0.6-0.8l0-0.1l0,0c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.6-1.1L7.4,10
			L7.2,10C7.1,9.9,7,9.7,6.8,9.6C6.4,8.8,6.2,7.8,6.3,7.4c0.1-0.1,0.2-0.2,0.2-0.2L6.8,7V6.7c0-2.2,0.8-3.2,1.2-3.5L8.1,3V2.7
			c0.2-0.4,0.7-0.6,1-0.6L9.5,2V1.6c0-0.1,0-0.1,0-0.2C9.6,1.2,9.7,1.1,9.8,1l0,0c0.2,0.3,0.6,0.4,0.9,0.5c0.6,0.1,1.1,0.3,1.4,0.5
			C12.3,2,12.5,2,12.5,2.1c1.6,0.6,2.6,2.4,2.6,4.6v0.4l0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2-0.1,1.3-0.5,2.3
			c0,0.1-0.2,0.2-0.3,0.3L14.7,10l-0.1,0.2c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.6
			c-0.2,0.3-0.4,0.5-0.6,0.7L13,12.8V13c0,0.9,0.3,2.1,0.8,2.3c0.6,0.2,1.2,0.4,1.9,0.6c1.4,0.4,3.8,1.1,4.1,2.2
			c0.3,1.1,0.3,1.3,0.3,1.7c0,0.6-0.4,1.2-1.2,1.2H3.2z"
				/>
				<path
					// className="st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ReportsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 1000 1000">
		<path d="M451.2 137.9c-214.6 0-388.7 173.99999999999997-388.7 388.70000000000005s174 388.79999999999995 388.7 388.79999999999995 388.7-174 388.7-388.79999999999995h-388.7v-388.70000000000005z m486.3 344.20000000000005c0-107.30000000000001-43.5-204.5-113.79999999999995-274.8l-274.9000000000001 274.8h388.70000000000005z m-437.1-397.70000000000005v388.6l274.80000000000007-274.8c-75.90000000000009-75.89999999999999-175.4000000000001-113.79999999999998-274.80000000000007-113.79999999999998z" />
	</SvgIcon>
);

export const ReportsExpandIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 27.965 26">
		<g transform="translate(2.994 4)">
			<path
				d="M114.561,134.185l4.72-4.72v-6.683a6.789,6.789,0,0,0-4.062,2.036,7.17,7.17,0,0,0-.658,9.368m-.049,1.463a8.159,8.159,0,0,1,0-11.538,7.861,7.861,0,0,1,5.769-2.39v8.159Z"
				transform="translate(-112.122 -121.721)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
			<path
				d="M172.946,263.881l-4.726,4.726a6.789,6.789,0,0,0,4.312,1.433,7.17,7.17,0,0,0,7.089-6.159h-6.675m-.414-1h8.159a8.159,8.159,0,0,1-8.159,8.159,7.861,7.861,0,0,1-5.769-2.39Z"
				transform="translate(-163.194 -253.04)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
			<path
				d="M270.05,119.36a7.174,7.174,0,0,0-6.089-6.089v6.089h6.089m1.07,1h-8.159V112.2A8.159,8.159,0,0,1,271.12,120.36Z"
				transform="translate(-253.109 -112.201)"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={0.5}
			/>
		</g>

		<rect width="26" height="26" fill="none" />

		<path
			d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
			transform="translate(22.005 18.325)"
			fill="currentColor"
		/>
	</SvgIcon>
);

// export const ReportsExpandIcon = (props: SvgIconProps) => (
// 	<SvgIcon {...props} viewBox="0 0 1000 1000">
// 		<g id="reports-icon-light-mode">
// 			<g id="icon_dashboard_side_menu" data-name="icon dashboard side menu" transform="translate(2.994 4)">
// 				<g id="Group_3247" data-name="Group 3247" transform="translate(0)">
// 					<g id="Group_3245" data-name="Group 3245" transform="translate(0)">
// 						<g id="Group_3240" data-name="Group 3240" transform="translate(0 0.622)">
// 							<g id="Group_3239" data-name="Group 3239">
// 								<path
// 									id="Path_6676"
// 									data-name="Path 6676"
// 									d="M114.561,134.185l4.72-4.72v-6.683a6.789,6.789,0,0,0-4.062,2.036,7.17,7.17,0,0,0-.658,9.368m-.049,1.463a8.159,8.159,0,0,1,0-11.538,7.861,7.861,0,0,1,5.769-2.39v8.159Z"
// 									transform="translate(-112.122 -121.721)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 						<g id="Group_3242" data-name="Group 3242" transform="translate(3.569 9.841)">
// 							<g id="Group_3241" data-name="Group 3241">
// 								<path
// 									id="Path_6677"
// 									data-name="Path 6677"
// 									d="M172.946,263.881l-4.726,4.726a6.789,6.789,0,0,0,4.312,1.433,7.17,7.17,0,0,0,7.089-6.159h-6.675m-.414-1h8.159a8.159,8.159,0,0,1-8.159,8.159,7.861,7.861,0,0,1-5.769-2.39Z"
// 									transform="translate(-166.763 -262.881)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 						<g id="Group_3244" data-name="Group 3244" transform="translate(9.852)">
// 							<g id="Group_3243" data-name="Group 3243">
// 								<path
// 									id="Path_6678"
// 									data-name="Path 6678"
// 									d="M270.05,119.36a7.174,7.174,0,0,0-6.089-6.089v6.089h6.089m1.07,1h-8.159V112.2A8.159,8.159,0,0,1,271.12,120.36Z"
// 									transform="translate(-262.961 -112.201)"
// 									fill="#323232"
// 									stroke="#323232"
// 									stroke-width="0.5"
// 								/>
// 							</g>
// 						</g>
// 					</g>
// 				</g>
// 			</g>
// 			<rect id="Rectangle_2025" data-name="Rectangle 2025" width="26" height="26" fill="none" />
// 			<path
// 				id="_Color"
// 				data-name=" ↳Color"
// 				d="M5.26,0,2.98,2.272.7,0,0,.7,2.98,3.675,5.96.7Z"
// 				transform="translate(22.005 18.325)"
// 				fill="#323232"
// 			/>
// 		</g>
// 	</SvgIcon>
// );

export const ReportsPageIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="reports-page-clip-path">
				<path fill="currentColor" d="M0 0H9.754V9.722H0z" data-name="Rectangle 1952" />
			</clipPath>
		</defs>
		<g data-name="Component 413 – 394" transform="translate(5 3)">
			<g data-name="Group 3958">
				<path
					fill="currentColor"
					d="M2 1.5a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h13a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5H2M2 0h13a2 2 0 012 2v17a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"
					data-name="Rectangle 1944"
				/>
				<path fill="currentColor" d="M0 0H11V2H0z" data-name="Rectangle 1950" transform="translate(3 13.301)" />
				<path fill="currentColor" d="M0 0H11V2H0z" data-name="Rectangle 1951" transform="translate(3 16.301)" />
				<g data-name="Group 3568" transform="translate(3.623 2.139)">
					<g clipPath="url(#reports-page-clip-path)" data-name="Group 3566">
						<path
							fill="currentColor"
							fillRule="evenodd"
							d="M6.546 9.38a4.342 4.342 0 01-1.759.342 4.69 4.69 0 01-1.612-.293A5.975 5.975 0 011.759 8.6c-.049-.049-.049-.1 0-.1l3.126-3.126.049-.049h4.4c.049 0 .049.049.049.1a6.465 6.465 0 01-.391 1.612A6.151 6.151 0 018.061 8.4l-.049-.049.049.049a5.38 5.38 0 01-1.514.977M9.722 4.4H5.374a.171.171 0 01-.1-.049V.049A.048.048 0 015.325 0a5.571 5.571 0 011.612.391 4.4 4.4 0 011.368.977l-.049.049.049-.049a5.383 5.383 0 01.977 1.368A3.778 3.778 0 019.673 4.4c.1-.049.1 0 .049 0m-8.6 3.566a5.145 5.145 0 01-.829-1.42A4.49 4.49 0 010 4.934a4.187 4.187 0 01.342-1.759 5.19 5.19 0 011.026-1.514A4.958 4.958 0 012.687.733 4.346 4.346 0 014.3.342a.171.171 0 01.1.049v4.4a.048.048 0 01-.049.049l-3.13 3.074c0 .049-.049.049-.1.049"
							data-name="Path 6688"
						/>
					</g>
				</g>
			</g>
		</g>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2019" />
	</SvgIcon>
);

export const CreateUserGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} style={{ transform: 'rotateY(180deg)', ...props.style }} viewBox="0 0 24 24">
		<path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z" />
	</SvgIcon>
);

export const AddShareIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z" />
	</SvgIcon>
);

export const SelectTenantGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 17.684 21">
		<g id="Group_4075" data-name="Group 4075" transform="translate(-3356 -10720)">
			<path
				id="Union_34"
				data-name="Union 34"
				d="M8.842,19.113l1.518-2.429h5.324a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2A1,1,0,0,0,1,2V15.684a1,1,0,0,0,1,1H7.324l1.519,2.429m0,1.887L6.77,17.684H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H15.684a2,2,0,0,1,2,2V15.684a2,2,0,0,1-2,2h-4.77Z"
				transform="translate(3356 10720)"
				fill="currentColor"
			/>
			<g id="Group_4074" data-name="Group 4074" transform="translate(3359.342 1.667)">
				<g id="Group_4073" data-name="Group 4073" transform="translate(-3357 8)">
					<rect
						id="Rectangle_1997"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
				<g id="Group_4072" data-name="Group 4072" transform="translate(-3357 4)">
					<rect
						id="Rectangle_1997-2"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37-2"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
				<g id="Group_4071" data-name="Group 4071" transform="translate(-3357)">
					<rect
						id="Rectangle_1997-3"
						data-name="Rectangle 1997"
						width="7"
						height="2"
						transform="translate(3361 10722)"
						fill="currentColor"
					/>
					<circle
						id="Ellipse_37-3"
						data-name="Ellipse 37"
						cx="1"
						cy="1"
						r="1"
						transform="translate(3357 10722)"
						fill="currentColor"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const TenantKeysIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 13.988 17.688">
		<g id="tenant-keys" transform="translate(-2.306 -0.206)">
			<path
				id="Path_6924"
				data-name="Path 6924"
				d="M10.8,10.9v5l1.5,1.5,1.5-1.5-1.2-1.2,1.2-1.2-1.2-1.2,1.2-1.2v-1a3.468,3.468,0,0,0,1.9-3,3.653,3.653,0,0,0-1.4-2.8"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<path
				id="Path_6925"
				data-name="Path 6925"
				d="M10.3,2.8A3.393,3.393,0,0,0,7,7.3L2.8,11.5v2.2H5.3V11.8H7.2V10H8.7l.5-.5a3.52,3.52,0,0,0,3.5-.8,3.441,3.441,0,0,0,0-4.8,2.589,2.589,0,0,0-1.1-.7"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<path
				id="Path_6926"
				data-name="Path 6926"
				d="M15.8,3.7V3.5A2.8,2.8,0,0,0,13,.7a2.734,2.734,0,0,0-2.8,2.8,2.906,2.906,0,0,0,1.4,2.4"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
			<circle
				id="Ellipse_36"
				data-name="Ellipse 36"
				cx="0.9"
				cy="0.9"
				r="0.9"
				transform="translate(9.8 4.9)"
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="0.988"
			/>
		</g>
	</SvgIcon>
);

export const TenantIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.tenant-line-st0{display:none;}
	.tenant-line-st1{display:inline;fill:#6D0E5E;}
	.tenant-line-st2{fill:transparent;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.tenant-line-st3{fill:transparent;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="tenant-line-st0">
			<rect x="3.8" y="2.7" className="tenant-line-st1" width="1.6" height="12.1" />
			<rect x="1.5" y="10.8" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="13" y="11" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="5.2" y="9.4" className="tenant-line-st1" width="7.2" height="3.4" />
			<rect x="4.6" y="11" className="tenant-line-st1" width="1.6" height="3.8" />
			<rect x="9.5" y="10.8" className="tenant-line-st1" width="2.9" height="3.8" />
			<rect x="4.5" y="1.2" className="tenant-line-st1" width="7" height="3.2" />
			<rect x="10.8" y="2.7" className="tenant-line-st1" width="1.6" height="7.1" />
			<rect x="7.1" y="4.2" className="tenant-line-st1" width="2" height="5.4" />
			<rect x="4.2" y="5.9" className="tenant-line-st1" width="7" height="2" />
		</g>
		<g id="Layer_1">
			<path className="tenant-line-st2" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4" />
			<path
				className="tenant-line-st2"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6
		l0,12.5"
			/>
			<rect x="5.4" y="7.9" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="5.4" y="4.3" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="9.2" y="7.9" className="tenant-line-st3" width="1.6" height="1.6" />
			<rect x="9.2" y="4.3" className="tenant-line-st3" width="1.6" height="1.6" />
			<path className="tenant-line-st2" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4" />
			<path className="tenant-line-st3" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15" />
			<line className="tenant-line-st3" x1="8" y1="15" x2="8" y2="12.6" />
			<line className="tenant-line-st2" x1="0.5" y1="15" x2="15.7" y2="15" />
		</g>
	</SvgIcon>
);

export const TenantIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.tenant-fill-st0{fill:currentColor;}
	.tenant-fill-st1{fill:transparent;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.tenant-fill-st2{fill:transparent;stroke:currentColor;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<rect x="3.8" y="2.7" className="tenant-fill-st0" width="1.6" height="12.1" />
			<rect x="1.5" y="10.8" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="13" y="11" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="5.2" y="9.4" className="tenant-fill-st0" width="7.2" height="3.4" />
			<rect x="4.6" y="11" className="tenant-fill-st0" width="1.6" height="3.8" />
			<rect x="9.5" y="10.8" className="tenant-fill-st0" width="2.9" height="3.8" />
			<rect x="4.5" y="1.2" className="tenant-fill-st0" width="7" height="3.2" />
			<rect x="10.8" y="2.7" className="tenant-fill-st0" width="1.6" height="7.1" />
			<rect x="7.1" y="4.2" className="tenant-fill-st0" width="2" height="5.4" />
			<rect x="4.2" y="5.9" className="tenant-fill-st0" width="7" height="2" />
		</g>
		<g id="Layer_1">
			<path className="tenant-fill-st1" d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4" />
			<path
				className="tenant-fill-st1"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6
		l0,12.5"
			/>
			<rect x="5.4" y="7.9" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="5.4" y="4.3" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="9.2" y="7.9" className="tenant-fill-st2" width="1.6" height="1.6" />
			<rect x="9.2" y="4.3" className="tenant-fill-st2" width="1.6" height="1.6" />
			<path className="tenant-fill-st1" d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4" />
			<path className="tenant-fill-st2" d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15" />
			<line className="tenant-fill-st2" x1="8" y1="15" x2="8" y2="12.6" />
			<line className="tenant-fill-st1" x1="0.5" y1="15" x2="15.7" y2="15" />
		</g>
	</SvgIcon>
);

export const WorkflowIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.workflow-line-st0{fill:currentColor;}
	.workflow-line-st1{fill:transparent;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1_00000143595855252159953840000010189435056039044006_">
			<path className="workflow-line-st0" d="M1.8,21.4V0.6L19.7,11L1.8,21.4z M2.9,2.5v17L17.5,11L2.9,2.5z" />
		</g>
		<g id="Layer_2_00000140714031565642397520000008672307113262246329_">
			<polygon className="workflow-line-st1" points="2.3,1.6 18.5,11 2.3,20.5 	" />
		</g>
	</SvgIcon>
);

export const WorkflowIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.workflow-fill-st0{display:none;}
	.workflow-fill-st1{display:inline;fill:currentColor;}
	.workflow-fill-st2{fill:currentColor;stroke:currentColor;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_1" className="workflow-fill-st0">
			<path className="workflow-fill-st1" d="M1.8,21.4V0.6L19.7,11L1.8,21.4z M2.9,2.5v17L17.5,11L2.9,2.5z" />
		</g>
		<g id="Layer_2">
			<polygon className="workflow-fill-st2" points="2.3,1.6 18.5,11 2.3,20.5 	" />
		</g>
	</SvgIcon>
);

export const DashboardIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.dashboard-line-st0{display:none;}
	.dashboard-line-st1{display:inline;fill:currentColor;}
	.dashboard-line-st2{fill:currentColor;}
	.dashboard-line-st3{display:inline;fill:none;stroke:currentColor;stroke-miterlimit:10;}
	.dashboard-line-st4{display:inline;fill:currentColor;}
	.dashboard-line-st5{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}
	.dashboard-line-st6{fill:currentColor;}`}
		</style>
		<g id="Layer_1" className="dashboard-line-st0">
			<path
				className="dashboard-line-st1"
				d="M18.5,18c1.8-1.9,2.9-4.4,2.9-7.2c0-0.9-0.1-1.9-0.4-2.7C21,8,21,8,21,7.9s0-0.1-0.1-0.1
		c-1.3-4.3-5.3-7.4-10-7.4C5.2,0.3,0.5,5,0.5,10.8S5.2,21.3,11,21.3C13.9,21.3,16.6,20,18.5,18C18.5,18.1,18.5,18,18.5,18L18.5,18z
		 M18.2,17.3L11.6,11l8.8-2.5c0.2,0.8,0.3,1.5,0.3,2.3C20.7,13.3,19.8,15.6,18.2,17.3z M20.2,7.8l-8.9,2.6V1.1
		C15.5,1.2,19,4,20.2,7.8z M1.2,10.8c0-5.3,4.2-9.6,9.4-9.8v10l7.2,6.8c-1.8,1.7-4.2,2.8-6.8,2.8C5.5,20.6,1.2,16.2,1.2,10.8z"
			/>
		</g>
		<g id="Layer_2" className="dashboard-line-st0">
			<circle className="dashboard-line-st2" cx="11.1" cy="11" r="10.2" />
			<circle className="dashboard-line-st3" cx="11.1" cy="11" r="10.2" />
			<line className="dashboard-line-st3" x1="11.1" y1="11" x2="18.2" y2="17.9" />
			<line className="dashboard-line-st3" x1="11" y1="1" x2="11.2" y2="11.4" />
			<line className="dashboard-line-st3" x1="20.7" y1="8.1" x2="11.4" y2="10.9" />
		</g>
		<g id="Layer_2_copy" className="dashboard-line-st0">
			<circle className="dashboard-line-st4" cx="11" cy="11" r="10.2" />
			<circle className="dashboard-line-st3" cx="11" cy="11" r="10.2" />
			<line className="dashboard-line-st3" x1="11" y1="11" x2="18.3" y2="18.1" />
			<line className="dashboard-line-st3" x1="11" y1="0.8" x2="11.2" y2="11.4" />
			<line className="dashboard-line-st3" x1="20.8" y1="8.1" x2="11.1" y2="11.1" />
		</g>
		<g id="Layer_4" className="dashboard-line-st0">
			<path
				className="dashboard-line-st5"
				d="M14.4,20.5c-1.1,0.5-2.4,0.7-3.6,0.7h0v0c-1.1,0-2.2-0.2-3.3-0.6c-1-0.4-2-1-2.9-1.7c0,0,0,0,0,0
		c-0.1-0.1-0.1-0.2,0-0.2l0,0l6.4-6.4c0,0,0.1-0.1,0.1-0.1v0l9,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2h0c-0.1,1.1-0.4,2.2-0.8,3.3
		c-0.5,1-1.1,1.9-1.9,2.8l0,0l-0.1-0.1l0.1,0.1C16.6,19.3,15.6,20,14.4,20.5L14.4,20.5z M20.9,10.3L20.9,10.3H12
		c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0l0-8.8h0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c1.2,0.1,2.3,0.4,3.3,0.8c1,0.5,2,1.1,2.8,2
		l-0.1,0.1l0.1-0.1c0.8,0.8,1.5,1.8,2,2.8c0.5,1,0.8,2.2,0.8,3.4h0C21,10.2,21,10.3,20.9,10.3L20.9,10.3L20.9,10.3z M3.3,17.6
		c-0.7-0.9-1.3-1.8-1.7-2.9c-0.4-1-0.6-2.2-0.6-3.3h0c0-1.3,0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.2,2.1-3.1l0,0l0,0l0,0l0,0
		c0.8-0.8,1.7-1.4,2.7-1.9c1-0.5,2.1-0.7,3.3-0.8v0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0l0,9h0c0,0,0,0.1-0.1,0.1l-6.4,6.3l0,0
		C3.5,17.6,3.4,17.6,3.3,17.6C3.3,17.6,3.3,17.6,3.3,17.6L3.3,17.6z"
			/>
		</g>
		<g id="Layer_4_copy">
			<g>
				<path
					className="dashboard-line-st6"
					d="M12.9,2.3c0.7,0.1,1.4,0.3,2.1,0.6c0.8,0.4,1.5,0.8,2.2,1.4c0,0.2,0.1,0.3,0.3,0.5C17.6,4.9,17.7,5,17.9,5
			c0.6,0.6,1,1.4,1.4,2.2c0.3,0.7,0.5,1.4,0.6,2.1h-7L12.9,2.3 M8.9,3.1l0,7.7l-5.4,5.4c-0.4-0.6-0.7-1.2-1-1.9
			C2.2,13.4,2,12.4,2,11.4c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.9,1.8-2.7c0,0,0,0,0,0C5.2,4.7,6,4.1,6.9,3.7C7.6,3.4,8.2,3.2,8.9,3.1
			 M11.8,12.9L11.8,12.9L11.8,12.9 M11.5,13.2l7.7,0c-0.1,0.7-0.3,1.4-0.6,2c-0.3,0.8-0.8,1.5-1.4,2.1c-0.2,0-0.3,0.1-0.4,0.3
			c-0.1,0.1-0.2,0.3-0.3,0.5c-0.7,0.6-1.5,1.1-2.4,1.5c-1,0.4-2.1,0.6-3.2,0.6c0,0,0,0,0,0c-1,0-2-0.2-2.9-0.5
			c-0.7-0.2-1.3-0.6-1.9-1L11.5,13.2 M12,1.2c-0.1,0-0.1,0.1-0.1,0.1h0l0,8.8c0,0,0,0,0,0c0,0.1,0.1,0.1,0.2,0.1h8.8h0l0,0
			c0.1,0,0.1-0.1,0.1-0.2h0c-0.1-1.2-0.4-2.3-0.8-3.4c-0.5-1-1.1-2-2-2.8l-0.1,0.1l0.1-0.1c-0.8-0.8-1.8-1.5-2.8-2
			C14.4,1.5,13.2,1.2,12,1.2C12,1.2,12,1.2,12,1.2L12,1.2z M9.8,1.9C9.8,1.9,9.8,1.9,9.8,1.9L9.8,1.9C8.6,2,7.5,2.3,6.5,2.8
			c-1,0.5-1.9,1.1-2.7,1.9l0,0l0,0l0,0C2.9,5.6,2.2,6.6,1.7,7.8C1.2,8.9,1,10.1,1,11.4h0c0,1.1,0.2,2.2,0.6,3.3c0.4,1,1,2,1.7,2.9
			c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0l6.4-6.3c0,0,0.1-0.1,0.1-0.1h0l0-9c0,0,0,0,0,0C9.9,2,9.9,1.9,9.8,1.9L9.8,1.9z
			 M9.9,11.1L9.9,11.1L9.9,11.1z M11.1,12.2c0,0-0.1,0-0.1,0.1l-6.4,6.4l0,0c-0.1,0.1-0.1,0.2,0,0.2c0,0,0,0,0,0
			c0.9,0.7,1.8,1.3,2.9,1.7c1,0.4,2.2,0.6,3.3,0.6c0,0,0,0,0,0v0h0c1.3,0,2.5-0.2,3.6-0.7c1.1-0.5,2.2-1.2,3.1-2.1l-0.1-0.1l0.1,0.1
			l0,0c0.8-0.8,1.4-1.7,1.9-2.8c0.5-1,0.7-2.1,0.8-3.3h0c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0L11.1,12.2L11.1,12.2
			C11.1,12.2,11.1,12.2,11.1,12.2L11.1,12.2z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ActivityDashboardIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<svg id="activity-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<rect id="Rectangle_4216" data-name="Rectangle 4216" width="24" height="24" fill="none" />
			<g id="Union_102" data-name="Union 102" transform="translate(-14016.75 -1200.5)" fill="none">
				<path d="M14034,1223v-9h5.5v9Zm-8,0v-21h5.5v21Zm-8,0v-15h5.5v15Z" stroke="none" />
				<path
					d="M 14037.9990234375 1221.500366210938 L 14037.9990234375 1215.50146484375 L 14035.4990234375 1215.50146484375 L 14035.4990234375 1221.500366210938 L 14037.9990234375 1221.500366210938 M 14030.0009765625 1221.500366210938 L 14030.0009765625 1203.50048828125 L 14027.5009765625 1203.50048828125 L 14027.5009765625 1221.500366210938 L 14030.0009765625 1221.500366210938 M 14021.9990234375 1221.500366210938 L 14021.9990234375 1209.5009765625 L 14019.4990234375 1209.5009765625 L 14019.4990234375 1221.500366210938 L 14021.9990234375 1221.500366210938 M 14039.4990234375 1223.000366210938 L 14033.9990234375 1223.000366210938 L 14033.9990234375 1214.00146484375 L 14039.4990234375 1214.00146484375 L 14039.4990234375 1223.000366210938 Z M 14031.5009765625 1223.000366210938 L 14026.0009765625 1223.000366210938 L 14026.0009765625 1202.00048828125 L 14031.5009765625 1202.00048828125 L 14031.5009765625 1223.000366210938 Z M 14023.4990234375 1223.000366210938 L 14017.9990234375 1223.000366210938 L 14017.9990234375 1208.0009765625 L 14023.4990234375 1208.0009765625 L 14023.4990234375 1223.000366210938 Z"
					stroke="none"
					fill="currentColor"
				/>
			</g>
		</svg>
	</SvgIcon>
);

export const DashboardIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">
			{`
	.dashboard-fill-st0{display:none;}
	.dashboard-fill-st1{display:inline;fill:currentColor;}
	.dashboard-fill-st2{fill:currentColor;}
	.dashboard-fill-st3{display:inline;fill:none;stroke:currentColor;stroke-miterlimit:10;}
	.dashboard-fill-st4{display:inline;fill:currentColor;}
	.dashboard-fill-st5{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}
	.dashboard-fill-st6{display:inline;}
	.dashboard-fill-st7{fill:currentColor;}`}
		</style>
		<g id="Layer_1" className="dashboard-fill-st0">
			<path
				className="dashboard-fill-st1"
				d="M18.5,18c1.8-1.9,2.9-4.4,2.9-7.2c0-0.9-0.1-1.9-0.4-2.7C21,8,21,8,21,7.9s0-0.1-0.1-0.1
		c-1.3-4.3-5.3-7.4-10-7.4C5.2,0.3,0.5,5,0.5,10.8S5.2,21.3,11,21.3C13.9,21.3,16.6,20,18.5,18C18.5,18.1,18.5,18,18.5,18L18.5,18z
		 M18.2,17.3L11.6,11l8.8-2.5c0.2,0.8,0.3,1.5,0.3,2.3C20.7,13.3,19.8,15.6,18.2,17.3z M20.2,7.8l-8.9,2.6V1.1
		C15.5,1.2,19,4,20.2,7.8z M1.2,10.8c0-5.3,4.2-9.6,9.4-9.8v10l7.2,6.8c-1.8,1.7-4.2,2.8-6.8,2.8C5.5,20.6,1.2,16.2,1.2,10.8z"
			/>
		</g>
		<g id="Layer_2" className="dashboard-fill-st0">
			<circle className="dashboard-fill-st2" cx="11.1" cy="11" r="10.2" />
			<circle className="dashboard-fill-st3" cx="11.1" cy="11" r="10.2" />
			<line className="dashboard-fill-st3" x1="11.1" y1="11" x2="18.2" y2="17.9" />
			<line className="dashboard-fill-st3" x1="11" y1="1" x2="11.2" y2="11.4" />
			<line className="dashboard-fill-st3" x1="20.7" y1="8.1" x2="11.4" y2="10.9" />
		</g>
		<g id="Layer_2_copy" className="dashboard-fill-st0">
			<circle className="dashboard-fill-st4" cx="11" cy="11" r="10.2" />
			<circle className="dashboard-fill-st3" cx="11" cy="11" r="10.2" />
			<line className="dashboard-fill-st3" x1="11" y1="11" x2="18.3" y2="18.1" />
			<line className="dashboard-fill-st3" x1="11" y1="0.8" x2="11.2" y2="11.4" />
			<line className="dashboard-fill-st3" x1="20.8" y1="8.1" x2="11.1" y2="11.1" />
		</g>
		<g id="Layer_4">
			<path
				className="dashboard-fill-st5"
				d="M14.4,20.5c-1.1,0.5-2.4,0.7-3.6,0.7h0v0c-1.1,0-2.2-0.2-3.3-0.6c-1-0.4-2-1-2.9-1.7c0,0,0,0,0,0
		c-0.1-0.1-0.1-0.2,0-0.2l0,0l6.4-6.4c0,0,0.1-0.1,0.1-0.1v0l9,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2h0c-0.1,1.1-0.4,2.2-0.8,3.3
		c-0.5,1-1.1,1.9-1.9,2.8l0,0l-0.1-0.1l0.1,0.1C16.6,19.3,15.6,20,14.4,20.5L14.4,20.5z M20.9,10.3L20.9,10.3H12
		c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0l0-8.8h0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c1.2,0.1,2.3,0.4,3.3,0.8c1,0.5,2,1.1,2.8,2
		l-0.1,0.1l0.1-0.1c0.8,0.8,1.5,1.8,2,2.8c0.5,1,0.8,2.2,0.8,3.4h0C21,10.2,21,10.3,20.9,10.3L20.9,10.3L20.9,10.3z M3.3,17.6
		c-0.7-0.9-1.3-1.8-1.7-2.9c-0.4-1-0.6-2.2-0.6-3.3h0c0-1.3,0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.2,2.1-3.1l0,0l0,0l0,0l0,0
		c0.8-0.8,1.7-1.4,2.7-1.9c1-0.5,2.1-0.7,3.3-0.8v0c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0l0,9h0c0,0,0,0.1-0.1,0.1l-6.4,6.3l0,0
		C3.5,17.6,3.4,17.6,3.3,17.6C3.3,17.6,3.3,17.6,3.3,17.6L3.3,17.6z"
			/>
		</g>
		<g id="Layer_4_copy" className="dashboard-fill-st0">
			<g className="dashboard-fill-st6">
				<path
					className="dashboard-fill-st7"
					d="M12.9,2.3c0.7,0.1,1.4,0.3,2.1,0.6c0.8,0.4,1.5,0.8,2.2,1.4c0,0.2,0.1,0.3,0.3,0.5C17.6,4.9,17.7,5,17.9,5
			c0.6,0.6,1,1.4,1.4,2.2c0.3,0.7,0.5,1.4,0.6,2.1h-7L12.9,2.3 M8.9,3.1l0,7.7l-5.4,5.4c-0.4-0.6-0.7-1.2-1-1.9
			C2.2,13.4,2,12.4,2,11.4c0-1.1,0.2-2.2,0.6-3.2c0.4-1,1-1.9,1.8-2.7c0,0,0,0,0,0C5.2,4.7,6,4.1,6.9,3.7C7.6,3.4,8.2,3.2,8.9,3.1
			 M11.8,12.9L11.8,12.9L11.8,12.9 M11.5,13.2l7.7,0c-0.1,0.7-0.3,1.4-0.6,2c-0.3,0.8-0.8,1.5-1.4,2.1c-0.2,0-0.3,0.1-0.4,0.3
			c-0.1,0.1-0.2,0.3-0.3,0.5c-0.7,0.6-1.5,1.1-2.4,1.5c-1,0.4-2.1,0.6-3.2,0.6c0,0,0,0,0,0c-1,0-2-0.2-2.9-0.5
			c-0.7-0.2-1.3-0.6-1.9-1L11.5,13.2 M12,1.2c-0.1,0-0.1,0.1-0.1,0.1h0l0,8.8c0,0,0,0,0,0c0,0.1,0.1,0.1,0.2,0.1h8.8h0l0,0
			c0.1,0,0.1-0.1,0.1-0.2h0c-0.1-1.2-0.4-2.3-0.8-3.4c-0.5-1-1.1-2-2-2.8l-0.1,0.1l0.1-0.1c-0.8-0.8-1.8-1.5-2.8-2
			C14.4,1.5,13.2,1.2,12,1.2C12,1.2,12,1.2,12,1.2L12,1.2z M9.8,1.9C9.8,1.9,9.8,1.9,9.8,1.9L9.8,1.9C8.6,2,7.5,2.3,6.5,2.8
			c-1,0.5-1.9,1.1-2.7,1.9l0,0l0,0l0,0C2.9,5.6,2.2,6.6,1.7,7.8C1.2,8.9,1,10.1,1,11.4h0c0,1.1,0.2,2.2,0.6,3.3c0.4,1,1,2,1.7,2.9
			c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l0,0l6.4-6.3c0,0,0.1-0.1,0.1-0.1h0l0-9c0,0,0,0,0,0C9.9,2,9.9,1.9,9.8,1.9L9.8,1.9z
			 M9.9,11.1L9.9,11.1L9.9,11.1z M11.1,12.2c0,0-0.1,0-0.1,0.1l-6.4,6.4l0,0c-0.1,0.1-0.1,0.2,0,0.2c0,0,0,0,0,0
			c0.9,0.7,1.8,1.3,2.9,1.7c1,0.4,2.2,0.6,3.3,0.6c0,0,0,0,0,0v0h0c1.3,0,2.5-0.2,3.6-0.7c1.1-0.5,2.2-1.2,3.1-2.1l-0.1-0.1l0.1,0.1
			l0,0c0.8-0.8,1.4-1.7,1.9-2.8c0.5-1,0.7-2.1,0.8-3.3h0c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0L11.1,12.2L11.1,12.2
			C11.1,12.2,11.1,12.2,11.1,12.2L11.1,12.2z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ReportsIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 23.8 28">
		<path
			id="Subtraction_9"
			data-name="Subtraction 9"
			d="M23.8,28H0V0H23.8V28ZM3.966,22.909v2.545H19.833V22.909Zm0-5.091v2.545H19.833V17.818Zm8.013-8.7-.068.068L7.533,13.561h0a.045.045,0,0,0-.045.024c-.012.028.007.071.048.113a8.367,8.367,0,0,0,1.983,1.162,6.6,6.6,0,0,0,2.258.411,6.1,6.1,0,0,0,2.462-.479,7.506,7.506,0,0,0,2.12-1.368,8.591,8.591,0,0,0,1.3-1.914A8.928,8.928,0,0,0,18.2,9.252c0-.067,0-.136-.068-.136ZM11.09,2.138a6.026,6.026,0,0,0-2.258.547,6.881,6.881,0,0,0-1.846,1.3A7.24,7.24,0,0,0,5.55,6.105a5.854,5.854,0,0,0-.479,2.462,6.323,6.323,0,0,0,.411,2.258,7.338,7.338,0,0,0,1.162,1.983h.016c.064,0,.122-.005.122-.068l4.378-4.31a.067.067,0,0,0,.068-.068V2.206h0A.239.239,0,0,0,11.09,2.138Zm1.367,5.609a.244.244,0,0,0,.137.068h6.02a5.321,5.321,0,0,0-.548-2.322A7.566,7.566,0,0,0,16.7,3.575a6.166,6.166,0,0,0-1.915-1.368,7.732,7.732,0,0,0-2.257-.547.068.068,0,0,0-.069.068v6.02Z"
			transform="translate(0 0)"
			fill="transparent"
			stroke="currentColor"
		/>
	</SvgIcon>
);

export const ReportsIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 23.8 28">
		<path
			id="Subtraction_9"
			data-name="Subtraction 9"
			d="M23.8,28H0V0H23.8V28ZM3.966,22.909v2.545H19.833V22.909Zm0-5.091v2.545H19.833V17.818Zm8.013-8.7-.068.068L7.533,13.561h0a.045.045,0,0,0-.045.024c-.012.028.007.071.048.113a8.367,8.367,0,0,0,1.983,1.162,6.6,6.6,0,0,0,2.258.411,6.1,6.1,0,0,0,2.462-.479,7.506,7.506,0,0,0,2.12-1.368,8.591,8.591,0,0,0,1.3-1.914A8.928,8.928,0,0,0,18.2,9.252c0-.067,0-.136-.068-.136ZM11.09,2.138a6.026,6.026,0,0,0-2.258.547,6.881,6.881,0,0,0-1.846,1.3A7.24,7.24,0,0,0,5.55,6.105a5.854,5.854,0,0,0-.479,2.462,6.323,6.323,0,0,0,.411,2.258,7.338,7.338,0,0,0,1.162,1.983h.016c.064,0,.122-.005.122-.068l4.378-4.31a.067.067,0,0,0,.068-.068V2.206h0A.239.239,0,0,0,11.09,2.138Zm1.367,5.609a.244.244,0,0,0,.137.068h6.02a5.321,5.321,0,0,0-.548-2.322A7.566,7.566,0,0,0,16.7,3.575a6.166,6.166,0,0,0-1.915-1.368,7.732,7.732,0,0,0-2.257-.547.068.068,0,0,0-.069.068v6.02Z"
			transform="translate(0 0)"
			fill="currentColor"
			strokeWidth="20"
		/>
	</SvgIcon>
);

export const BsnIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<svg id="bsn-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
			<defs>
				<clipPath id="BsnIconLine-clip-path">
					<rect
						id="Rectangle_3484"
						data-name="Rectangle 3484"
						width="20"
						height="19.9"
						transform="translate(0 0)"
						fill="currentColor"
					/>
				</clipPath>
			</defs>
			<g id="Group_8911" data-name="Group 8911" transform="translate(3 3.05)">
				<g id="Group_8910" data-name="Group 8910" clipPath="url(#BsnIconLine-clip-path)">
					<path
						id="Path_8236"
						data-name="Path 8236"
						d="M2.25,16.25A9.71,9.71,0,0,1,0,10.95H2.05a8.651,8.651,0,0,0,.55,2.063A7.9,7.9,0,0,0,3.65,14.85ZM0,8.95A11.554,11.554,0,0,1,.75,6.125,9.2,9.2,0,0,1,2.25,3.65l1.4,1.4A7.906,7.906,0,0,0,2.6,6.888,8.644,8.644,0,0,0,2.05,8.95ZM8.95,19.9a9.768,9.768,0,0,1-2.813-.712A10.369,10.369,0,0,1,3.65,17.7l1.4-1.45A9.323,9.323,0,0,0,6.9,17.325a7.775,7.775,0,0,0,2.05.575ZM5.1,3.65,3.65,2.2A10.768,10.768,0,0,1,6.175.713,9.915,9.915,0,0,1,9,0V2a8,8,0,0,0-2.063.575A8.683,8.683,0,0,0,5.1,3.65M10.95,19.9v-2a8.156,8.156,0,0,0,3.95-1.65l1.45,1.45a9.882,9.882,0,0,1-2.538,1.5,10.342,10.342,0,0,1-2.862.7m4-16.25a9.136,9.136,0,0,0-1.875-1.075A8.182,8.182,0,0,0,11,2V0a10.062,10.062,0,0,1,2.837.713A10.213,10.213,0,0,1,16.35,2.2Zm2.8,12.6-1.4-1.4a7.9,7.9,0,0,0,1.05-1.837,8.651,8.651,0,0,0,.55-2.063H20a11.542,11.542,0,0,1-.75,2.825,9.2,9.2,0,0,1-1.5,2.475m.2-7.3a8.644,8.644,0,0,0-.55-2.062A7.906,7.906,0,0,0,16.35,5.05l1.4-1.4A9.71,9.71,0,0,1,20,8.95Zm-13.6,2.843A5.765,5.765,0,0,1,4.235,8.37l1.138.438a5.147,5.147,0,0,0-.135,1.262,4.7,4.7,0,0,0,.191,1.244ZM4.661,7.26a6.888,6.888,0,0,1,1.02-1.409A5.475,5.475,0,0,1,7.042,4.8L7.52,5.873a4.734,4.734,0,0,0-.975.8A5.145,5.145,0,0,0,5.8,7.7Zm2.633,7.989a5.8,5.8,0,0,1-1.41-1A6.15,6.15,0,0,1,4.821,12.9l1.086-.506a5.632,5.632,0,0,0,.8.992,4.631,4.631,0,0,0,1.016.756Zm1.33-9.843-.5-1.115A6.4,6.4,0,0,1,9.847,4a5.912,5.912,0,0,1,1.721.207l-.427,1.111A4.718,4.718,0,0,0,9.873,5.2a5.119,5.119,0,0,0-1.249.2M8.4,15.676l.427-1.111a4.862,4.862,0,0,0,2.545-.073l.5,1.114a5.9,5.9,0,0,1-1.729.292A6.187,6.187,0,0,1,8.4,15.676m5.688-8.169a5.442,5.442,0,0,0-.811-1,4.9,4.9,0,0,0-1.03-.762l.427-1.11a5.987,5.987,0,0,1,1.424,1A6.068,6.068,0,0,1,15.179,7ZM12.958,15.1l-.478-1.076a4.7,4.7,0,0,0,.975-.8A5.152,5.152,0,0,0,14.2,12.2l1.138.438a6.839,6.839,0,0,1-1.019,1.408A5.428,5.428,0,0,1,12.958,15.1m1.669-4.01a5.2,5.2,0,0,0,.135-1.262,4.7,4.7,0,0,0-.191-1.245L15.647,8.1a5.782,5.782,0,0,1,.118,3.422Z"
						fill="currentColor"
					/>
				</g>
			</g>
			<rect id="Rectangle_3485" data-name="Rectangle 3485" width="26" height="26" fill="none" />
		</svg>
	</SvgIcon>
);

export const BsnIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<svg id="bsn-dashboard-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
			<defs>
				<clipPath id="BsnIconFill-clip-path">
					<rect
						id="Rectangle_3484"
						data-name="Rectangle 3484"
						width="20"
						height="19.9"
						transform="translate(0 0)"
						fill="currentColor"
					/>
				</clipPath>
			</defs>
			<g id="Group_8911" data-name="Group 8911" transform="translate(3 3.05)">
				<g id="Group_8910" data-name="Group 8910" clipPath="url(#BsnIconFill-clip-path)">
					<path
						id="Path_8236"
						data-name="Path 8236"
						d="M2.25,16.25A9.71,9.71,0,0,1,0,10.95H2.05a8.651,8.651,0,0,0,.55,2.063A7.9,7.9,0,0,0,3.65,14.85ZM0,8.95A11.554,11.554,0,0,1,.75,6.125,9.2,9.2,0,0,1,2.25,3.65l1.4,1.4A7.906,7.906,0,0,0,2.6,6.888,8.644,8.644,0,0,0,2.05,8.95ZM8.95,19.9a9.768,9.768,0,0,1-2.813-.712A10.369,10.369,0,0,1,3.65,17.7l1.4-1.45A9.323,9.323,0,0,0,6.9,17.325a7.775,7.775,0,0,0,2.05.575ZM5.1,3.65,3.65,2.2A10.768,10.768,0,0,1,6.175.713,9.915,9.915,0,0,1,9,0V2a8,8,0,0,0-2.063.575A8.683,8.683,0,0,0,5.1,3.65M10.95,19.9v-2a8.156,8.156,0,0,0,3.95-1.65l1.45,1.45a9.882,9.882,0,0,1-2.538,1.5,10.342,10.342,0,0,1-2.862.7m4-16.25a9.136,9.136,0,0,0-1.875-1.075A8.182,8.182,0,0,0,11,2V0a10.062,10.062,0,0,1,2.837.713A10.213,10.213,0,0,1,16.35,2.2Zm2.8,12.6-1.4-1.4a7.9,7.9,0,0,0,1.05-1.837,8.651,8.651,0,0,0,.55-2.063H20a11.542,11.542,0,0,1-.75,2.825,9.2,9.2,0,0,1-1.5,2.475m.2-7.3a8.644,8.644,0,0,0-.55-2.062A7.906,7.906,0,0,0,16.35,5.05l1.4-1.4A9.71,9.71,0,0,1,20,8.95Zm-13.6,2.843A5.765,5.765,0,0,1,4.235,8.37l1.138.438a5.147,5.147,0,0,0-.135,1.262,4.7,4.7,0,0,0,.191,1.244ZM4.661,7.26a6.888,6.888,0,0,1,1.02-1.409A5.475,5.475,0,0,1,7.042,4.8L7.52,5.873a4.734,4.734,0,0,0-.975.8A5.145,5.145,0,0,0,5.8,7.7Zm2.633,7.989a5.8,5.8,0,0,1-1.41-1A6.15,6.15,0,0,1,4.821,12.9l1.086-.506a5.632,5.632,0,0,0,.8.992,4.631,4.631,0,0,0,1.016.756Zm1.33-9.843-.5-1.115A6.4,6.4,0,0,1,9.847,4a5.912,5.912,0,0,1,1.721.207l-.427,1.111A4.718,4.718,0,0,0,9.873,5.2a5.119,5.119,0,0,0-1.249.2M8.4,15.676l.427-1.111a4.862,4.862,0,0,0,2.545-.073l.5,1.114a5.9,5.9,0,0,1-1.729.292A6.187,6.187,0,0,1,8.4,15.676m5.688-8.169a5.442,5.442,0,0,0-.811-1,4.9,4.9,0,0,0-1.03-.762l.427-1.11a5.987,5.987,0,0,1,1.424,1A6.068,6.068,0,0,1,15.179,7ZM12.958,15.1l-.478-1.076a4.7,4.7,0,0,0,.975-.8A5.152,5.152,0,0,0,14.2,12.2l1.138.438a6.839,6.839,0,0,1-1.019,1.408A5.428,5.428,0,0,1,12.958,15.1m1.669-4.01a5.2,5.2,0,0,0,.135-1.262,4.7,4.7,0,0,0-.191-1.245L15.647,8.1a5.782,5.782,0,0,1,.118,3.422Z"
						fill="currentColor"
					/>
				</g>
			</g>
			<rect id="Rectangle_3485" data-name="Rectangle 3485" width="26" height="26" fill="none" />
		</svg>
	</SvgIcon>
);

export const MonitorIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<svg id="bsn-monitor-devices" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
			<path
				id="Path_10055"
				data-name="Path 10055"
				d="M4,0H20a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z"
				fill="#4b9c14"
				opacity="0"
			/>
			<path
				id="Union_62"
				data-name="Union 62"
				d="M7.169,19.632l-.394-3.124a5.584,5.584,0,0,1-.519-.262c-.175-.1-.342-.205-.5-.315L2.832,17.158,0,12.29l2.536-1.9q0-.045-.007-.089-.015-.238-.015-.474t.016-.461q0-.058.009-.119L0,7.341,2.832,2.494,5.754,3.713c.164-.113.333-.221.508-.321s.337-.184.5-.26L7.171,0h5.66l.394,3.139a4.95,4.95,0,0,1,.52.267c.155.092.312.195.469.307L17.169,2.5,20,7.341,17.437,9.263q0,.065.006.129c0,.141,0,.282,0,.424s0,.284-.01.43q0,.071-.011.145l2.539,1.9-2.832,4.87L14.21,15.921c-.161.114-.325.22-.49.316a5.247,5.247,0,0,1-.494.255l-.394,3.139Zm-.887-4.97a4.537,4.537,0,0,0,.639.435,3.83,3.83,0,0,0,.68.309l.4.132.349,2.769h3.3L12,15.538l.388-.137a3.806,3.806,0,0,0,.654-.305,5.708,5.708,0,0,0,.659-.452l.312-.247,2.557,1.083,1.65-2.838L15.96,10.953l.092-.415a2.131,2.131,0,0,0,.052-.352c.006-.126.009-.249.009-.37s0-.263,0-.394a1.61,1.61,0,0,0-.041-.308L15.974,8.7l2.278-1.708L16.6,4.165,14.008,5.232,13.7,4.988a5.882,5.882,0,0,0-.641-.445,3.945,3.945,0,0,0-.676-.314L12,4.091l-.347-2.766H8.346L7.99,4.082l-.382.138a4.324,4.324,0,0,0-.678.319,5.6,5.6,0,0,0-.67.451l-.31.243L3.4,4.167,1.748,6.991,3.957,8.647l-.051.383q-.03.229-.043.421t-.013.374q0,.194.013.389t.041.373l.061.391L1.747,12.641,3.4,15.482,5.97,14.4Zm2.676-1.994a1.022,1.022,0,0,1,1.963-.39H14.8v.811H10.907a1.022,1.022,0,0,1-1.949-.421Zm.5,0a.518.518,0,1,0,.518-.515A.517.517,0,0,0,9.461,12.668Zm-4.252.406v-.811h3.01v.811ZM6.89,10.218H5.208V9.407H6.9a1.014,1.014,0,1,1-.014.811Zm.425-.39a.519.519,0,1,0,.519-.515A.518.518,0,0,0,7.315,9.828Zm2.281.406V9.372h5.2v.862Zm1.556-3.246A1.023,1.023,0,0,1,13.1,6.567h1.7v.811H13.117a1.023,1.023,0,0,1-1.966-.39Zm.5,0a.519.519,0,1,0,.519-.515A.517.517,0,0,0,11.655,6.988Zm-6.447.355V6.557h5.2v.786Z"
				transform="translate(2 2.184)"
				fill="currentColor"
			/>
		</svg>
	</SvgIcon>
);

export const DeviceIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.device-line-st0{display:none;}
	.device-line-st1{display:inline;fill:currentColor;}
	.device-line-st2{fill:none;stroke:currentColor;stroke-width:0.9452;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="device-line-st0">
			<rect x="3.1" y="1.1" className="device-line-st1" width="2.9" height="13.1" />
			<rect x="5.8" y="6.4" className="device-line-st1" width="7" height="7.7" />
			<rect x="12" y="3.3" className="device-line-st1" width="0.8" height="3.4" />
			<rect x="5.7" y="1.9" className="device-line-st1" width="0.6" height="1.6" />
			<rect x="5.2" y="3.1" className="device-line-st1" width="7.2" height="0.6" />
			<rect x="5.9" y="3.5" className="device-line-st1" width="1.9" height="3.2" />
		</g>
		<g id="Layer_1">
			<g>
				<polygon className="device-line-st2" points="2.8,0.9 6.1,0.9 6.6,3.1 13,3.1 13,14.3 2.8,14.3 		" />
				<line className="device-line-st2" x1="9.4" y1="11.8" x2="4.1" y2="11.8" />
				<line className="device-line-st2" x1="9.4" y1="8.6" x2="4.1" y2="8.6" />
				<line className="device-line-st2" x1="6.4" y1="2.2" x2="12.5" y2="0.9" />
				<line className="device-line-st2" x1="12.5" y1="15.4" x2="10.9" y2="15.4" />
				<line className="device-line-st2" x1="3.4" y1="15.4" x2="5" y2="15.4" />
				<rect x="7.4" y="4.2" className="device-line-st2" width="4.4" height="2.2" />
			</g>
		</g>
	</SvgIcon>
);

export const DeviceIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.device-fill-st0{fill:currentColor;}
	.device-fill-st1{fill:none;stroke:currentColor;stroke-width:0.9452;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<rect x="3.1" y="1.1" className="device-fill-st0" width="2.9" height="13.1" />
			<rect x="5.8" y="6.4" className="device-fill-st0" width="7" height="7.7" />
			<rect x="12" y="3.3" className="device-fill-st0" width="0.8" height="3.4" />
			<rect x="5.7" y="1.9" className="device-fill-st0" width="0.6" height="1.6" />
			<rect x="5.2" y="3.1" className="device-fill-st0" width="7.2" height="0.6" />
			<rect x="5.9" y="3.5" className="device-fill-st0" width="1.9" height="3.2" />
		</g>
		<g id="Layer_1">
			<g>
				<polygon className="device-fill-st1" points="2.8,0.9 6.1,0.9 6.6,3.1 13,3.1 13,14.3 2.8,14.3 		" />
				<line className="device-fill-st1" x1="9.4" y1="11.8" x2="4.1" y2="11.8" />
				<line className="device-fill-st1" x1="9.4" y1="8.6" x2="4.1" y2="8.6" />
				<line className="device-fill-st1" x1="6.4" y1="2.2" x2="12.5" y2="0.9" />
				<line className="device-fill-st1" x1="12.5" y1="15.4" x2="10.9" y2="15.4" />
				<line className="device-fill-st1" x1="3.4" y1="15.4" x2="5" y2="15.4" />
				<rect x="7.4" y="4.2" className="device-fill-st1" width="4.4" height="2.2" />
			</g>
		</g>
	</SvgIcon>
);

export const NamingIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<g id="Group_6882" data-name="Group 6882" transform="translate(14123 9434.5)" opacity="0.971">
			<g id="Group_6880" data-name="Group 6880" transform="translate(-413 -767)">
				<g id="Group_6879" data-name="Group 6879" transform="translate(1)">
					<path
						id="Subtraction_16"
						data-name="Subtraction 16"
						d="M6.771,20.173H1.921A1.924,1.924,0,0,1,0,18.251V1.921A1.924,1.924,0,0,1,1.921,0H14.409A1.924,1.924,0,0,1,16.33,1.921V9.094a7.652,7.652,0,0,0-1.441-.442V1.921a.481.481,0,0,0-.481-.481H1.921a.481.481,0,0,0-.481.481v16.33a.481.481,0,0,0,.481.481H6.092a7.684,7.684,0,0,0,.678,1.439ZM13.583,5.194H2.747V3.362H13.583v1.83Z"
						transform="translate(-13706.165 -8665.5)"
						fill="currentColor"
					/>
					<g id="Group_6878" data-name="Group 6878" transform="translate(-59.25 110.404)">
						<path
							id="Subtraction_15"
							data-name="Subtraction 15"
							d="M6.2,12.4A6.2,6.2,0,1,1,10.121,1.394l-.946.949A4.822,4.822,0,0,0,6.2,1.329a4.87,4.87,0,1,0,4.762,3.837l1.072-1.074A6.207,6.207,0,0,1,6.2,12.4Z"
							transform="translate(-13640 -8766.047)"
							fill="currentColor"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.95)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24_-_Outline"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24 - Outline"
							d="M78.087-877.391l-3.547-3.547,1.676-1.683,1.87,1.87,6.768-6.784,1.682,1.682Zm-2.3-3.549,2.3,2.3,7.2-7.209-.428-.428L78.088-879.5l-1.87-1.87Z"
							transform="translate(-13713.06 -7878.869)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24-2"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.323)"
							fill="currentColor"
						/>
					</g>
				</g>
				<rect
					id="Rectangle_3067"
					data-name="Rectangle 3067"
					width="26"
					height="26"
					transform="translate(-13710 -8667.5)"
					fill="none"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const NamingIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<g id="Group_6882" data-name="Group 6882" transform="translate(14123 9434.5)" opacity="0.971">
			<g id="Group_6880" data-name="Group 6880" transform="translate(-413 -767)">
				<g id="Group_6879" data-name="Group 6879" transform="translate(1)">
					<path
						id="Subtraction_16"
						data-name="Subtraction 16"
						d="M6.771,20.173H1.921A1.924,1.924,0,0,1,0,18.251V1.921A1.924,1.924,0,0,1,1.921,0H14.409A1.924,1.924,0,0,1,16.33,1.921V9.094a7.652,7.652,0,0,0-1.441-.442V1.921a.481.481,0,0,0-.481-.481H1.921a.481.481,0,0,0-.481.481v16.33a.481.481,0,0,0,.481.481H6.092a7.684,7.684,0,0,0,.678,1.439ZM13.583,5.194H2.747V3.362H13.583v1.83Z"
						transform="translate(-13706.165 -8665.5)"
						fill="currentColor"
					/>
					<g id="Group_6878" data-name="Group 6878" transform="translate(-59.25 110.404)">
						<path
							id="Subtraction_15"
							data-name="Subtraction 15"
							d="M6.2,12.4A6.2,6.2,0,1,1,10.121,1.394l-.946.949A4.822,4.822,0,0,0,6.2,1.329a4.87,4.87,0,1,0,4.762,3.837l1.072-1.074A6.207,6.207,0,0,1,6.2,12.4Z"
							transform="translate(-13640 -8766.047)"
							fill="currentColor"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.95)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24_-_Outline"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24 - Outline"
							d="M78.087-877.391l-3.547-3.547,1.676-1.683,1.87,1.87,6.768-6.784,1.682,1.682Zm-2.3-3.549,2.3,2.3,7.2-7.209-.428-.428L78.088-879.5l-1.87-1.87Z"
							transform="translate(-13713.06 -7878.869)"
							fill="none"
						/>
						<path
							id="add_task_FILL1_wght500_GRAD0_opsz24-2"
							data-name="add_task_FILL1_wght500_GRAD0_opsz24"
							d="M78.168-877.937l-2.921-2.921,1.051-1.055,1.87,1.87,6.768-6.784,1.055,1.055Z"
							transform="translate(-13713.141 -7878.323)"
							fill="currentColor"
						/>
					</g>
				</g>
				<rect
					id="Rectangle_3067"
					data-name="Rectangle 3067"
					width="26"
					height="26"
					transform="translate(-13710 -8667.5)"
					fill="none"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LicenseIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<rect id="Rectangle_3023" data-name="Rectangle 3023" width="26" height="26" fill="none" />
		<g id="devices_black_24dp" transform="translate(1 1)">
			<path id="Path_6934" data-name="Path 6934" d="M0,0H24V24H0Z" fill="none" />
			<path
				id="Path_6935"
				data-name="Path 6935"
				d="M4,6H22V4H4A2.006,2.006,0,0,0,2,6V17H0v3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z"
				// fill="#323232"
			/>
		</g>
	</SvgIcon>
);

export const LicenseIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26 26">
		<rect id="Rectangle_3023" data-name="Rectangle 3023" width="26" height="26" fill="none" />
		<g id="devices_black_24dp" transform="translate(1 1)">
			<path id="Path_6934" data-name="Path 6934" d="M0,0H24V24H0Z" fill="none" />
			<path
				id="Path_6935"
				data-name="Path 6935"
				d="M4,6H22V4H4A2.006,2.006,0,0,0,2,6V17H0v3H14V17H4ZM23,8H17a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9A1,1,0,0,0,23,8Zm-1,9H18V10h4Z"
				// fill="#323232"
			/>
		</g>
	</SvgIcon>
);

export const TransferIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" height="24" width="24" {...props}>
		<path d="m480-320 160-160-160-160-56 56 64 64H320v80h168l-64 64 56 56Zm0 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
	</SvgIcon>
);

export const RolesIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.127 26.43" {...props}>
		<g transform="translate(.125)">
			<path fill="none" d="M0 0H26.001V26.43H0z" data-name="Rectangle 2207" transform="translate(.001)" />
			<g fill="currentColor" data-name="Group 4722" transform="translate(-59.501 -973.001)">
				<path
					stroke="currentColor"
					strokeWidth="0.25"
					d="M78.621 997.431H61.378a1.857 1.857 0 01-1.877-1.877 7.225 7.225 0 01.329-1.99c.325-1.41 3.327-2.479 6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152 3.152 0 01-.884-1.106.562.562 0 01-.114-.169.567.567 0 00-.108-.164 5.985 5.985 0 01-.774-1.435 2.968 2.968 0 01-.658-.549 5.62 5.62 0 01-.667-2.99 1.33 1.33 0 01.551-.552 6.125 6.125 0 011.439-4.31v-.223a1.817 1.817 0 011.549-1.1.858.858 0 01.105-.442 1.534 1.534 0 01.778-.884h.007a.4.4 0 01.321.11l.223.219c0 .113.217.222.661.332a15.4 15.4 0 011.653.541h.01l.027.01c.12.045.223.084.3.11 2.008.777 3.206 2.884 3.206 5.635a.9.9 0 01.55.548 5.42 5.42 0 01-.55 2.991 1.356 1.356 0 01-.551.552 6.461 6.461 0 01-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568 0 00-.223.442 3.951 3.951 0 01-.755.978l-.02.02a3.188 3.188 0 00.552 2.1c.417.165.9.331 1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477 2.477 0 00.424-.537 1.251 1.251 0 01.333-.771.8.8 0 01.219-.442 2.011 2.011 0 00.361-.6l.01-.022.071-.151.223-.332.328-.223.11-.11a4.457 4.457 0 00.555-1.99l-.665-.219v-.774a5.948 5.948 0 00-.69-2.941 3.881 3.881 0 00-1.852-1.7h0a.539.539 0 01-.327-.109 6.549 6.549 0 00-1.549-.555 1.614 1.614 0 01-.529-.133l-.02-.007a8.103 8.103 0 00-.226-.079v.774l-.884.219a1.216 1.216 0 00-.665.223v.442l-.328.333a4.807 4.807 0 00-1.106 3.535v.665l-.552.329a3.57 3.57 0 00.552 1.881l.219.219.332.223.223.442a3.445 3.445 0 00.539 1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792 2.792 0 00.551.771l.556.333-.113.665c0 .987-.377 2.565-1.217 2.984h-.219l-.442.109c-3.6 1.122-5.536 2.014-5.748 2.652a4.473 4.473 0 00-.332 1.658.752.752 0 00.773.774h17.353a.752.752 0 00.774-.774c0-.091 0-.178-.008-.276h1c.009.137.009.259.009.389a1.859 1.859 0 01-1.883 1.874z"
					data-name="Subtraction 10"
				/>
				<path
					d="M-1270.261 2083.955l-.438-1.085h-.093a3.506 3.506 0 01-.915-.123 5.034 5.034 0 01-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312 3.312 0 01-.49-1.027 3.177 3.177 0 01-.081-.831v-.223l-1.113-.362.344-1.613 1.206.158a2.507 2.507 0 01.583-.818 2.788 2.788 0 01.868-.633l-.142-1.2 1.589-.355.438 1.086h.168a3.128 3.128 0 01.916.119 3.227 3.227 0 01.788.293c.077.037.158.076.248.117l.972-.834 1.038 1.064-.765 1.028a3.305 3.305 0 01.474 1.036c.079.349.129.636.182.94l.018.1 1.113.362-.344 1.613-1.206-.158-.078.127a3.474 3.474 0 01-.533.723 2.633 2.633 0 01-.84.6l.142 1.2-1.588.355zm-.634-7.635a2.754 2.754 0 00-2.75 2.75 2.753 2.753 0 002.75 2.75 2.753 2.753 0 002.75-2.75 2.753 2.753 0 00-2.75-2.75z"
					data-name="Subtraction 11"
					transform="translate(1350.316 -1089.749)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RolesIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26.278 26.43">
		<style type="text/css">{`.role-line-st0{fill:currentColor;}`}</style>
		<g id="user-roles-icon-outline" transform="translate(0.125)">
			<rect
				id="Rectangle_2207"
				data-name="Rectangle 2207"
				width="26.002"
				height="26.43"
				transform="translate(0.001)"
				fill="none"
			/>
			<g id="Group_4722" data-name="Group 4722" transform="translate(-59.501 -973.001)">
				<path
					className="role-line-st0"
					id="Subtraction_10"
					data-name="Subtraction 10"
					d="M14085.121-6126.569h-17.243a1.857,1.857,0,0,1-1.877-1.877,7.225,7.225,0,0,1,.329-1.99c.325-1.41,3.327-2.479,6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152,3.152,0,0,1-.884-1.106.562.562,0,0,1-.114-.169.567.567,0,0,0-.108-.164,5.985,5.985,0,0,1-.774-1.435,2.968,2.968,0,0,1-.658-.549,5.62,5.62,0,0,1-.667-2.99,1.33,1.33,0,0,1,.551-.552,6.125,6.125,0,0,1,1.439-4.31v-.223a1.817,1.817,0,0,1,1.549-1.1.858.858,0,0,1,.105-.442,1.534,1.534,0,0,1,.778-.884h.007a.4.4,0,0,1,.321.11l.223.219c0,.113.217.222.661.332a15.4,15.4,0,0,1,1.653.541l.01,0,.027.01c.12.045.223.084.3.11,2.008.777,3.206,2.884,3.206,5.635a.9.9,0,0,1,.55.548,5.42,5.42,0,0,1-.55,2.991,1.356,1.356,0,0,1-.551.552,6.461,6.461,0,0,1-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568,0,0,0-.223.442,3.951,3.951,0,0,1-.755.978l-.02.02a3.188,3.188,0,0,0,.552,2.1c.417.165.9.331,1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477,2.477,0,0,0,.424-.537,1.251,1.251,0,0,1,.333-.771.8.8,0,0,1,.219-.442,2.011,2.011,0,0,0,.361-.6l.01-.022c.025-.054.048-.1.071-.151l.223-.332.328-.223.11-.11a4.457,4.457,0,0,0,.555-1.99l-.665-.219v-.774a5.948,5.948,0,0,0-.69-2.941,3.881,3.881,0,0,0-1.852-1.7h0a.539.539,0,0,1-.327-.109,6.549,6.549,0,0,0-1.549-.555,1.614,1.614,0,0,1-.529-.133l-.02-.007c-.071-.026-.145-.052-.226-.079v.774l-.884.219a1.216,1.216,0,0,0-.665.223v.442l-.328.333a4.807,4.807,0,0,0-1.106,3.535v.665l-.552.329a3.57,3.57,0,0,0,.552,1.881l.219.219.332.223.223.442a3.445,3.445,0,0,0,.539,1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792,2.792,0,0,0,.551.771l.556.333-.113.665c0,.987-.377,2.565-1.217,2.984h-.219l-.442.109c-3.6,1.122-5.536,2.014-5.748,2.652a4.473,4.473,0,0,0-.332,1.658.752.752,0,0,0,.773.774h17.353a.752.752,0,0,0,.774-.774c0-.091,0-.178-.008-.276h1c.009.137.009.259.009.389A1.859,1.859,0,0,1,14085.121-6126.569Z"
					transform="translate(-14006.5 7124)"
					stroke="currentColor"
					strokeWidth="0.25"
				/>
				<path
					className="role-line-st0"
					id="Subtraction_11"
					data-name="Subtraction 11"
					d="M-1270.261,2083.955h0l-.438-1.085h-.093a3.506,3.506,0,0,1-.915-.123,5.034,5.034,0,0,1-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312,3.312,0,0,1-.49-1.027,3.177,3.177,0,0,1-.081-.831c0-.077,0-.15,0-.223l-1.113-.362.344-1.613,1.206.158a2.507,2.507,0,0,1,.583-.818,2.788,2.788,0,0,1,.868-.633l-.142-1.2,1.589-.355.438,1.086c.053,0,.109,0,.168,0a3.128,3.128,0,0,1,.916.119,3.227,3.227,0,0,1,.788.293c.077.037.158.076.248.117l.972-.834,1.038,1.064-.765,1.028a3.305,3.305,0,0,1,.474,1.036c.079.349.129.636.182.94l.018.1,1.113.362-.344,1.613-1.206-.158-.078.127a3.474,3.474,0,0,1-.533.723,2.633,2.633,0,0,1-.84.6l.142,1.2-1.588.355Zm-.634-7.635a2.754,2.754,0,0,0-2.75,2.75,2.753,2.753,0,0,0,2.75,2.75,2.753,2.753,0,0,0,2.75-2.75A2.753,2.753,0,0,0-1270.895,2076.32Z"
					transform="translate(1350.317 -1089.749)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const RolesIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 26.278 26.43">
		<style type="text/css">{`.role-fill-st0{fill:currentColor;}`}</style>
		<g id="user-roles-icon-filled" transform="translate(0.125)">
			<g id="user-roles-icon-light-mode">
				<rect
					id="Rectangle_2207"
					data-name="Rectangle 2207"
					width="26.002"
					height="26.43"
					transform="translate(0.001)"
					fill="none"
				/>
				<g id="Group_4722" data-name="Group 4722" transform="translate(-59.501 -973.001)">
					<path
						className="role-fill-st0"
						id="Subtraction_10"
						data-name="Subtraction 10"
						d="M14085.121-6126.569h-17.243a1.857,1.857,0,0,1-1.877-1.877,7.225,7.225,0,0,1,.329-1.99c.325-1.41,3.327-2.479,6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.152,3.152,0,0,1-.884-1.106.562.562,0,0,1-.114-.169.567.567,0,0,0-.108-.164,5.985,5.985,0,0,1-.774-1.435,2.968,2.968,0,0,1-.658-.549,5.62,5.62,0,0,1-.667-2.99,1.33,1.33,0,0,1,.551-.552,6.125,6.125,0,0,1,1.439-4.31v-.223a1.817,1.817,0,0,1,1.549-1.1.858.858,0,0,1,.105-.442,1.534,1.534,0,0,1,.778-.884h.007a.4.4,0,0,1,.321.11l.223.219c0,.113.217.222.661.332a15.4,15.4,0,0,1,1.653.541l.01,0,.027.01c.12.045.223.084.3.11,2.008.777,3.206,2.884,3.206,5.635a.9.9,0,0,1,.55.548,5.42,5.42,0,0,1-.55,2.991,1.356,1.356,0,0,1-.551.552,6.461,6.461,0,0,1-.468.892l-.008.013c-.118.2-.215.362-.3.53a.568.568,0,0,0-.223.442,3.951,3.951,0,0,1-.755.978l-.02.02a3.188,3.188,0,0,0,.552,2.1c.417.165.9.331,1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.477,2.477,0,0,0,.424-.537,1.251,1.251,0,0,1,.333-.771.8.8,0,0,1,.219-.442,2.011,2.011,0,0,0,.361-.6l.01-.022c.025-.054.048-.1.071-.151l.223-.332.328-.223.11-.11a4.457,4.457,0,0,0,.555-1.99l-.665-.219v-.774a5.948,5.948,0,0,0-.69-2.941,3.881,3.881,0,0,0-1.852-1.7h0a.539.539,0,0,1-.327-.109,6.549,6.549,0,0,0-1.549-.555,1.614,1.614,0,0,1-.529-.133l-.02-.007c-.071-.026-.145-.052-.226-.079v.774l-.884.219a1.216,1.216,0,0,0-.665.223v.442l-.328.333a4.807,4.807,0,0,0-1.106,3.535v.665l-.552.329a3.57,3.57,0,0,0,.552,1.881l.219.219.332.223.223.442a3.445,3.445,0,0,0,.539,1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.792,2.792,0,0,0,.551.771l.556.333-.113.665c0,.987-.377,2.565-1.217,2.984h-.219l-.442.109c-3.6,1.122-5.536,2.014-5.748,2.652a4.473,4.473,0,0,0-.332,1.658.752.752,0,0,0,.773.774h17.353a.752.752,0,0,0,.774-.774c0-.091,0-.178-.008-.276h1c.009.137.009.259.009.389A1.859,1.859,0,0,1,14085.121-6126.569Z"
						transform="translate(-14006.5 7124)"
						stroke="currentColor"
						strokeWidth="0.25"
					/>
					<path
						className="role-fill-st0"
						id="Subtraction_11"
						data-name="Subtraction 11"
						d="M-1270.261,2083.955h0l-.438-1.085h-.093a3.506,3.506,0,0,1-.915-.123,5.034,5.034,0,0,1-1.111-.405l-.976.735-1.138-1.061.769-.927a3.312,3.312,0,0,1-.49-1.027,3.177,3.177,0,0,1-.081-.831c0-.077,0-.15,0-.223l-1.113-.362.344-1.613,1.206.158a2.507,2.507,0,0,1,.583-.818,2.788,2.788,0,0,1,.868-.633l-.142-1.2,1.589-.355.438,1.086c.053,0,.109,0,.168,0a3.128,3.128,0,0,1,.916.119,3.227,3.227,0,0,1,.788.293c.077.037.158.076.248.117l.972-.834,1.038,1.064-.765,1.028a3.305,3.305,0,0,1,.474,1.036c.079.349.129.636.182.94l.018.1,1.113.362-.344,1.613-1.206-.158-.078.127a3.474,3.474,0,0,1-.533.723,2.633,2.633,0,0,1-.84.6l.142,1.2-1.588.355Zm-.634-7.635a2.754,2.754,0,0,0-2.75,2.75,2.753,2.753,0,0,0,2.75,2.75,2.753,2.753,0,0,0,2.75-2.75A2.753,2.753,0,0,0-1270.895,2076.32Z"
						transform="translate(1350.317 -1089.749)"
					/>
				</g>
			</g>
			<path
				className="role-fill-st0"
				id="Path_6929"
				data-name="Path 6929"
				d="M2123.375-1671.262l1.449.526,1.814.833,1.108.838.545.883.591,1.373.36,1.406-.36.955.922.685-.264,1.422-.658,1.11-.791,1-.346,1.014-.847,1.073v1.285l.59,1.085,1.007.543.873-.3a3.3,3.3,0,0,0,.437,3.162c1.166,1.38,4.106,1.409,4.106,1.409l.73.393-.187.783-.684.684h-1.9l-16.511.028s-.839-.374-.867-1.1a3.61,3.61,0,0,1,.343-1.942,3.366,3.366,0,0,1,1.868-1.776c.815-.173,2.464-.887,3.471-1.251s1.929-.47,2.115-1.325a4.455,4.455,0,0,0,.177-1.808,26.856,26.856,0,0,1-1.854-2.6c-.305-.749-1.065-1.356-1.121-2.013s-.332-1.344-.179-1.634a3.34,3.34,0,0,0,.6-1.369,4.855,4.855,0,0,1,.7-2.4c.513-.69.47-1.413.971-1.621s1.333-.571,1.333-.571Z"
				transform="translate(-2113.999 1673)"
			/>
		</g>
	</SvgIcon>
);

export const UserIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">{`.user-line-st0{fill:currentColor;}`}</style>
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					className="user-line-st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const UserIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 22 22">
		<style type="text/css">{`.user-fill-st0{fill:currentColor;}`}</style>
		<g id="Layer_2" />
		<g id="Layer_1">
			<g>
				<path
					className="user-fill-st0"
					d="M3.2,21.1c-0.8,0-1.2-0.6-1.2-1.2c0-0.2,0-0.8,0.3-1.7c0.3-1.2,4.1-2.3,5.6-2.8l0.4-0.1l0,0
			C9,15,9.2,13.4,9.2,13l0-0.3L9,12.6c-0.2-0.1-0.4-0.4-0.6-0.8l0-0.1l0,0c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.6-1.1L7.4,10
			L7.2,10C7.1,9.9,7,9.7,6.8,9.6C6.4,8.8,6.2,7.8,6.3,7.4c0.1-0.1,0.2-0.2,0.2-0.2L6.8,7V6.7c0-2.2,0.8-3.2,1.2-3.5L8.1,3V2.7
			c0.2-0.4,0.7-0.6,1-0.6L9.5,2V1.6c0-0.1,0-0.1,0-0.2C9.6,1.2,9.7,1.1,9.8,1l0,0c0.2,0.3,0.6,0.4,0.9,0.5c0.6,0.1,1.1,0.3,1.4,0.5
			C12.3,2,12.5,2,12.5,2.1c1.6,0.6,2.6,2.4,2.6,4.6v0.4l0.3,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.2-0.1,1.3-0.5,2.3
			c0,0.1-0.2,0.2-0.3,0.3L14.7,10l-0.1,0.2c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1,0.1-0.2,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.6
			c-0.2,0.3-0.4,0.5-0.6,0.7L13,12.8V13c0,0.9,0.3,2.1,0.8,2.3c0.6,0.2,1.2,0.4,1.9,0.6c1.4,0.4,3.8,1.1,4.1,2.2
			c0.3,1.1,0.3,1.3,0.3,1.7c0,0.6-0.4,1.2-1.2,1.2H3.2z"
				/>
				<path
					className="user-fill-st0"
					d="M10,1.7c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0.1,1,0.3,1.4,0.5c0.1,0.1,0.3,0.1,0.3,0.1c1.4,0.6,2.3,2.1,2.3,4.2v0.7
			l0.6,0.2c0,0.3-0.1,1.1-0.5,1.8c0,0,0,0-0.1,0.1l-0.3,0.2L14.2,10c-0.1,0.2-0.2,0.5-0.4,0.7c-0.1,0.1-0.2,0.3-0.2,0.4
			c-0.1,0.1-0.3,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.5l-0.3,0.3V13c0,0.2,0,2.3,1.1,2.8l0,0l0,0c0.5,0.2,1.2,0.4,1.9,0.6
			c1.1,0.3,3.5,1.1,3.7,1.9c0.3,1,0.3,1.2,0.3,1.5c0,0.3-0.2,0.7-0.7,0.7H3.2c-0.5,0-0.7-0.4-0.7-0.7c0-0.2,0-0.7,0.3-1.5l0,0l0,0
			c0.1-0.3,0.7-1,5.2-2.4l0.4-0.1l0.1,0l0.1,0c0.8-0.4,1.1-1.9,1.1-2.7l0.1-0.6l-0.5-0.3c-0.1-0.1-0.3-0.3-0.5-0.7l-0.1-0.1l0,0
			c0-0.1-0.1-0.2-0.2-0.3c-0.2-0.3-0.4-0.6-0.5-1L7.8,9.7L7.5,9.5c0,0-0.1-0.1-0.2-0.2C6.9,8.7,6.8,8,6.8,7.6l0.5-0.3V6.7
			c0-2,0.7-2.9,1-3.2l0.3-0.3V2.8C8.7,2.7,9,2.6,9.2,2.6L10,2.4L10,1.7 M9.8,0.4C9.5,0.5,9.2,0.9,9.1,1.2C9,1.4,9,1.5,9,1.6
			C8.4,1.7,7.8,2,7.6,2.6c0,0.1,0,0.1,0,0.2c-0.7,0.7-1.3,2-1.3,3.9C6.1,6.8,5.9,7,5.8,7.2C5.7,7.7,5.9,9,6.4,9.9
			c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.5,0.4,0.9,0.7,1.3c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.5,0.5,0.8,0.8,1c-0.1,1.1-0.4,1.8-0.6,1.9
			L7.7,15c-2.7,0.8-5.6,1.8-5.9,3.1c-0.3,1-0.3,1.7-0.3,1.8c0,0.9,0.7,1.7,1.7,1.7h15.6c1,0,1.7-0.8,1.7-1.7c0-0.4,0-0.7-0.3-1.8
			c-0.3-1.3-2.4-2-4.4-2.6c-0.7-0.2-1.3-0.4-1.8-0.6c-0.2-0.1-0.5-0.9-0.5-1.9c0.2-0.2,0.5-0.5,0.7-0.9c0-0.2,0.1-0.3,0.2-0.4
			c0.2-0.4,0.5-0.8,0.7-1.3c0.2-0.1,0.4-0.3,0.5-0.5C16,9,16.3,7.7,16.1,7.2C16,7,15.9,6.8,15.6,6.7c0-2.5-1.1-4.4-2.9-5.1
			c-0.3-0.1-1-0.4-1.8-0.6c-0.4-0.1-0.6-0.2-0.6-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C10,0.4,9.9,0.4,9.8,0.4L9.8,0.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const FormIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">
			{`.form-line-st0{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.form-line-st1{fill:currentColor;}`}
		</style>
		<rect x="3.7" y="3.7" className="form-line-st0" width="16.6" height="16.7" />
		<rect x="7" y="7" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="7" className="form-line-st1" width="6" height="1.9" />
		<rect x="7" y="11" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="11" className="form-line-st1" width="6" height="1.9" />
		<rect x="7" y="15" className="form-line-st1" width="2" height="1.9" />
		<rect x="11" y="15" className="form-line-st1" width="6" height="1.9" />
	</SvgIcon>
);

export const FormIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<style type="text/css">
			{`.form-fill-st0{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1{fill:currentColor;}`}
		</style>
		<rect x="3.7" y="3.7" className="form-fill-st0" width="16.6" height="16.7" />
		<path
			className="form-fill-st1"
			d="M20,20.1H4V3.9h16V20.1z M9,7H7V9h2V7z M17,7h-6V9h6V7z M9,11H7v1.9h2V11z M17,11h-6v1.9h6V11z M9,15H7v1.9h2
	V15z M17,15h-6v1.9h6V15z"
		/>
	</SvgIcon>
);

export const LogIconLine = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.log-line-st0{display:none;}
	.log-line-st1{display:inline;fill:currentColor;}
	.log-line-st2{fill:none;stroke:currentColor;stroke-width:0.9615;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2" className="log-line-st0">
			<polygon className="log-line-st1" points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9 	" />
		</g>
		<g id="Layer_1">
			<polyline className="log-line-st2" points="13.4,3.3 15.1,3.3 15.1,13.5 0.7,13.5 0.7,3.3 2.4,3.3 	" />
			<g>
				<path
					className="log-line-st2"
					d="M7.9,3.3c0,0,1.3-0.8,2.6-1.1c1.4-0.3,2.7-0.2,2.7-0.2v10.2v0c0,0-1.4-0.1-2.7,0.2c-1.3,0.3-2.6,1.1-2.6,1.1
			V3.3z"
				/>
				<path
					className="log-line-st2"
					d="M7.9,13.5V3.3c0,0-1.3-0.8-2.6-1.1C3.9,1.8,2.6,1.9,2.6,1.9v10.2v0c0,0,1.4-0.1,2.7,0.2
			C6.6,12.7,7.9,13.5,7.9,13.5L7.9,13.5z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LogIconFill = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 16 16">
		<style type="text/css">
			{`
	.log-fill-st0{fill:currentColor;}
	.log-fill-st1{fill:none;stroke:currentColor;stroke-width:0.9615;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}`}
		</style>
		<g id="Layer_2">
			<polygon className="log-fill-st0" points="2.8,1.8 2.5,12 7.9,13.4 13.1,11.9 13.1,1.7 7.9,2.9 	" />
		</g>
		<g id="Layer_1">
			<polyline className="log-fill-st1" points="13.4,3.3 15.1,3.3 15.1,13.5 0.7,13.5 0.7,3.3 2.4,3.3 	" />
			<g>
				<path
					className="log-fill-st1"
					d="M7.9,3.3c0,0,1.3-0.8,2.6-1.1c1.4-0.3,2.7-0.2,2.7-0.2v10.2v0c0,0-1.4-0.1-2.7,0.2c-1.3,0.3-2.6,1.1-2.6,1.1
			V3.3z"
				/>
				<path
					className="log-fill-st1"
					d="M7.9,13.5V3.3c0,0-1.3-0.8-2.6-1.1C3.9,1.8,2.6,1.9,2.6,1.9v10.2v0c0,0,1.4-0.1,2.7,0.2
			C6.6,12.7,7.9,13.5,7.9,13.5L7.9,13.5z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const BellIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			transform="rotate(20 12 12)"
			fill="currentColor"
			d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21"
		/>
	</SvgIcon>
);

export const AddToGroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M2,16H10V14H2M18,14V10H16V14H12V16H16V20H18V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z"
		/>
	</SvgIcon>
);

export const AddToDeviceGroupIcon = AddToGroupIcon;

export const AddToFormGroupIcon = AddToDeviceGroupIcon;

export const AddToWorkflowGroupIcon = AddToDeviceGroupIcon;

export const AddToUserGroupIcon = AddToDeviceGroupIcon;

export const LicenseGroupIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
		<g id="Layer_2">
			<rect
				x="3.8"
				y="2.7"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="12.1"
			/>
			<rect
				x="1.5"
				y="10.8"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="13"
				y="11"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="5.2"
				y="9.4"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7.2"
				height="3.4"
			/>
			<rect
				x="4.6"
				y="11"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="3.8"
			/>
			<rect
				x="9.5"
				y="10.8"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="2.9"
				height="3.8"
			/>
			<rect
				x="4.5"
				y="1.2"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7"
				height="3.2"
			/>
			<rect
				x="10.8"
				y="2.7"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="1.6"
				height="7.1"
			/>
			<rect
				x="7.1"
				y="4.2"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="2"
				height="5.4"
			/>
			<rect
				x="4.2"
				y="5.9"
				style={{ fill: 'currentColor' }}
				className="st0-LicenseGroupIcon"
				width="7"
				height="2"
			/>
		</g>
		<g id="Layer_1">
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M3.4,10.6c-0.6,0.1-1.5,0.2-2.2,0.4v4"
			/>
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M12.8,15l0-12.5c-0.6-0.1-0.7-0.2-1.3-0.3v-1C10.2,1.1,9.2,1,8.1,1C7,1,6,1.1,4.7,1.4v1C4.2,2.4,4,2.5,3.4,2.6   l0,12.5"
			/>
			<rect
				x="5.4"
				y="7.9"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="5.4"
				y="4.3"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="7.9"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<rect
				x="9.2"
				y="4.3"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				width="1.6"
				height="1.6"
			/>
			<path
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				d="M12.8,10.6c0.6,0.1,1.5,0.2,2.2,0.4v4"
			/>
			<path
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				d="M9.6,15v-2.2c-0.7-0.2-1.3-0.2-1.7-0.2c-0.5,0-1.2,0.1-1.7,0.2V15"
			/>
			<line
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: 0.5,
					strokeLinejoin: 'round',
					strokeMiterlimit: 10,
				}}
				className="st2-LicenseGroupIcon"
				x1="8"
				y1="15"
				x2="8"
				y2="12.6"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeLinejoin: 'round', strokeMiterlimit: 10 }}
				className="st1-LicenseGroupIcon"
				x1="0.5"
				y1="15"
				x2="15.7"
				y2="15"
			/>
		</g>
	</SvgIcon>
);

export const ClearSelectedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			fill="currentColor"
			d="M4 20H18V22H4C2.9 22 2 21.11 2 20V6H4V20M20.22 2H7.78C6.8 2 6 2.8 6 3.78V16.22C6 17.2 6.8 18 7.78 18H20.22C21.2 18 22 17.2 22 16.22V3.78C22 2.8 21.2 2 20.22 2M19 13.6L17.6 15L14 11.4L10.4 15L9 13.6L12.6 10L9 6.4L10.4 5L14 8.6L17.6 5L19 6.4L15.4 10L19 13.6Z"
		/>
	</SvgIcon>
);

export const ExpiredIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon className={clsx('mdi-svg-icon', props.className)} path={mdiIcons.mdiClockAlert} {...props} />
);

export const LogoutIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 48 48">
		<g>
			<path
				d="M28.9,28.5c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.7-0.4,1.1v7h-17V11h17v7c0,0.5,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.1,0.4
                  c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.7,0.4-1.1v-7c0-0.8-0.3-1.5-0.9-2.1C28.9,8.3,28.2,8,27.4,8h-17C9.6,8,8.9,8.3,8.3,8.9
                  C7.7,9.5,7.4,10.2,7.4,11v26c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h17c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1v-7
                  c0-0.5-0.1-0.8-0.4-1.1C29.7,28.6,29.3,28.5,28.9,28.5z"
			/>
			<path
				d="M42.2,24c0-0.4-0.2-0.7-0.4-1c0,0,0-0.1-0.1-0.1L35,16.3c-0.3-0.3-0.7-0.5-1.1-0.5c-0.4,0-0.8,0.2-1.1,0.5
                c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.4,0.1,0.7,0.4,1l4.1,4.1H16.4c-0.5,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.4,0.6-0.4,1.1s0.1,0.8,0.4,1.1
                c0.3,0.3,0.7,0.4,1.1,0.4h20.5l-4.1,4.1c-0.3,0.3-0.4,0.7-0.4,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.2,0.6,0.4,1.1,0.4
                c0.4,0,0.7-0.1,1-0.4l6.8-6.8C42,24.7,42.2,24.4,42.2,24z"
			/>
		</g>
	</SvgIcon>
);

export const BlockUserIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon className="mdi-svg-icon" path={mdiIcons.mdiAccountCancelOutline} {...props} />
);

export const BulkActionCloseIcon = () => (
	// {/* <ClearSelectedIcon /> */}
	<LibraryAddCheckOutlined />
);

export const SortLabelIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 320 512">
		<path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z" />
	</SvgIcon>
);

export const GroupIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0V0z" fill="none" />
		<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
		<circle cx="8" cy="14" r="2" />
		<circle cx="12" cy="8" r="2" />
		<circle cx="16" cy="14" r="2" />
	</SvgIcon>
);

export const TrayArrowDownIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" />
	</SvgIcon>
);

export const TrayArrowUpIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="m 2 12 H 4 V 17 H 20 V 12 H 22 V 17 C 22 18.11 21.11 19 20 19 H 4 C 2.9 19 2 18.11 2 17 V 12 M 12 2 L 17.55 7.45 L 16.13 8.87 L 13 5.75 V 15 H 11 V 5.75 L 8 8.87 L 6.46 7.45 L 12 2 Z" />
	</SvgIcon>
);

export const CopyIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
	</SvgIcon>
);

export const DesignIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M20.97 7.27c.39-.39.39-1.02 0-1.41l-2.83-2.83a.9959.9959 0 0 0-1.41 0l-4.49 4.49-3.89-3.89c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l3.89 3.89L3 16.76V21h4.24l4.52-4.52 3.89 3.89c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-3.89-3.89 4.48-4.48zM5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.2 1.2-1.9 1.9-3.88-3.88zm11.23 7.44-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9-3.89-3.89 1.9-1.9 1.21 1.21zM6.41 19H5v-1.41l9.61-9.61 1.3 1.3.11.11L6.41 19zm9.61-12.44 1.41-1.41 1.41 1.41-1.41 1.41-1.41-1.41z" />
	</SvgIcon>
);

export const PreviewAppIcon = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<rect id="Rectangle_574" data-name="Rectangle 574" width="24" height="24" fill="none" />
		<path
			id="Path_6040"
			data-name="Path 6040"
			d="M19,3H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2,2,0,0,0,19,3Zm0,16H5V7H19Zm-7-8.5A4.927,4.927,0,0,1,16.34,13a5.017,5.017,0,0,1-8.68,0A4.927,4.927,0,0,1,12,10.5M12,9a6.445,6.445,0,0,0-6,4,6.5,6.5,0,0,0,12,0,6.445,6.445,0,0,0-6-4Zm0,5.5A1.5,1.5,0,1,1,13.5,13,1.5,1.5,0,0,1,12,14.5Z"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const WorkflowPreviewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 96.8 88.595" {...props}>
		<g id="wfx-empty" transform="translate(-1.9 -5.902)" opacity="0.4">
			<g id="Group_1096" data-name="Group 1096">
				<path
					id="Path_6404"
					data-name="Path 6404"
					d="M39.8,47.9,55,32.7a2.587,2.587,0,0,1,1.8-.7h9a28.6,28.6,0,0,1-1.9,6.6c-1.7,3.8.8,6.7,4.3,5S98.7,25,98.7,25,71.7,8,68.2,6.4c-3.4-1.7-5.9,1.2-4.3,5a27.818,27.818,0,0,1,1.8,6.5H56.8a16.176,16.176,0,0,0-11.7,4.9L27.6,40.2C32.9,41.1,36.5,44.6,39.8,47.9Z"
					fill="currentColor"
				/>
			</g>
			<path
				id="Path_6405"
				data-name="Path 6405"
				d="M68.2,56.7c-3.4-1.7-5.9,1.2-4.3,5a34.6,34.6,0,0,1,1.9,6.6h-9a2.748,2.748,0,0,1-1.8-.7L39.4,51.9c-4.2-4.2-8-8.8-14.5-8.8H1.9V57.2H20c5.5,0,8,3.3,9.4,4.7L45.1,77.6a16.585,16.585,0,0,0,11.7,4.9h8.9A35.893,35.893,0,0,1,63.9,89c-1.7,3.8.8,6.7,4.3,5S98.7,75.4,98.7,75.4,71.7,58.3,68.2,56.7Z"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const WorkflowActivityLogIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 99 99" {...props}>
		<g id="menu_book_black_24dp" opacity="0.41">
			<g id="Group_1092" data-name="Group 1092">
				<rect id="Rectangle_910" data-name="Rectangle 910" width="99" height="99" fill="none" />
			</g>
			<g id="Group_1095" data-name="Group 1095" transform="translate(4.125 18.563)">
				<g id="Group_1094" data-name="Group 1094">
					<path
						id="Path_6400"
						data-name="Path 6400"
						d="M83.5,6.563A48.694,48.694,0,0,0,69.063,4.5c-8.044,0-16.706,1.65-22.687,6.188C40.394,6.15,31.731,4.5,23.688,4.5S6.981,6.15,1,10.688V71.119a2.218,2.218,0,0,0,2.063,2.063c.412,0,.619-.206,1.031-.206a50.348,50.348,0,0,1,19.594-4.537c8.044,0,16.706,1.65,22.688,6.188,5.569-3.506,15.675-6.187,22.688-6.187,6.806,0,13.819,1.237,19.594,4.331a1.859,1.859,0,0,0,1.031.206,2.218,2.218,0,0,0,2.063-2.062V10.688A28.135,28.135,0,0,0,83.5,6.563Zm0,55.688a47.934,47.934,0,0,0-14.437-2.062c-7.012,0-17.119,2.681-22.687,6.188V18.938c5.569-3.506,15.675-6.187,22.688-6.187A47.934,47.934,0,0,1,83.5,14.813Z"
						transform="translate(-1 -4.5)"
						fill="currentColor"
					/>
					<g id="Group_1093" data-name="Group 1093" transform="translate(49.5 18.563)">
						<path
							id="Path_6401"
							data-name="Path 6401"
							d="M31.563,15.188A48.238,48.238,0,0,1,41.875,16.26V9.99A55.7,55.7,0,0,0,31.563,9,47.466,47.466,0,0,0,13,12.424v6.847C17.661,16.631,24.137,15.188,31.563,15.188Z"
							transform="translate(-13 -9)"
							fill="currentColor"
						/>
						<path
							id="Path_6402"
							data-name="Path 6402"
							d="M13,15.084v6.847c4.661-2.64,11.137-4.084,18.563-4.084A48.238,48.238,0,0,1,41.875,18.92V12.65a55.7,55.7,0,0,0-10.312-.99A48.226,48.226,0,0,0,13,15.084Z"
							transform="translate(-13 -0.688)"
							fill="currentColor"
						/>
						<path
							id="Path_6403"
							data-name="Path 6403"
							d="M31.563,14.33A47.466,47.466,0,0,0,13,17.754V24.6c4.661-2.64,11.137-4.084,18.563-4.084A48.238,48.238,0,0,1,41.875,21.59V15.32A52.375,52.375,0,0,0,31.563,14.33Z"
							transform="translate(-13 7.656)"
							fill="currentColor"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const LicenseIcon = (props: SvgIconProps) => {
	const style = `
		.st0-LicenseIcon{fill:none;}
		.st1-LicenseIcon{display:none;}
	`;
	return (
		<SvgIcon x="0px" y="0px" viewBox="0 0 20 20" {...props}>
			<style type="text/css">{style}</style>
			<g id="Layer_1">
				<g>
					<g>
						<path
							d="M18.7,8.2l-1.9-2.1l0.3-2.8l-2.8-0.6l-1.4-2.4l-2.6,1.1L7.7,0.2L6.2,2.6L3.5,3.2l0.3,2.8L1.9,8.2l1.9,2.1l-0.3,2.8
							l2.8,0.6l1.4,2.4l2.6-1.1l2.6,1.1l1.4-2.4l2.8-0.6l-0.3-2.8L18.7,8.2z M15.7,9.3l-0.4,0.5l0.1,0.7l0.1,1.5L14,12.3l-0.6,0.1
							L13,13l-0.8,1.3l-1.4-0.6l-0.6-0.3l-0.6,0.3l-1.4,0.6L7.6,13l-0.3-0.6l-0.6-0.1L5.1,12l0.1-1.5l0.1-0.7L4.9,9.3l-1-1.1l1-1.1
							l0.4-0.5L5.3,5.9L5.1,4.4l1.5-0.3L7.2,4l0.3-0.6l0.8-1.3l1.4,0.6L10.3,3l0.6-0.3l1.4-0.6L13,3.4L13.3,4L14,4.1l1.5,0.3l-0.1,1.5
							l-0.1,0.7l0.4,0.5l1,1.1L15.7,9.3z"
						/>
						<polygon
							className="st1-LicenseIcon"
							points="8.8,9.5 7.1,7.8 5.9,8.9 8.8,11.8 14.4,6.2 13.3,5"
						/>
					</g>
				</g>
			</g>
			<g id="Layer_2">
				<polygon points="3.3,11.6 0,15.7 3.4,15.9 4,19.8 7.2,16.1 6.5,14.8 4.5,17.1 4.2,14.9 2.5,14.8 3.6,13.5 3.2,13.4" />
				<polygon points="17.2,11.6 20,15.3 17.1,15.9 16.7,19.7 13.3,16 14,14.8 16,17 16.3,14.9 17.9,14.6 16.9,13.5 17.3,13.3" />
			</g>
		</SvgIcon>
	);
};

export const SettingsIcon = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2236" />
			<g transform="translate(1 1)">
				<path
					d="M13.307 25.25v-6.914h1.886v2.514H25.25v1.886H15.193v2.514zM3.25 22.736V20.85h6.914v1.886zm5.029-5.029v-2.514H3.25v-1.886h5.029v-2.514h1.886v6.914zm5.029-2.514v-1.886H25.25v1.886zm5.029-5.029V3.25h1.886v2.514h5.027V7.65h-5.029v2.514zM3.25 7.65V5.764h11.943V7.65z"
					transform="translate(-3.25 -3.25)"
				/>
			</g>
		</SvgIcon>
	);
};

export const RunningIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<path id="Path_6010" d="M6.3,6.5l7,4.5l-7,4.5V6.5 M3.6,1.7v18.6L18.3,11L3.6,1.7z" />
	</SvgIcon>
);

export const StoppedIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_8">
			<path id="Path_6012" d="M17.1,4.7V17H4.8V4.7H17.1 M20.2,1.7H1.8v18.4h18.4C20.2,20.1,20.2,1.7,20.2,1.7z" />
		</g>
	</SvgIcon>
);

export const ShareIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<path
			id="Path_6008"
			d="M14.9,10c1.6,0,3-1.3,3-3s-1.3-3-3-3c-1.6,0-3,1.3-3,3S13.2,10,14.9,10L14.9,10z M7,10
	c1.6,0,3-1.3,3-3S8.7,4,7,4S4,5.4,4,7C4,8.7,5.3,10,7,10L7,10z M7,12c-2.3,0-6.9,1.2-6.9,3.5V18h13.8v-2.5C13.9,13.1,9.3,12,7,12z
	 M14.9,12c-0.3,0-0.6,0-1,0c1.2,0.7,1.9,2,1.9,3.4v2.5h5.9v-2.5C21.8,13.1,17.2,12,14.9,12z"
		/>
	</SvgIcon>
);

export const AddIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="add">
			<path
				id="Path_6014"
				fill="currentColor"
				d="M20.4,12.3h-8.1v8.1H9.6v-8.1h-8V9.6h8.1V1.5h2.7v8.1h8.1v2.7H20.4z"
			/>
		</g>
	</SvgIcon>
);

export const PausedIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="pause">
			<path id="Path_6006" fill="currentColor" d="M2.9,20.3h5.4V1.5H2.9V20.3z M13.7,1.5v18.8H19V1.5H13.7z" />
		</g>
	</SvgIcon>
);

export const CopyAltIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="copy">
			<path
				fill="currentColor"
				d="M15,1.3H4.4c-1,0-1.8,0.8-1.8,1.8v12.3h1.8V3.1H15V1.3z M14.1,4.8H7.9c-1,0-1.8,0.8-1.8,1.8v12.3
		c0,1,0.8,1.8,1.8,1.8h9.7c1,0,1.8-0.8,1.8-1.8v-8.8L14.1,4.8z M7.9,18.9V6.6h5.3V11h4.4v7.9H7.9z"
			/>
		</g>
	</SvgIcon>
);

export const PasteIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="copy_2">
			<path
				fill="currentColor"
				d="M15.9,7.2H11c-0.8,0-1.4,0.6-1.4,1.4v9.7c0,0.8,0.6,1.4,1.4,1.4h7.6c0.8,0,1.4-0.6,1.4-1.4v-6.9L15.9,7.2z
		 M11,18.2V8.6h4.1V12h3.4v6.2H11z"
			/>
		</g>
		<g id="Layer_13">
			<path
				fill="currentColor"
				d="M4.3,4.1h1.6v2.4h7.9V4.1h1.6v2.3H17V4.1c0-0.9-0.7-1.6-1.6-1.6H12C11.7,1.6,10.8,1,9.8,1S7.9,1.7,7.6,2.6H4.3
		c-0.9,0-1.6,0.7-1.6,1.6v12.6c0,0.9,0.7,1.6,1.6,1.6H9c0-0.6,0-1.1,0-1.6H4.3V4.1z M9.8,2.6c0.4,0,0.8,0.4,0.8,0.8
		s-0.4,0.8-0.8,0.8C9.4,4.1,9,3.8,9,3.3C9,2.9,9.4,2.6,9.8,2.6z"
			/>
		</g>
	</SvgIcon>
);

export const ScheduleIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_7">
			<path
				id="Path_6031"
				fill="currentColor"
				d="M11,0.7c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S16.5,0.7,11,0.7L11,0.7z M11,18.7
		c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S15.4,18.7,11,18.7z"
			/>
			<path id="Path_6032" fill="currentColor" d="M11.5,5.7H10v6l5.2,3.1l0.8-1.2L11.5,11V5.7z" />
		</g>
	</SvgIcon>
);

export const PublicSamplesIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Layer_6">
			<path
				id="Path_6042"
				fill="currentColor"
				d="M11.1,0.7C5.5,0.7,1,5.2,1,10.8S5.5,21,11.1,21s10.1-4.5,10.1-10.1S16.7,0.7,11.1,0.7z M3,10.8
		C3,10.2,3.1,9.6,3.2,9l4.9,4.9v1c0,1.1,0.9,2,2,2v2C6,18.4,3,14.9,3,10.8z M17.1,16.3c-0.3-0.8-1-1.4-1.9-1.4h-1v-3
		c0-0.6-0.5-1-1-1H7v-2h2c0.6,0,1-0.5,1-1v-2h2c1.1,0,2-0.9,2-2V3.3c4.2,1.7,6.2,6.4,4.5,10.5C18.3,14.7,17.7,15.6,17.1,16.3z"
			/>
		</g>
	</SvgIcon>
);

export const DeleteIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="delete">
			<path
				fill="currentColor"
				d="M5.2,18.6c0,1.1,0.8,2.1,2,2.2h7.9c1.1-0.1,2-1,2-2.2v-13H5.2V18.6z M7.2,7.8h7.9v10.8H7.2V7.8z M14.6,2.4
		l-1-1.1h-5l-1,1.1H4.2v2.2h13.9V2.4H14.6z"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeWidth: '1.3883' }}
				x1="9.8"
				y1="10.4"
				x2="9.8"
				y2="18.7"
			/>
			<line
				style={{ fill: 'none', stroke: 'currentColor', strokeWidth: '1.3883' }}
				x1="12.6"
				y1="10.4"
				x2="12.6"
				y2="18.7"
			/>
		</g>
	</SvgIcon>
);

export const PermanentDeleteIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3796" data-name="Rectangle 3796" width="24" height="24" fill="none" />
		<path
			id="delete_forever_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M184.6-803.528l2.442-2.458,2.442,2.458.99-1-2.442-2.458,2.442-2.458-.99-1-2.442,2.458-2.442-2.458-.99,1,2.442,2.458-2.442,2.458Zm-1.965,4.108a1.634,1.634,0,0,1-1.2-.5,1.655,1.655,0,0,1-.493-1.213v-12H180v-1.418h4.226v-.836h5.635v.836h4.226v1.418h-.939v12a1.655,1.655,0,0,1-.493,1.213,1.634,1.634,0,0,1-1.2.5Zm9.1-13.706h-9.392v12a.278.278,0,0,0,.09.2.275.275,0,0,0,.2.091h8.814a.275.275,0,0,0,.2-.091.278.278,0,0,0,.09-.2Zm-9.392,0v0Z"
			transform="translate(-175 819.381)"
			// fill="#f44336"
		/>
	</SvgIcon>
);

export const RestoreDeleteIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path
			id="restore_from_trash_24dp_5F6368_FILL0_wght300_GRAD0_opsz24"
			d="M186.38-804H187.8v-4.177l1.749,1.72,1-1-3.454-3.454-3.454,3.454,1,1,1.749-1.72Zm-3.726,4.581a1.65,1.65,0,0,1-1.213-.5,1.649,1.649,0,0,1-.5-1.213v-12H180v-1.418h4.254v-.836h5.671v.836h4.254v1.418h-.945v12a1.649,1.649,0,0,1-.5,1.213,1.65,1.65,0,0,1-1.213.5Zm9.162-13.706h-9.452v12a.277.277,0,0,0,.091.2.277.277,0,0,0,.2.091h8.871a.277.277,0,0,0,.2-.091.277.277,0,0,0,.091-.2Zm-9.452,0v0Z"
			transform="translate(-175 819.402)"
			fill={props.htmlColor ?? '#7d61bc'}
		/>
		<rect id="Rectangle_3960" data-name="Rectangle 3960" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const EditIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="Icon_feather-edit-3" transform="translate(-3.25 -3.818)">
			<path
				id="Path_5658"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M4.2,23.3h20.2"
			/>
			<path
				id="Path_5659"
				style={{
					fill: 'none',
					stroke: 'currentColor',
					strokeWidth: '1.4932',
					strokeLinecap: 'round',
					strokeLinejoin: 'round',
				}}
				d="M17.9,6.9c0.7-0.8,1.9-0.8,2.7-0.1c0,0,0.1,0.1,0.1,0.1c0.8,0.8,0.8,2.1,0,3L9,22.3l-3.7,1
		l0.9-4L17.9,6.9z"
			/>
		</g>
	</SvgIcon>
);

export const NamingTextIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3179" data-name="Rectangle 3179" width="26" height="26" fill="none" />
		<g id="Group_6799" data-name="Group 6799" transform="translate(-472 -424)">
			<path
				id="text_fields_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M86.5-779.2v-16.9H80V-800H96.9v3.9H90.4v16.9Zm11.7,0v-10.4H94.3v-3.9H106v3.9h-3.9v10.4Z"
				transform="translate(392 1227)"
				fill="#5f3fa5"
			/>
		</g>
	</SvgIcon>
);

const meta = '{meta}';
export const NamingMetadataIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3178" data-name="Rectangle 3178" width="26" height="26" fill="none" />
		<g id="Group_7947" data-name="Group 7947" transform="translate(-88 -307)">
			<path
				id="keyboard_alt_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M42.364-779.909a2.276,2.276,0,0,1-1.669-.694A2.276,2.276,0,0,1,40-782.273v-15.364a2.276,2.276,0,0,1,.694-1.669A2.276,2.276,0,0,1,42.364-800H63.636a2.276,2.276,0,0,1,1.669.694A2.276,2.276,0,0,1,66-797.636v15.364a2.276,2.276,0,0,1-.694,1.669,2.276,2.276,0,0,1-1.669.694Zm0-2.364H63.636v-15.364H42.364Zm0,0v0Z"
				transform="translate(48 1109.955)"
				fill="#5f3fa5"
			/>
			<text
				id="_meta_"
				data-name="{meta}"
				transform="translate(101 321.955)"
				fill="#5f3fa5"
				fontSize="6"
				fontFamily="Helvetica"
			>
				<tspan x="-8" y="0">
					{meta}
				</tspan>
			</text>
		</g>
	</SvgIcon>
);

export const NamingCounterIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3180" data-name="Rectangle 3180" width="26" height="26" fill="none" />
		<path
			id="counter_3_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M93-854a12.658,12.658,0,0,1-5.07-1.024A13.127,13.127,0,0,1,83.8-857.8a13.128,13.128,0,0,1-2.779-4.128A12.658,12.658,0,0,1,80-867a12.659,12.659,0,0,1,1.024-5.07A13.128,13.128,0,0,1,83.8-876.2a13.127,13.127,0,0,1,4.128-2.779A12.659,12.659,0,0,1,93-880a12.659,12.659,0,0,1,5.07,1.024A13.127,13.127,0,0,1,102.2-876.2a13.128,13.128,0,0,1,2.779,4.128A12.659,12.659,0,0,1,106-867a12.658,12.658,0,0,1-1.024,5.07A13.128,13.128,0,0,1,102.2-857.8a13.127,13.127,0,0,1-4.128,2.779A12.658,12.658,0,0,1,93-854Zm0-2.6a10.037,10.037,0,0,0,7.378-3.022A10.037,10.037,0,0,0,103.4-867a10.037,10.037,0,0,0-3.022-7.378A10.037,10.037,0,0,0,93-877.4a10.037,10.037,0,0,0-7.378,3.023A10.037,10.037,0,0,0,82.6-867a10.037,10.037,0,0,0,3.022,7.378A10.037,10.037,0,0,0,93-856.6ZM93-867Zm-3.9,6.5h5.2a2.5,2.5,0,0,0,1.836-.764A2.5,2.5,0,0,0,96.9-863.1v-1.95a1.894,1.894,0,0,0-.552-1.4,1.894,1.894,0,0,0-1.4-.552,1.894,1.894,0,0,0,1.4-.553,1.894,1.894,0,0,0,.552-1.4v-1.95a2.5,2.5,0,0,0-.764-1.836A2.5,2.5,0,0,0,94.3-873.5H89.1v2.6h5.2v2.6H91.7v2.6h2.6v2.6H89.1Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingFileNameIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3181" data-name="Rectangle 3181" width="26" height="26" fill="none" />
		<path
			id="description_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M165.2-859.2h10.4v-2.6H165.2Zm0-5.2h10.4V-867H165.2ZM162.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,160-856.6v-20.8a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,162.6-880H173l7.8,7.8v15.6a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,178.2-854Zm9.1-16.9v-6.5h-9.1v20.8h15.6v-14.3Zm-9.1-6.5v0Z"
			transform="translate(-157.4 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingFileExtensionIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3182" data-name="Rectangle 3182" width="26" height="26" fill="none" />
		<g id="Group_7949" data-name="Group 7949" transform="translate(-473.6 -424.4)">
			<path
				id="description_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
				d="M162.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,160-856.6v-20.8a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,162.6-880H173l7.8,7.8v15.6a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,178.2-854Zm9.1-16.9v-6.5h-9.1v20.8h15.6v-14.3Zm-9.1-6.5v0Z"
				transform="translate(316.2 1304.4)"
				fill="#5f3fa5"
			/>
			<text
				id="_.xyz"
				data-name=".xyz"
				transform="translate(486 442)"
				fill="#5f3fa5"
				fontSize="6"
				fontFamily="Helvetica"
			>
				<tspan x="-5" y="0">
					.xyz
				</tspan>
			</text>
		</g>
	</SvgIcon>
);

export const NamingDateIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3183" data-name="Rectangle 3183" width="26" height="26" fill="none" />
		<path
			id="calendar_month_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M122.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,120-856.6v-18.2a2.5,2.5,0,0,1,.764-1.836,2.5,2.5,0,0,1,1.836-.764h1.3V-880h2.6v2.6h10.4V-880h2.6v2.6h1.3a2.5,2.5,0,0,1,1.836.764,2.5,2.5,0,0,1,.764,1.836v18.2a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,140.8-854Zm0-2.6h18.2v-13H122.6Zm0-15.6h18.2v-2.6H122.6Zm0,0v0Zm9.1,7.8a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,131.7-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,131.7-864.4Zm-5.2,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,126.5-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,126.5-864.4Zm10.4,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926A1.258,1.258,0,0,1,136.9-867a1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,136.9-864.4Zm-5.2,5.2a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,131.7-859.2Zm-5.2,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,126.5-859.2Zm10.4,0a1.258,1.258,0,0,1-.926-.374,1.258,1.258,0,0,1-.374-.926,1.258,1.258,0,0,1,.374-.926,1.258,1.258,0,0,1,.926-.374,1.258,1.258,0,0,1,.926.374,1.258,1.258,0,0,1,.374.926,1.258,1.258,0,0,1-.374.926A1.258,1.258,0,0,1,136.9-859.2Z"
			transform="translate(-118.7 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingTimeIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3184" data-name="Rectangle 3184" width="26" height="26" fill="none" />
		<path
			id="schedule_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M97.29-860.89l1.82-1.82-4.81-4.81v-5.98H91.7v7.02ZM93-854a12.658,12.658,0,0,1-5.07-1.024A13.127,13.127,0,0,1,83.8-857.8a13.128,13.128,0,0,1-2.779-4.128A12.658,12.658,0,0,1,80-867a12.659,12.659,0,0,1,1.024-5.07A13.128,13.128,0,0,1,83.8-876.2a13.127,13.127,0,0,1,4.128-2.779A12.659,12.659,0,0,1,93-880a12.659,12.659,0,0,1,5.07,1.024A13.127,13.127,0,0,1,102.2-876.2a13.128,13.128,0,0,1,2.779,4.128A12.659,12.659,0,0,1,106-867a12.658,12.658,0,0,1-1.024,5.07A13.128,13.128,0,0,1,102.2-857.8a13.127,13.127,0,0,1-4.128,2.779A12.658,12.658,0,0,1,93-854ZM93-867Zm0,10.4a10.025,10.025,0,0,0,7.361-3.039A10.025,10.025,0,0,0,103.4-867a10.025,10.025,0,0,0-3.039-7.361A10.026,10.026,0,0,0,93-877.4a10.026,10.026,0,0,0-7.361,3.039A10.025,10.025,0,0,0,82.6-867a10.025,10.025,0,0,0,3.039,7.361A10.025,10.025,0,0,0,93-856.6Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingIDIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3185" data-name="Rectangle 3185" width="26" height="26" fill="none" />
		<path
			id="badge_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M82.6-854a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,80-856.6v-14.3a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,82.6-873.5h6.5v-3.9a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,91.7-880h2.6a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,96.9-877.4v3.9h6.5a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,106-870.9v14.3a2.5,2.5,0,0,1-.764,1.836A2.5,2.5,0,0,1,103.4-854Zm0-2.6h20.8v-14.3H96.9a2.5,2.5,0,0,1-.764,1.836,2.5,2.5,0,0,1-1.836.764H91.7a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,89.1-870.9H82.6Zm2.6-2.6H93v-.585a1.832,1.832,0,0,0-.309-1.024,2.041,2.041,0,0,0-.861-.731,6.7,6.7,0,0,0-1.316-.439,6.579,6.579,0,0,0-1.414-.146,6.579,6.579,0,0,0-1.414.146,6.7,6.7,0,0,0-1.316.439,2.041,2.041,0,0,0-.861.731,1.832,1.832,0,0,0-.309,1.024Zm10.4-1.95h5.2v-1.95H95.6Zm-6.5-1.95a1.881,1.881,0,0,0,1.381-.569,1.881,1.881,0,0,0,.569-1.381,1.88,1.88,0,0,0-.569-1.381A1.881,1.881,0,0,0,89.1-867a1.881,1.881,0,0,0-1.381.569,1.88,1.88,0,0,0-.569,1.381,1.881,1.881,0,0,0,.569,1.381A1.881,1.881,0,0,0,89.1-863.1Zm6.5-1.95h5.2V-867H95.6Zm-3.9-5.85h2.6v-6.5H91.7ZM93-863.75Z"
			transform="translate(-80 880)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const NamingSeparatorIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 26 26" {...props}>
		<rect id="Rectangle_3186" data-name="Rectangle 3186" width="26" height="26" fill="none" />
		<path
			id="tab_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			d="M82.6-781.8h20.8v-10.4H94.3v-5.2H82.6Zm0,2.6a2.5,2.5,0,0,1-1.836-.764A2.5,2.5,0,0,1,80-781.8v-15.6a2.5,2.5,0,0,1,.764-1.836A2.5,2.5,0,0,1,82.6-800h20.8a2.5,2.5,0,0,1,1.836.764A2.5,2.5,0,0,1,106-797.4v15.6a2.5,2.5,0,0,1-.764,1.836,2.5,2.5,0,0,1-1.836.764Zm0-2.6v0Z"
			transform="translate(-80 802.6)"
			fill="#5f3fa5"
		/>
	</SvgIcon>
);

export const ExportIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="icon-export" transform="translate(-0.129 -1.029)">
			<g id="Group_615">
				<g id="Group_614">
					<path
						id="Path_6034"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="0.75"
						strokeMiterlimit="10"
						d="M14.1,18.2l-2.6,2.6v-7.7c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4l0,0v7.7l-2.6-2.6
				c-0.2-0.1-0.3-0.1-0.5,0c-0.1,0.2-0.1,0.3,0,0.5l3.2,3.2c0.2,0.1,0.4,0.1,0.6,0l3.2-3.2c0.1-0.2,0.1-0.3,0-0.5
				C14.5,18.1,14.3,18.1,14.1,18.2z"
					/>
				</g>
				<path
					id="Path_6035"
					fill="currentColor"
					stroke="currentColor"
					strokeWidth="0.75"
					strokeMiterlimit="10"
					d="M16.1,16.4h-2.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h2.8c2.7,0,4.9-2.2,4.9-4.9
			c0-2.6-2.2-4.8-4.8-4.8c-0.3,0-0.5,0-0.8,0.1h-0.3L15,5.7c-0.8-1.9-2.6-3.1-4.6-3c-2.7,0-4.8,2.1-4.8,4.8v0.6H5
			c-2.1,0-3.8,1.8-3.8,3.8s1.8,3.8,3.9,3.8l0,0h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-2.5,0-4.5-2-4.5-4.5
			S2.5,7.5,5,7.5c0.1-3,2.5-5.3,5.5-5.4c2.2,0,4.2,1.3,5,3.3h0.7c3,0,5.5,2.5,5.5,5.5V11C21.6,14,19.1,16.3,16.1,16.4z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ImportIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 22 22" {...props}>
		<g id="icon-import" transform="translate(-0.129 -1.029)">
			<g id="Group_617">
				<g id="Group_616">
					<path
						id="Path_6037"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="0.75"
						strokeMiterlimit="10"
						d="M14.6,15c0.1-0.2,0.1-0.3,0-0.5l-3.2-3.2c-0.2-0.1-0.4-0.1-0.6,0l-3.2,3.2
				c-0.1,0.2-0.1,0.3,0,0.5c0.2,0.1,0.3,0.1,0.5,0l2.6-2.6v7.7c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-7.7l2.6,2.6
				C14.2,15.1,14.4,15.1,14.6,15z"
					/>
				</g>
				<path
					id="Path_6038"
					fill="currentColor"
					stroke="currentColor"
					strokeWidth="0.75"
					strokeMiterlimit="10"
					d="M16.1,17.9h-2.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h2.8c2.7,0,4.9-2.2,4.9-4.9
			c0-2.6-2.2-4.8-4.8-4.8c-0.3,0-0.5,0-0.8,0.1h-0.3L15,7.2c-0.8-1.9-2.6-3.1-4.6-3C7.7,4.2,5.6,6.3,5.6,9v0.6H5
			c-2.1,0-3.8,1.8-3.8,3.9s1.8,3.8,3.9,3.7l0,0h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-2.5,0-4.5-2-4.5-4.5
			C0.6,11,2.5,9,5,9c0.1-3,2.5-5.3,5.5-5.4c2.2,0,4.2,1.3,5,3.3h0.7c3,0,5.5,2.5,5.5,5.5v0.1C21.5,15.5,19.1,17.8,16.1,17.9z"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ResetIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" transform="scale(-1, 1)" viewBox="0 0 24 24" {...props}>
		<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
	</SvgIcon>
);

export const QuickLinksIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth="1.25"
			d="M13.327 2.658h4.441l-3.992 7.828h2.747L8.23 23.342l3.441-10.319H9.319z"
			data-name="Path 6922"
		/>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2189" />
	</SvgIcon>
);

export const LayoutRowsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm3-3h37v-7h-37zm37-10v-7h-37v7zm0-10v-7h-37v7zm0-10v-7h-37v7z"
			data-name="homepage layout 4 horizontal icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const LayoutColumnsIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm3-3h37v-7h-37zm37-10v-7h-37v7zm0-10v-7h-37v7zm0-10v-7h-37v7z"
			data-name="homepage layout 4 vertical icon"
			transform="rotate(90 6940.5 -14174.502)"
		/>
	</SvgIcon>
);

export const LayoutGridIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm40-3v-17h-17v17zm-37 0h17v-17h-17zm20-20h17v-17h-17zm-3.006 0v-17h-17v17z"
			data-name="homepage layout 2x2 icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const LayoutLeftIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 43" {...props}>
		<path
			fill="currentColor"
			d="M21115-7234v-43h43v43zm40-3v-10.5h-17v10.5zm-37 0h17v-37h-17zm20-13.5h17v-10h-17zm0-13h17v-10.5h-17z"
			data-name="homepage layout 1x3 icon"
			transform="translate(-21115.002 7277.002)"
		/>
	</SvgIcon>
);

export const SystemModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2243" />
		<g data-name="Group 5789" transform="translate(-87.889 -793.199)">
			<g fill="currentColor" data-name="Group 5755" transform="translate(90.889 797.099)">
				<path
					d="M85.4-823.8v-1.8h-3.6a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 0180-827.4v-10.8a1.733 1.733 0 01.529-1.271A1.733 1.733 0 0181.8-840h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0198-838.2v10.8a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529h-3.6v1.8zm-3.6-3.6h14.4v-10.8H81.8zm0 0z"
					transform="translate(-80 840)"
				/>
				<path
					d="M2.746 7.132l-.214-1.07q-.214-.089-.4-.187a3.106 3.106 0 01-.383-.241l-1.036.321L0 4.743l.82-.713a3.292 3.292 0 01-.036-.464A3.293 3.293 0 01.82 3.1L0 2.389l.713-1.212 1.034.323a3.1 3.1 0 01.383-.241q.187-.1.4-.187L2.746 0h1.426l.214 1.07a3.6 3.6 0 01.4.2 2.813 2.813 0 01.383.267l1.034-.357.713 1.248-.82.713a2.8 2.8 0 010 .892l.82.713-.711 1.209-1.034-.32a3.106 3.106 0 01-.383.241q-.187.1-.4.187l-.214 1.07zm.713-2.14a1.431 1.431 0 001.427-1.426A1.431 1.431 0 003.459 2.14a1.431 1.431 0 00-1.426 1.426 1.431 1.431 0 001.426 1.427z"
					transform="rotate(149 6.854 6.217)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LightModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2241" />
		<path
			fill="currentColor"
			d="M49-908.545a2.367 2.367 0 001.739-.716 2.367 2.367 0 00.716-1.739 2.367 2.367 0 00-.716-1.739 2.367 2.367 0 00-1.739-.716 2.367 2.367 0 00-1.739.716 2.367 2.367 0 00-.716 1.739 2.367 2.367 0 00.716 1.739 2.367 2.367 0 001.739.716zm0 1.636a3.943 3.943 0 01-2.894-1.2 3.943 3.943 0 01-1.2-2.894 3.943 3.943 0 011.2-2.894 3.943 3.943 0 012.894-1.2 3.943 3.943 0 012.894 1.2 3.943 3.943 0 011.2 2.894 3.943 3.943 0 01-1.2 2.894 3.943 3.943 0 01-2.894 1.2zm-8.182-3.273a.792.792 0 01-.583-.235A.792.792 0 0140-911a.792.792 0 01.235-.583.792.792 0 01.583-.235h1.636a.792.792 0 01.583.235.792.792 0 01.235.583.792.792 0 01-.235.583.792.792 0 01-.583.235zm14.727 0a.792.792 0 01-.583-.235.792.792 0 01-.235-.583.792.792 0 01.235-.583.792.792 0 01.583-.235h1.636a.792.792 0 01.583.235A.792.792 0 0158-911a.792.792 0 01-.235.583.792.792 0 01-.583.235zM49-916.727a.792.792 0 01-.583-.235.792.792 0 01-.235-.583v-1.636a.792.792 0 01.235-.583A.792.792 0 0149-920a.791.791 0 01.583.235.792.792 0 01.235.583v1.636a.792.792 0 01-.235.583.791.791 0 01-.583.236zM49-902a.792.792 0 01-.583-.235.792.792 0 01-.235-.583v-1.636a.791.791 0 01.235-.583.792.792 0 01.583-.235.791.791 0 01.583.235.791.791 0 01.235.583v1.636a.792.792 0 01-.235.583A.792.792 0 0149-902zm-5.2-13.05l-.88-.859a.712.712 0 01-.235-.573.887.887 0 01.235-.593.808.808 0 01.593-.245.743.743 0 01.573.245l.859.88a.821.821 0 01.225.573.821.821 0 01-.225.573.7.7 0 01-.562.235.875.875 0 01-.583-.236zm10.1 10.125l-.859-.88a.834.834 0 01-.225-.583.763.763 0 01.225-.562.7.7 0 01.563-.235.875.875 0 01.583.235l.88.859a.712.712 0 01.235.573.887.887 0 01-.235.593.808.808 0 01-.593.245.743.743 0 01-.565-.245zm-.85-10.125a.7.7 0 01-.235-.562.875.875 0 01.235-.583l.859-.88a.712.712 0 01.573-.235.888.888 0 01.593.235.808.808 0 01.245.593.743.743 0 01-.245.573l-.88.859a.821.821 0 01-.573.225.821.821 0 01-.572-.225zm-10.125 10.125a.808.808 0 01-.245-.593.743.743 0 01.245-.573l.88-.859a.834.834 0 01.583-.225.763.763 0 01.563.225.7.7 0 01.235.563.875.875 0 01-.235.583l-.859.88a.712.712 0 01-.573.235.888.888 0 01-.594-.236zM49-911z"
			transform="translate(-37 923)"
		/>
	</SvgIcon>
);

export const DarkModeIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2242" />
		<path
			fill="currentColor"
			d="M129-822a8.679 8.679 0 01-6.375-2.625A8.679 8.679 0 01120-831a8.679 8.679 0 012.625-6.375A8.679 8.679 0 01129-840q.35 0 .688.025t.662.075a5.293 5.293 0 00-1.637 1.888 5.309 5.309 0 00-.613 2.513 5.207 5.207 0 001.575 3.825 5.207 5.207 0 003.825 1.574 5.287 5.287 0 002.525-.613 5.323 5.323 0 001.875-1.637q.05.325.075.662T138-831a8.679 8.679 0 01-2.625 6.375A8.679 8.679 0 01129-822zm0-2a6.772 6.772 0 003.95-1.213 7.013 7.013 0 002.55-3.162q-.5.125-1 .2a6.726 6.726 0 01-1 .075 7.133 7.133 0 01-5.238-2.163 7.133 7.133 0 01-2.162-5.237 6.732 6.732 0 01.075-1q.075-.5.2-1a7.013 7.013 0 00-3.163 2.55A6.772 6.772 0 00122-831a6.745 6.745 0 002.05 4.95A6.745 6.745 0 00129-824zm-.25-6.75z"
			transform="translate(-117 843)"
		/>
	</SvgIcon>
);

export const AdvancedMenuIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" overflow="visible" {...props}>
		<g data-name="Group 4846" transform="translate(-3, 0)">
			<path
				fill="currentColor"
				d="M23996.76 22244l-.416-3.367a5.115 5.115 0 01-.9-.416 5.727 5.727 0 01-.824-.574l-3.09 1.318-2.523-4.422 2.67-2.039a4.658 4.658 0 01-.053-.494c-.012-.166-.016-.33-.016-.494s0-.318.016-.48.027-.34.053-.533l-2.67-2.037 2.523-4.4 3.078 1.307a6.986 6.986 0 01.844-.578 5.471 5.471 0 01.883-.422l.428-3.367h5.049l.418 3.377a5.083 5.083 0 01.891.424 7.071 7.071 0 01.8.566l3.119-1.307 2.525 4.4-2.711 2.07a2.8 2.8 0 01.063.5v.469c0 .156 0 .3-.008.457a3.2 3.2 0 01-.078.533l2.691 2.049-2.523 4.422-3.082-1.328a7.281 7.281 0 01-.828.578 4.867 4.867 0 01-.867.41l-.418 3.379zm-.492-5.242a6.079 6.079 0 001.568.633l.355 2.951h2.148l.395-2.961a6.036 6.036 0 001.531-.629 6.773 6.773 0 001.336-1.045l2.719 1.152 1.078-1.879-2.373-1.8a4.4 4.4 0 00.186-.844 6.9 6.9 0 00.051-.832 6.7 6.7 0 00-.051-.832 4.122 4.122 0 00-.186-.82l2.395-1.828-1.076-1.879-2.752 1.17a5.849 5.849 0 00-1.314-1.049 5.654 5.654 0 00-1.555-.643l-.344-2.963h-2.172l-.361 2.951a5.734 5.734 0 00-1.547.611 6.572 6.572 0 00-1.354 1.064l-2.719-1.143-1.076 1.879 2.363 1.777a4.2 4.2 0 00-.193.818 7.271 7.271 0 00-.055.9 6.679 6.679 0 00.055.844 5.174 5.174 0 00.182.82l-2.352 1.8 1.076 1.879 2.709-1.16a6.163 6.163 0 001.333 1.058zm2.3-.809v-3.723h-3.686v-1.453h3.686v-3.723h1.432v3.723h3.686v1.453H24000v3.723z"
				data-name="Union 27"
				transform="translate(-23986.285 -22220.5)"
			/>
			<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2048" />
			<path
				fill="currentColor"
				d="M5.26 0L2.98 2.272.7 0 0 .7l2.98 2.975L5.96.7z"
				data-name="↳Color"
				transform="translate(23.281 19.824)"
			/>
		</g>
	</SvgIcon>
);

export const HomeMenuIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" overflow="visible" {...props}>
		<g data-name="Group 4845" transform="translate(-3, 0)">
			<path
				fill="currentColor"
				d="M153.385-834.707h3.563v-5.908h5.1l.006 5.908h3.5l-.006-9.2-6.077-4.557-6.078 4.557zm-1.516 1.512v-11.39l7.593-5.7 7.593 5.7v11.392h-6.54v-5.914h-2.049v5.914zm7.593-8.277z"
				data-name="home_FILL0_wght500_GRAD0_opsz24 (1)"
				transform="translate(-146.463 854.739)"
			/>
			<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 2036" />
			<path
				fill="currentColor"
				d="M5.26 0L2.98 2.272.7 0 0 .7l2.98 2.975L5.96.7z"
				data-name="↳Color"
				transform="translate(23.279 17.824)"
			/>
		</g>
	</SvgIcon>
);

export const TicketIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path
				fill="currentColor"
				d="M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2 4.89 2 6V10C3.11 10 4 10.9 4 12S3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12S20.9 10 22 10M20 8.54C18.81 9.23 18 10.53 18 12S18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.5 5.2 9.23 4 8.54L4 6H20V8.54M11 15H13V17H11M11 11H13V13H11M11 7H13V9H11Z"
			/>
		</g>
	</SvgIcon>
);

export const GridViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path d="M11 11V3H5c-1.1 0-2 .9-2 2v6zm2 0h8V5c0-1.1-.9-2-2-2h-6zm-2 2H3v6c0 1.1.9 2 2 2h6zm2 0v8h6c1.1 0 2-.9 2-2v-6z" />
		</g>
	</SvgIcon>
);

export const ListViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			id="list_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="#323232"
			d="M123.806-678.1v-1.9h13.322v1.9Zm0 3.806v-1.9h13.322v1.9Zm0 3.806v-1.9h13.322v1.9Zm-2.855-7.612a.92.92 0 0 1-.678-.274.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.274Zm0 3.806a.92.92 0 0 1-.678-.273.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.276Zm0 3.806a.92.92 0 0 1-.678-.274.92.92 0 0 1-.274-.678.92.92 0 0 1 .274-.678.92.92 0 0 1 .678-.274.92.92 0 0 1 .678.274.92.92 0 0 1 .274.678.92.92 0 0 1-.274.678.92.92 0 0 1-.677.278Z"
			transform="translate(-116.564 687.242)"
		/>
		<rect id="Rectangle_3409" width="24" height="24" fill="none" data-name="Rectangle 3409" rx="3" />
	</SvgIcon>
);

export const CardViewIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3409" width="24" height="24" fill="none" data-name="Rectangle 3409" rx="3" />
		<path
			id="view_agenda_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="#323232"
			d="M121.717-833.133a1.65 1.65 0 0 1-1.212-.5 1.65 1.65 0 0 1-.5-1.212v-3.434a1.65 1.65 0 0 1 .5-1.212 1.65 1.65 0 0 1 1.212-.5h12.017a1.65 1.65 0 0 1 1.212.5 1.65 1.65 0 0 1 .5 1.212v3.434a1.65 1.65 0 0 1-.5 1.212 1.65 1.65 0 0 1-1.212.5Zm0-1.717h12.017v-3.434h-12.017Zm0 10.3a1.65 1.65 0 0 1-1.212-.5 1.65 1.65 0 0 1-.5-1.213v-3.437a1.65 1.65 0 0 1 .5-1.212 1.65 1.65 0 0 1 1.212-.5h12.017a1.65 1.65 0 0 1 1.212.5 1.65 1.65 0 0 1 .5 1.212v3.433a1.65 1.65 0 0 1-.5 1.213 1.65 1.65 0 0 1-1.212.5Zm0-1.717h12.017v-3.433h-12.017Zm0-3.433"
			transform="translate(-115.725 844.275)"
		/>
	</SvgIcon>
);

export const InternalAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3017" />
			<path
				d="M9 11.7a.884.884 0 10-.641-.259A.871.871 0 009 11.7zm0-3.6a.884.884 0 10-.641-.259A.871.871 0 009 8.1zm0-3.6a.884.884 0 00.9-.9.9.9 0 10-1.8 0 .884.884 0 00.9.9zm7.2 9.9H1.8a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 010 12.6V9a1.733 1.733 0 001.271-.529 1.793 1.793 0 000-2.542A1.733 1.733 0 000 5.4V1.8A1.733 1.733 0 01.529.529 1.733 1.733 0 011.8 0h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0118 1.8v3.6a1.805 1.805 0 00-1.8 1.8A1.805 1.805 0 0018 9v3.6a1.805 1.805 0 01-1.8 1.8zm0-1.8v-2.3a3.69 3.69 0 01-1.316-1.316 3.549 3.549 0 010-3.578A3.69 3.69 0 0116.2 4.095V1.8H1.8v2.295a3.69 3.69 0 011.316 1.316 3.549 3.549 0 010 3.578A3.69 3.69 0 011.8 10.3v2.3zM9 7.2z"
				transform="rotate(90 8.1 11.1)"
			/>
		</g>
	</SvgIcon>
);
export const ExternalAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3197" />
		<path
			d="M89-862a8.709 8.709 0 01-3.488-.709 9.128 9.128 0 01-2.869-1.935 9.129 9.129 0 01-1.935-2.869A8.709 8.709 0 0180-871a8.684 8.684 0 01.709-3.5 9.164 9.164 0 011.935-2.857 9.128 9.128 0 012.869-1.935A8.709 8.709 0 0189-880a8.684 8.684 0 013.5.709 9.164 9.164 0 012.857 1.935 9.165 9.165 0 011.935 2.857A8.684 8.684 0 0198-871a8.709 8.709 0 01-.709 3.488 9.129 9.129 0 01-1.935 2.869 9.164 9.164 0 01-2.857 1.935A8.684 8.684 0 0189-862zm0-1.845a11.43 11.43 0 001.012-1.687 10.654 10.654 0 00.7-1.867H87.29a10.655 10.655 0 00.7 1.867 11.43 11.43 0 001.01 1.687zm-2.34-.36a12.47 12.47 0 01-.709-1.541 13.219 13.219 0 01-.506-1.654H82.79a7.467 7.467 0 001.631 1.957 6.474 6.474 0 002.239 1.238zm4.68 0a6.474 6.474 0 002.239-1.237 7.467 7.467 0 001.631-1.958h-2.655a13.218 13.218 0 01-.506 1.654 12.469 12.469 0 01-.709 1.541zm-9.315-4.995h3.06q-.067-.45-.1-.889T84.95-871q0-.473.034-.911t.1-.889h-3.06a7.7 7.7 0 00-.169.889 7.164 7.164 0 00-.055.911 7.163 7.163 0 00.056.911 7.7 7.7 0 00.169.889zm4.86 0h4.23q.067-.45.1-.889t.035-.911q0-.473-.034-.911t-.1-.889h-4.23q-.068.45-.1.889t-.036.911q0 .473.034.911t.101.889zm6.03 0h3.06a7.7 7.7 0 00.169-.889A7.163 7.163 0 0096.2-871a7.164 7.164 0 00-.056-.911 7.7 7.7 0 00-.169-.889h-3.06q.067.45.1.889t.034.911q0 .473-.034.911t-.1.889zm-.36-5.4h2.655a7.469 7.469 0 00-1.631-1.958 6.476 6.476 0 00-2.239-1.237 12.474 12.474 0 01.709 1.541 13.219 13.219 0 01.506 1.654zm-5.265 0h3.42a10.652 10.652 0 00-.7-1.867 11.423 11.423 0 00-1.01-1.688 11.424 11.424 0 00-1.013 1.688 10.653 10.653 0 00-.697 1.867zm-4.5 0h2.655a13.22 13.22 0 01.506-1.654 12.475 12.475 0 01.709-1.541 6.476 6.476 0 00-2.239 1.237 7.468 7.468 0 00-1.631 1.958z"
			transform="translate(-77 883)"
		/>
	</SvgIcon>
);
export const UrlAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3198" />
			<path
				d="M81.8-785.6a1.733 1.733 0 01-1.271-.529A1.733 1.733 0 0180-787.4v-10.8a1.733 1.733 0 01.529-1.271A1.733 1.733 0 0181.8-800h14.4a1.733 1.733 0 011.271.529A1.733 1.733 0 0198-798.2v10.8a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529zm0-1.8h14.4v-10.8H81.8zm0 0z"
				transform="translate(-77 804.8)"
			/>
			<path
				d="M85.4-674H83a2.891 2.891 0 01-2.122-.878A2.891 2.891 0 0180-677a2.891 2.891 0 01.878-2.122A2.891 2.891 0 0183-680h2.4v1.2H83a1.736 1.736 0 00-1.275.525A1.736 1.736 0 0081.2-677a1.736 1.736 0 00.525 1.275A1.736 1.736 0 0083-675.2h2.4zm-1.8-2.4v-1.2h4.8v1.2zm3 2.4v-1.2H89a1.736 1.736 0 001.275-.525A1.736 1.736 0 0090.8-677a1.736 1.736 0 00-.525-1.275A1.736 1.736 0 0089-678.8h-2.4v-1.2H89a2.891 2.891 0 012.123.878A2.891 2.891 0 0192-677a2.891 2.891 0 01-.877 2.122A2.891 2.891 0 0189-674z"
				transform="translate(-74 688.8)"
			/>
		</g>
	</SvgIcon>
);

export const CopyLinkIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g data-name="Group 6736" transform="translate(-5764 -1811)">
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3102" transform="translate(5764 1811)" />
			<path
				fill="currentColor"
				d="M7.2 8H4a3.855 3.855 0 01-2.83-1.17A3.855 3.855 0 010 4a3.855 3.855 0 011.17-2.83A3.855 3.855 0 014 0h3.2v1.6H4a2.314 2.314 0 00-1.7.7A2.314 2.314 0 001.6 4a2.314 2.314 0 00.7 1.7 2.314 2.314 0 001.7.7h3.2zM4.8 4.8V3.2h6.4v1.6zm4 3.2V6.4H12a2.314 2.314 0 001.7-.7 2.314 2.314 0 00.7-1.7 2.314 2.314 0 00-.7-1.7 2.314 2.314 0 00-1.7-.7H8.8V0H12a3.855 3.855 0 012.83 1.17A3.855 3.855 0 0116 4a3.855 3.855 0 01-1.17 2.83A3.855 3.855 0 0112 8z"
				transform="rotate(-45 5087.727 -6049.092)"
			/>
		</g>
	</SvgIcon>
);
export const ServiceAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<g>
			<path
				d="M196.525-862a2.028 2.028 0 01-1.058-.281 2.045 2.045 0 01-.742-.754 1.733 1.733 0 01-1.271-.529 1.733 1.733 0 01-.529-1.271v-3.2a6.519 6.519 0 01-2.126-2.318 6.342 6.342 0 01-.8-3.128 6.294 6.294 0 011.9-4.624 6.294 6.294 0 014.624-1.9 6.294 6.294 0 014.624 1.9 6.294 6.294 0 011.9 4.624 6.3 6.3 0 01-.8 3.15 6.577 6.577 0 01-2.126 2.295v3.2a1.733 1.733 0 01-.529 1.271 1.733 1.733 0 01-1.271.529 2.045 2.045 0 01-.743.754 2.028 2.028 0 01-1.053.282zm-1.8-2.835h3.6v-.81h-3.6zm0-1.71h3.6v-.855h-3.6zm-.18-2.655h1.3v-2.43l-1.98-1.98.945-.945 1.71 1.71 1.71-1.71.945.945-1.98 1.98v2.43h1.3a4.928 4.928 0 001.98-1.721 4.469 4.469 0 00.765-2.554 4.561 4.561 0 00-1.372-3.352 4.561 4.561 0 00-3.352-1.372 4.561 4.561 0 00-3.353 1.372 4.561 4.561 0 00-1.372 3.352 4.469 4.469 0 00.765 2.554 4.928 4.928 0 001.989 1.721zm1.98-3.645zm0-.855z"
				transform="translate(-184.525 883)"
			/>
			<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3016" opacity="0.22" />
		</g>
	</SvgIcon>
);

export const PlayIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
	</SvgIcon>
);

export const LinkIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiLink} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const AppsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			fill="currentColor"
			d="M162-784a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-784zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-790zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-796z"
			transform="translate(-155 805)"
		/>
		<path fill="none" d="M0 0H26V26H0z" data-name="Rectangle 3022" />
	</SvgIcon>
);

export const CustomizeIcon = (props: Omit<MdiIconProps, 'path'>) => (
	<MdiIcon path={mdiIcons.mdiPaletteOutline} {...props} className={clsx('mdi-svg-icon', props.className)} />
);

export const CreateWorkflowIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<g data-name="Group 4395" transform="translate(-1233 -469)">
			<rect
				width="24"
				height="24"
				fill="none"
				data-name="Rectangle 2172"
				rx="12"
				transform="translate(1233 469)"
			/>
			<g fill="currentColor" data-name="Group 4394" transform="translate(37.956 -.38)">
				<path
					d="M10.238 9.073l5.9 3.76-5.9 3.76v-7.52M8 5v15.665l12.309-7.833z"
					data-name="Path 220"
					transform="translate(1193.823 467.722)"
				/>
				<path
					d="M84.606-874.826v-2.051h-2.051v-1.555h2.051v-2.051h1.555v2.051h2.051v1.555h-2.05v2.051z"
					transform="translate(1125.843 1365.24)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const AddJobIcon = (props: SvgIconProps) => (
	<SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<rect width="24" height="24" fill="none" data-name="Rectangle 2154" rx="12" />
		<path
			fill="currentColor"
			d="M79.621-872.628a7.558 7.558 0 01-3.027-.61 7.823 7.823 0 01-2.459-1.656 7.821 7.821 0 01-1.656-2.459 7.556 7.556 0 01-.61-3.026 7.556 7.556 0 01.61-3.026 7.822 7.822 0 011.656-2.459 7.819 7.819 0 012.459-1.656 7.555 7.555 0 013.026-.61 7.633 7.633 0 012.336.352 7.907 7.907 0 012.041.988l-1.261 1.28a6.473 6.473 0 00-1.472-.656 5.634 5.634 0 00-1.645-.236 5.81 5.81 0 00-4.263 1.758 5.8 5.8 0 00-1.76 4.266 5.8 5.8 0 001.76 4.266 5.81 5.81 0 004.263 1.758 5.846 5.846 0 001.129-.107 6.5 6.5 0 001.06-.3l1.3 1.322a8.3 8.3 0 01-1.667.6 7.632 7.632 0 01-1.82.211zm5.213-1.569v-2.279h-2.279v-1.724h2.279v-2.279h1.728v2.279h2.279v1.728h-2.278v2.279zm-6.291-2.6l-3.3-3.3 1.186-1.191 2.111 2.111 7.638-7.657 1.191 1.191z"
			transform="translate(-67.869 892.131)"
		/>
	</SvgIcon>
);

export const PinIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		{props.htmlColor === 'white' ? (
			<path
				fillRule="evenodd"
				d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
			/>
		) : (
			<path d="M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4m3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z" />
		)}
	</SvgIcon>
);

export const ProfileIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2233" />
		<g transform="translate(1 1)">
			<g data-name="Group 5776" transform="translate(.875 1)">
				<g fill="currentColor" data-name="Group 5777">
					<path
						d="M35.54 42.761a7.092 7.092 0 01-6.069-3.18l-.359-.532.547-.335a10.847 10.847 0 012.831-1.222 11.866 11.866 0 013.1-.406 11.355 11.355 0 013.026.406 12.915 12.915 0 012.891 1.21l.6.336-.4.556a7.628 7.628 0 01-2.637 2.326 7.435 7.435 0 01-3.53.841zm-4.65-3.334a5.939 5.939 0 001.726 1.411 6.063 6.063 0 002.924.694 6.222 6.222 0 002.955-.7 6.328 6.328 0 001.773-1.4 11.322 11.322 0 00-1.975-.758 10.128 10.128 0 00-2.7-.362 10.638 10.638 0 00-2.783.363 9.614 9.614 0 00-1.92.752zm4.744-3.1a3.842 3.842 0 01-2.807-1.2 3.887 3.887 0 01-1.187-2.821 3.77 3.77 0 011.2-2.832 3.936 3.936 0 012.795-1.13 3.8 3.8 0 012.78 1.169 3.841 3.841 0 011.16 2.793 3.934 3.934 0 01-1.155 2.814 3.753 3.753 0 01-2.786 1.203zm0-6.752a2.71 2.71 0 00-1.948.791 2.551 2.551 0 00-.818 1.943 2.664 2.664 0 00.83 1.955 2.621 2.621 0 001.936.834 2.535 2.535 0 001.9-.828 2.709 2.709 0 00.809-1.961 2.618 2.618 0 00-.8-1.928 2.575 2.575 0 00-1.909-.81z"
						transform="translate(-25.483 -25.843)"
					/>
					<path
						d="M36.725 47.675a10.96 10.96 0 01-11-10.967 10.96 10.96 0 0111-11.033 10.96 10.96 0 0111 11.033 10.96 10.96 0 01-11 10.967zm0-20.308a9.268 9.268 0 00-9.308 9.341 9.268 9.268 0 009.308 9.275 9.268 9.268 0 009.308-9.275 9.268 9.268 0 00-9.308-9.341z"
						data-name="admin_panel_settings_FILL0_wght200_GRAD0_opsz48"
						transform="translate(-26.6 -26.55)"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const PageIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 46.4 52" {...props}>
		<path d="M17.54,41.8H36.86V38.2H17.54Zm0-10.2H36.86V28H17.54ZM11.6,52a3.454,3.454,0,0,1-2.52-1.08A3.454,3.454,0,0,1,8,48.4V7.6A3.454,3.454,0,0,1,9.08,5.08,3.454,3.454,0,0,1,11.6,4H33.26L46.4,17.14V48.4A3.691,3.691,0,0,1,42.8,52ZM31.46,18.76H42.8L31.46,7.6Z" />
	</SvgIcon>
);

export const DescriptionIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 50 43.545" {...props}>
		<path d="M26,43.545a20.941,20.941,0,0,0-5.673-3.218A17.876,17.876,0,0,0,14,39.182a17.093,17.093,0,0,0-4.5.6,19.744,19.744,0,0,0-4.227,1.691,2.1,2.1,0,0,1-2.209-.055A2.108,2.108,0,0,1,2,39.509V13.218a2.344,2.344,0,0,1,.3-1.145,1.883,1.883,0,0,1,.9-.818A22.766,22.766,0,0,1,8.436,9.291,23.592,23.592,0,0,1,26,11.909v27.6a22.315,22.315,0,0,1,5.836-2.7,21.7,21.7,0,0,1,6.164-.9,26.479,26.479,0,0,1,4.282.382,13.437,13.437,0,0,1,4.445,1.582V10.327q.545.218,1.064.436a10.333,10.333,0,0,1,1.009.491,2.591,2.591,0,0,1,.873.845A2.056,2.056,0,0,1,50,13.218V39.509a2.216,2.216,0,0,1-3.273,1.964A19.744,19.744,0,0,0,42.5,39.782a17.093,17.093,0,0,0-4.5-.6,17.876,17.876,0,0,0-6.327,1.145A20.941,20.941,0,0,0,26,43.545Zm3.273-9.109V15.182L43.455,1V22.109Z" />
	</SvgIcon>
);

export const ContactUsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 30.33 30.33" {...props}>
		<path d="M0,0H30.33V30.33H0Z" fill="none" />
		<path
			d="M14.665,2A11.443,11.443,0,0,0,3,13.19,11.443,11.443,0,0,0,14.665,24.38h.686v3.95c6.67-3.081,10.979-9.215,10.979-15.14A11.443,11.443,0,0,0,14.665,2Zm1.372,19.089H13.293V18.456h2.745Zm0-4.608H13.293c0-4.279,4.117-3.95,4.117-6.583a2.747,2.747,0,0,0-5.489,0H9.176a5.38,5.38,0,0,1,5.489-5.266A5.38,5.38,0,0,1,20.154,9.9C20.154,13.19,16.037,13.519,16.037,16.482Z"
			transform="translate(0 0)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const NewFormIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="NewFormIcon-clip-path">
				<path fill="none" d="M0 0H19.279V20.545H0z" data-name="Rectangle 3018" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3011" />
		<g data-name="Group 6515" transform="translate(2.36 2.727)">
			<g data-name="Group 6526">
				<g data-name="Group 6529">
					<g data-name="Group 6530">
						<g data-name="Group 6525">
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3012"
								transform="translate(3.419 3.411)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3013"
								transform="translate(7.451 3.411)"
							/>
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3014"
								transform="translate(3.419 7.001)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3015"
								transform="translate(7.451 7.001)"
							/>
							<path
								fill="currentColor"
								d="M0 0H1.371V1.303H0z"
								data-name="Rectangle 3016"
								transform="translate(3.419 10.592)"
							/>
							<path
								fill="currentColor"
								d="M0 0H4.114V1.303H0z"
								data-name="Rectangle 3017"
								transform="translate(7.451 10.592)"
							/>
							<g data-name="Group 6514">
								<g clipPath="url(#NewFormIcon-clip-path)" data-name="Group 6513">
									<path
										fill="currentColor"
										d="M10.278 14.269H1.3V1.295h12.883v8.858h1.3V.44a.441.441 0 00-.44-.44H.44A.44.44 0 000 .44v14.694a.44.44 0 00.44.44h9.838z"
										data-name="Path 6958"
									/>
								</g>
							</g>
						</g>
						<path
							fill="currentColor"
							d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
							data-name="↳Color"
							transform="translate(11.565 12.739)"
						/>
					</g>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const NewRoleIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="NewRoleIcon-clip-path">
				<path fill="none" d="M0 0H20.669V20.608H0z" data-name="Rectangle 3019" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3020" />
		<g data-name="Group 6517" transform="translate(2 1.696)">
			<g clipPath="url(#NewRoleIcon-clip-path)" data-name="Group 6516">
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="0.25"
					d="M7.126 8.411a4.836 4.836 0 00.35.669l.006.01c.088.149.16.272.223.4a.425.425 0 01.166.331 2.985 2.985 0 00.565.733l.015.014a2.4 2.4 0 01-.413 1.575c-.312.124-.67.248-1.063.37l.215.734c.5-.147.843-.258 1.1-.359.863-.394.907-2 .907-2.32v-.334l-.249-.247-.013-.014a1.887 1.887 0 01-.317-.4A.946.946 0 008.369 9a.6.6 0 00-.169-.334 1.5 1.5 0 01-.27-.451L7.928 8.2c-.019-.041-.036-.079-.054-.113l-.166-.249-.246-.168-.083-.082a3.354 3.354 0 01-.415-1.493l.5-.164V5.35a4.47 4.47 0 01.516-2.206 2.905 2.905 0 011.382-1.277.4.4 0 00.245-.082 4.869 4.869 0 011.158-.416 1.207 1.207 0 00.4-.1h.014c.054-.02.108-.039.169-.059v.581l.661.164a.9.9 0 01.5.167v.33l.239.25a3.606 3.606 0 01.828 2.651v.5l.412.249a2.68 2.68 0 01-.412 1.411l-.163.164-.249.167L13 8.17a2.6 2.6 0 01-.4.816L12.584 9l-.009.01c-.077.077-.157.157-.157.237l-.082.084a2.088 2.088 0 01-.412.578l-.415.249.084.5c0 .74.282 1.923.91 2.238h.166l.331.082a23.308 23.308 0 012.915 1.24l.008-.875a12.249 12.249 0 00-2.678-1.113l-.331-.082c-.152-.078-.407-.618-.5-1.575a2.371 2.371 0 00.661-.829.416.416 0 00.085-.127.438.438 0 01.081-.123 4.507 4.507 0 00.579-1.076A2.264 2.264 0 0014.313 8a4.217 4.217 0 00.5-2.242 1 1 0 00-.411-.414 4.6 4.6 0 00-1.076-3.232v-.164a1.36 1.36 0 00-1.159-.827.638.638 0 00-.079-.331 1.15 1.15 0 00-.582-.663H11.5a.3.3 0 00-.24.082l-.167.164c0 .085-.162.167-.494.249a11.568 11.568 0 00-1.23.406h-.008l-.02.007c-.09.034-.167.063-.225.083-1.5.583-2.4 2.163-2.4 4.226a.675.675 0 00-.411.411A4.079 4.079 0 006.715 8a1.018 1.018 0 00.411.411z"
					data-name="Path 6962"
				/>
				<g fill="currentColor" data-name="Group 6527">
					<path
						d="M2.988 15.335l.294-.713h.062a2.439 2.439 0 00.619-.08 3.4 3.4 0 00.746-.267l.652.483.766-.7-.516-.609a2.165 2.165 0 00.327-.679 2.054 2.054 0 00.054-.547v-.143l.75-.235-.231-1.065-.81.1a1.654 1.654 0 00-.392-.539 1.876 1.876 0 00-.582-.415l.1-.782-1.069-.23-.294.714h-.113a2.129 2.129 0 00-.615.079 2.149 2.149 0 00-.53.19l-.167.076-.652-.548-.7.7.513.675a2.141 2.141 0 00-.318.681c-.054.23-.088.419-.123.618l-.011.067L0 12.4l.231 1.06.811-.105.052.084a2.3 2.3 0 00.359.475 1.761 1.761 0 00.564.394l-.1.787 1.066.235zm.425-5.019a1.808 1.808 0 11-1.845 1.808 1.816 1.816 0 011.845-1.808"
						data-name="Path 6959"
					/>
					<path
						d="M20.669 17.688h-2.907v2.92h-.969v-2.92h-2.908v-.974h2.908v-2.92h.969v2.92h2.907z"
						data-name="Path 6960"
					/>
					<path
						d="M7.126 8.411a4.836 4.836 0 00.35.669l.006.01c.088.149.16.272.223.4a.425.425 0 01.166.331 2.985 2.985 0 00.565.733l.015.014a2.4 2.4 0 01-.413 1.575c-.312.124-.67.248-1.063.37l.215.734c.5-.147.843-.258 1.1-.359.863-.394.907-2 .907-2.32v-.334l-.249-.247-.013-.014a1.887 1.887 0 01-.317-.4A.946.946 0 008.369 9a.6.6 0 00-.169-.334 1.5 1.5 0 01-.27-.451L7.928 8.2c-.019-.041-.036-.079-.054-.113l-.166-.249-.246-.168-.083-.082a3.354 3.354 0 01-.415-1.493l.5-.164V5.35a4.47 4.47 0 01.516-2.206 2.905 2.905 0 011.382-1.277.4.4 0 00.245-.082 4.869 4.869 0 011.158-.416 1.207 1.207 0 00.4-.1h.014c.054-.02.108-.039.169-.059v.581l.661.164a.9.9 0 01.5.167v.33l.239.25a3.606 3.606 0 01.828 2.651v.5l.412.249a2.68 2.68 0 01-.412 1.411l-.163.164-.249.167L13 8.17a2.6 2.6 0 01-.4.816L12.584 9l-.009.01c-.077.077-.157.157-.157.237l-.082.084a2.088 2.088 0 01-.412.578l-.415.249.084.5c0 .74.282 1.923.91 2.238h.166l.331.082a23.308 23.308 0 012.915 1.24l.008-.875a12.249 12.249 0 00-2.678-1.113l-.331-.082c-.152-.078-.407-.618-.5-1.575a2.371 2.371 0 00.661-.829.416.416 0 00.085-.127.438.438 0 01.081-.123 4.507 4.507 0 00.579-1.076A2.264 2.264 0 0014.313 8a4.217 4.217 0 00.5-2.242 1 1 0 00-.411-.414 4.6 4.6 0 00-1.076-3.232v-.164a1.36 1.36 0 00-1.159-.827.638.638 0 00-.079-.331 1.15 1.15 0 00-.582-.663H11.5a.3.3 0 00-.24.082l-.167.164c0 .085-.162.167-.494.249a11.568 11.568 0 00-1.23.406h-.008l-.02.007c-.09.034-.167.063-.225.083-1.5.583-2.4 2.163-2.4 4.226a.675.675 0 00-.411.411A4.079 4.079 0 006.715 8a1.018 1.018 0 00.411.414"
						data-name="Path 6961"
					/>
					<path
						d="M12.644 16.785H3.989a.564.564 0 01-.58-.547V16.2c0-.068 0-.133.006-.207h-.747v.292A1.392 1.392 0 004.04 17.7h8.6z"
						data-name="Path 6963"
					/>
				</g>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth="0.25"
					d="M12.644 16.785H3.989a.564.564 0 01-.58-.547V16.2c0-.068 0-.133.006-.207h-.747v.292A1.392 1.392 0 004.04 17.7h8.6z"
					data-name="Path 6964"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const AddAppIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath>
				<path fill="none" d="M0 0H19.279V20.545H0z" data-name="Rectangle 3018" />
			</clipPath>
		</defs>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3011" />
		<g data-name="Group 6515" transform="translate(3.36 1.727)">
			<g data-name="Group 6526">
				<g data-name="Group 6529">
					<g data-name="Group 6530">
						<path
							fill="currentColor"
							d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
							data-name="↳Color"
							transform="translate(11.565 12.739)"
						/>
					</g>
				</g>
			</g>
			<path
				fill="currentColor"
				d="M162-784a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-784zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-786a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-788a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-786a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-784zm-6-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-790zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-792a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-794a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-792a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-790zm-12-6a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01160-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01162-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01164-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01162-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01166-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01168-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01170-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01168-796zm6 0a1.926 1.926 0 01-1.412-.587A1.926 1.926 0 01172-798a1.926 1.926 0 01.588-1.413A1.926 1.926 0 01174-800a1.926 1.926 0 011.413.587A1.926 1.926 0 01176-798a1.926 1.926 0 01-.587 1.413A1.926 1.926 0 01174-796z"
				transform="translate(-160.36 801.273)"
			/>
		</g>
	</SvgIcon>
);

export const AddSingleDeviceIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3010" />
		<g data-name="Group 6512" transform="translate(-337.167 -640.3)">
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth="0.2"
				d="M343.537 662.171h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
				data-name="Path 6950"
			/>
			<path
				fill="currentColor"
				d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
				data-name="Path 6951"
				transform="translate(340.91 642.911)"
			/>
			<path
				fill="none"
				d="M0 0H17.933V19.971H0z"
				data-name="Rectangle 3009"
				transform="translate(340.201 642.315)"
			/>
			<g data-name="Group 6524">
				<g data-name="Group 6528">
					<g fill="currentColor" data-name="Group 6523">
						<path
							d="M3.238 17.425h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
							data-name="Path 6949"
							transform="translate(340.299 644.746)"
						/>
						<path
							d="M8.388 13.045H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
							data-name="Path 6952"
							transform="translate(340.444 644.091)"
						/>
						<path
							d="M8.388 9.862H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
							data-name="Path 6953"
							transform="translate(340.444 643.614)"
						/>
						<path
							d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
							data-name="Path 6954"
							transform="translate(340.91 642.911)"
						/>
						<path
							d="M7.46 16.768H1.183V1.2h3.062l.521 2.289a.592.592 0 00.575.46h7.409v6.161h1.178V3.357a.591.591 0 00-.591-.591H5.812l-.018-.08 7.044-1.507a.591.591 0 10-.246-1.15l-7.063 1.5-.24-1.054a.59.59 0 00-.575-.46H.591A.592.592 0 000 .607v16.749a.593.593 0 00.591.593H7.46z"
							data-name="Path 6956"
							transform="translate(340.201 642.314)"
						/>
					</g>
					<path
						fill="currentColor"
						d="M6.784 3.894H3.877v2.92h-.969v-2.92H0V2.92h2.908V0h.969v2.92h2.907z"
						data-name="↳Color"
						transform="translate(350.167 654.767)"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const ImportDevicesIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 3010" />
		<g data-name="Group 6512" transform="translate(-337.167 -640.3)">
			<path
				fill="none"
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth="0.2"
				d="M343.537 662.171h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
				data-name="Path 6950"
			/>
			<path
				fill="currentColor"
				d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
				data-name="Path 6951"
				transform="translate(340.91 642.911)"
			/>
			<path
				fill="currentColor"
				d="M11.684 15.157l-2.529-2.532.709-.735 1.311 1.31V9.078h1.01v4.127l1.315-1.313.709.735zm-3.035 2.026a1.013 1.013 0 01-1.012-1.013v-1.52h1.012v1.52h6.07v-1.52h1.01v1.52a1.013 1.013 0 01-1.01 1.013z"
				data-name="Path 6955"
				transform="translate(341.875 644.372)"
			/>
			<g fill="currentColor" data-name="Group 6519">
				<path
					d="M3.238 17.425h-2a.59.59 0 010-1.18h2a.59.59 0 110 1.18z"
					data-name="Path 6949"
					transform="translate(340.298 644.746)"
				/>
				<path
					d="M8.388 13.045H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
					data-name="Path 6952"
					transform="translate(340.444 644.091)"
				/>
				<path
					d="M8.388 9.862H2.177a.591.591 0 010-1.18h6.211a.591.591 0 010 1.18z"
					data-name="Path 6953"
					transform="translate(340.444 643.614)"
				/>
				<path
					d="M5.326 3.986h5.491a.59.59 0 01.59.59v2.745a.59.59 0 01-.59.59H5.326a.59.59 0 01-.59-.59V4.576a.59.59 0 01.59-.59m4.9 1.18h-4.31v1.565h4.308z"
					data-name="Path 6954"
					transform="translate(340.91 642.911)"
				/>
				<path
					d="M7.46 16.768H1.183V1.2h3.062l.521 2.289a.592.592 0 00.575.46h7.409V9.11h1.178V3.357a.591.591 0 00-.591-.591H5.812l-.018-.08 7.044-1.507a.591.591 0 10-.246-1.15l-7.063 1.5-.24-1.054a.59.59 0 00-.575-.46H.591A.592.592 0 000 .607v16.749a.593.593 0 00.591.593H7.46z"
					data-name="Path 6956"
					transform="translate(340.201 642.314)"
				/>
			</g>
			<path
				fill="none"
				d="M0 0H17.933V19.971H0z"
				data-name="Rectangle 3009"
				transform="translate(340.201 642.315)"
			/>
		</g>
	</SvgIcon>
);

export const CopyFlippedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<g id="Group_3641" data-name="Group 3641" transform="translate(9890 17702)">
			<path
				id="content_copy_FILL0_wght500_GRAD0_opsz24"
				d="M107.913-879.6a1.488,1.488,0,0,1-1.093-.451,1.488,1.488,0,0,1-.451-1.092v-9.453h1.544v9.453h7.417v1.544Zm2.9-2.9a1.488,1.488,0,0,1-1.093-.451,1.488,1.488,0,0,1-.451-1.093v-8.047a1.488,1.488,0,0,1,.451-1.093,1.488,1.488,0,0,1,1.093-.451h6.011a1.488,1.488,0,0,1,1.093.451,1.488,1.488,0,0,1,.451,1.093v8.047a1.488,1.488,0,0,1-.451,1.093,1.488,1.488,0,0,1-1.093.451Zm0-1.544h6.011v-8.047h-6.011Zm0,0v0Z"
				transform="translate(-9990.369 -16803.387)"
				fill="#7d61bc"
			/>
			<g id="Group_3627" data-name="Group 3627" transform="translate(-40 97)">
				<g id="Group_3622" data-name="Group 3622" transform="translate(-82 -22)">
					<rect
						id="Rectangle_1958"
						data-name="Rectangle 1958"
						width="24"
						height="24"
						transform="translate(-9768 -17777)"
						fill="none"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);

export const HourglassBottomIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<g>
			<rect fill="none" height="24" width="24" />
		</g>
		<g>
			<path d="M18,22l-0.01-6L14,12l3.99-4.01L18,2H6v6l4,4l-4,3.99V22H18z M8,7.5V4h8v3.5l-4,4L8,7.5z" />
		</g>
	</SvgIcon>
);
export const JobsIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<rect fill="none" height="24" width="24" />
		<path d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z" />
	</SvgIcon>
);
export const JobQueueIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path
			d="M16,1H4C2.9,1,2,1.9,2,3v14h2V3h12V1z M15,5H8C6.9,5,6,5.9,6,7l0,14c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2V11L15,5z M8,21V7h6
	v5h5v9H8z"
		/>
		<polygon points="10.3,14.6 8.9,16 12.4,19.5 18.1,13.9 16.7,12.4 12.4,16.7 " />
	</SvgIcon>
);
export const JobQueueManagementIcon = (props: SvgIconProps) => (
	<SvgIcon transform="translate(-4 -4)" viewBox="0 0 19 19" overflow="visible" {...props}>
		<g transform="translate(3 3)">
			<path fill="none" d="M0 0h18v18H0z" data-name="Path 6725" />
			<path
				fill="currentColor"
				d="M13.646 1H3.664A1.618 1.618 0 002 2.557v10.9h1.664v-10.9h9.982zm-.832 3.113H6.991A1.618 1.618 0 005.327 5.67v10.9a1.618 1.618 0 001.664 1.557h9.15a1.618 1.618 0 001.659-1.562V8.783zM6.991 16.565V5.67h4.991v3.891h4.159v7z"
				data-name="Path 6726"
				transform="translate(-1.122 -.561)"
			/>
		</g>
		<path fill="none" d="M0 0H24V24H0z" data-name="Rectangle 2027" />
		<path
			fill="currentColor"
			d="M2.205 5.727l-.172-.859q-.172-.072-.322-.15a2.494 2.494 0 01-.311-.193l-.83.258L0 3.809l.659-.573a2.644 2.644 0 01-.029-.372 2.644 2.644 0 01.029-.372L0 1.919.573.945 1.4 1.2a2.491 2.491 0 01.308-.193q.15-.079.322-.15L2.205 0h1.146l.172.859a2.891 2.891 0 01.322.158 2.259 2.259 0 01.308.215l.83-.286.573 1-.656.574a2.252 2.252 0 010 .716l.659.573-.573.974-.83-.258a2.5 2.5 0 01-.308.193q-.15.079-.322.15l-.172.859zm.573-1.718a1.149 1.149 0 001.145-1.145 1.149 1.149 0 00-1.145-1.146 1.149 1.149 0 00-1.146 1.146 1.149 1.149 0 001.146 1.145z"
			transform="rotate(164 6.88 9.893)"
		/>
	</SvgIcon>
);
export const JobLockedIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<rect width="24" height="24" fill="none" />
		<g transform="translate(-34 4)">
			<path
				d="M9.143,18A1.138,1.138,0,0,1,8,16.857V8.59A1.138,1.138,0,0,1,9.143,7.448h1.333V5.619a3.489,3.489,0,0,1,1.057-2.562,3.633,3.633,0,0,1,5.124,0,3.489,3.489,0,0,1,1.057,2.562V7.448h1.333A1.138,1.138,0,0,1,20.19,8.59v8.267A1.138,1.138,0,0,1,19.048,18ZM14.1,14.19a1.43,1.43,0,0,0,1.038-.419,1.361,1.361,0,0,0,.429-1.01,1.5,1.5,0,0,0-.429-1.038,1.388,1.388,0,0,0-2.076,0,1.5,1.5,0,0,0-.429,1.038,1.361,1.361,0,0,0,.429,1.01A1.43,1.43,0,0,0,14.1,14.19ZM11.619,7.448h4.952V5.619a2.478,2.478,0,0,0-4.229-1.752,2.387,2.387,0,0,0-.724,1.752Z"
				transform="translate(31.905 -2)"
				fill="#5f3fa5"
			/>
		</g>
	</SvgIcon>
);

export const JobQueueActiveIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="task-pool" transform="translate(4 4)">
			<path id="Path_6725" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
			<path
				id="Path_6727"
				data-name="Path 6727"
				d="M9.78,13.783l-.88.88,2.2,2.2,3.583-3.52L13.8,12.4l-2.7,2.7Z"
				transform="translate(-2.534 -3.54)"
			/>
		</g>
		<g id="task-pool-2" data-name="task-pool" transform="translate(4 4)">
			<path id="Path_6725-2" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726-2"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
			<path
				id="Path_6727-2"
				data-name="Path 6727"
				d="M9.78,13.783l-.88.88,2.2,2.2,3.583-3.52L13.8,12.4l-2.7,2.7Z"
				transform="translate(-2.534 -3.54)"
			/>
		</g>
	</SvgIcon>
);

export const JobQueueInactiveIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
				<stop offset="0" stopColor="#fff" />
				<stop offset="0.482" stopColor="#fff" stopOpacity="0.38" />
				<stop offset="1" stopColor="#41b80e" stopOpacity="0.38" />
			</radialGradient>
		</defs>
		<rect id="Rectangle_596" data-name="Rectangle 596" width="24" height="24" rx="4" opacity="0" />
		<g id="task-pool" transform="translate(4 4)">
			<path id="Path_6725" data-name="Path 6725" d="M0,0H16V16H0Z" fill="none" />
			<path
				id="Path_6726"
				data-name="Path 6726"
				d="M12.352,1H3.479A1.438,1.438,0,0,0,2,2.384v9.685H3.479V2.384h8.873Zm-.739,2.767H6.436A1.438,1.438,0,0,0,4.958,5.151v9.685A1.438,1.438,0,0,0,6.436,16.22H14.57a1.438,1.438,0,0,0,1.479-1.384V7.918ZM6.436,14.836V5.151h4.436V8.61h3.7v6.226Z"
				transform="translate(-1.22 -0.61)"
			/>
		</g>
	</SvgIcon>
);

export const CampaignIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path d="M18 11v2h4v-2zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61M20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4M4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55zM15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34" />
	</SvgIcon>
);

export const CelebrationIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path d="m2 22 14-5-9-9zm10.35-5.82L5.3 18.7l2.52-7.05zm2.18-3.65 5.59-5.59c.49-.49 1.28-.49 1.77 0l.59.59 1.06-1.06-.59-.59c-1.07-1.07-2.82-1.07-3.89 0l-5.59 5.59zm-4.47-5.65-.59.59 1.06 1.06.59-.59c1.07-1.07 1.07-2.82 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76m7 5-1.59 1.59 1.06 1.06 1.59-1.59c.49-.49 1.28-.49 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61c-1.08-1.07-2.82-1.07-3.89 0m-2-6-3.59 3.59 1.06 1.06 3.59-3.59c1.07-1.07 1.07-2.82 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77" />
	</SvgIcon>
);

export const StarIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Rectangle_3195" fill="none" d="M0 0h24v24H0z" data-name="Rectangle 3195" />
		<path
			id="stars_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="currentColor"
			d="m86-864 4-3.05 4 3.05-1.5-4.95 4-2.85h-4.9L90-877l-1.6 5.2h-4.9l4 2.85Zm4 4a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138 10.1 10.1 0 0 1-2.138-3.175A9.7 9.7 0 0 1 80-870a9.7 9.7 0 0 1 .787-3.9 10.1 10.1 0 0 1 2.138-3.175 10.1 10.1 0 0 1 3.175-2.138A9.7 9.7 0 0 1 90-880a9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138 10.1 10.1 0 0 1 2.138 3.175A9.7 9.7 0 0 1 100-870a9.7 9.7 0 0 1-.787 3.9 10.1 10.1 0 0 1-2.138 3.175 10.1 10.1 0 0 1-3.175 2.138A9.7 9.7 0 0 1 90-860m0-2a7.72 7.72 0 0 0 5.675-2.325A7.72 7.72 0 0 0 98-870a7.72 7.72 0 0 0-2.325-5.675A7.72 7.72 0 0 0 90-878a7.72 7.72 0 0 0-5.675 2.325A7.72 7.72 0 0 0 82-870a7.72 7.72 0 0 0 2.325 5.675A7.72 7.72 0 0 0 90-862m0-8"
			transform="translate(-78 882)"
		/>
	</SvgIcon>
);

export const SunnyIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Rectangle_3197" fill="none" d="M0 0h24v24H0z" data-name="Rectangle 3197" />
		<path
			id="partly_cloudy_day_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
			fill="currentColor"
			d="M49.091-916.364V-920h1.818v3.636Zm6.045 2.5-1.273-1.273 2.568-2.591 1.273 1.3Zm1.227 4.773v-1.818H60v1.818Zm.068 6.8-2.568-2.568 1.273-1.273 2.591 2.545Zm-11.567-11.573-2.564-2.568 1.3-1.3 2.545 2.591Zm-.318 10.227h4.091a1.32 1.32 0 0 0 .966-.4A1.32 1.32 0 0 0 50-905a1.34 1.34 0 0 0-.386-.966 1.28 1.28 0 0 0-.955-.4H47.5l-.455-1.091a2.6 2.6 0 0 0-1-1.193 2.7 2.7 0 0 0-1.5-.443 2.63 2.63 0 0 0-1.932.8 2.63 2.63 0 0 0-.8 1.932 2.63 2.63 0 0 0 .8 1.932 2.63 2.63 0 0 0 1.932.793Zm0 1.818a4.38 4.38 0 0 1-3.216-1.33 4.38 4.38 0 0 1-1.33-3.215 4.38 4.38 0 0 1 1.33-3.216 4.38 4.38 0 0 1 3.216-1.33 4.44 4.44 0 0 1 2.489.739 4.46 4.46 0 0 1 1.67 1.989 2.89 2.89 0 0 1 2.216.977 3.34 3.34 0 0 1 .9 2.341 3.03 3.03 0 0 1-.966 2.17 3.1 3.1 0 0 1-2.216.875Zm7.273-3.045q-.114-.455-.227-.886t-.227-.886a3.7 3.7 0 0 0 1.648-1.341 3.5 3.5 0 0 0 .623-2.023 3.5 3.5 0 0 0-1.068-2.568A3.5 3.5 0 0 0 50-913.636a3.53 3.53 0 0 0-2.386.886 3.5 3.5 0 0 0-1.2 2.25q-.455-.114-.932-.2t-.932-.2a5.13 5.13 0 0 1 1.875-3.273A5.5 5.5 0 0 1 50-915.455a5.26 5.26 0 0 1 3.864 1.591A5.26 5.26 0 0 1 55.455-910a5.28 5.28 0 0 1-1 3.148 5.44 5.44 0 0 1-2.637 1.988ZM50.023-910"
			transform="translate(-38 922.909)"
		/>
	</SvgIcon>
);

export const CirclePlusIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Path_8158" data-name="Path 8158" d="M0,0H24V24H0Z" fill="none" />
		<path
			id="Path_8159"
			data-name="Path 8159"
			d="M10.5,2A8.5,8.5,0,1,0,19,10.5,8.5,8.5,0,0,0,10.5,2Zm4.25,9.35h-3.4v3.4H9.65v-3.4H6.25V9.65h3.4V6.25h1.7v3.4h3.4Z"
			transform="translate(1.5 1.5)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const TransferOwnershipIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_2901" data-name="Rectangle 2901" width="24" height="24" fill="none" />
		<g id="Group_7867" data-name="Group 7867" transform="translate(0.255 0.523)">
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.931,1.931,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.677,7.677,0,0,1,1.49-.45,8.085,8.085,0,0,1,1.55-.15,8.084,8.084,0,0,1,1.55.15,7.677,7.677,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-476.162 564.065)"
				fill="currentColor"
			/>
			<path
				id="supervisor_account_FILL0_wght400_GRAD0_opsz24-2"
				data-name="supervisor_account_FILL0_wght400_GRAD0_opsz24"
				d="M484-556a1.932,1.932,0,0,1-1.42-.58A1.932,1.932,0,0,1,482-558a1.931,1.931,0,0,1,.58-1.42A1.931,1.931,0,0,1,484-560a1.931,1.931,0,0,1,1.42.58A1.931,1.931,0,0,1,486-558a1.931,1.931,0,0,1-.58,1.42A1.931,1.931,0,0,1,484-556Zm-4,4v-1.12a1.679,1.679,0,0,1,.25-.89,1.408,1.408,0,0,1,.71-.59,7.672,7.672,0,0,1,1.49-.45,8.08,8.08,0,0,1,1.55-.15,8.079,8.079,0,0,1,1.55.15,7.671,7.671,0,0,1,1.49.45,1.408,1.408,0,0,1,.71.59,1.678,1.678,0,0,1,.25.89V-552Z"
				transform="translate(-468.349 570.888)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.446,0,2.828,1.618,1.211l.566.586-.627.627H4.319V0h.809V3.233H1.557l.627.627Z"
				transform="translate(10.061 13.065) rotate(90)"
				fill="currentColor"
			/>
			<path
				id="repeat_one_FILL0_wght400_GRAD0_opsz24-2"
				data-name="repeat_one_FILL0_wght400_GRAD0_opsz24"
				d="M1.618,4.447,0,2.829,1.618,1.211l.566.587-.627.627H4.319V0h.809V3.234H1.557l.627.627Z"
				transform="translate(13.428 10.193) rotate(-90)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const CalendarIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g id="Group_908" data-name="Group 908">
			<rect id="Rectangle_891" data-name="Rectangle 891" width="24" height="24" fill="none" />
		</g>
		<g id="Group_909" data-name="Group 909" transform="translate(3 2)">
			<path
				id="Path_6213"
				data-name="Path 6213"
				d="M19,4H18V2H16V4H8V2H6V4H5A1.991,1.991,0,0,0,3.01,6L3,20a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V10H19ZM19,8H5V6H19ZM9,14H7V12H9Zm4,0H11V12h2Zm4,0H15V12h2ZM9,18H7V16H9Zm4,0H11V16h2Zm4,0H15V16h2Z"
				transform="translate(-3 -2)"
				fill="currentColor"
			/>
		</g>
	</SvgIcon>
);

export const ThumbsDownIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="ThumbsDownIcon-clip-path">
				<rect id="Rectangle_3056" data-name="Rectangle 3056" width="20" height="20" fill="#323232" />
			</clipPath>
		</defs>
		<g id="Group_7180" data-name="Group 7180" transform="translate(-6860 -1664) rotate(180)">
			<g id="Group_7178" data-name="Group 7178" transform="translate(-6882 -1686.002)">
				<g
					id="Group_7177"
					data-name="Group 7177"
					transform="translate(0 0.002)"
					clipPath="url(#ThumbsDownIcon-clip-path)"
				>
					<path
						id="Path_8100"
						data-name="Path 8100"
						d="M276.6,0a1.776,1.776,0,0,1,1.543,1.048,5.58,5.58,0,0,1,.566,4.241c-.257,1.264-.411,2.488-.411,2.488h6.53l0,.008a1.588,1.588,0,0,1-.15,3.162h.131a1.616,1.616,0,0,1,1.624,1.5,1.566,1.566,0,0,1-1.537,1.67H284.5a1.592,1.592,0,0,1-.667,3.047H283.5a1.627,1.627,0,0,1,.482,1.866,1.514,1.514,0,0,1-1.426.969h-5.531a11.36,11.36,0,0,1-5.687-1.511l-.027-.016V9.366c2.817-.181,4.261-4.557,4.364-5.3s.262-3.917.262-3.917A1.532,1.532,0,0,1,276.6,0"
						transform="translate(-266.431 -0.002)"
						fill={props.htmlColor ? props.htmlColor : '#323232'}
					/>
					<path
						id="Path_8101"
						data-name="Path 8101"
						d="M3.388,481.63H.81A.822.822,0,0,1,0,480.8V472.11a.822.822,0,0,1,.81-.834H3.388a.822.822,0,0,1,.81.834V480.8a.822.822,0,0,1-.81.834"
						transform="translate(0 -462.556)"
						fill={props.htmlColor ? props.htmlColor : '#323232'}
					/>
				</g>
			</g>
			<rect
				id="Rectangle_3057"
				data-name="Rectangle 3057"
				width="24"
				height="24"
				transform="translate(-6884 -1688)"
				fill="none"
			/>
		</g>
	</SvgIcon>
);

export const ThumbsUpIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="ThumbsUpIcon-clip-path">
				<rect id="Rectangle_3056" data-name="Rectangle 3056" width="20" height="20" fill="#323232" />
			</clipPath>
		</defs>
		<g id="Group_7178" data-name="Group 7178" transform="translate(2 1.998)">
			<g
				id="Group_7177"
				data-name="Group 7177"
				transform="translate(0 0.002)"
				clipPath="url(#ThumbsUpIcon-clip-path)"
			>
				<path
					id="Path_8100"
					data-name="Path 8100"
					d="M276.6,0a1.776,1.776,0,0,1,1.543,1.048,5.58,5.58,0,0,1,.566,4.241c-.257,1.264-.411,2.488-.411,2.488h6.53l0,.008a1.588,1.588,0,0,1-.15,3.162h.131a1.616,1.616,0,0,1,1.624,1.5,1.566,1.566,0,0,1-1.537,1.67H284.5a1.592,1.592,0,0,1-.667,3.047H283.5a1.627,1.627,0,0,1,.482,1.866,1.514,1.514,0,0,1-1.426.969h-5.531a11.36,11.36,0,0,1-5.687-1.511l-.027-.016V9.366c2.817-.181,4.261-4.557,4.364-5.3s.262-3.917.262-3.917A1.532,1.532,0,0,1,276.6,0"
					transform="translate(-266.431 -0.002)"
					fill={props.htmlColor ? props.htmlColor : '#323232'}
				/>
				<path
					id="Path_8101"
					data-name="Path 8101"
					d="M3.388,481.63H.81A.822.822,0,0,1,0,480.8V472.11a.822.822,0,0,1,.81-.834H3.388a.822.822,0,0,1,.81.834V480.8a.822.822,0,0,1-.81.834"
					transform="translate(0 -462.556)"
					fill={props.htmlColor ? props.htmlColor : '#323232'}
				/>
			</g>
		</g>
		<rect id="Rectangle_3057" data-name="Rectangle 3057" width="24" height="24" fill="none" />
	</SvgIcon>
);

export const ApprovalIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path id="Path_6765" data-name="Path 6765" d="M0,0H24V24H0Z" fill="none" />
		<path
			id="verified_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="verified_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M47.6-879l-1.9-3.2-3.6-.8.35-3.7L40-889.5l2.45-2.8L42.1-896l3.6-.8,1.9-3.2,3.4,1.45L54.4-900l1.9,3.2,3.6.8-.35,3.7L62-889.5l-2.45,2.8.35,3.7-3.6.8L54.4-879,51-880.45Zm.85-2.55,2.55-1.1,2.6,1.1,1.4-2.4,2.75-.65-.25-2.8,1.85-2.1-1.85-2.15.25-2.8-2.75-.6-1.45-2.4L51-896.35l-2.6-1.1-1.4,2.4-2.75.6.25,2.8-1.85,2.15,1.85,2.1-.25,2.85,2.75.6ZM51-889.5Zm-1.05,3.55,5.65-5.65-1.4-1.45-4.25,4.25-2.15-2.1-1.4,1.4Z"
			transform="translate(-38.926 902)"
			fill={props.htmlColor ? props.htmlColor : '#323232'}
		/>
	</SvgIcon>
);

export const SignatureTypeBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 76 76" {...props}>
		<g id="Group_6957" data-name="Group 6957" transform="translate(-915.704 -480.501)">
			<path
				id="Path_7941"
				data-name="Path 7941"
				d="M0,0V65"
				transform="translate(978.5 486.5)"
				fill="none"
				stroke="#f2eff9"
				strokeWidth="2"
			/>
			<g id="Group_6956" data-name="Group 6956" transform="translate(929.907 496.496)">
				<path
					id="Path_6092"
					data-name="Path 6092"
					d="M14.413,38.223,9.422,52.779H3.6L19.4,6.2h7.07L42.693,53.195H36.455L31.464,38.639H14.413ZM29.8,33.648,25.226,20.34c-.832-2.911-1.664-5.822-2.5-8.318h0c-.832,2.5-1.664,5.406-2.5,7.9L15.661,33.232H29.8Z"
					transform="translate(-3.6 -6.2)"
					fill="#f2eff9"
				/>
			</g>
		</g>
		<rect id="Rectangle_3176" data-name="Rectangle 3176" width="76" height="76" fill="none" />
	</SvgIcon>
);

export const SignatureDrawBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 82 76" {...props}>
		<g id="Group_6960" data-name="Group 6960" transform="translate(2420.931 4574.999)">
			<g id="Group_6958" data-name="Group 6958" transform="translate(-2418.483 -4565.462)">
				<path
					id="Path_7936"
					data-name="Path 7936"
					d="M77.1,46H16.85a78.893,78.893,0,0,0,2.882-8.278q.526-1.858.958-3.74A5.532,5.532,0,0,1,26.227,36.7a4.432,4.432,0,0,1,.311,3.126,6.539,6.539,0,0,0-1.72,2.665,1.167,1.167,0,0,0,.411,1.392c.912.611,2.852-.134,3.192-.417a6.84,6.84,0,0,0,1.84-2.381c1.209-.655,3.109-.591,5.67.207l.882.274A22.353,22.353,0,0,0,43.6,42.939h.033A3.138,3.138,0,0,0,45.979,41.6a1.151,1.151,0,0,0,.037-1.165,1.5,1.5,0,0,0-1.409-.628H44.6a19.66,19.66,0,0,1-5.52-1.132,17.133,17.133,0,0,0-7.116-1.129c-.394.04-.771.1-1.135.177-.007-.07-.017-.144-.027-.217a7.481,7.481,0,0,0-4.187-5.74,10.243,10.243,0,0,0-5.263-.945,79.137,79.137,0,0,0,1.356-13.788,62.765,62.765,0,0,0-.478-9.48c-.291-2.024-.935-4.892-3.142-6.442-4.331-3.035-9.767.661-13.1,4.745C1.376,11.513.257,18.756,3.139,24.313A14.471,14.471,0,0,0,16.092,32.3l.174,0a18.349,18.349,0,0,0-3.59,2.361A28.945,28.945,0,0,0,4.6,46H0v3.693H3.55c-.033.16-.083.324-.107.484a5.736,5.736,0,0,0,2.848,6.191,4.555,4.555,0,0,0,2.047.488,5.479,5.479,0,0,0,3.914-1.82,17.305,17.305,0,0,0,3.089-5.343H77.1ZM8.9,25.411A13.879,13.879,0,0,1,6.3,13.323c.925-3.376,3.857-8.669,7.487-9.861a3.57,3.57,0,0,1,1.085-.194,2.017,2.017,0,0,1,1.172.354c2.01,1.386,2.241,6.361,2.351,8.749l.023.481a75.826,75.826,0,0,1-.935,16.309l-.127.007A9.778,9.778,0,0,1,8.9,25.411m.965,18.637a24.888,24.888,0,0,1,6.151-8.011c-.25.962-.521,1.923-.808,2.878C14.476,41.347,13.6,43.7,12.656,46H8.933c.3-.671.614-1.329.935-1.95m.4,7.206-.264.538c-.431.9-.494,1.045-1.332,1.062a6.025,6.025,0,0,1-.785-.013,1.844,1.844,0,0,1-.237-.568,3.931,3.931,0,0,1-.08-1.423,8.793,8.793,0,0,1,.164-1.159H10.98c-.244.511-.451,1.059-.708,1.563"
					transform="translate(0 0)"
					fill="#f2eff9"
				/>
				<g id="Group_6953" data-name="Group 6953" transform="translate(47.689 0.701)">
					<path
						id="Path_7937"
						data-name="Path 7937"
						d="M36.19,6.308a1.31,1.31,0,0,0-.751-1.553C32.928,3.4,31.675,2.718,29.164,1.363c-.371-.2-1.3-.417-1.71.214A147.16,147.16,0,0,0,15.473,24.317L23.7,28.775A147.747,147.747,0,0,0,36.19,6.308"
						transform="translate(-11.493 2.007)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7938"
						data-name="Path 7938"
						d="M14.769,22.6c.578.314,1.443-.094,2.484-1.439,0,0,2.595-.25,7.71-8.131L17.236,8.84c-3.907,8.762-2.625,10.913-2.625,10.913-.264.8-.658,2.4.157,2.845"
						transform="translate(-14.281 19.977)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7939"
						data-name="Path 7939"
						d="M20.723,16.884a1.344,1.344,0,0,0,1.88-.391A76.743,76.743,0,0,0,28.811,5.043a1.357,1.357,0,0,0-2.488-1.085A74.135,74.135,0,0,1,20.332,15a1.374,1.374,0,0,0,.391,1.88"
						transform="translate(-0.614 6.665)"
						fill="#f2eff9"
					/>
					<path
						id="Path_7940"
						data-name="Path 7940"
						d="M26.145,3.432c.19-.354-.067-.872-.584-1.149l-3.5-1.9c-.511-.277-1.089-.217-1.282.14l-.755,1.392,5.37,2.909Z"
						transform="translate(-0.854 -0.21)"
						fill="#f2eff9"
					/>
				</g>
			</g>
		</g>
		<rect id="Rectangle_3175" data-name="Rectangle 3175" width="82" height="76" fill="none" />
	</SvgIcon>
);

export const R2mRegisterIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path
			id="Union_51"
			fill="currentColor"
			d="M14019.93 1222.268a1.91 1.91 0 0 1-1.93-1.93v-16.409a1.91 1.91 0 0 1 1.93-1.927h8.471l5.6 5.6v12.736a1.913 1.913 0 0 1-1.931 1.93Zm-.226-1.7a.3.3 0 0 0 .226.1h12.141a.3.3 0 0 0 .226-.1.3.3 0 0 0 .105-.225V1208.4h-4.8v-4.8h-7.671a.31.31 0 0 0-.226.1.3.3 0 0 0-.105.225v16.409a.3.3 0 0 0 .1.229Zm4.259-2.399a.95.95 0 0 1-.687-.275.92.92 0 0 1-.274-.68v-3.128a.92.92 0 0 1 .274-.68.95.95 0 0 1 .688-.275h.116v-1.057a1.9 1.9 0 0 1 .584-1.409 2.037 2.037 0 0 1 2.85 0 1.9 1.9 0 0 1 .585 1.409v1.057h.092a.93.93 0 0 1 .687.275.91.91 0 0 1 .278.68v3.128a.91.91 0 0 1-.278.68.93.93 0 0 1-.687.275Zm1.362-6.843a1 1 0 0 0-.306.75v1.057h2.134v-1.057a1 1 0 0 0-.307-.75 1.107 1.107 0 0 0-1.521 0"
			data-name="Union 51"
			transform="translate(-14014.001 -1200.002)"
		/>
	</SvgIcon>
);

export const UnivPrintEnableIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none" />
		<path
			id="Union_101"
			data-name="Union 101"
			d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
			transform="translate(-14016.5 -1198.608)"
			fill="#7d61bc"
		/>
	</SvgIcon>
);

export const UnivPrintStatusIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<svg
			id="universal-print-connector"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill={props.htmlColor} />
			<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none" />
			<path
				id="Union_101"
				data-name="Union 101"
				d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
				transform="translate(-14016.5 -1198.608)"
				fill="#fff"
			/>
		</svg>
	</SvgIcon>
);

export const UnivPrintDisabledIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_4145" data-name="Rectangle 4145" width="24" height="24" rx="4" fill="#4b9c14" opacity="0" />
		<rect id="Rectangle_4143" data-name="Rectangle 4143" width="24" height="24" fill="none" />
		<path
			id="Union_101"
			data-name="Union 101"
			d="M14025.187,1219.215v-2.41h-2.234v-3.428a1.487,1.487,0,0,1,1.5-1.508h8.086a1.481,1.481,0,0,1,1.508,1.508v3.428h-2.237v2.41Zm.905-.905h4.82v-2.572h-4.82Zm5.722-3.474v1.064h1.332v-2.523a.59.59,0,0,0-.6-.6h-8.086a.573.573,0,0,0-.427.173.582.582,0,0,0-.176.43v2.523h1.332v-1.064Zm1.332-2.061h0Zm1.558,1.755a2.4,2.4,0,0,0,1.694-.648,2.166,2.166,0,0,0,0-3.178,2.381,2.381,0,0,0-1.694-.648h-1.431v-1.79a4.183,4.183,0,0,0-1.4-3.167,5.016,5.016,0,0,0-6.754,0,4.183,4.183,0,0,0-1.4,3.167h-.479a3.339,3.339,0,0,0-2.36.916,2.993,2.993,0,0,0,0,4.429,3.441,3.441,0,0,0,.853.68v2.029a8.69,8.69,0,0,1-2.113-1.374,4.661,4.661,0,0,1-1.628-3.481,4.772,4.772,0,0,1,1.124-3.111,5.005,5.005,0,0,1,2.935-1.744,6.064,6.064,0,0,1,2.386-3.333,6.826,6.826,0,0,1,4.059-1.276,6.668,6.668,0,0,1,4.735,1.822,5.866,5.866,0,0,1,1.944,4.443,4.26,4.26,0,0,1,2.73,1.332,3.873,3.873,0,0,1-.165,5.546,4.278,4.278,0,0,1-3.044,1.177Zm-3.133-.423a.579.579,0,0,1-.173-.43.609.609,0,0,1,1.033-.43.6.6,0,0,1,.172.43.594.594,0,0,1-.172.43.622.622,0,0,1-.86,0Zm-.658-2.237v-1.807h-4.82v1.807h-.905v-2.709h6.627v2.709Z"
			transform="translate(-14016.5 -1198.608)"
			fill="#d1d1d1"
		/>
	</SvgIcon>
);

export const SignatureUploadBackgroundIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 76 76" {...props}>
		<g id="Group_7946" data-name="Group 7946" transform="translate(928.771 4283.303)">
			<g id="Group_3172" data-name="Group 3172" transform="translate(-1128.539 -4775.303)">
				<g id="Group_6951" data-name="Group 6951" transform="translate(2.768)">
					<g
						id="Rectangle_1474"
						data-name="Rectangle 1474"
						transform="translate(200 495)"
						fill="#f2eff9"
						stroke="#f2eff9"
						strokeWidth="0.5"
					>
						<rect width="69.535" height="69.535" stroke="none" />
						<rect x="0.25" y="0.25" width="69.035" height="69.035" fill="none" />
					</g>
					<path
						id="image_FILL0_wght400_GRAD0_opsz48"
						d="M9.551,42.769H73.258L54.107,17.234,36.91,39.512,24.794,22.967Z"
						transform="translate(193.365 514.618)"
						fill="#dfd8ef"
					/>
				</g>
			</g>
		</g>
		<rect id="Rectangle_3174" data-name="Rectangle 3174" width="76" height="76" fill="none" />
	</SvgIcon>
);

export const ResetPasswordIcon = (props: SvgIconProps) => (
	<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3248" data-name="Rectangle 3248" width="24" height="24" fill="none" />
		<g id="Group_8020" data-name="Group 8020" transform="translate(-690.308 -961.949)">
			<path
				id="Union_47"
				data-name="Union 47"
				d="M4.009,1.747A5.787,5.787,0,0,0,2.247,6v.5L.869,5.114,0,5.986,2.868,8.853,5.731,5.986l-.869-.872L3.485,6.495V6a4.6,4.6,0,0,1,1.4-3.373,4.662,4.662,0,0,1,3.4-1.387,4.387,4.387,0,0,1,.944.1,4.53,4.53,0,0,1,.923.309l.027.012L11.1.737,11.049.71A6.221,6.221,0,0,0,9.7.18,5.8,5.8,0,0,0,8.28,0,5.881,5.881,0,0,0,4.009,1.747Zm9.581,1.426L10.752,6.01l.869.869L13,5.5V6a4.588,4.588,0,0,1-1.4,3.37,4.665,4.665,0,0,1-3.4,1.387,4.427,4.427,0,0,1-.943-.1,4.31,4.31,0,0,1-.919-.309l-.027-.012-.926.926.051.027a6,6,0,0,0,1.348.53,5.635,5.635,0,0,0,1.417.18,5.867,5.867,0,0,0,4.273-1.747A5.785,5.785,0,0,0,14.236,6V5.5l1.378,1.378.872-.869L13.619,3.143Z"
				transform="translate(710.794 976.941) rotate(180)"
				fill={props.htmlColor ? props.htmlColor : '#323232'}
			/>
			<path
				id="password_FILL1_wght400_GRAD0_opsz24"
				d="M2.611,11.245l-.974-.535.637-1.07H1V8.57H2.274L1.637,7.535,2.611,7l.637,1.035L3.885,7l.974.535L4.222,8.57H5.5V9.64H4.222l.637,1.07-.974.535-.637-1.07Zm5.995,0-.974-.535.637-1.07H6.995V8.57H8.269L7.632,7.535,8.606,7l.637,1.035L9.88,7l.974.535L10.217,8.57h1.274V9.64H10.217l.637,1.07-.974.535-.637-1.07Zm5.995,0-.974-.535.637-1.07H12.99V8.57h1.274l-.637-1.035L14.6,7l.637,1.035L15.875,7l.974.535L16.212,8.57h1.274V9.64H16.212l.637,1.07-.974.535-.637-1.07Z"
				transform="translate(693.308 971.704)"
				fill={props.htmlColor ? props.htmlColor : '#323232'}
			/>
		</g>
	</SvgIcon>
);

export const PurpleCircleOneIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_1" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M16.4,21h-2.7v-8.7s0-1.3,0-1.3c-.5.5-.8.7-.9.9l-1.5,1.2-1.3-1.6,4.1-3.3h2.2v12.8Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleTwoIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_2" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M18.7,21h-9v-1.9l3.2-3.3c1-1,1.6-1.7,1.9-2,.3-.4.5-.7.6-1s.2-.7.2-1c0-.5-.1-.9-.4-1.2-.3-.3-.7-.4-1.1-.4s-1,.1-1.5.3-1,.6-1.5,1l-1.5-1.7c.6-.5,1.2-.9,1.6-1.1s.9-.4,1.4-.5,1-.2,1.7-.2,1.5.1,2.1.4,1.1.7,1.4,1.2.5,1.1.5,1.8-.1,1.1-.3,1.7c-.2.5-.5,1.1-1,1.6-.4.5-1.2,1.3-2.3,2.3l-1.7,1.6h0c0,.1,5.6.1,5.6.1v2.3Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleThreeIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_3" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M18.2,11c0,.8-.2,1.5-.7,2s-1.2.9-2,1.2h0c1,.2,1.8.5,2.4,1,.5.5.8,1.2.8,2,0,1.2-.4,2.2-1.3,2.9-.9.7-2.2,1-3.8,1s-2.6-.2-3.7-.7v-2.3c.5.3,1,.5,1.6.6s1.2.2,1.8.2c.9,0,1.6-.2,2-.5s.6-.8.6-1.5-.2-1-.7-1.3-1.3-.4-2.4-.4h-1v-2.1h1c1,0,1.7-.1,2.2-.4.5-.3.7-.7.7-1.3,0-1-.6-1.5-1.8-1.5s-.9,0-1.3.2-.9.4-1.5.7l-1.3-1.9c1.2-.8,2.6-1.3,4.2-1.3s2.4.3,3.2.8c.8.5,1.2,1.3,1.2,2.2Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleFourIcon = (props: SvgIconProps) => (
	<SvgIcon width="28" height="28" viewBox="0 0 28 28" {...props}>
		<path id="Path_6923" d="M14,0c7.7,0,14,6.3,14,14s-6.3,14-14,14S0,21.7,0,14,6.3,0,14,0Z" fill="#603fa5" />
		<g id="_4" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M19,18.3h-1.5v2.7h-2.7v-2.7h-5.5v-1.9l5.6-8.3h2.5v8.1h1.5v2.1ZM14.8,16.2v-2.2c0-.4,0-.9,0-1.6s0-1.1,0-1.2h0c-.2.5-.5.9-.8,1.4l-2.4,3.6h3.1Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PurpleCircleBypassIcon = (props: SvgIconProps) => (
	<SvgIcon width="36" height="36" viewBox="0 0 36 36" {...props}>
		<path id="Path_6923" d="M18,0c9.9,0,18,8.1,18,18s-8.1,18-18,18S0,27.9,0,18,8.1,0,18,0Z" fill="#603fa5" />
		<g id="Bypass" style={{ isolation: 'isolate' }}>
			<g style={{ isolation: 'isolate' }}>
				<path
					d="M3.8,14.6h2c.9,0,1.6.1,2,.4.4.3.6.7.6,1.2s0,.7-.3.9c-.2.2-.4.4-.7.4h0c.4.1.7.3.9.6.2.2.3.6.3,1,0,.6-.2,1-.6,1.4-.4.3-1,.5-1.7.5h-2.4v-6.4ZM5.2,17.1h.8c.4,0,.6,0,.8-.2s.2-.3.2-.6,0-.4-.3-.5c-.2-.1-.5-.2-.9-.2h-.7v1.4ZM5.2,18.2v1.7h.9c.4,0,.7,0,.8-.2s.3-.4.3-.7c0-.5-.4-.8-1.1-.8h-.8Z"
					fill="#fff"
				/>
				<path
					d="M9,16.1h1.5l.9,2.8c0,.2.1.5.2.9h0c0-.3,0-.6.2-.9l.9-2.8h1.4l-2.1,5.5c-.2.5-.5.9-.8,1.2-.4.3-.8.4-1.2.4s-.5,0-.7,0v-1.1c.2,0,.3,0,.5,0s.4,0,.6-.2c.2-.1.3-.4.4-.7v-.2c0,0-1.9-4.9-1.9-4.9Z"
					fill="#fff"
				/>
				<path
					d="M17.6,21.1c-.6,0-1-.2-1.4-.6h0c0,.4,0,.6,0,.7v2h-1.3v-7.1h1.1l.2.6h0c.3-.5.8-.7,1.4-.7s1,.2,1.4.7c.3.4.5,1.1.5,1.9s0,1-.2,1.4-.4.7-.7.9c-.3.2-.6.3-1,.3ZM17.2,17.1c-.3,0-.6.1-.7.3-.2.2-.2.5-.2,1h0c0,.7,0,1.1.2,1.3s.4.3.7.3c.6,0,.9-.5.9-1.5s0-.8-.2-1.1c-.1-.2-.4-.4-.7-.4Z"
					fill="#fff"
				/>
				<path
					d="M23.7,21l-.3-.7h0c-.2.3-.5.5-.7.6-.2.1-.5.2-.9.2s-.8-.1-1.1-.4c-.3-.3-.4-.7-.4-1.2s.2-.9.5-1.2c.4-.2.9-.4,1.7-.4h.9v-.2c0-.5-.3-.7-.8-.7s-.9.1-1.4.4l-.4-.9c.6-.3,1.2-.4,1.9-.4s1.2.1,1.5.4c.4.3.5.7.5,1.3v3.3h-.9ZM23.3,18.7h-.5c-.4,0-.7,0-.9.2-.2.1-.3.3-.3.6,0,.4.2.6.7.6s.6,0,.7-.3c.2-.2.3-.4.3-.7v-.4Z"
					fill="#fff"
				/>
				<path
					d="M29.4,19.5c0,.5-.2.9-.5,1.2-.3.3-.9.4-1.6.4s-.7,0-.9,0c-.3,0-.5-.1-.7-.2v-1.1c.2.1.5.2.8.3.3,0,.6.1.8.1.5,0,.7-.1.7-.4s0-.2,0-.3c0,0-.2-.1-.3-.2-.2,0-.4-.2-.6-.3-.4-.2-.7-.3-.8-.4-.2-.1-.3-.3-.4-.5,0-.2-.1-.4-.1-.6,0-.4.2-.8.5-1,.3-.2.8-.4,1.4-.4s1.2.1,1.7.4l-.4,1c-.2-.1-.5-.2-.7-.3-.2,0-.4-.1-.7-.1-.4,0-.6.1-.6.3s0,.2.2.3c.1,0,.4.2.8.4.4.2.7.3.8.4s.3.3.4.5c0,.2.1.4.1.6Z"
					fill="#fff"
				/>
				<path
					d="M33.9,19.5c0,.5-.2.9-.5,1.2-.3.3-.9.4-1.6.4s-.7,0-.9,0c-.3,0-.5-.1-.7-.2v-1.1c.2.1.5.2.8.3.3,0,.6.1.8.1.5,0,.7-.1.7-.4s0-.2,0-.3c0,0-.2-.1-.3-.2-.2,0-.4-.2-.6-.3-.4-.2-.7-.3-.8-.4-.2-.1-.3-.3-.4-.5,0-.2-.1-.4-.1-.6,0-.4.2-.8.5-1,.3-.2.8-.4,1.4-.4s1.2.1,1.7.4l-.4,1c-.2-.1-.5-.2-.7-.3-.2,0-.4-.1-.7-.1-.4,0-.6.1-.6.3s0,.2.2.3c.1,0,.4.2.8.4.4.2.7.3.8.4s.3.3.4.5c0,.2.1.4.1.6Z"
					fill="#fff"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const SefIcon = (props: SvgIconProps) => (
	<SvgIcon width="47.001" height="38.365" viewBox="0 0 47.001 38.365" {...props}>
		<defs>
			<filter id="Rectangle_2306" x="0" y="0" width="47.001" height="38.365" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="landscape-sef-icon-paper-trays" transform="translate(4.501 3.5)">
			<g id="Group_9890" data-name="Group 9890" transform="translate(-20320 -10199) rotate(90)">
				<g transform="matrix(0, -1, 1, 0, 10195.5, -20315.5)" filter="url(#Rectangle_2306)">
					<g
						id="Rectangle_2305-2"
						data-name="Rectangle 2305"
						transform="translate(42.5 3.5) rotate(90)"
						fill="#fff"
						stroke="#262626"
						strokeWidth="0.5"
					>
						<rect width="29.365" height="38.001" stroke="none" />
						<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
					</g>
				</g>
				<path
					id="Path_10459"
					data-name="Path 10459"
					d="M4.509-1.709A1.576,1.576,0,0,1,3.894-.387a2.668,2.668,0,0,1-1.67.475A4.183,4.183,0,0,1,.466-.207V-.927a4.628,4.628,0,0,0,.861.264,4.532,4.532,0,0,0,.923.1A1.862,1.862,0,0,0,3.375-.85a.93.93,0,0,0,.378-.789,1.013,1.013,0,0,0-.134-.547,1.245,1.245,0,0,0-.448-.393,6.271,6.271,0,0,0-.956-.409,3.051,3.051,0,0,1-1.281-.76A1.678,1.678,0,0,1,.549-4.9a1.426,1.426,0,0,1,.558-1.182,2.319,2.319,0,0,1,1.477-.439,4.352,4.352,0,0,1,1.762.352l-.233.65a3.982,3.982,0,0,0-1.547-.334,1.5,1.5,0,0,0-.927.255.84.84,0,0,0-.334.708,1.084,1.084,0,0,0,.123.547,1.158,1.158,0,0,0,.415.391,5.16,5.16,0,0,0,.894.393,3.54,3.54,0,0,1,1.391.773A1.521,1.521,0,0,1,4.509-1.709ZM9.4,0H5.823V-6.425H9.4v.664H6.57v2.07H9.233v.659H6.57V-.668H9.4Zm2.171,0h-.747V-6.425H14.41v.664H11.575V-3.41h2.663v.664H11.575Z"
					transform="translate(10216.684 -20331.316) rotate(-90)"
					fill="#d7d7d7"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const LefIcon = (props: SvgIconProps) => (
	<SvgIcon width="38.365" height="47.001" viewBox="0 0 38.365 47.001" {...props}>
		<defs>
			<filter id="Rectangle_2305" x="0" y="0" width="38.365" height="47.001" filterUnits="userSpaceOnUse">
				<feOffset dy="1" />
				<feGaussianBlur stdDeviation="1.5" result="blur" />
				<feFlood floodOpacity="0.278" />
				<feComposite operator="in" in2="blur" />
				<feComposite in="SourceGraphic" />
			</filter>
		</defs>
		<g id="portrait-lef-icon-paper-trays" transform="translate(4.5 3.5)">
			<g transform="matrix(1, 0, 0, 1, -4.5, -3.5)" filter="url(#Rectangle_2305)">
				<g
					id="Rectangle_2305-2"
					data-name="Rectangle 2305"
					transform="translate(4.5 3.5)"
					fill="#fff"
					stroke="#262626"
					strokeWidth="0.5"
				>
					<rect width="29.365" height="38.001" stroke="none" />
					<rect x="0.25" y="0.25" width="28.865" height="37.501" fill="none" />
				</g>
			</g>
			<path
				id="Path_10460"
				data-name="Path 10460"
				d="M.883,0V-6.425H1.63V-.677H4.465V0ZM9.136,0H5.555V-6.425H9.136v.664H6.3v2.07H8.965v.659H6.3V-.668H9.136Zm2.171,0H10.56V-6.425h3.582v.664H11.307V-3.41H13.97v.664H11.307Z"
				transform="translate(8 23)"
				fill="#d7d7d7"
			/>
		</g>
	</SvgIcon>
);

export const TimerIcon = (props: SvgIconProps) => (
	<SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
		<path
			id="schedule_24dp_5F6368_FILL0_wght400_GRAD0_opsz24_1_"
			data-name="schedule_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 (1)"
			d="M90.64-868.24l1.12-1.12-2.96-2.96V-876H87.2v4.32ZM88-864a7.791,7.791,0,0,1-3.12-.63,8.08,8.08,0,0,1-2.54-1.71,8.081,8.081,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.078,8.078,0,0,1,1.71-2.54,8.078,8.078,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.078,8.078,0,0,1,2.54,1.71,8.078,8.078,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.081,8.081,0,0,1-1.71,2.54,8.08,8.08,0,0,1-2.54,1.71A7.791,7.791,0,0,1,88-864ZM88-872Zm0,6.4a6.17,6.17,0,0,0,4.53-1.87A6.17,6.17,0,0,0,94.4-872a6.17,6.17,0,0,0-1.87-4.53A6.169,6.169,0,0,0,88-878.4a6.169,6.169,0,0,0-4.53,1.87A6.17,6.17,0,0,0,81.6-872a6.17,6.17,0,0,0,1.87,4.53A6.17,6.17,0,0,0,88-865.6Z"
			transform="translate(-80 880)"
			fill="#0870f8"
		/>
	</SvgIcon>
);

export const TimeoutIcon = (props: SvgIconProps) => (
	<SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
		<path
			id="schedule_24dp_5F6368_FILL1_wght400_GRAD0_opsz24"
			d="M90.64-868.24l1.12-1.12-2.96-2.96V-876H87.2v4.32ZM88-864a7.79,7.79,0,0,1-3.12-.63,8.079,8.079,0,0,1-2.54-1.71,8.078,8.078,0,0,1-1.71-2.54A7.79,7.79,0,0,1,80-872a7.79,7.79,0,0,1,.63-3.12,8.079,8.079,0,0,1,1.71-2.54,8.079,8.079,0,0,1,2.54-1.71A7.789,7.789,0,0,1,88-880a7.789,7.789,0,0,1,3.12.63,8.079,8.079,0,0,1,2.54,1.71,8.079,8.079,0,0,1,1.71,2.54A7.79,7.79,0,0,1,96-872a7.79,7.79,0,0,1-.63,3.12,8.079,8.079,0,0,1-1.71,2.54,8.079,8.079,0,0,1-2.54,1.71A7.79,7.79,0,0,1,88-864Z"
			transform="translate(-80 880)"
			fill="#f99806"
		/>
	</SvgIcon>
);

export * from './print.icons';
export * from './edge-gateway.icons';
